<template>
  <div class="ngc h-full flex bg-[#0a0a0c] text-white overflow-hidden">
    <aside
      class="ngc-sidebar relative z-30 w-[248px] shrink-0 border-r border-white/[0.08] bg-[#0c0c0e] flex flex-col text-[11px]"
    >
      <div class="ngc-sidebar-head">
        <button type="button" class="ngc-tb-btn ngc-sidebar-back-btn" title="返回首页" @click="goHome">
          <i class="fas fa-chevron-left text-[10px]" aria-hidden="true"></i>
          <span>返回首页</span>
        </button>

        <div class="ngc-toolbar-segment ngc-sidebar-action-segment">
          <button type="button" class="ngc-tb-btn ngc-tb-btn--icon ngc-sidebar-action-btn" @click="newProject">
            <i class="fas fa-plus text-[10px]" aria-hidden="true"></i>
            <span>新建项目</span>
          </button>
          <button
            type="button"
            class="ngc-tb-btn ngc-tb-btn--add ngc-sidebar-action-btn"
            :disabled="saving || autoSaving"
            @click="saveProject"
          >
            <i
              class="fas text-[10px]"
              :class="saving || autoSaving ? 'fa-spinner fa-spin' : 'fa-save'"
              aria-hidden="true"
            ></i>
            <span>{{ saving || autoSaving ? '保存中…' : '保存' }}</span>
          </button>
        </div>

        <p
          v-if="autoSaveHint"
          class="ngc-sidebar-hint"
          :class="`ngc-sidebar-hint--${autoSaveHintTone}`"
        >
          {{ autoSaveHint }}
        </p>
      </div>
      <div
        class="shrink-0 px-3 py-2 flex items-center justify-between border-b border-white/[0.06] bg-[#0a0a0c]/80"
      >
        <span class="text-[10px] text-gray-500 font-medium uppercase tracking-wider">历史项目</span>
        <button
          type="button"
          class="h-7 w-7 rounded-lg text-gray-500 hover:text-violet-200 hover:bg-white/[0.06] flex items-center justify-center transition-colors"
          title="刷新列表"
          @click="refreshList"
        >
          <i class="fas fa-sync-alt text-[11px]"></i>
        </button>
      </div>
      <div class="flex-1 overflow-y-auto overflow-x-hidden p-2 space-y-1.5 min-h-0">
        <p v-if="listError" class="text-amber-200/90 px-1 text-[10px] leading-relaxed">{{ listError }}</p>
        <p
          v-if="!listError && !projectList.length"
          class="px-2 py-6 text-center text-[10px] text-gray-600 leading-relaxed"
        >
          暂无历史记录<br /><span class="text-gray-500">保存项目后将显示在此</span>
        </p>
        <button
          v-for="p in projectList"
          :key="p.uuid"
          type="button"
          class="w-full text-left rounded-xl border transition-colors flex gap-2.5 p-2 items-start"
          :class="
            p.uuid === projectUuid
              ? 'border-violet-500/45 bg-violet-600/12 ring-1 ring-violet-500/20'
              : 'border-white/[0.06] bg-white/[0.02] hover:bg-white/[0.05] hover:border-white/10'
          "
          :title="p.title"
          @click.stop="onSidebarProjectClick(p)"
        >
          <div
            class="w-11 h-11 rounded-lg shrink-0 overflow-hidden border border-white/[0.08] bg-[#141418] flex items-center justify-center"
          >
            <img
              v-if="p.thumb_url"
              :src="p.thumb_url"
              alt=""
              class="w-full h-full object-cover"
              @error="onProjectThumbError(p)"
            />
            <i v-else class="far fa-image text-gray-600 text-sm"></i>
          </div>
          <div class="min-w-0 flex-1 pt-0.5">
            <p
              class="text-[11px] font-medium truncate leading-tight"
              :class="p.uuid === projectUuid ? 'text-white' : 'text-gray-300'"
            >
              {{ p.title || '未命名画布' }}
            </p>
            <p class="text-[9px] text-gray-500 mt-1 tabular-nums flex items-center gap-1 flex-wrap">
              {{ formatProjectListTime(p.updated_at) }}
              <span
                v-if="p._localOnly"
                class="text-[8px] px-1 py-0 rounded bg-amber-500/15 text-amber-200/90 border border-amber-500/25"
              >
                本机
              </span>
            </p>
          </div>
        </button>
      </div>
      <div class="p-2 border-t border-white/[0.06] space-y-1">
       <!-- <button
          type="button"
          class="w-full h-8 rounded-lg text-gray-400 hover:text-white hover:bg-white/[0.06] text-xs"
          @click="goSimpleWorkspace"
        >
          简易对话画布
        </button> -->
        <!-- <router-link
          to="/"
          class="inline-flex w-full h-8 items-center justify-center gap-1.5 rounded-lg text-xs text-gray-400 no-underline transition hover:bg-white/[0.06] hover:text-white"
        >
          <i class="fas fa-arrow-left text-[10px] opacity-90"></i>
          返回首页
        </router-link> -->
      </div>
    </aside>

    <div class="flex-1 flex flex-col min-w-0 min-h-0">
      <header class="ngc-canvas-toolbar shrink-0">
        <div class="ngc-toolbar-leading">
          <div class="ngc-toolbar-group ngc-toolbar-title">
            <i class="fas fa-layer-group text-[10px] text-violet-300/70 shrink-0" aria-hidden="true"></i>
            <input
              v-model="projectTitle"
              class="ngc-toolbar-input"
              placeholder="项目名称"
            />
          </div>

          <span class="ngc-toolbar-divider" aria-hidden="true"></span>

          <div class="ngc-toolbar-group">
            <button
              type="button"
              class="ngc-tb-btn ngc-tb-btn--run"
              :disabled="graphRunning || !nodes.length"
              @click="runGraph"
            >
              <i
                class="fas text-[10px]"
                :class="graphRunning ? 'fa-spinner fa-spin' : 'fa-play'"
                aria-hidden="true"
              ></i>
              <span>{{ graphRunning ? '执行中…' : '执行画布' }}</span>
            </button>
          </div>

          <span class="ngc-toolbar-divider" aria-hidden="true"></span>

          <div class="ngc-toolbar-group ngc-toolbar-segment">
            <button
              type="button"
              class="ngc-tb-btn ngc-tb-btn--icon"
              title="适应画布到视口"
              @click="fitView"
            >
              <i class="fas fa-compress-arrows-alt text-[10px]" aria-hidden="true"></i>
              <span>适应</span>
            </button>
            <button
              type="button"
              class="ngc-tb-btn ngc-tb-btn--icon ngc-tb-btn--amber"
              :disabled="!nodes.length"
              title="分层从左到右；列内自上而下等距；图片/视频节点序号按画布自上而下 1→2→3 排列"
              @click="tidyCanvasLayout"
            >
              <i class="fas fa-sitemap text-[10px]" aria-hidden="true"></i>
              <span>整理</span>
            </button>
            <button
              type="button"
              class="ngc-tb-btn ngc-tb-btn--icon"
              :disabled="!deleteUndoStack.length"
              title="撤销最近一次删除（Ctrl+Z / ⌘Z）"
              @click="undoLastDelete"
            >
              <i class="fas fa-undo text-[10px]" aria-hidden="true"></i>
              <span>撤销</span>
            </button>
            <button
              type="button"
              class="ngc-tb-btn ngc-tb-btn--icon ngc-tb-btn--amber"
              :disabled="!hasVideoNodesToDownload || ngcBulkVideoDownloadRunning"
              :title="
                hasVideoNodesToDownload
                  ? '按视频节点序号依次下载画布上所有已生成视频到本机'
                  : '暂无已生成视频的视频节点'
              "
              @click="downloadAllVideoNodeOutputs"
            >
              <i
                class="fas text-[10px]"
                :class="ngcBulkVideoDownloadRunning ? 'fa-spinner fa-spin' : 'fa-download'"
                aria-hidden="true"
              ></i>
              <span>{{ ngcBulkVideoDownloadRunning ? '下载中…' : '全部下载视频' }}</span>
            </button>
          </div>

          <span class="ngc-toolbar-divider" aria-hidden="true"></span>

          <div class="ngc-toolbar-group ngc-toolbar-zoom" title="缩放">
            <button type="button" class="ngc-tb-btn ngc-tb-btn--icon-only" @click="zoom(-0.1)">
              <i class="fas fa-minus text-[9px]" aria-hidden="true"></i>
            </button>
            <span class="ngc-toolbar-zoom-label tabular-nums"
              >{{ Math.round(viewport.scale * 100) }}%</span
            >
            <button type="button" class="ngc-tb-btn ngc-tb-btn--icon-only" @click="zoom(0.1)">
              <i class="fas fa-plus text-[9px]" aria-hidden="true"></i>
            </button>
          </div>

          <label class="ngc-toolbar-check">
            <input v-model="showMinimap" type="checkbox" class="ngc-toolbar-checkbox" />
            <span>小地图</span>
          </label>

          <div class="relative inline-block shrink-0">
            <button
              type="button"
              class="ngc-tb-btn ngc-tb-btn--add"
              @click.stop="toggleAddBar"
            >
              <i class="fas fa-plus text-[10px]" aria-hidden="true"></i>
              <span>添加节点</span>
              <i class="fas fa-chevron-down text-[8px] opacity-60" aria-hidden="true"></i>
            </button>
            <div
              v-if="showAddBar"
              class="ngc-toolbar-dropdown absolute left-0 top-full mt-1.5 z-[120]"
              @mousedown.stop
            >
              <button
                v-for="opt in addOptions"
                :key="'bar-' + opt.type"
                type="button"
                class="ngc-toolbar-dropdown-item"
                @click="addNodeAtViewportCenter(opt.type); showAddBar = false"
              >
                {{ opt.label }}
              </button>
            </div>
          </div>

          <div class="ngc-toolbar-tools" title="画布工具">
            <button
              type="button"
              class="ngc-tb-tool"
              :class="{ 'ngc-tb-tool--active': canvasTool === 'select' }"
              title="选择：拖移节点、连线"
              @click="canvasTool = 'select'"
            >
              <i class="fas fa-mouse-pointer" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              class="ngc-tb-tool"
              :class="{ 'ngc-tb-tool--active-hand': canvasTool === 'hand' }"
              title="手势：拖移平移画布"
              @click="canvasTool = 'hand'"
            >
              <i class="fas fa-hand-paper" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <div class="ngc-toolbar-trailing">
          <button
            type="button"
            class="ngc-toolbar-credits"
            title="查看余额与充值"
            @click="onNgcToolbarCreditsClick"
          >
            <i class="fas fa-coins text-[9px] text-amber-300/85 shrink-0" aria-hidden="true"></i>
            <span class="ngc-toolbar-credits-label">剩余积分</span>
            <span class="ngc-toolbar-credits-value tabular-nums">{{ ngcToolbarCreditsDisplay }}</span>
          </button>
        </div>
        <!-- <span class="hidden lg:inline text-gray-600 max-w-[320px] truncate" title="操作说明"
          >从节点右侧 <strong class="text-gray-500">+</strong> 拖线到空白松手 →
          引用菜单 · 单击连线选中 → 点击处剪刀删除 · 双击空白添加 · 手势工具 / Alt / 中键 平移</span
        >
        <label class="flex items-center gap-1 text-gray-500 cursor-pointer">
          <input v-model="showGrid" type="checkbox" class="rounded border-white/20" />
          网格
        </label>
        <button
          type="button"
          class="h-8 px-2 rounded-lg bg-rose-500/15 border border-rose-500/25 text-rose-200 disabled:opacity-30"
          :disabled="!selectedId && !selectedEdgeId"
          @click="removeCurrentSelection"
        >
          删除
        </button> -->
      </header>

      <div
        ref="viewEl"
        class="flex-1 relative overflow-hidden bg-[#1a1a1a] select-none"
        :class="viewCanvasCursorClass"
        @wheel.prevent="onWheel"
        @mousedown="onViewMouseDown"
      >
        <div
          ref="viewGridEl"
          class="pointer-events-none absolute inset-0 z-[1]"
          :style="gridStyle"
        ></div>

        <div ref="viewWorldLayerEl" class="absolute inset-0 z-[2]" :style="layerStyle">
          <!-- 铺满世界坐标的大底板：接收空白处双击/拖移（否则 .self 永远点不到外层 viewEl） -->
          <div
            data-nc-canvas-bg
            class="absolute left-0 top-0 z-0"
            :class="
              canvasTool === 'hand' || isPanning ? 'cursor-grab' : 'cursor-crosshair'
            "
            style="width: 12000px; height: 12000px"
            @mousedown="onWorldMouseDown"
            @dblclick.stop.prevent="onWorldDblClick"
          ></div>
          <svg
            class="ngc-edges-svg absolute overflow-visible z-[1]"
            :style="{ width: '1px', height: '1px', left: 0, top: 0 }"
          >
            <defs>
              <linearGradient id="ngc-edge-flow-grad" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stop-color="#22d3ee" stop-opacity="0.15" />
                <stop offset="35%" stop-color="#e879f9" stop-opacity="1" />
                <stop offset="50%" stop-color="#ffffff" stop-opacity="1" />
                <stop offset="65%" stop-color="#a78bfa" stop-opacity="1" />
                <stop offset="100%" stop-color="#22d3ee" stop-opacity="0.15" />
              </linearGradient>
            </defs>
            <g v-for="e in ngcEdgesBackgroundVisible" :key="'eg-' + e.id">
              <!-- 宽透明描边便于点选；non-scaling-stroke 使点击区域不随缩放过细 -->
              <path
                :d="ngcBackgroundEdgePathById[e.id] || ''"
                fill="none"
                stroke="transparent"
                stroke-width="18"
                vector-effect="non-scaling-stroke"
                class="ngc-edge-hit"
                @mousedown.stop="selectEdge(e, $event)"
              />
              <!-- 底层柔光 -->
              <path
                :d="ngcBackgroundEdgePathById[e.id] || ''"
                fill="none"
                pointer-events="none"
                :stroke="selectedEdgeId === e.id ? 'rgba(56,189,248,0.45)' : 'rgba(168,85,247,0.35)'"
                :stroke-width="selectedEdgeId === e.id ? 7 : 5"
                stroke-linecap="round"
                vector-effect="non-scaling-stroke"
                class="ngc-edge-aura"
              />
              <!-- 主线 -->
              <path
                :d="ngcBackgroundEdgePathById[e.id] || ''"
                fill="none"
                pointer-events="none"
                :stroke="
                  selectedEdgeId === e.id ? 'rgba(147,197,253,0.95)' : 'rgba(192,132,252,0.72)'
                "
                :stroke-width="selectedEdgeId === e.id ? 3.2 : 2.2"
                stroke-linecap="round"
                vector-effect="non-scaling-stroke"
                class="ngc-edge-core"
              />
              <!-- 流光（pathLength 归一化便于 dash 沿整条线运动） -->
              <path
                :d="ngcBackgroundEdgePathById[e.id] || ''"
                pathLength="100"
                fill="none"
                pointer-events="none"
                stroke="url(#ngc-edge-flow-grad)"
                :stroke-width="selectedEdgeId === e.id ? 2.8 : 2"
                stroke-linecap="round"
                stroke-dasharray="18 82"
                vector-effect="non-scaling-stroke"
                class="ngc-edge-stream"
                :class="[
                  selectedEdgeId === e.id ? 'ngc-edge-stream--selected' : '',
                  !ngcEdgeStreamActiveForEdge(e) ? 'ngc-edge-stream--fx-off' : ''
                ]"
                :style="{ animationDelay: edgeStreamDelaySec(e) }"
              />
            </g>
            <g class="pointer-events-none">
              <path
                v-if="linkDragPath"
                :d="linkDragPath"
                fill="none"
                stroke="rgba(56,189,248,0.35)"
                stroke-width="5"
                stroke-linecap="round"
                vector-effect="non-scaling-stroke"
              />
              <path
                v-if="linkDragPath"
                :d="linkDragPath"
                fill="none"
                stroke="rgba(147,197,253,0.88)"
                stroke-width="2.2"
                stroke-linecap="round"
                vector-effect="non-scaling-stroke"
              />
              <path
                v-if="linkDragPath"
                pathLength="100"
                :d="linkDragPath"
                fill="none"
                stroke="url(#ngc-edge-flow-grad)"
                stroke-width="2"
                stroke-linecap="round"
                stroke-dasharray="14 86"
                vector-effect="non-scaling-stroke"
                class="ngc-edge-stream ngc-edge-stream--drag"
              />
              <path
                v-if="connectMenuPreviewPath"
                :d="connectMenuPreviewPath"
                fill="none"
                stroke="rgba(147,197,253,0.85)"
                stroke-width="2"
                vector-effect="non-scaling-stroke"
              />
            </g>
          </svg>

          <div
            v-for="n in ngcNodesVisibleInViewport"
            :key="n.id"
            :data-ngc-node-box="n.id"
            class="ngc-node-box absolute rounded-xl border bg-[#12121a] shadow-lg flex flex-col overflow-visible"
            :class="
              n.id === selectedId ? 'border-violet-500/60 ring-1 ring-violet-500/30' : 'border-white/[0.1]'
            "
            :style="nodeBoxLayoutStyle(n)"
            @mousedown.capture="onNodeStackCapture(n, $event)"
            @mousedown.stop="onNodeDown(n, $event)"
          >
            <button
              type="button"
              class="absolute left-0 top-1/2 z-20 flex h-7 w-7 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border bg-[#25252c] text-xs text-gray-200 shadow-md hover:border-emerald-400/60 hover:text-emerald-200"
              :class="
                n.type === 'image'
                  ? 'border-sky-400/45 ring-2 ring-sky-500/25'
                  : n.type === 'video'
                    ? 'border-amber-400/45 ring-2 ring-amber-500/25'
                    : n.type === 'audio'
                      ? 'border-cyan-400/45 ring-2 ring-cyan-500/25'
                      : n.type === 'directorDeck'
                        ? 'border-emerald-400/45 ring-2 ring-emerald-500/25'
                        : n.type === 'storyboard'
                          ? 'border-rose-400/45 ring-2 ring-rose-500/25'
                          : n.type === 'scriptWrite'
                            ? 'border-fuchsia-400/45 ring-2 ring-fuchsia-500/25'
                            : n.type === 'ecomDetail'
                            ? 'border-orange-400/45 ring-2 ring-orange-500/25'
                            : n.type === 'uiDesign'
                              ? 'border-indigo-400/45 ring-2 ring-indigo-500/25'
                              : 'border-white/20'
              "
              title="拖入连线：松手在空白处选上游节点，或松手在其它节点右侧 + 上连接"
              data-nc-in
              :data-node-id="n.id"
              @mousedown.left.stop.prevent="startLinkDragFromIn(n, $event)"
            >
              +
            </button>
            <button
              type="button"
              class="absolute right-0 top-1/2 z-20 flex h-7 w-7 translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-white/20 bg-[#25252c] text-xs text-gray-200 shadow-md hover:border-violet-400/70 hover:text-violet-100"
              title="拖出连线：松手在空白处选新节点，或松手在下游左侧 + 上连接"
              data-nc-out
              :data-node-id="n.id"
              @mousedown.left.stop.prevent="startLinkDrag(n, $event)"
            >
              +
            </button>

            <div
              class="shrink-0 px-2 py-1.5 flex items-center justify-between text-[10px] border-b border-white/[0.06] bg-white/[0.03]"
            >
              <span class="font-semibold text-gray-200 truncate flex items-center gap-1.5 min-w-0">
                <template v-if="n.type === 'llm'">
                  <i class="far fa-file-lines text-violet-300/90 shrink-0"></i>
                  文本节点 {{ textNodeIndex(n) }}
                </template>
                <template v-else-if="n.type === 'image'">
                  <i class="far fa-image text-sky-300/90 shrink-0"></i>
                  <span class="truncate min-w-0">
                    图片节点 {{ imageNodeIndex(n) }}
                    <span
                      v-if="String(n.data.spawnPlanLabel || '').trim()"
                      class="text-gray-500 font-normal"
                    >
                      · {{ n.data.spawnPlanLabel }}
                    </span>
                  </span>
                </template>
                <template v-else-if="n.type === 'video'">
                  <i class="fas fa-video text-amber-300/90 shrink-0"></i>
                  视频节点 {{ videoNodeIndex(n) }}
                </template>
                <template v-else-if="n.type === 'audio'">
                  <i class="fas fa-music text-cyan-300/90 shrink-0"></i>
                  音频节点 {{ audioNodeIndex(n) }}
                </template>
                <template v-else-if="n.type === 'ecomDetail'">
                  <i class="fas fa-store text-orange-300/90 shrink-0"></i>
                  电商详情图 {{ ecomDetailNodeIndex(n) }}
                </template>
                <template v-else-if="n.type === 'uiDesign'">
                  <i class="fas fa-mobile-alt text-indigo-300/90 shrink-0"></i>
                  UI 设计 {{ uiDesignNodeIndex(n) }}
                </template>
                <template v-else-if="n.type === 'directorDeck'">
                  <i class="fas fa-clapperboard text-emerald-300/90 shrink-0"></i>
                  导演台 {{ directorDeckNodeIndex(n) }}
                </template>
                <template v-else-if="n.type === 'note'">
                  <i class="fas fa-sticky-note text-gray-400/90 shrink-0"></i>
                  注释
                </template>
                <template v-else-if="n.type === 'storyboard'">
                  <i class="fas fa-list-ol text-rose-300/90 shrink-0"></i>
                  分镜脚本 {{ storyboardNodeIndex(n) }}
                </template>
                <template v-else-if="n.type === 'scriptWrite'">
                  <i class="fas fa-pen-fancy text-fuchsia-300/90 shrink-0"></i>
                  剧本创作 {{ scriptWriteNodeIndex(n) }}
                </template>
                <template v-else>{{ nodeTitle(n) }}</template>
              </span>
              <span v-if="n.data && n.data.status" class="text-[9px] text-gray-500 shrink-0">{{
                n.data.status
              }}</span>
            </div>
            <div
              class="p-2 space-y-2 text-[10px] flex flex-col flex-none min-h-0 min-w-0"
              :class="
                n.type === 'image' ||
                n.type === 'video' ||
                n.type === 'storyboard' ||
                n.type === 'scriptWrite'
                  ? 'overflow-visible'
                  : 'overflow-y-visible overflow-x-hidden'
              "
            >
              <template v-if="n.type === 'note'">
                <textarea
                  v-model="n.data.body"
                  rows="4"
                  class="w-full flex-1 min-h-[72px] rounded-lg bg-[#0f0f12] border border-white/10 px-2 py-1 text-gray-300 outline-none resize-y overflow-y-visible"
                  placeholder="注释…"
                  @mousedown.stop
                  @keydown.stop
                />
              </template>
              <template v-else-if="n.type === 'storyboard'">
                <p class="text-[9px] leading-snug text-gray-500">
                  粘贴<strong class="text-gray-400">剧本</strong>后，<strong class="text-gray-400">解析并添加视频节点</strong> 会建素材图，并按<strong class="text-gray-400"> 10～15 秒/镜</strong>合并生成视频节点（见<strong class="text-gray-400">续集接续</strong>）。素材图<strong class="text-gray-400">出图</strong>后再跑视频。<strong class="text-gray-400">非续接</strong>再次解析会删自动<strong class="text-gray-400">图+视频</strong>重建；<strong class="text-gray-400">续接</strong>保留素材图，仅重建视频。
                </p>
                <div class="grid grid-cols-3 gap-1.5" @mousedown.stop>
                  <div class="min-w-0 space-y-1">
                    <label class="block text-[8px] text-gray-500">风格</label>
                    <button
                      type="button"
                      class="ngc-node-field-input flex w-full items-center justify-between gap-1 text-left"
                      :class="
                        n.data.workflowStyle && typeof n.data.workflowStyle === 'object'
                          ? 'text-gray-100'
                          : 'text-gray-400'
                      "
                      :title="storyboardNodeStyleButtonTitle(n)"
                      @click.stop="openWorkflowStyleLibrary(n)"
                    >
                      <span class="min-w-0 flex-1 truncate">{{
                        (n.data.workflowStyle && n.data.workflowStyle.name) || '风格库'
                      }}</span>
                      <i class="fas fa-palette shrink-0 text-[10px] opacity-75" aria-hidden="true"></i>
                    </button>
                  </div>
                  <div class="min-w-0 space-y-1">
                    <label class="block text-[8px] text-gray-500">语言</label>
                    <NgcNodeSelect
                      :value="n.data.storyboardLanguage"
                      :options="STORYBOARD_LANGUAGE_OPTIONS"
                      size="sm"
                      accent="violet"
                      @input="v => { $set(n.data, 'storyboardLanguage', v); scheduleAutosave() }"
                    />
                  </div>
                  <div class="min-w-0 space-y-1">
                    <label class="block text-[8px] text-gray-500">比例</label>
                    <NgcNodeSelect
                      :value="n.data.storyboardAspectRatio"
                      :options="STORYBOARD_ASPECT_RATIO_OPTIONS"
                      size="sm"
                      accent="violet"
                      @input="v => onStoryboardAspectRatioChange(n, v)"
                    />
                  </div>
                </div>
                <textarea
                  v-model="n.data.body"
                  rows="10"
                  class="w-full min-h-[140px] flex-1 rounded-lg bg-[#0f0f12] border border-white/10 px-2 py-2 text-[11px] leading-relaxed text-gray-200 outline-none resize-y font-mono"
                  placeholder="粘贴剧本或时间轴分镜稿，形如：0-3秒：中景…并说「…」，参考的分镜画面…"
                  @mousedown.stop
                  @keydown.stop
                />
                <div
                  class="rounded-lg border border-white/[0.06] bg-[#141418]/90 px-2 py-1.5 space-y-1"
                  @mousedown.stop
                >
                  <p class="text-[9px] leading-snug text-gray-500">
                    <strong class="text-gray-400">续集接续</strong>：在<strong class="text-gray-400">自动或指定前一集</strong>生效时，再次解析<strong class="text-gray-400">不会清空</strong>本分镜下已有素材图，也不会动前一集画布；同名角色/道具/场景<strong class="text-gray-400">直接复用已有图片节点</strong>，提示词以<strong class="text-gray-400">画布节点里当前内容</strong>为准（与模型摘要无关）。仅<strong class="text-gray-400">新</strong>名称会新建图。选「不续接」则与首季相同，会删本分镜自动图后重建。
                  </p>
                  <NgcNodeSelect
                    :value="n.data.continuityFromStoryboardId"
                    :options="storyboardContinuityDropdownOptions(n)"
                    size="sm"
                    @input="v => { $set(n.data, 'continuityFromStoryboardId', v); scheduleAutosave() }"
                  />
                </div>
                <div
                  v-if="n.data.output"
                  class="rounded-lg bg-violet-950/20 border border-violet-500/20 px-2 py-1.5 text-[10px] text-gray-300 whitespace-pre-wrap max-h-[min(28vh,220px)] overflow-y-auto"
                >
                  <p class="text-[8px] font-medium text-violet-300/90 mb-1">解析摘要</p>
                  {{ n.data.output }}
                </div>
                <div class="mt-auto flex flex-col gap-2 border-t border-white/[0.06] pt-2" @mousedown.stop>
                  <div class="relative w-full" @mousedown.stop>
                    <button
                      type="button"
                      class="flex h-8 w-full min-w-0 items-center justify-between gap-2 rounded-lg border border-white/10 bg-[#18181c] px-2.5 text-[10px] text-gray-300 outline-none hover:bg-white/[0.05]"
                      :class="
                        storyboardModelPickerNodeId === n.id
                          ? 'border-sky-500/50 ring-1 ring-sky-500/25'
                          : ''
                      "
                      title="分镜解析所用模型"
                      @click.stop="toggleStoryboardModelPicker(n)"
                    >
                      <span class="flex min-w-0 flex-1 items-center gap-1.5">
                        <i class="fas fa-list-ol shrink-0 text-[9px] text-violet-300/90 opacity-90"></i>
                        <span class="min-w-0 truncate text-left">{{
                          storyboardNodeModelTriggerLabel(n)
                        }}</span>
                      </span>
                      <i
                        class="fas shrink-0 text-[8px] opacity-70"
                        :class="
                          storyboardModelPickerNodeId === n.id ? 'fa-chevron-up' : 'fa-chevron-down'
                        "
                      ></i>
                    </button>
                    <div
                      v-show="storyboardModelPickerNodeId === n.id"
                      class="ngc-inline-model-picker ngc-inline-model-picker--node-anchor"
                      @mousedown.stop
                    >
                      <div class="ngc-inline-model-picker__head">
                        <span class="ngc-inline-model-picker__title">分镜模型</span>
                        <button
                          type="button"
                          class="ngc-inline-model-picker__close"
                          title="关闭"
                          @click="closeStoryboardModelPickerModal"
                        >
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                      <div class="ngc-inline-model-picker__list">
                        <button
                          v-for="m in storyboardModelOptions"
                          :key="'sbm-' + n.id + '-' + m.id"
                          type="button"
                          class="ngc-inline-model-picker__item"
                          :class="
                            String(n.data.model || '').trim() === String(m.id || '').trim()
                              ? 'ngc-inline-model-picker__item--active'
                              : ''
                          "
                          @click.stop="setStoryboardNodeModel(n, m.id)"
                        >
                          <span
                            class="ngc-inline-model-picker__icon"
                          >
                            <i class="fas fa-list-ol text-[9px] text-violet-200/85"></i>
                          </span>
                          <span class="min-w-0 flex-1">{{ m.label }}</span>
                          <span
                            v-if="ngcModelOptionCreditsLine(m, 'text')"
                            class="shrink-0 tabular-nums text-[9px] text-gray-500"
                            >{{ ngcModelOptionCreditsLine(m, 'text') }}</span
                          >
                        </button>
                      </div>
                    </div>
                  </div>
                  <button
                    type="button"
                    class="flex w-full items-center justify-between gap-2 rounded-lg border border-amber-500/35 bg-amber-950/25 px-2.5 py-2 text-[10px] font-medium text-amber-100/95 hover:bg-amber-900/35 disabled:opacity-35"
                    :disabled="isNodeRunning(n.id)"
                    title="续接时保留本分镜素材图并复用前一集同名节点；仅重建本分镜视频。非续接时会删本分镜自动图+视频后重建"
                    @click.stop="runStoryboardParseAndSpawnVideos(n)"
                  >
                    <span class="flex min-w-0 flex-1 items-center justify-center gap-2">
                      <i class="fas fa-film shrink-0 text-[11px]"></i>
                      <span class="truncate">解析剧本并添加视频节点</span>
                    </span>
                    <span
                      class="flex shrink-0 items-center gap-0.5 text-[9px] tabular-nums text-amber-200/90"
                    >
                      <i class="fas fa-bolt text-amber-400 text-[8px]"></i>
                      {{ ngcFormatCatalogCredits(storyboardCreditDisplay(n)) }}
                    </span>
                  </button>
                </div>
              </template>
              <template v-else-if="n.type === 'scriptWrite'">
                <p class="text-[9px] leading-snug text-gray-500">
                  选择<strong class="text-gray-400">题材 / 篇幅</strong>（可选填<strong class="text-gray-400">梗概</strong>），用
                  <strong class="text-gray-400">↑</strong> 生成完整剧本；可连下游<strong class="text-gray-400">分镜脚本</strong>节点继续拆解镜头。
                </p>
                <div class="grid grid-cols-2 gap-1.5" @mousedown.stop>
                  <div class="min-w-0 space-y-1">
                    <label class="block text-[8px] text-gray-500">题材</label>
                    <NgcNodeSelect
                      :value="n.data.genrePick"
                      :options="SCRIPT_WRITE_GENRE_OPTIONS"
                      size="sm"
                      placeholder="选择题材"
                      @input="v => { $set(n.data, 'genrePick', v); scheduleAutosave() }"
                    />
                    <input
                      v-if="n.data.genrePick === SCRIPT_WRITE_SELECT_CUSTOM"
                      v-model="n.data.genreCustom"
                      type="text"
                      class="ngc-node-field-input w-full"
                      placeholder="输入自定义题材"
                      @keydown.stop
                      @input="scheduleAutosave"
                    />
                  </div>
                  <div class="min-w-0 space-y-1">
                    <label class="block text-[8px] text-gray-500">篇幅</label>
                    <NgcNodeSelect
                      :value="n.data.lengthHintPick"
                      :options="SCRIPT_WRITE_LENGTH_OPTIONS"
                      size="sm"
                      placeholder="选择篇幅"
                      @input="v => { $set(n.data, 'lengthHintPick', v); scheduleAutosave() }"
                    />
                    <input
                      v-if="n.data.lengthHintPick === SCRIPT_WRITE_SELECT_CUSTOM"
                      v-model="n.data.lengthHintCustom"
                      type="text"
                      class="ngc-node-field-input w-full"
                      placeholder="如 2 分钟、12 集×45 分"
                      @keydown.stop
                      @input="scheduleAutosave"
                    />
                  </div>
                </div>
                <textarea
                  v-model="n.data.body"
                  rows="9"
                  class="w-full min-h-[120px] flex-1 rounded-lg bg-[#0f0f12] border border-white/10 px-2 py-2 text-[11px] leading-relaxed text-gray-200 outline-none resize-y"
                  placeholder="选填：故事梗概、人物关系、风格参考、必须保留的情节…"
                  @mousedown.stop
                  @keydown.stop
                />
                <div
                  v-if="n.data.output"
                  class="rounded-lg bg-fuchsia-950/20 border border-fuchsia-500/20 px-2 py-1.5 text-[10px] text-gray-300 whitespace-pre-wrap max-h-[min(28vh,220px)] overflow-y-auto"
                >
                  <p class="text-[8px] font-medium text-fuchsia-300/90 mb-1">已生成剧本</p>
                  {{ n.data.output }}
                </div>
                <div class="relative mt-auto flex flex-wrap items-center justify-between gap-2 border-t border-white/[0.06] pt-2" @mousedown.stop>
                  <div class="min-w-0 flex-1 max-w-[70%]" @mousedown.stop>
                    <button
                      type="button"
                      class="flex h-8 w-full min-w-0 items-center justify-center gap-1 rounded-lg border border-white/10 bg-[#18181c] px-1.5 text-[10px] text-gray-300 outline-none hover:bg-white/[0.05]"
                      :class="
                        storyboardModelPickerNodeId === n.id
                          ? 'border-sky-500/50 ring-1 ring-sky-500/25'
                          : ''
                      "
                      title="剧本创作所用模型"
                      @click.stop="toggleStoryboardModelPicker(n)"
                    >
                      <i class="fas fa-pen-fancy shrink-0 text-[9px] text-fuchsia-300/90 opacity-90"></i>
                      <span class="min-w-0 flex-1 truncate text-left">{{
                        storyboardNodeModelTriggerLabel(n)
                      }}</span>
                      <i
                        class="fas shrink-0 text-[8px] opacity-70"
                        :class="
                          storyboardModelPickerNodeId === n.id ? 'fa-chevron-up' : 'fa-chevron-down'
                        "
                      ></i>
                    </button>
                  </div>
                  <span class="flex items-center gap-0.5 text-[9px] tabular-nums text-amber-200/80 shrink-0">
                    <i class="fas fa-bolt text-amber-400 text-[8px]"></i>
                    {{ ngcFormatCatalogCredits(scriptWriteCreditDisplay(n)) }}
                  </span>
                  <button
                    type="button"
                    class="ngc-node-run-btn"
                    :class="{ 'ngc-node-run-btn--wide': scriptWriteHasGeneratedContent(n) }"
                    :disabled="isNodeRunning(n.id)"
                    :title="
                      scriptWriteHasGeneratedContent(n)
                        ? '重新生成剧本（将覆盖当前结果）'
                        : '生成剧本'
                    "
                    @click.stop="onScriptWriteGenerateClick(n)"
                  >
                    <template v-if="scriptWriteHasGeneratedContent(n)">
                      <i class="fas fa-redo ngc-node-run-btn__icon ngc-node-run-btn__icon--sm" aria-hidden="true"></i>
                      <span class="ngc-node-run-btn__text">重新生成</span>
                    </template>
                    <i v-else class="fas fa-arrow-up ngc-node-run-btn__icon" aria-hidden="true"></i>
                  </button>
                  <div
                    v-show="storyboardModelPickerNodeId === n.id"
                    class="ngc-inline-model-picker ngc-inline-model-picker--node-anchor"
                    @mousedown.stop
                  >
                    <div class="ngc-inline-model-picker__head">
                      <span class="ngc-inline-model-picker__title">创作模型</span>
                      <button
                        type="button"
                        class="ngc-inline-model-picker__close"
                        title="关闭"
                        @click="closeStoryboardModelPickerModal"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                    <div class="ngc-inline-model-picker__list">
                      <button
                        v-for="m in storyboardModelOptions"
                        :key="'swm-' + n.id + '-' + m.id"
                        type="button"
                        class="ngc-inline-model-picker__item"
                        :class="
                          String(n.data.model || '').trim() === String(m.id || '').trim()
                            ? 'ngc-inline-model-picker__item--active'
                            : ''
                        "
                        @click.stop="setStoryboardNodeModel(n, m.id)"
                      >
                        <span
                          class="ngc-inline-model-picker__icon"
                        >
                          <i class="fas fa-pen-fancy text-[9px] text-fuchsia-200/85"></i>
                        </span>
                        <span class="min-w-0 flex-1">{{ m.label }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="n.type === 'llm'">
                <div class="flex items-start gap-2 text-gray-400">
                  <i class="fas fa-align-left mt-0.5 text-gray-500 shrink-0"></i>
                  <div class="flex-1 min-w-0">
                    <p class="text-[10px] text-gray-500 mb-1">尝试:</p>
                    <div class="grid grid-cols-2 gap-1.5">
                      <button
                        v-for="opt in textModeChoices"
                        :key="opt.key"
                        type="button"
                        class="flex items-center gap-1.5 rounded-lg border px-2 py-1.5 text-left transition-colors"
                        :class="
                          (n.data.textMode || 'write') === opt.key
                            ? 'border-violet-500/45 bg-violet-600/15 text-gray-100'
                            : 'border-white/10 bg-[#151518] text-gray-400 hover:border-white/18'
                        "
                        @mousedown.stop
                        @click="setLlmTextMode(n, opt.key)"
                      >
                        <i :class="[opt.icon, 'text-[11px] opacity-80 shrink-0']"></i>
                        <span class="leading-tight">{{ opt.label }}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <textarea
                  v-model="n.data.prompt"
                  rows="5"
                  class="w-full min-h-[104px] rounded-xl bg-[#0f0f12] border border-white/10 px-2.5 py-2 text-gray-200 text-[11px] leading-relaxed outline-none resize-y overflow-y-visible"
                  placeholder="写下你想讲的故事、场景或角色设定。例如：一个来自未来的机器人，在城市屋顶看星星。"
                  @mousedown.stop
                  @keydown.stop
                />
                <video
                  v-if="n.data.inlineVideoUrl"
                  :src="n.data.inlineVideoUrl"
                  controls
                  playsinline
                  class="w-full max-h-32 rounded-lg border border-white/10 bg-black/50"
                  @mousedown.stop
                />
                <div
                  v-if="n.data.output"
                  class="rounded-lg bg-black/25 border border-white/[0.06] px-2 py-1.5 text-[10px] text-gray-400 whitespace-pre-wrap"
                >
                  {{ n.data.output }}
                </div>
                <div
                  class="relative mt-auto flex items-center justify-between gap-2 border-t border-white/[0.06] pt-2"
                  @mousedown.stop
                >
                  <div class="min-w-0 max-w-[58%] flex-1" @mousedown.stop>
                    <button
                      type="button"
                      class="flex h-8 w-full min-w-0 items-center justify-center gap-1 rounded-lg border border-white/10 bg-[#18181c] px-1.5 text-[10px] text-gray-300 outline-none hover:bg-white/[0.05]"
                      :class="
                        llmModelPickerNodeId === n.id
                          ? 'border-sky-500/50 ring-1 ring-sky-500/25'
                          : ''
                      "
                      title="文本节点模型"
                      @click.stop="toggleLlmModelPicker(n)"
                    >
                      <i class="fas fa-align-left shrink-0 text-[9px] text-violet-300/90 opacity-90"></i>
                      <span class="min-w-0 flex-1 truncate text-left">{{
                        llmNodeModelTriggerLabel(n)
                      }}</span>
                      <i
                        class="fas shrink-0 text-[8px] opacity-70"
                        :class="llmModelPickerNodeId === n.id ? 'fa-chevron-up' : 'fa-chevron-down'"
                      ></i>
                    </button>
                  </div>
                  <div class="flex items-center gap-1 shrink-0 text-amber-200/90">
                    <span
                      class="flex h-8 w-8 items-center justify-center rounded-lg border border-white/10 text-[10px] text-gray-500"
                      title="语言 / 翻译（示意）"
                    >文A</span>
                    <span class="flex items-center gap-0.5 px-1 text-[10px] tabular-nums text-amber-200/90"
                      ><i class="fas fa-bolt text-amber-400 text-[9px]"></i
                      >{{ ngcNodeCreditBoltText(n) }}</span
                    >
                    <button
                      type="button"
                      class="ngc-node-run-btn"
                      :disabled="isNodeRunning(n.id)"
                      title="执行本节点"
                      @click.stop="runSingleTextNode(n)"
                    >
                      <i class="fas fa-arrow-up ngc-node-run-btn__icon" aria-hidden="true"></i>
                    </button>
                  </div>
                  <div
                    v-show="llmModelPickerNodeId === n.id"
                    class="ngc-inline-model-picker ngc-inline-model-picker--node-anchor"
                    @mousedown.stop
                  >
                    <div class="ngc-inline-model-picker__head">
                      <span class="ngc-inline-model-picker__title">文本模型</span>
                      <button
                        type="button"
                        class="ngc-inline-model-picker__close"
                        title="关闭"
                        @click="closeLlmModelPickerModal"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                    <div class="ngc-inline-model-picker__list">
                      <button
                        v-for="m in llmModelOptions"
                        :key="'llmm-' + n.id + '-' + m.id"
                        type="button"
                        class="ngc-inline-model-picker__item"
                        :class="
                          String(n.data.model || '').trim() === String(m.id || '').trim()
                            ? 'ngc-inline-model-picker__item--active'
                            : ''
                        "
                        @click.stop="setLlmNodeModel(n, m.id)"
                      >
                        <span
                          class="ngc-inline-model-picker__icon"
                        >
                          <i class="fas fa-align-left text-[9px] text-violet-200/85"></i>
                        </span>
                        <span class="min-w-0 flex-1">
                          <span class="block">{{ m.label }}</span>
                          <span
                            v-if="ngcModelOptionCreditsLine(m, 'text')"
                            class="block text-[9px] text-amber-200/65 font-normal"
                            >{{ ngcModelOptionCreditsLine(m, 'text') }}</span
                          >
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="n.type === 'image'">
                <div class="flex flex-col gap-2 w-full min-w-0">
                <div
                  v-if="
                    String(n.data.imageInputMode || 'generate') === 'generate' &&
                    n.data.imageInpaintMode
                  "
                  class="flex flex-wrap items-center gap-1 rounded-lg border border-violet-500/30 bg-violet-950/25 px-1.5 py-1 shrink-0"
                  @mousedown.stop
                  @pointerdown.stop
                >
                  <span
                    class="text-[9px] text-violet-200/90 font-medium whitespace-nowrap px-0.5"
                    >重绘</span
                  >
                  <button
                    type="button"
                    class="flex h-7 w-7 items-center justify-center rounded-md border text-[10px] transition-colors"
                    :class="
                      (n.data.inpaintDrawTool || 'brush') === 'brush'
                        ? 'border-violet-400/50 bg-violet-600/25 text-violet-100'
                        : 'border-white/10 text-gray-400 hover:bg-white/[0.06]'
                    "
                    title="画笔（[ ] 调节粗细；画布上按住 Alt 滚轮）"
                    @click.stop="setInpaintDrawTool(n, 'brush')"
                  >
                    <i class="fas fa-paint-brush"></i>
                  </button>
                  <button
                    type="button"
                    class="flex h-7 w-7 items-center justify-center rounded-md border text-[10px] transition-colors"
                    :class="
                      n.data.inpaintDrawTool === 'rect'
                        ? 'border-violet-400/50 bg-violet-600/25 text-violet-100'
                        : 'border-white/10 text-gray-400 hover:bg-white/[0.06]'
                    "
                    title="矩形选区（按住 Shift 拖正方形）"
                    @click.stop="setInpaintDrawTool(n, 'rect')"
                  >
                    <i class="far fa-square"></i>
                  </button>
                  <button
                    type="button"
                    class="flex h-7 w-7 items-center justify-center rounded-md border text-[10px] transition-colors"
                    :class="
                      n.data.inpaintDrawTool === 'erase'
                        ? 'border-violet-400/50 bg-violet-600/25 text-violet-100'
                        : 'border-white/10 text-gray-400 hover:bg-white/[0.06]'
                    "
                    title="橡皮（恢复保留区）"
                    @click.stop="setInpaintDrawTool(n, 'erase')"
                  >
                    <i class="fas fa-eraser"></i>
                  </button>
                  <label class="flex items-center gap-1 text-[9px] text-gray-500 whitespace-nowrap">
                    <i class="fas fa-circle-notch text-[8px] opacity-70"></i>
                    <input
                      v-model.number="n.data.inpaintBrushSize"
                      type="range"
                      min="2"
                      max="128"
                      step="1"
                      class="w-14 h-1 accent-violet-400"
                      @mousedown.stop
                    />
                    <span class="tabular-nums text-gray-400 w-7 text-right">{{ Math.round(n.data.inpaintBrushSize || 28) }}</span>
                  </label>
                  <button
                    type="button"
                    class="flex h-7 w-7 items-center justify-center rounded-md border border-white/10 text-gray-400 hover:bg-white/[0.06]"
                    title="撤销"
                    @click.stop="inpaintUndo(n)"
                  >
                    <i class="fas fa-undo text-[10px]"></i>
                  </button>
                  <button
                    type="button"
                    class="flex h-7 w-7 items-center justify-center rounded-md border border-white/10 text-gray-400 hover:bg-white/[0.06]"
                    title="重做"
                    @click.stop="inpaintRedo(n)"
                  >
                    <i class="fas fa-redo text-[10px]"></i>
                  </button>
                  <button
                    type="button"
                    class="ml-auto text-[9px] px-2 py-0.5 rounded-md border border-emerald-500/35 text-emerald-200/90 hover:bg-emerald-900/30"
                    title="应用蒙版并退出（可再去下方改提示词后生成）"
                    @click.stop="finishImageInpaintMode(n)"
                  >
                    完成
                  </button>
                  <button
                    type="button"
                    class="text-[9px] px-2 py-0.5 rounded-md text-gray-500 hover:text-rose-300"
                    title="退出重绘（不应用当前笔触）"
                    @click.stop="cancelImageInpaintMode(n)"
                  >
                    取消
                  </button>
                  <button
                    type="button"
                    class="flex h-7 items-center gap-1 rounded-md border border-violet-400/35 bg-violet-600/15 px-2 text-[9px] text-violet-100/95 hover:bg-violet-600/25"
                    title="大屏在线涂抹蒙版（便于精细涂抹）"
                    @click.stop="openInpaintOnlineEditor(n)"
                  >
                    <i class="fas fa-expand-alt text-[9px]"></i>
                    在线编辑
                  </button>
                </div>
                <div
                  v-if="imageNodeHasOwnImageData(n)"
                  class="min-h-[168px] rounded-xl bg-[#0c0c10] border border-white/[0.07] flex flex-col items-stretch justify-center overflow-hidden shrink-0 relative"
                  @mousedown.stop="onNodeDown(n, $event)"
                  @dragstart.prevent
                >
                  <button
                    type="button"
                    class="absolute top-2 right-2 z-20 flex h-8 items-center gap-1 rounded-lg border border-white/15 bg-black/60 px-2 text-white shadow-[0_4px_16px_rgba(0,0,0,0.45)] backdrop-blur-sm transition-colors hover:bg-black/75 hover:border-white/25 disabled:opacity-40"
                    :disabled="ngcImageAssetSavingId === n.id"
                    title="加入角色库（保存至我的资产 · 角色）"
                    @mousedown.stop
                    @pointerdown.stop
                    @click.stop="addImageNodeToAssetLibrary(n)"
                  >
                    <i
                      class="fas text-[11px]"
                      :class="ngcImageAssetSavingId === n.id ? 'fa-spinner fa-spin' : 'fa-user-plus'"
                    ></i>
                    <span class="text-[9px] font-medium leading-none whitespace-nowrap">角色库</span>
                  </button>
                  <div
                    :data-ngc-inpaint-wrap="n.id"
                    :class="[
                      'relative flex-1 min-h-[120px] flex items-center justify-center',
                      n.data.imageInpaintMode ? 'cursor-crosshair touch-none' : ''
                    ]"
                    @pointerdown="onImageNodeInpaintSurfacePointerDown($event, n, 'inline')"
                    @mousedown="onImageNodeInpaintSurfacePointerDown($event, n, 'inline')"
                    @wheel="inpaintWrapWheel($event, n)"
                  >
                    <img
                      :data-ngc-inpaint-base-img="n.id"
                      :src="imageNodeOwnPreviewSrc(n)"
                      alt=""
                      draggable="false"
                      class="relative z-0 max-w-full w-full h-auto object-contain select-none pointer-events-none"
                      @dragstart.prevent
                      @load="onInpaintInlineBaseImgLoad(n)"
                    />
                    <canvas
                      v-show="
                        n.data.imageInpaintMode &&
                        imageNodeOwnPreviewSrc(n) &&
                        inpaintOnlineEditorNodeId !== n.id
                      "
                      :data-ngc-inpaint-canvas="n.id"
                      class="pointer-events-none touch-none cursor-crosshair absolute z-[80]"
                      style="left: 0; top: 0; width: 0; height: 0"
                    ></canvas>
                  </div>
                </div>
                <div
                  class="rounded-xl border border-white/[0.08] bg-[#111116] p-2 space-y-2 shrink-0 w-full shadow-[inset_0_1px_0_rgba(255,255,255,0.04)]"
                >
                  <div class="space-y-1.5 shrink-0">
                    <p class="px-0.5 text-[9px] font-medium tracking-wide text-gray-500">图片来源</p>
                    <div
                      class="grid grid-cols-2 gap-1 rounded-xl border border-white/[0.07] bg-[#0a0a0e] p-1 shadow-[inset_0_1px_0_rgba(255,255,255,0.03)]"
                      @mousedown.stop
                    >
                      <button
                        type="button"
                        class="group flex items-center justify-center gap-1.5 rounded-lg px-2 py-2 transition-all duration-150"
                        :class="
                          String(n.data.imageInputMode || 'generate') === 'generate'
                            ? 'bg-white/[0.11] text-gray-50 shadow-[0_1px_0_rgba(255,255,255,0.08),inset_0_1px_0_rgba(255,255,255,0.06)] ring-1 ring-white/[0.14]'
                            : 'text-gray-500 hover:bg-white/[0.04] hover:text-gray-300'
                        "
                        @click.stop="setImageInputMode(n, 'generate')"
                      >
                        <span
                          class="flex h-6 w-6 shrink-0 items-center justify-center rounded-md transition-colors"
                          :class="
                            String(n.data.imageInputMode || 'generate') === 'generate'
                              ? 'bg-white/[0.14]'
                              : 'bg-white/[0.05] group-hover:bg-white/[0.08]'
                          "
                        >
                          <i
                            class="fas fa-wand-magic-sparkles text-[11px] text-white"
                            :class="
                              String(n.data.imageInputMode || 'generate') === 'generate'
                                ? 'opacity-100'
                                : 'opacity-50 group-hover:opacity-75'
                            "
                          ></i>
                        </span>
                        <span class="text-[10px] font-medium leading-none">文生图</span>
                      </button>
                      <button
                        type="button"
                        class="group flex items-center justify-center gap-1.5 rounded-lg px-2 py-2 transition-all duration-150"
                        :class="
                          String(n.data.imageInputMode || 'generate') === 'upload'
                            ? 'bg-white/[0.11] text-gray-50 shadow-[0_1px_0_rgba(255,255,255,0.08),inset_0_1px_0_rgba(255,255,255,0.06)] ring-1 ring-white/[0.14]'
                            : 'text-gray-500 hover:bg-white/[0.04] hover:text-gray-300'
                        "
                        @click.stop="setImageInputMode(n, 'upload')"
                      >
                        <span
                          class="flex h-6 w-6 shrink-0 items-center justify-center rounded-md transition-colors"
                          :class="
                            String(n.data.imageInputMode || 'generate') === 'upload'
                              ? 'bg-white/[0.14]'
                              : 'bg-white/[0.05] group-hover:bg-white/[0.08]'
                          "
                        >
                          <i
                            class="fas fa-cloud-arrow-up text-[11px] text-white"
                            :class="
                              String(n.data.imageInputMode || 'generate') === 'upload'
                                ? 'opacity-100'
                                : 'opacity-50 group-hover:opacity-75'
                            "
                          ></i>
                        </span>
                        <span class="text-[10px] font-medium leading-none">上传图片</span>
                      </button>
                    </div>
                  </div>
                  <div
                    v-if="String(n.data.imageInputMode || 'generate') === 'upload'"
                    class="shrink-0 space-y-1.5 rounded-lg border border-white/[0.08] bg-[#111116] px-2 py-1.5"
                  >
                    <p class="text-[8px] leading-snug text-gray-500">
                      使用本机图片或上游已出图节点作为本节点输出。上传成功即写入下游可引用的 imageUrl；仅接上游时可点下方「应用」。
                    </p>
                    <div class="flex flex-wrap items-center gap-1.5">
                      <input
                        :id="'ngc-img-in-' + n.id"
                        type="file"
                        accept="image/*"
                        class="hidden"
                        @change="onImageNodeFile(n, $event)"
                      />
                      <label
                        :for="'ngc-img-in-' + n.id"
                        class="inline-flex cursor-pointer items-center gap-1 rounded-lg border border-white/15 bg-white/[0.06] px-2 py-1.5 text-[10px] text-gray-200 hover:bg-white/[0.1]"
                      >
                        <i class="fas fa-upload text-[10px]"></i>
                        选择文件
                      </label>
                      <p
                        v-if="imageNodeHasOwnImageData(n)"
                        class="flex-1 min-w-0 text-[9px] text-emerald-400/90 truncate"
                        :title="imageNodeOwnPreviewSrc(n)"
                      >
                        已选文件
                      </p>
                      <button
                        v-if="imageNodeHasOwnImageData(n)"
                        type="button"
                        class="shrink-0 rounded px-1.5 py-0.5 text-[9px] text-gray-400 hover:bg-white/[0.06] hover:text-rose-200"
                        title="清除已上传的图片"
                        @click.stop="clearImageNodeUploadedImage(n)"
                      >
                        清除
                      </button>
                    </div>
                    <div class="flex items-center justify-end gap-1.5 pt-0.5 border-t border-white/[0.06]">
                      <button
                        type="button"
                        class="ngc-node-run-btn"
                        :disabled="isNodeRunning(n.id)"
                        title="从本地上传或上游应用为节点输出"
                        @click.stop="runSingleImageNode(n)"
                      >
                        <i class="fas fa-arrow-up ngc-node-run-btn__icon" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                  <template v-if="String(n.data.imageInputMode || 'generate') === 'generate'">
                  <div class="flex items-center gap-2 min-w-0 max-w-full overflow-hidden">
                    <div
                      class="inline-flex shrink-0 overflow-hidden rounded-lg border border-white/[0.10] bg-[#101014] shadow-[inset_0_1px_0_rgba(255,255,255,0.04)] divide-x divide-white/[0.08]"
                      @mousedown.stop
                    >
                      <button
                        type="button"
                        class="flex min-w-[48px] max-w-[92px] flex-1 flex-col items-center gap-0.5 px-2 py-1.5 transition-colors"
                        :class="
                          effectiveImageWorkflowStyle(n)
                            ? 'bg-white/[0.10] text-gray-100'
                            : 'text-gray-500 hover:bg-white/[0.05] hover:text-gray-300'
                        "
                        :title="imageNodeStyleButtonTitle(n)"
                        @click.stop="openImageStyleLibrary(n)"
                      >
                        <i class="fas fa-palette text-[11px] opacity-90"></i>
                        <span class="text-[9px] leading-none truncate w-full text-center">{{
                          imageNodeStyleButtonLabel(n)
                        }}</span>
                      </button>
                      <button
                        type="button"
                        class="flex min-w-[48px] flex-1 flex-col items-center gap-0.5 px-2 py-1.5 transition-colors"
                        :class="
                          n.data.uiMark
                            ? 'bg-white/[0.10] text-gray-100'
                            : 'text-gray-500 hover:bg-white/[0.05] hover:text-gray-300'
                        "
                        title="标记（示意）"
                        @click.stop="$set(n.data, 'uiMark', !n.data.uiMark)"
                      >
                        <i class="fas fa-map-marker-alt text-[11px] opacity-90"></i>
                        <span class="text-[9px] leading-none">标记</span>
                      </button>
                      <button
                        type="button"
                        class="flex min-w-[48px] flex-1 flex-col items-center gap-0.5 px-2 py-1.5 transition-colors"
                        :class="
                          n.data.uiFocus
                            ? 'bg-white/[0.10] text-gray-100'
                            : 'text-gray-500 hover:bg-white/[0.05] hover:text-gray-300'
                        "
                        title="聚焦（示意）"
                        @click.stop="$set(n.data, 'uiFocus', !n.data.uiFocus)"
                      >
                        <i class="fas fa-crosshairs text-[11px] opacity-90"></i>
                        <span class="text-[9px] leading-none">聚焦</span>
                      </button>
                      <button
                        type="button"
                        class="flex min-w-[48px] flex-1 flex-col items-center gap-0.5 px-2 py-1.5 transition-colors"
                        :class="
                          n.data.uiCharacterDesign
                            ? 'bg-white/[0.10] text-gray-100'
                            : 'text-gray-500 hover:bg-white/[0.05] hover:text-gray-300'
                        "
                        title="角色设计图：先经角色设计师扩写提示词，再按本节点底栏所选图片模型出图（如 Seedream / GPT-Image 等）"
                        @click.stop="$set(n.data, 'uiCharacterDesign', !n.data.uiCharacterDesign)"
                      >
                        <i class="fas fa-user text-[11px] opacity-90"></i>
                        <span class="text-[9px] leading-none">角色</span>
                      </button>
                    </div>
                    <div
                      v-if="upstreamVisualThumbRefsForNode(n).length"
                      class="ngc-upstream-thumb-scroll flex-1 min-w-0 overflow-x-auto overflow-y-hidden scrollbar-thin"
                      @mousedown.stop
                      @wheel.prevent="onUpstreamThumbStripWheel"
                    >
                      <div class="flex flex-nowrap items-center gap-1.5 w-max py-0.5 pr-0.5">
                      <button
                        v-for="ref in upstreamVisualThumbRefsForNode(n)"
                        :key="ref.key"
                        type="button"
                        class="relative shrink-0 w-10 h-10 rounded-lg overflow-hidden border border-white/15 bg-[#1a1a22] shadow-sm hover:border-sky-400/40 hover:ring-1 hover:ring-sky-500/25 transition-colors"
                        :title="
                          ref.title +
                          ' · 点击预览 · Alt+点击定位上游 · 右键删除引用'
                        "
                        @click.stop="onUpstreamThumbClick(n, ref, $event)"
                        @contextmenu.prevent.stop="onUpstreamThumbContextMenu(n, ref, $event)"
                      >
                        <img
                          v-if="ref.kind === 'image' && ref.url && !isUpstreamThumbBad(n, ref)"
                          :src="ref.url"
                          alt=""
                          draggable="false"
                          class="w-full h-full object-cover select-none"
                          @dragstart.prevent
                          @error="markUpstreamThumbBad(n, ref)"
                        />
                        <div
                          v-else-if="ref.kind === 'image'"
                          class="w-full h-full flex items-center justify-center bg-black/35 text-gray-500"
                        >
                          <i class="far fa-image text-xs"></i>
                        </div>
                        <div
                          v-else-if="ref.kind === 'audio'"
                          class="w-full h-full flex flex-col items-center justify-center bg-cyan-950/40 text-cyan-100/90"
                        >
                          <i class="fas fa-music text-[12px]"></i>
                        </div>
                        <div
                          v-else
                          class="w-full h-full flex flex-col items-center justify-center px-1 bg-violet-950/50 text-[8px] text-violet-100/90 leading-tight text-center line-clamp-2"
                        >
                          <i class="fas fa-align-left text-[10px] mb-0.5 opacity-80"></i>
                          <span class="truncate w-full">{{ ref.snippet }}</span>
                        </div>
                        <span
                          class="absolute top-0.5 right-0.5 min-w-[14px] h-[14px] px-0.5 flex items-center justify-center rounded-full bg-white text-[8px] font-bold text-gray-900 shadow-sm leading-none"
                        >
                          {{ ref.badge }}
                        </span>
                      </button>
                      </div>
                    </div>
                    <button
                      type="button"
                      class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-white/10 text-gray-400 hover:bg-white/[0.06] hover:text-gray-200"
                      title="展开：提示区更高并带滚动；收起：节省画布高度"
                      @click.stop="toggleImagePanelExpand(n)"
                    >
                      <i class="fas fa-expand-alt text-[11px]"></i>
                    </button>
                  </div>
                  <div class="relative overflow-visible min-w-0 max-w-full">
                    <div
                      v-prompt-chips-editor="n"
                      :data-prompt-node-id="n.id"
                      data-prompt-editor
                      contenteditable="true"
                      spellcheck="false"
                      role="textbox"
                      aria-multiline="true"
                      :data-placeholder="'描述你想要生成的画面内容，按/呼出指令，@引用素材'"
                      :class="[
                        'ngc-prompt-ed relative w-full rounded-lg border border-white/10 bg-[#09090d] px-2.5 py-2 text-[11px] leading-relaxed text-gray-200 outline-none overflow-y-auto whitespace-pre-wrap break-words',
                        n.data.panelExpanded
                          ? 'min-h-[104px] max-h-[min(52vh,420px)]'
                          : 'min-h-[72px] max-h-[176px]'
                      ]"
                      @mousedown.stop
                      @input="onPromptEditorInput(n, $event)"
                      @compositionend="onPromptCompositionEnd(n, $event)"
                      @keydown="onNodePromptKeydown(n, $event)"
                      @focus="onPromptFocus(n)"
                      @blur="onPromptBlur(n)"
                      @paste="onPromptEditorPaste(n, $event)"
                    ></div>
                    <div
                      v-if="assetMention && assetMention.nodeId === n.id"
                      class="ngc-asset-mention absolute z-[50] max-h-[220px] overflow-y-auto rounded-lg border border-white/15 bg-[#1a1a22] py-1 shadow-xl"
                      :style="assetMentionMenuStyle(n)"
                      @mousedown.prevent.stop="cancelCloseAssetMentionTimer"
                      @wheel="onNgAssetMentionWheel"
                    >
                      <p
                        v-if="!assetMentionFilteredRefs(n).length"
                        class="px-2.5 py-2 text-[10px] text-gray-500"
                      >
                        {{ upstreamVisualThumbRefsForNode(n).length ? '无匹配素材' : '暂无可引用上游素材' }}
                      </p>
                      <button
                        v-for="(ref, idx) in assetMentionFilteredRefs(n)"
                        :key="'am-' + ref.key"
                        type="button"
                        class="flex w-full items-center gap-2 px-2 py-1.5 text-left text-[10px] transition-colors"
                        :class="
                          idx === assetMention.highlightIndex
                            ? 'bg-sky-500/15 text-gray-100'
                            : 'text-gray-200 hover:bg-white/[0.06]'
                        "
                        @mousedown.prevent
                        @click="applyAssetMentionPick(n, ref)"
                      >
                        <span
                          class="flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded border border-white/10 bg-[#0f0f12]"
                        >
                          <img
                            v-if="ref.kind === 'image' && ref.url && !isUpstreamThumbBad(n, ref)"
                            :src="ref.url"
                            alt=""
                            draggable="false"
                            class="h-full w-full object-cover select-none"
                            @dragstart.prevent
                            @error="markUpstreamThumbBad(n, ref)"
                          />
                          <i
                            v-else-if="ref.kind === 'image'"
                            class="far fa-image text-[11px] text-gray-500"
                          ></i>
                          <i
                            v-else-if="ref.kind === 'audio'"
                            class="fas fa-music text-[11px] text-cyan-200/90"
                          ></i>
                          <i v-else class="fas fa-align-left text-[10px] text-violet-200/90"></i>
                        </span>
                        <span class="min-w-0 flex-1 truncate font-medium"
                          >{{ assetRefKindLabel(ref) }} {{ ref.badge }}</span
                        >
                        <span class="shrink-0 tabular-nums text-[9px] text-gray-500"
                          >(@{{ ref.badge }})</span
                        >
                      </button>
                    </div>
                  </div>
                  <template
                    v-if="gptInpaintCapableSeedreamModels.includes(String(n.data.seedreamModel || '').trim())"
                  >
                    <input
                      :id="'ngc-inpaint-mask-' + n.id"
                      type="file"
                      accept="image/png,image/webp,.png"
                      class="hidden"
                      @change="onImageNodeInpaintMaskFile(n, $event)"
                    />
                    <div
                      v-if="String(n.data.inpaintMaskUrl || '').trim()"
                      class="rounded-lg border border-violet-500/25 bg-violet-950/20 px-2 py-1.5 space-y-1.5"
                      @mousedown.stop
                    >
                      <p class="text-[9px] text-gray-400 leading-snug">
                        <span class="text-violet-200/90 font-medium">局部重绘</span>
                        可选上传蒙版：须为带
                        <span class="text-amber-200/85">Alpha</span>
                        的 PNG（透明=重绘区），并与
                        <span class="text-amber-200/85">首张参考原图</span>
                        同尺寸；请先接上游图片或选风格参考作为底图。
                      </p>
                      <div class="flex flex-wrap items-center gap-1.5">
                        <label
                          :for="'ngc-inpaint-mask-' + n.id"
                          class="inline-flex cursor-pointer items-center gap-1 rounded-lg border border-violet-400/30 bg-violet-600/10 px-2 py-1 text-[10px] text-violet-100/90 hover:bg-violet-600/18"
                        >
                          <i class="fas fa-paint-brush text-[10px]"></i>
                          上传蒙版
                        </label>
                        <img
                          :src="n.data.inpaintMaskUrl"
                          alt=""
                          draggable="false"
                          class="h-8 w-8 shrink-0 rounded object-cover border border-white/15 bg-black/40"
                        />
                        <button
                          type="button"
                          class="text-[9px] text-gray-400 hover:text-rose-300 px-1"
                          title="清除蒙版"
                          @click.stop="$set(n.data, 'inpaintMaskUrl', '')"
                        >
                          清除
                        </button>
                      </div>
                    </div>
                  </template>
                  <div class="relative border-t border-white/[0.06] pt-1">
                    <div class="ngc-image-gen-bar flex flex-nowrap items-center gap-1 min-w-0">
                      <div class="min-w-0 flex-1 shrink" @mousedown.stop>
                        <button
                          type="button"
                          class="flex h-8 w-full min-w-0 items-center justify-center gap-1 rounded-lg border border-white/10 bg-[#16161c] px-1.5 text-[10px] text-gray-300 outline-none hover:bg-white/[0.05]"
                          :class="
                            imageModelPickerNodeId === n.id
                              ? 'border-sky-500/50 ring-1 ring-sky-500/25'
                              : ''
                          "
                          title="出图模型"
                          @click.stop="toggleImageModelPicker(n)"
                        >
                          <i
                            class="fas fa-microchip shrink-0 text-[9px] text-violet-300/90 opacity-90"
                          ></i>
                          <span class="min-w-0 flex-1 truncate text-left">{{
                            imageNodeModelTriggerLabel(n)
                          }}</span>
                          <i
                            class="fas shrink-0 text-[8px] opacity-70"
                            :class="
                              imageModelPickerNodeId === n.id ? 'fa-chevron-up' : 'fa-chevron-down'
                            "
                          ></i>
                        </button>
                      </div>
                      <div class="relative shrink-0" @mousedown.stop>
                        <button
                          type="button"
                          class="flex h-8 w-[92px] max-w-[92px] items-center justify-center gap-1 rounded-lg border border-white/10 bg-[#16161c] px-1.5 text-[10px] text-gray-300 outline-none hover:bg-white/[0.05]"
                          :class="
                            imageAspectPickerNodeId === n.id
                              ? 'border-sky-500/50 ring-1 ring-sky-500/25'
                              : ''
                          "
                          title="分辨率与比例"
                          @click.stop="toggleImageAspectPicker(n)"
                        >
                          <span
                            class="shrink-0 rounded-sm border border-white/35 bg-white/[0.06]"
                            :style="ngcImageRatioFrameStyle(imageNodeAspectParts(n).ratioSlug)"
                          ></span>
                          <span class="min-w-0 flex-1 truncate text-left">{{
                            imageNodeAspectTriggerLabel(n)
                          }}</span>
                          <i
                            class="fas shrink-0 text-[8px] opacity-70"
                            :class="imageAspectPickerNodeId === n.id ? 'fa-chevron-up' : 'fa-chevron-down'"
                          ></i>
                        </button>
                      </div>
                      <NgcNodeSelect
                        :value="n.data.imageCount"
                        :options="imageCountDropdownOptions()"
                        size="narrow"
                        number-value
                        class="shrink-0"
                        @input="v => $set(n.data, 'imageCount', v)"
                      />
                      <span
                        class="flex shrink-0 items-center gap-0.5 whitespace-nowrap px-0.5 text-[10px] tabular-nums text-amber-200/90"
                      >
                        <i class="fas fa-bolt text-amber-400 text-[9px]"></i>
                        {{ ngcFormatCatalogCredits(imageNodeCreditHint(n)) }}
                      </span>
                      <button
                        type="button"
                        class="ngc-node-run-btn"
                        :class="{ 'ngc-node-run-btn--wide': imageNodeHasGeneratedOutput(n) }"
                        :disabled="isNodeRunning(n.id)"
                        :title="imageNodeHasGeneratedOutput(n) ? '重新生成（将覆盖当前图片）' : '生成图片'"
                        @click.stop="onImageNodeGenerateClick(n)"
                      >
                        <template v-if="imageNodeHasGeneratedOutput(n)">
                          <i class="fas fa-redo ngc-node-run-btn__icon ngc-node-run-btn__icon--sm" aria-hidden="true"></i>
                          <span class="ngc-node-run-btn__text">重新生成</span>
                        </template>
                        <i v-else class="fas fa-arrow-up ngc-node-run-btn__icon" aria-hidden="true"></i>
                      </button>
                    </div>
                    <div
                      v-show="imageModelPickerNodeId === n.id"
                      class="ngc-inline-model-picker ngc-inline-model-picker--node-anchor"
                      @mousedown.stop
                    >
                      <div class="ngc-inline-model-picker__head">
                        <span class="ngc-inline-model-picker__title">出图模型</span>
                        <button
                          type="button"
                          class="ngc-inline-model-picker__close"
                          title="关闭"
                          @click="closeImageModelPickerModal"
                        >
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                      <div class="ngc-inline-model-picker__list">
                        <button
                          v-for="im in imageModelOptions"
                          :key="'imrow-' + n.id + '-' + (im.id || '_')"
                          type="button"
                          class="ngc-inline-model-picker__item"
                          :class="
                            String(n.data.seedreamModel || '').trim() ===
                            String(im.id != null ? im.id : '').trim()
                              ? 'ngc-inline-model-picker__item--active'
                              : ''
                          "
                          @click.stop="setImageNodeSeedreamModel(n, im.id)"
                        >
                          <span
                            class="ngc-inline-model-picker__icon"
                          >
                            <i class="fas fa-image text-[9px] text-violet-200/85"></i>
                          </span>
                          <span class="min-w-0 flex-1">
                            <span class="block">{{ im.label }}</span>
                            <span
                              v-if="ngcModelOptionCreditsLine(im, 'image')"
                              class="block text-[9px] text-amber-200/65 font-normal"
                              >{{ ngcModelOptionCreditsLine(im, 'image') }}</span
                            >
                          </span>
                        </button>
                      </div>
                    </div>
                    <div
                      v-show="imageAspectPickerNodeId === n.id"
                      class="ngc-image-aspect-picker ngc-inline-model-picker--node-anchor"
                      @mousedown.stop
                    >
                      <div class="ngc-inline-model-picker__head">
                        <span class="ngc-inline-model-picker__title">分辨率与比例</span>
                        <button
                          type="button"
                          class="ngc-inline-model-picker__close"
                          title="关闭"
                          @click="closeImageAspectPickerModal"
                        >
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                      <p class="mb-1.5 text-[9px] font-medium text-gray-500">分辨率</p>
                      <div class="flex gap-1.5 mb-2.5">
                        <button
                          v-for="t in ngcImageResolutionTiers"
                          :key="'irt-' + n.id + '-' + t.id"
                          type="button"
                          class="flex-1 rounded-lg border py-1.5 text-[10px] transition-colors"
                          :class="
                            imageNodeAspectParts(n).tier === t.id
                              ? 'border-white/50 bg-white/[0.12] text-gray-100'
                              : 'border-white/10 bg-[#141418] text-gray-400 hover:border-white/20'
                          "
                          @click.stop="setImageNodeAspectTier(n, t.id)"
                        >
                          {{ t.label }}
                        </button>
                      </div>
                      <p class="mb-1.5 text-[9px] font-medium text-gray-500">比例</p>
                      <div class="space-y-1.5">
                        <div
                          v-for="(row, ri) in ngcImageAspectRatioGrid"
                          :key="'irr-' + n.id + '-' + ri"
                          class="flex flex-wrap gap-1"
                        >
                          <button
                            v-for="slug in row"
                            :key="'irs-' + n.id + '-' + slug"
                            type="button"
                            class="flex min-w-[46px] flex-1 flex-col items-center gap-0.5 rounded-lg border px-1 py-1.5 text-[9px] transition-colors"
                            :class="
                              imageNodeAspectParts(n).ratioSlug === slug
                                ? 'ngc-inline-model-picker__item--active'
                                : ''
                            "
                            @click.stop="setImageNodeAspectRatio(n, slug)"
                          >
                            <span
                              class="rounded-sm border border-white/35 bg-white/[0.06]"
                              :style="ngcImageRatioFrameStyle(slug)"
                            ></span>
                            <span class="leading-none">{{ ngcImageRatioButtonLabel(slug) }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  </template>
                </div>
                </div>
              </template>
              <template v-else-if="n.type === 'video'">
               <!-- <div
                  class="shrink-0 flex items-center justify-between gap-1 px-1 py-1 rounded-lg bg-[#0f0f12] border border-white/[0.07] text-[9px] text-gray-500"
                  @mousedown.stop
                >
                  <div class="flex items-center gap-0.5 flex-wrap">
                    <button
                      type="button"
                      class="p-1.5 rounded-md hover:bg-white/[0.06] text-gray-400 hover:text-gray-200"
                      title="剪辑（示意）"
                      @click.stop
                    >
                      <i class="fas fa-cut"></i><span class="ml-0.5">剪辑</span>
                    </button>
                    <button
                      type="button"
                      class="p-1.5 rounded-md hover:bg-white/[0.06]"
                      :class="n.data.uiHd ? 'text-amber-200' : 'text-gray-400'"
                      title="高清"
                      @click.stop="$set(n.data, 'uiHd', !n.data.uiHd)"
                    >
                      HD<span class="opacity-70"> 高清</span>
                    </button>
                    <span class="px-1 text-gray-600">解析</span>
                    <button type="button" class="p-1.5 rounded-md hover:bg-white/[0.06] text-gray-400" title="人声分离" @click.stop>
                      <i class="fas fa-user"></i><i class="fas fa-music text-[8px] ml-0.5"></i>
                    </button>
                    <button type="button" class="p-1.5 rounded-md hover:bg-white/[0.06] text-gray-400" title="分离音视频" @click.stop>
                      <i class="fas fa-photo-video text-[10px]"></i>
                    </button>
                  </div>
                  <div class="flex items-center gap-0.5 shrink-0">
                    <button
                      type="button"
                      class="p-1.5 rounded-md text-gray-500 hover:text-gray-300 disabled:opacity-40"
                      :disabled="!String(n.data.videoUrl || '').trim()"
                      title="下载本节点视频"
                      @click.stop="downloadVideoNodeOutput(n)"
                    >
                      <i class="fas fa-download"></i>
                    </button>
                    <button type="button" class="p-1.5 rounded-md text-gray-500 hover:text-gray-300" title="全屏" @click.stop>
                      <i class="fas fa-expand"></i>
                    </button>
                  </div>
                </div> -->
                <div
                  v-if="n.data.referenceImageUrl"
                  class="shrink-0 flex items-center gap-2 rounded-lg border border-amber-500/25 bg-amber-950/20 px-1.5 py-1"
                  @mousedown.stop
                >
                  <img
                    :src="n.data.referenceImageUrl"
                    alt=""
                    draggable="false"
                    class="h-9 w-14 shrink-0 rounded object-cover border border-white/10"
                  />
                  <span class="min-w-0 flex-1 text-[8px] leading-snug text-gray-500">图生视频参考图（含导演台同步）</span>
                  <button
                    type="button"
                    class="shrink-0 rounded px-1.5 py-0.5 text-[8px] text-gray-400 hover:bg-white/[0.06] hover:text-rose-200"
                    title="清除参考图"
                    @click.stop="$set(n.data, 'referenceImageUrl', '')"
                  >
                    清除
                  </button>
                </div>
                <div
                  class="relative shrink-0 min-h-[140px] max-h-[min(44vh,400px)] rounded-xl bg-black border border-white/[0.08] overflow-hidden flex items-center justify-center"
                  @mousedown.stop
                >
                  <video
                    v-if="n.data.videoUrl"
                    :src="n.data.videoUrl"
                    controls
                    playsinline
                    class="w-full max-w-full max-h-[min(44vh,400px)] object-contain bg-black"
                  />
                  <div v-else class="flex flex-col items-center justify-center py-10 text-gray-600">
                    <i class="fas fa-film text-4xl mb-2 opacity-50"></i>
                    <span class="text-[10px]">生成后在此预览</span>
                  </div>
                  <span
                    class="absolute top-2 right-2 text-[9px] tabular-nums px-1.5 py-0.5 rounded bg-black/70 text-gray-300 border border-white/10"
                  >
                    {{ videoPreviewResolutionLabel(n) }}
                  </span>
                </div>
                <div
                  class="rounded-xl border border-white/[0.08] bg-[#111116] p-2 space-y-2 shrink-0 mt-auto shadow-[inset_0_1px_0_rgba(255,255,255,0.04)]"
                  @mousedown.stop
                >
                  <div class="flex gap-0.5 overflow-x-auto pb-0.5 -mx-0.5 px-0.5 scrollbar-thin">
                    <button
                      v-for="tab in videoModeTabs"
                      :key="tab.key"
                      type="button"
                      class="shrink-0 px-2 py-1 rounded-lg text-[10px] whitespace-nowrap transition-colors border"
                      :class="
                        (n.data.videoMode || 'ref') === tab.key
                          ? 'border-amber-500/40 bg-amber-600/15 text-amber-100'
                          : 'border-transparent text-gray-500 hover:text-gray-300 hover:bg-white/[0.04]'
                      "
                      @click.stop="$set(n.data, 'videoMode', tab.key)"
                    >
                      {{ tab.label }}
                    </button>
                  </div>
                  <div class="flex items-center gap-2 min-w-0">
                    <div class="flex gap-1 shrink-0">
                      <!-- 标记、运镜：功能暂未开放
                      <button type="button" ...>标记</button>
                      <button type="button" ...>运镜</button>
                      -->
                      <button
                        type="button"
                        class="flex flex-col items-center gap-0.5 rounded-lg border px-2 py-1 min-w-[40px] transition-colors border-white/10 bg-[#16161c] text-gray-400 hover:border-amber-500/35 hover:text-gray-200"
                        title="从角色库选择角色并连至本节点"
                        @click.stop="openNgcCharacterLibrary(n, $event)"
                      >
                        <i class="fas fa-users text-[10px]"></i>
                        <span class="text-[8px]">角色库</span>
                      </button>
                    </div>
                    <div
                      v-if="upstreamVisualThumbRefsForNode(n).length"
                      class="ngc-upstream-thumb-scroll flex-1 min-w-0 overflow-x-auto overflow-y-hidden scrollbar-thin"
                      @mousedown.stop
                      @wheel.prevent="onUpstreamThumbStripWheel"
                    >
                      <div class="flex flex-nowrap items-center gap-1.5 w-max py-0.5 pr-0.5">
                      <button
                        v-for="ref in upstreamVisualThumbRefsForNode(n)"
                        :key="'v-' + ref.key"
                        type="button"
                        class="relative shrink-0 w-9 h-9 rounded-lg overflow-hidden border border-white/15 bg-[#1a1a22] hover:border-amber-400/35 transition-colors"
                        :title="
                          ref.title +
                          ' · 点击预览 · Alt+点击定位上游 · 右键删除引用'
                        "
                        @click.stop="onUpstreamThumbClick(n, ref, $event)"
                        @contextmenu.prevent.stop="onUpstreamThumbContextMenu(n, ref, $event)"
                      >
                        <img
                          v-if="ref.kind === 'image' && ref.url && !isUpstreamThumbBad(n, ref)"
                          :src="ref.url"
                          alt=""
                          draggable="false"
                          class="w-full h-full object-cover select-none"
                          @dragstart.prevent
                          @error="markUpstreamThumbBad(n, ref)"
                        />
                        <div
                          v-else-if="ref.kind === 'image'"
                          class="w-full h-full flex items-center justify-center text-gray-500"
                        >
                          <i class="far fa-image text-[10px]"></i>
                        </div>
                        <div
                          v-else-if="ref.kind === 'audio'"
                          class="w-full h-full flex items-center justify-center bg-cyan-950/35 text-cyan-100/90"
                        >
                          <i class="fas fa-music text-[11px]"></i>
                        </div>
                        <div
                          v-else
                          class="w-full h-full flex flex-col items-center justify-center px-0.5 bg-violet-950/40 text-[6px] text-violet-100/90 text-center leading-tight"
                        >
                          <i class="fas fa-align-left text-[7px] shrink-0 mb-px"></i>
                          <span class="line-clamp-2 w-full break-all">{{ ref.snippet }}</span>
                        </div>
                        <span
                          class="absolute top-0 right-0 min-w-[13px] h-[13px] flex items-center justify-center rounded-bl bg-white text-[7px] font-bold text-gray-900"
                        >
                          {{ ref.badge }}
                        </span>
                      </button>
                      </div>
                    </div>
                  </div>
                  <div class="relative overflow-visible" @mousedown.stop>
                    <div
                      v-prompt-chips-editor="n"
                      :data-prompt-node-id="n.id"
                      data-prompt-editor
                      contenteditable="true"
                      spellcheck="false"
                      role="textbox"
                      aria-multiline="true"
                      :data-placeholder="'描述镜头、节奏与对白；可写「[图片1]」「[音频2]」等引用（与上方素材序号对应）。按/呼出指令，@引用素材。'"
                      :class="[
                        'ngc-prompt-ed relative w-full rounded-lg border border-white/10 bg-[#09090d] px-2.5 py-2 text-[11px] font-normal leading-relaxed text-gray-200 outline-none overflow-y-auto whitespace-pre-wrap break-words',
                        n.data.panelExpanded
                          ? 'min-h-[120px] max-h-[min(58vh,480px)]'
                          : 'min-h-[88px] max-h-[200px]'
                      ]"
                      @mousedown.stop
                      @input="onPromptEditorInput(n, $event)"
                      @compositionend="onPromptCompositionEnd(n, $event)"
                      @keydown="onNodePromptKeydown(n, $event)"
                      @focus="onPromptFocus(n)"
                      @blur="onPromptBlur(n)"
                      @paste="onPromptEditorPaste(n, $event)"
                    ></div>
                    <div
                      v-if="assetMention && assetMention.nodeId === n.id"
                      class="ngc-asset-mention absolute z-[50] max-h-[220px] overflow-y-auto rounded-lg border border-white/15 bg-[#1a1a22] py-1 shadow-xl"
                      :style="assetMentionMenuStyle(n)"
                      @mousedown.prevent.stop="cancelCloseAssetMentionTimer"
                      @wheel="onNgAssetMentionWheel"
                    >
                      <p
                        v-if="!assetMentionFilteredRefs(n).length"
                        class="px-2.5 py-2 text-[10px] text-gray-500"
                      >
                        {{ upstreamVisualThumbRefsForNode(n).length ? '无匹配素材' : '暂无可引用上游素材' }}
                      </p>
                      <button
                        v-for="(ref, idx) in assetMentionFilteredRefs(n)"
                        :key="'vm-' + ref.key"
                        type="button"
                        class="flex w-full items-center gap-2 px-2 py-1.5 text-left text-[10px] transition-colors"
                        :class="
                          idx === assetMention.highlightIndex
                            ? 'bg-amber-500/15 text-gray-100'
                            : 'text-gray-200 hover:bg-white/[0.06]'
                        "
                        @mousedown.prevent
                        @click="applyAssetMentionPick(n, ref)"
                      >
                        <span
                          class="flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded border border-white/10 bg-[#0f0f12]"
                        >
                          <img
                            v-if="ref.kind === 'image' && ref.url && !isUpstreamThumbBad(n, ref)"
                            :src="ref.url"
                            alt=""
                            draggable="false"
                            class="h-full w-full object-cover select-none"
                            @dragstart.prevent
                            @error="markUpstreamThumbBad(n, ref)"
                          />
                          <i
                            v-else-if="ref.kind === 'image'"
                            class="far fa-image text-[11px] text-gray-500"
                          ></i>
                          <i
                            v-else-if="ref.kind === 'audio'"
                            class="fas fa-music text-[11px] text-cyan-200/90"
                          ></i>
                          <i v-else class="fas fa-align-left text-[10px] text-violet-200/90"></i>
                        </span>
                        <span class="min-w-0 flex-1 truncate font-medium"
                          >{{ assetRefKindLabel(ref) }} {{ ref.badge }}</span
                        >
                        <span class="shrink-0 tabular-nums text-[9px] text-gray-500"
                          >(@{{ ref.badge }})</span
                        >
                      </button>
                    </div>
                  </div>
                  <div class="relative flex items-center justify-between gap-1.5 flex-wrap pt-1 border-t border-white/[0.06]">
                    <div class="min-w-0 max-w-[130px] flex-1" @mousedown.stop>
                      <button
                        type="button"
                        class="flex h-8 w-full min-w-0 items-center justify-center gap-1 rounded-lg border border-white/10 bg-[#16161c] px-1 text-[10px] text-gray-300 outline-none hover:bg-white/[0.05]"
                        :class="
                          videoModelPickerNodeId === n.id
                            ? 'border-sky-500/50 ring-1 ring-sky-500/25'
                            : ''
                        "
                        title="视频生成模型"
                        @click.stop="toggleVideoModelPicker(n)"
                      >
                        <i class="fas fa-video shrink-0 text-[9px] text-violet-300/90 opacity-90"></i>
                        <span class="min-w-0 flex-1 truncate text-left">{{
                          videoNodeModelTriggerLabel(n)
                        }}</span>
                        <i
                          class="fas shrink-0 text-[8px] opacity-70"
                          :class="
                            videoModelPickerNodeId === n.id ? 'fa-chevron-up' : 'fa-chevron-down'
                          "
                        ></i>
                      </button>
                    </div>
                    <div
                      class="relative ngc-video-spec-popover flex-1 min-w-[min(100%,168px)] max-w-[220px]"
                      @mousedown.stop
                    >
                      <button
                        type="button"
                        class="flex h-8 w-full items-center justify-between gap-1 rounded-lg border border-white/10 bg-[#16161c] px-2 text-[10px] text-gray-200 hover:border-white/16 hover:bg-[#1a1a22]"
                        @click.stop="toggleVideoSpecPanel(n)"
                      >
                        <span class="flex min-w-0 flex-1 items-center gap-1.5 truncate tabular-nums">
                          <span
                            class="shrink-0 rounded-sm border border-white/30 bg-white/[0.06]"
                            :style="ngcVideoRatioMiniStyle(effectiveVideoRatio(n))"
                          ></span>
                          <span class="truncate">{{ videoSpecSummaryRatioText(n) }}</span>
                          <span class="text-gray-600">·</span>
                          <span>{{ videoSpecResolutionUi(n) }}</span>
                          <span class="text-gray-600">·</span>
                          <span>{{ Math.min(15, Math.max(1, Number(n.data.duration) || 5)) }}s</span>
                          <span class="text-gray-600">·</span>
                          <i
                            class="text-[9px]"
                            :class="
                              n.data.seedanceGenerateAudio
                                ? 'fas fa-volume-up text-sky-300/90'
                                : 'fas fa-volume-mute text-gray-600'
                            "
                          ></i>
                        </span>
                        <i
                          class="fas shrink-0 text-[9px] text-gray-500"
                          :class="videoSpecPanelNodeId === n.id ? 'fa-chevron-up' : 'fa-chevron-down'"
                        ></i>
                      </button>
                      <div
                        v-if="videoSpecPanelNodeId === n.id"
                        class="absolute bottom-full left-0 right-0 z-[70] mb-1 max-h-[min(72vh,520px)] overflow-y-auto rounded-xl border border-white/12 bg-[#14141a] p-2.5 shadow-2xl"
                        @mousedown.stop
                      >
                        <p class="mb-1.5 text-[9px] font-medium text-gray-500">比例</p>
                        <div class="space-y-1.5">
                          <div
                            v-for="(row, ri) in videoSpecRatioGrid"
                            :key="'vr-' + n.id + '-' + ri"
                            class="flex flex-wrap gap-1"
                          >
                            <button
                              v-for="slug in row"
                              :key="'vrs-' + n.id + '-' + slug"
                              type="button"
                              class="flex min-w-[44px] flex-1 flex-col items-center gap-0.5 rounded-lg border px-1 py-1.5 text-[9px] transition-colors"
                              :class="
                                effectiveVideoRatio(n) === slug
                                  ? 'border-white/45 bg-white/[0.08] text-gray-100'
                                  : 'border-white/10 bg-[#0f0f12] text-gray-400 hover:border-white/18'
                              "
                              @click.stop="setVideoNodeRatio(n, slug)"
                            >
                              <span
                                class="rounded-sm border border-white/35 bg-white/[0.06]"
                                :style="ngcVideoRatioMiniStyle(slug)"
                              ></span>
                              <span class="leading-none">{{ videoSpecRatioButtonLabel(slug) }}</span>
                            </button>
                          </div>
                        </div>
                        <p class="mb-1 mt-2.5 text-[9px] font-medium text-gray-500">清晰度</p>
                        <div class="flex gap-1">
                          <button
                            v-for="rv in ngcVideoResolutionOptions"
                            :key="'vres-' + n.id + '-' + rv"
                            type="button"
                            class="flex-1 rounded-lg border py-1.5 text-[10px] font-medium tabular-nums transition-colors"
                            :class="
                              String(n.data.resolution || '720p').toLowerCase() === rv
                                ? 'border-white/45 bg-white/[0.08] text-gray-100'
                                : 'border-white/10 bg-[#0f0f12] text-gray-400 hover:border-white/18'
                            "
                            @click.stop="onVideoResolutionPick(n, rv)"
                          >
                            {{ rv === '480p' ? '480P' : rv === '1080p' ? '1080P' : '720P' }}
                          </button>
                        </div>
                        <p class="mb-1 mt-2.5 text-[9px] font-medium text-gray-500">视频时长</p>
                        <div class="flex items-center gap-2">
                          <input
                            type="range"
                            min="1"
                            max="15"
                            step="1"
                            class="ngc-video-duration-range h-1.5 flex-1 cursor-pointer accent-sky-500"
                            :value="Math.min(15, Math.max(1, Number(n.data.duration) || 5))"
                            @input="onVideoDurationInput(n, $event)"
                          />
                          <span class="w-8 shrink-0 text-right text-[10px] tabular-nums text-gray-200"
                            >{{ Math.min(15, Math.max(1, Number(n.data.duration) || 5)) }}s</span
                          >
                        </div>
                        <div class="mt-2.5 border-t border-white/[0.06] pt-2">
                          <p class="mb-1 flex items-center gap-1 text-[9px] font-medium text-gray-500">
                            生成音频
                            <i
                              class="far fa-question-circle cursor-help text-gray-600"
                              title="偏好项：随项目保存。当前 Seedance 创建任务未单独传该开关，后续可对齐上游。"
                            ></i>
                          </p>
                          <div class="grid grid-cols-2 gap-1">
                            <button
                              type="button"
                              class="rounded-lg border py-1.5 text-[10px] transition-colors"
                              :class="
                                n.data.seedanceGenerateAudio
                                  ? 'border-white/45 bg-white/[0.08] text-gray-100'
                                  : 'border-white/10 bg-[#0f0f12] text-gray-400 hover:border-white/18'
                              "
                              @click.stop="$set(n.data, 'seedanceGenerateAudio', true)"
                            >
                              开启
                            </button>
                            <button
                              type="button"
                              class="rounded-lg border py-1.5 text-[10px] transition-colors"
                              :class="
                                !n.data.seedanceGenerateAudio
                                  ? 'border-white/45 bg-white/[0.08] text-gray-100'
                                  : 'border-white/10 bg-[#0f0f12] text-gray-400 hover:border-white/18'
                              "
                              @click.stop="$set(n.data, 'seedanceGenerateAudio', false)"
                            >
                              关闭
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <span class="text-[10px] text-gray-500 tabular-nums">1个</span>
                    <span class="flex items-center gap-0.5 text-[10px] tabular-nums text-amber-200/90">
                      <i class="fas fa-bolt text-amber-400 text-[9px]"></i>
                      {{ ngcFormatCatalogCredits(videoNodeCreditHint(n)) }}
                    </span>
                    <button
                      type="button"
                      class="ngc-node-run-btn"
                      :disabled="isNodeRunning(n.id)"
                      title="生成视频"
                      @click.stop="runSingleVideoNode(n)"
                    >
                      <i class="fas fa-arrow-up ngc-node-run-btn__icon" aria-hidden="true"></i>
                    </button>
                    <button
                      type="button"
                      class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-white/10 text-gray-400 hover:bg-white/[0.06]"
                      title="展开：提示区更高并带滚动；收起：节省画布高度"
                      @click.stop="toggleVideoPanelExpand(n)"
                    >
                      <i class="fas fa-expand-alt text-[11px]"></i>
                    </button>
                    <div
                      v-show="videoModelPickerNodeId === n.id"
                      class="ngc-inline-model-picker ngc-inline-model-picker--node-anchor"
                      @mousedown.stop
                    >
                      <div class="ngc-inline-model-picker__head">
                        <span class="ngc-inline-model-picker__title">视频模型</span>
                        <button
                          type="button"
                          class="ngc-inline-model-picker__close"
                          title="关闭"
                          @click="closeVideoModelPickerModal"
                        >
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                      <div class="ngc-inline-model-picker__list">
                        <button
                          v-for="vm in videoModelOptions"
                          :key="'vmm-' + n.id + '-' + (vm.id || '_')"
                          type="button"
                          class="ngc-inline-model-picker__item"
                          :class="
                            String(n.data.seedanceModel || '').trim() ===
                            String(vm.id != null ? vm.id : '').trim()
                              ? 'ngc-inline-model-picker__item--active'
                              : ''
                          "
                          @click.stop="setVideoNodeSeedanceModel(n, vm.id)"
                        >
                          <span
                            class="ngc-inline-model-picker__icon"
                          >
                            <i class="fas fa-video text-[9px] text-violet-200/85"></i>
                          </span>
                          <span class="min-w-0 flex-1">
                            <span class="block">{{ vm.label }}</span>
                            <span
                              v-if="ngcModelOptionCreditsLine(vm, 'video')"
                              class="block text-[9px] text-amber-200/65 font-normal"
                              >{{ ngcModelOptionCreditsLine(vm, 'video') }}</span
                            >
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="n.type === 'audio'">
                <div class="space-y-1.5 shrink-0" @mousedown.stop>
                  <p class="px-0.5 text-[9px] font-medium tracking-wide text-gray-500">音频来源</p>
                  <div
                    class="grid grid-cols-2 gap-1 rounded-xl border border-white/[0.07] bg-[#0a0a0e] p-1 shadow-[inset_0_1px_0_rgba(255,255,255,0.03)]"
                  >
                    <button
                      type="button"
                      class="group flex items-center justify-center gap-1.5 rounded-lg px-2 py-2 transition-all duration-150"
                      :class="
                        String(n.data.audioInputMode || 'tts') === 'upload'
                          ? 'bg-white/[0.11] text-gray-50 shadow-[0_1px_0_rgba(255,255,255,0.08),inset_0_1px_0_rgba(255,255,255,0.06)] ring-1 ring-white/[0.14]'
                          : 'text-gray-500 hover:bg-white/[0.04] hover:text-gray-300'
                      "
                      @click.stop="setAudioInputMode(n, 'upload')"
                    >
                      <span
                        class="flex h-6 w-6 shrink-0 items-center justify-center rounded-md transition-colors"
                        :class="
                          String(n.data.audioInputMode || 'tts') === 'upload'
                            ? 'bg-white/[0.14]'
                            : 'bg-white/[0.05] group-hover:bg-white/[0.08]'
                        "
                      >
                        <i
                          class="fas fa-cloud-arrow-up text-[11px] text-white"
                          :class="
                            String(n.data.audioInputMode || 'tts') === 'upload'
                              ? 'opacity-100'
                              : 'opacity-50 group-hover:opacity-75'
                          "
                        ></i>
                      </span>
                      <span class="text-[10px] font-medium leading-none">上传音频</span>
                    </button>
                    <button
                      type="button"
                      class="group flex items-center justify-center gap-1.5 rounded-lg px-2 py-2 transition-all duration-150"
                      :class="
                        String(n.data.audioInputMode || 'tts') === 'tts'
                          ? 'bg-white/[0.11] text-gray-50 shadow-[0_1px_0_rgba(255,255,255,0.08),inset_0_1px_0_rgba(255,255,255,0.06)] ring-1 ring-white/[0.14]'
                          : 'text-gray-500 hover:bg-white/[0.04] hover:text-gray-300'
                      "
                      @click.stop="setAudioInputMode(n, 'tts')"
                    >
                      <span
                        class="flex h-6 w-6 shrink-0 items-center justify-center rounded-md transition-colors"
                        :class="
                          String(n.data.audioInputMode || 'tts') === 'tts'
                            ? 'bg-white/[0.14]'
                            : 'bg-white/[0.05] group-hover:bg-white/[0.08]'
                        "
                      >
                        <i
                          class="fas fa-wave-square text-[11px] text-white"
                          :class="
                            String(n.data.audioInputMode || 'tts') === 'tts'
                              ? 'opacity-100'
                              : 'opacity-50 group-hover:opacity-75'
                          "
                        ></i>
                      </span>
                      <span class="text-[10px] font-medium leading-none">文生音频</span>
                    </button>
                  </div>
                </div>
                <div
                  v-if="n.data.audioInputMode === 'upload'"
                  class="shrink-0 space-y-1.5 rounded-xl border border-white/[0.08] bg-[#111116] px-2 py-1.5"
                  @mousedown.stop
                >
                  <p class="text-[8px] leading-snug text-gray-500">
                    使用本机文件或上游音频作为本节点输出（不 TTS）。上传成功即写入下游可引用的输出。
                  </p>
                  <div class="flex flex-wrap items-center gap-1.5">
                    <input
                      :id="'ngc-audio-in-' + n.id"
                      type="file"
                      accept="audio/*"
                      class="hidden"
                      @change="onAudioNodeFile(n, $event)"
                    />
                    <label
                      :for="'ngc-audio-in-' + n.id"
                      class="inline-flex cursor-pointer items-center gap-1 rounded-lg border border-white/15 bg-white/[0.06] px-2 py-1.5 text-[10px] text-gray-200 hover:bg-white/[0.1]"
                    >
                      <i class="fas fa-upload text-[10px]"></i>
                      选择文件
                    </label>
                    <p
                      v-if="n.data.referenceAudioUrl"
                      class="flex-1 min-w-0 text-[9px] text-emerald-400/90 truncate"
                      :title="n.data.referenceAudioUrl"
                    >
                      已选文件
                    </p>
                  </div>
                  <audio
                    v-if="n.data.referenceAudioUrl || n.data.audioUrl"
                    :src="n.data.audioUrl || n.data.referenceAudioUrl"
                    controls
                    class="w-full h-8 rounded-lg border border-white/10 bg-black/40"
                    @mousedown.stop
                  />
                </div>
                <div
                  v-if="upstreamVisualThumbRefsForNode(n).length"
                  class="ngc-upstream-thumb-scroll shrink-0 max-w-full overflow-x-auto overflow-y-hidden py-1 scrollbar-thin"
                  @mousedown.stop
                  @wheel.prevent="onUpstreamThumbStripWheel"
                >
                  <div class="flex flex-nowrap items-center gap-1 w-max pr-0.5">
                  <button
                    v-for="ref in upstreamVisualThumbRefsForNode(n)"
                    :key="'ar-' + ref.key"
                    type="button"
                    class="relative h-8 w-8 shrink-0 rounded-lg border border-white/12 bg-[#1a1a22] overflow-hidden hover:border-cyan-400/35"
                    :title="
                      ref.title + ' · 点击预览 · Alt+点击定位上游 · 右键删除引用'
                    "
                    @click.stop="onUpstreamThumbClick(n, ref, $event)"
                    @contextmenu.prevent.stop="onUpstreamThumbContextMenu(n, ref, $event)"
                  >
                    <img
                      v-if="ref.kind === 'image' && ref.url && !isUpstreamThumbBad(n, ref)"
                      :src="ref.url"
                      alt=""
                      draggable="false"
                      class="h-full w-full object-cover select-none"
                      @dragstart.prevent
                      @error="markUpstreamThumbBad(n, ref)"
                    />
                    <div
                      v-else-if="ref.kind === 'image'"
                      class="flex h-full w-full items-center justify-center text-gray-500"
                    >
                      <i class="far fa-image text-[10px]"></i>
                    </div>
                    <div
                      v-else-if="ref.kind === 'audio'"
                      class="flex h-full w-full items-center justify-center bg-cyan-950/40 text-cyan-100"
                    >
                      <i class="fas fa-music text-[10px]"></i>
                    </div>
                    <div
                      v-else
                      class="flex h-full w-full flex-col items-center justify-center bg-violet-950/40 px-0.5 text-[6px] leading-tight text-violet-100"
                    >
                      <i class="fas fa-align-left text-[7px]"></i>
                    </div>
                    <span
                      class="absolute bottom-0 right-0 min-w-[12px] rounded-tl bg-white/95 px-0.5 text-[7px] font-bold text-gray-900"
                    >
                      {{ ref.badge }}
                    </span>
                  </button>
                  </div>
                </div>
                <div
                  v-if="n.data.audioInputMode === 'tts'"
                  class="rounded-xl border border-white/[0.08] bg-[#111116] p-2 pb-2.5 space-y-2 shrink-0 flex flex-col min-h-0"
                  @mousedown.stop
                >
                  <template
                    v-if="
                      n.data.model === 'volc-doubao-tts-2' ||
                      n.data.model === 'volc-doubao-tts-2-expressive' ||
                      n.data.model === 'volc-doubao-icl-2'
                    "
                  >
                    <div class="space-y-1.5 rounded-lg border border-white/[0.06] bg-[#0e0e12] px-2 py-1.5">
                      <label class="block text-[9px] text-gray-500">合成模式</label>
                      <NgcNodeSelect
                        :value="n.data.volcTtsExpressMode"
                        :options="volcTtsExpressDropdownOptions()"
                        size="md"
                        @input="v => $set(n.data, 'volcTtsExpressMode', v)"
                      />
                      <div class="space-y-1.5 rounded-lg border border-white/[0.05] bg-[#09090d]/80 px-2 py-1.5">
                        <div class="flex items-center justify-between gap-2">
                          <span class="text-[9px] text-gray-500">音调 / 语速 / 音量</span>
                          <button
                            type="button"
                            class="inline-flex items-center gap-0.5 rounded-md border border-white/10 px-1.5 py-0.5 text-[8px] text-gray-400 hover:bg-white/[0.06] hover:text-gray-200"
                            title="恢复默认"
                            @mousedown.stop
                            @click.stop="resetVolcAudioProsody(n)"
                          >
                            <i class="fas fa-undo text-[7px]"></i>
                            重置
                          </button>
                        </div>
                        <div class="space-y-1">
                          <div class="flex items-center gap-1.5">
                            <span class="w-7 shrink-0 text-[9px] text-gray-400">音调</span>
                            <span class="text-[8px] text-gray-600 shrink-0">低</span>
                            <input
                              v-model.number="n.data.volcAudioPitch"
                              type="range"
                              min="-10"
                              max="10"
                              step="1"
                              class="min-w-0 flex-1 h-1 accent-violet-500"
                              @mousedown.stop
                              @click.stop
                            />
                            <span class="text-[8px] text-gray-600 shrink-0">高</span>
                            <span class="w-5 shrink-0 text-right text-[9px] tabular-nums text-gray-300">{{ volcAudioBiasDisplay(n, 'volcAudioPitch') }}</span>
                          </div>
                          <div class="flex items-center gap-1.5">
                            <span class="w-7 shrink-0 text-[9px] text-gray-400">语速</span>
                            <span class="text-[8px] text-gray-600 shrink-0">低</span>
                            <input
                              v-model.number="n.data.volcAudioSpeed"
                              type="range"
                              min="-10"
                              max="10"
                              step="1"
                              class="min-w-0 flex-1 h-1 accent-violet-500"
                              @mousedown.stop
                              @click.stop
                            />
                            <span class="text-[8px] text-gray-600 shrink-0">高</span>
                            <span class="w-5 shrink-0 text-right text-[9px] tabular-nums text-gray-300">{{ volcAudioBiasDisplay(n, 'volcAudioSpeed') }}</span>
                          </div>
                          <div class="flex items-center gap-1.5">
                            <span class="w-7 shrink-0 text-[9px] text-gray-400">音量</span>
                            <span class="text-[8px] text-gray-600 shrink-0">低</span>
                            <input
                              v-model.number="n.data.volcAudioVolume"
                              type="range"
                              min="-10"
                              max="10"
                              step="1"
                              class="min-w-0 flex-1 h-1 accent-violet-500"
                              @mousedown.stop
                              @click.stop
                            />
                            <span class="text-[8px] text-gray-600 shrink-0">高</span>
                            <span class="w-5 shrink-0 text-right text-[9px] tabular-nums text-gray-300">{{ volcAudioBiasDisplay(n, 'volcAudioVolume') }}</span>
                          </div>
                        </div>
                       <!-- <p class="text-[7px] leading-snug text-gray-600">
                          对应 V3 <strong class="text-gray-500">audio_params</strong> 中 pitch_ratio / speed_ratio / volume_ratio（0 为默认，不调接口）。
                        </p> -->
                      </div>
                      <!-- <p class="text-[8px] leading-snug text-gray-600">
                        <template v-if="n.data.volcTtsExpressMode === 'default'">
                          句首表现力（<strong class="text-gray-400">[]</strong> 或全角
                          <strong class="text-gray-500">【】</strong>）提交后会<strong class="text-gray-300">从正文剥离开</strong>，写入
                          <strong class="text-gray-400">context_texts</strong>，仅朗读后面台词，避免念出「声音略紧张」等说明。全角会先转为半角再处理。正文含半角
                          <strong class="text-gray-400">[]</strong>
                          时将请求 <strong class="text-gray-400">seed-tts-2.0-expressive</strong>（与
                          <a
                            class="text-cyan-500/90 hover:underline"
                            href="https://www.volcengine.com/docs/6561/1329505?lang=zh"
                            target="_blank"
                            rel="noopener noreferrer"
                            @mousedown.stop
                            @click.stop
                          >V3 文档</a>
                          一致）。效果因音色而异，以控制台为准。
                        </template>
                        <template v-else-if="n.data.volcTtsExpressMode === 'voice_instruction'">
                          用自然语言控制情绪、方言、语气、语速等，写入下方「语音指令」；正文框内为要合成的台词。
                        </template>
                        <template v-else>
                          上文仅参与理解语境与情绪承接，不会被完整朗读；正文框内为要合成的台词。
                        </template>
                      </p> -->
                      <div class="flex flex-col gap-1.5 border-t border-white/[0.06] pt-1.5 mt-0.5">
                        <div class="flex flex-wrap gap-1.5 shrink-0">
                          <button
                            type="button"
                            class="rounded-lg border border-white/10 bg-[#16161c] px-2 py-1 text-[10px] text-gray-300 hover:border-cyan-400/35"
                            title="插入停顿标记"
                            @click.stop="insertAudioTag(n, 'pause')"
                          >
                            &lt;#&gt; 停顿
                          </button>
                          <template v-if="volcTtsExpressModeIsDefault(n)">
                            <button
                              type="button"
                              class="rounded-lg border border-amber-500/25 bg-amber-500/10 px-2 py-1 text-[10px] text-amber-100/95 hover:border-amber-400/40"
                              title="在句前插入方括号表现力描述（心理活动、表情、动作等），可改括号内文字"
                              @click.stop="insertAudioTag(n, 'tone')"
                            >
                              [ ] 表现力
                            </button>
                          </template>
                        </div>
                        <p
                          v-if="volcTtsExpressModeIsDefault(n)"
                          class="flex items-start gap-1 rounded-md border border-amber-500/20 bg-amber-500/[0.07] px-1.5 py-1 text-[8px] leading-snug text-amber-100/90"
                        >
                          <i class="fas fa-lightbulb mt-0.5 shrink-0 text-amber-400/90 text-[9px]"></i>
                          <span>
                            句首写半角
                            <strong class="font-mono text-amber-50/95">[]</strong>
                            或全角
                            <strong class="font-mono text-amber-50/95">【】</strong>
                            ：括号内为<strong class="text-amber-50/95">表演说明</strong>（不会当台词念出），后面接要对白朗读的正文。例如
                            <strong class="font-mono text-amber-50/95">【声音略紧张】你好，我爱你</strong>
                            。
                          </span>
                        </p>
                      </div>
                      <div v-if="n.data.volcTtsExpressMode === 'voice_instruction'" class="space-y-1">
                        <label class="block text-[9px] text-gray-500">语音指令</label>
                        <textarea
                          v-model="n.data.volcVoiceInstruction"
                          rows="2"
                          class="w-full resize-y rounded-lg border border-white/10 bg-[#09090d] px-2 py-1.5 text-[10px] text-gray-200 outline-none min-h-[44px] max-h-[120px]"
                          placeholder="如：用轻松、稍慢的语气朗读；略带四川口音"
                          @mousedown.stop
                          @keydown.stop
                        />
                        <p class="text-[8px] text-gray-600">
                          对应
                          <a
                            class="text-cyan-500/90 hover:underline"
                            href="https://www.volcengine.com/docs/6561/1329505?lang=zh"
                            target="_blank"
                            rel="noopener noreferrer"
                            @mousedown.stop
                            @click.stop
                          >语音合成 V3</a>
                          · additions.context_texts
                        </p>
                      </div>
                      <div
                        v-if="n.data.volcTtsExpressMode === 'prior_context'"
                        class="flex flex-col gap-1.5 sm:flex-row sm:items-stretch"
                      >
                        <div
                          class="flex shrink-0 items-center justify-center gap-1 rounded-lg border border-white/12 bg-[#16161c] px-2 py-1.5 text-[10px] text-gray-300 sm:w-[92px]"
                          title="引入上文"
                        >
                          <span class="text-violet-300/90 font-serif leading-none">“</span>
                          <span>引入上文</span>
                        </div>
                        <textarea
                          v-model="n.data.volcPriorContext"
                          rows="2"
                          class="min-h-[48px] flex-1 resize-y rounded-lg border border-white/10 bg-[#09090d] px-2 py-1.5 text-[10px] text-gray-200 outline-none max-h-[120px]"
                          placeholder="输入合成文本的上文，模型会理解内容并承接语境的情绪进行合成"
                          @mousedown.stop
                          @keydown.stop
                        />
                      </div>
                    </div>
                  </template>
                  <template
                    v-else
                  >
                    <div class="flex flex-col gap-1.5 rounded-lg border border-white/[0.06] bg-[#0e0e12] px-2 py-1.5">
                      <div class="flex flex-wrap gap-1.5 shrink-0">
                        <button
                          type="button"
                          class="rounded-lg border border-white/10 bg-[#16161c] px-2 py-1 text-[10px] text-gray-300 hover:border-cyan-400/35"
                          title="插入停顿标记"
                          @click.stop="insertAudioTag(n, 'pause')"
                        >
                          &lt;#&gt; 停顿
                        </button>
                        <button
                          type="button"
                          class="rounded-lg border border-amber-500/25 bg-amber-500/10 px-2 py-1 text-[10px] text-amber-100/95 hover:border-amber-400/40"
                          title="在句前插入方括号表现力描述（心理活动、表情、动作等），可改括号内文字"
                          @click.stop="insertAudioTag(n, 'tone')"
                        >
                          [ ] 表现力
                        </button>
                      </div>
                      <p
                        class="flex items-start gap-1 rounded-md border border-amber-500/20 bg-amber-500/[0.07] px-1.5 py-1 text-[8px] leading-snug text-amber-100/90"
                      >
                        <i class="fas fa-lightbulb mt-0.5 shrink-0 text-amber-400/90 text-[9px]"></i>
                        <span>
                          在任意句前添加半角
                          <strong class="font-medium text-amber-50/95">[心理活动、细腻表情、肢体动作等描述]</strong>
                          ；全角
                          <strong class="font-mono text-amber-50/95">【】</strong>
                          在提交合成时会自动转为半角
                          <strong class="font-mono text-amber-50/95">[]</strong>
                          。例如
                          <strong class="font-mono text-amber-50/95">[声音略紧张]</strong>
                          你好。
                        </span>
                      </p>
                    </div>
                  </template>
                  <textarea
                    v-model="n.data.synthText"
                    :rows="4"
                    class="w-full shrink-0 rounded-lg bg-[#09090d] border border-white/10 px-2.5 py-2 text-gray-200 text-[11px] leading-relaxed outline-none resize-y overflow-y-visible min-h-[72px]"
                    :placeholder="
                      volcTtsExpressModeIsDefault(n)
                        ? '输入要合成的文本。句前可加 [心理活动、表情、动作] 等，如：[声音略紧张] 你好。'
                        : '输入要合成的正文台词（语音指令或上文在上方单独填写）。'
                    "
                    @mousedown.stop
                    @keydown.stop
                  />
                  <!-- <p class="text-[9px] text-gray-500 leading-relaxed flex flex-wrap items-center gap-x-1.5 gap-y-0.5">
                    <span class="shrink-0">说明</span>
                    <a
                      class="text-cyan-400/90 hover:underline shrink-0"
                      href="https://www.volcengine.com/docs/6561/1816214?lang=zh"
                      target="_blank"
                      rel="noopener noreferrer"
                      @mousedown.stop
                      @click.stop
                    >API Key</a>
                    <a
                      class="text-cyan-400/90 hover:underline shrink-0"
                      href="https://www.volcengine.com/docs/6561/1329505?lang=zh"
                      target="_blank"
                      rel="noopener noreferrer"
                      @mousedown.stop
                      @click.stop
                    >V3 合成</a>
                  </p> -->
                  <template
                    v-if="n.data.model === 'volc-doubao-tts-2' || n.data.model === 'volc-doubao-tts-2-expressive'"
                  >
                    <label class="block text-[9px] text-gray-500 mb-0.5">公版音色</label>
                    <NgcNodeSelect
                      :value="n.data.volcSpeakerPick"
                      :options="volcSpeakerDropdownOptions()"
                      size="md"
                      menu-up
                      class="mb-1"
                      @input="
                        v => {
                          $set(n.data, 'volcSpeakerPick', v)
                          syncAudioVolcPublicSpeakerFromPick(n)
                        }
                      "
                    />
                    <input
                      v-if="n.data.volcSpeakerPick === volcSpeakerCustomId"
                      v-model="n.data.volcPublicSpeaker"
                      type="text"
                      class="w-full rounded-lg bg-[#09090d] border border-white/10 px-2 py-1.5 text-[10px] text-gray-200 outline-none"
                      placeholder="文档 2.0 音色 voice_type，如 zh_female_xxx_uranus_bigtts"
                      @mousedown.stop
                      @keydown.stop
                    />
                    <p
                      v-else
                      class="text-[9px] text-gray-600 font-mono truncate mb-0.5"
                      :title="n.data.volcPublicSpeaker"
                    >
                      {{ n.data.volcPublicSpeaker }}
                    </p>
                    <!-- <a
                      class="inline-block text-[9px] text-cyan-400/90 hover:underline mb-1"
                      href="https://www.volcengine.com/docs/6561/1257544?lang=zh"
                      target="_blank"
                      rel="noopener noreferrer"
                      @mousedown.stop
                      @click.stop
                    >音色列表（文档）</a> -->
                  </template>
                  <template v-if="n.data.model === 'volc-doubao-icl-2'">
                    <input
                      v-model="n.data.cloneScriptText"
                      type="text"
                      class="w-full rounded-lg bg-[#09090d] border border-white/10 px-2 py-1.5 text-[10px] text-gray-200 outline-none"
                      placeholder="复刻对照文本（须与参考音频朗读内容一致）"
                      @mousedown.stop
                      @keydown.stop
                    />
                    <div class="flex items-center gap-1.5 flex-wrap">
                      <button
                        type="button"
                        class="rounded-lg border border-cyan-500/35 bg-cyan-600/15 px-2 py-1 text-[10px] text-cyan-100 hover:bg-cyan-600/25 disabled:opacity-35"
                        :disabled="isNodeRunning(n.id)"
                        title="上传参考音并填对照文本后，向火山注册复刻音色"
                        @click.stop="registerVolcCloneForAudioNode(n)"
                      >
                        注册复刻音色
                      </button>
                      <span v-if="n.data.volcSpeakerId" class="text-[9px] text-emerald-400/90 truncate max-w-[140px]" :title="n.data.volcSpeakerId">
                        已注册 {{ n.data.volcSpeakerId }}
                      </span>
                    </div>
                  </template>
                  <div
                    class="relative ngc-audio-gen-bar flex flex-nowrap items-center gap-1.5 min-w-0 border-t border-white/[0.06] pt-1.5"
                  >
                    <div class="min-w-0 flex-1 shrink" @mousedown.stop>
                      <button
                        type="button"
                        class="flex h-8 w-full min-w-0 items-center gap-1.5 rounded-lg border border-white/[0.10] bg-[#121218] px-1.5 text-[10px] text-gray-200 outline-none transition-colors hover:bg-white/[0.05] hover:border-white/[0.14]"
                        :class="
                          audioModelPickerNodeId === n.id
                            ? 'border-sky-500/45 ring-1 ring-sky-500/20 bg-[#14141c]'
                            : ''
                        "
                        title="语音合成模型"
                        @click.stop="toggleAudioModelPicker(n)"
                      >
                        <span
                          class="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-white/[0.08] border border-white/[0.08]"
                        >
                          <i class="fas fa-music text-[10px] text-white/90"></i>
                        </span>
                        <span class="min-w-0 flex-1 truncate text-left font-medium">{{
                          audioNodeModelTriggerLabel(n)
                        }}</span>
                        <i
                          class="fas shrink-0 text-[8px] text-gray-500"
                          :class="
                            audioModelPickerNodeId === n.id ? 'fa-chevron-up' : 'fa-chevron-down'
                          "
                        ></i>
                      </button>
                    </div>
                    <div
                      class="flex shrink-0 items-center gap-2 rounded-lg border border-white/[0.08] bg-[#0a0a0e] px-2 py-1 shadow-[inset_0_1px_0_rgba(255,255,255,0.03)]"
                      title="字数与积分"
                    >
                      <span class="text-[9px] tabular-nums text-gray-500 whitespace-nowrap">
                        {{ (n.data.synthText || '').length }}/{{ n.data.maxChars || 50000 }}
                      </span>
                      <span class="h-3 w-px shrink-0 bg-white/[0.10]" aria-hidden="true"></span>
                      <span
                        class="flex items-center gap-0.5 text-[9px] tabular-nums text-amber-200/90 whitespace-nowrap"
                      >
                        <i class="fas fa-bolt text-amber-400/90 text-[8px]"></i>
                        {{ ngcNodeCreditBoltText(n) }}
                      </span>
                    </div>
                    <button
                      type="button"
                      class="ngc-node-run-btn"
                      :disabled="isNodeRunning(n.id)"
                      title="合成语音"
                      @click.stop="runSingleAudioNode(n)"
                    >
                      <i class="fas fa-arrow-up ngc-node-run-btn__icon" aria-hidden="true"></i>
                    </button>
                    <div
                      v-show="audioModelPickerNodeId === n.id"
                      class="ngc-inline-model-picker ngc-inline-model-picker--node-anchor"
                      @mousedown.stop
                    >
                      <div class="ngc-inline-model-picker__head">
                        <span class="ngc-inline-model-picker__title">音频模型</span>
                        <button
                          type="button"
                          class="ngc-inline-model-picker__close"
                          title="关闭"
                          @click="closeAudioModelPickerModal"
                        >
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                      <div class="ngc-inline-model-picker__list">
                        <button
                          v-for="am in audioModelOptions"
                          :key="'amm-' + n.id + '-' + am.id"
                          type="button"
                          class="ngc-inline-model-picker__item"
                          :class="
                            String(n.data.model || '').trim() === String(am.id || '').trim()
                              ? 'ngc-inline-model-picker__item--active'
                              : ''
                          "
                          @click.stop="setAudioNodeModel(n, am.id)"
                        >
                          <span
                            class="ngc-inline-model-picker__icon"
                          >
                            <i class="fas fa-music text-[9px] text-violet-200/85"></i>
                          </span>
                          <span class="min-w-0 flex-1">{{ am.label }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <audio
                    v-if="n.data.audioUrl"
                    :src="n.data.audioUrl"
                    controls
                    class="w-full h-9 rounded-lg border border-white/10 bg-black/40"
                    @mousedown.stop
                  />
                </div>
              </template>
              <template v-else-if="n.type === 'ecomDetail'">
                <div
                  class="flex flex-1 flex-col gap-2 min-h-[200px] rounded-xl border border-orange-500/20 bg-[#12100e] p-2.5"
                >
                  <div
                    v-if="(n.data.upstreamImageAnalysis || '').trim()"
                    class="max-h-[100px] overflow-y-auto scrollbar-thin shrink-0 rounded-lg border border-cyan-500/20 bg-cyan-950/15 p-2"
                  >
                    <p class="text-[9px] font-medium text-cyan-200/90 mb-1">
                      上游商品图解析
                    </p>
                    <p
                      class="text-[9px] text-gray-400 leading-snug line-clamp-4"
                      :title="n.data.upstreamImageAnalysis"
                    >
                      {{ n.data.upstreamImageAnalysis }}
                    </p>
                  </div>
                  <div
                    v-if="ecomDetailPromptPlanCount(n)"
                    class="max-h-[min(42vh,320px)] overflow-y-auto scrollbar-thin shrink-0 space-y-1.5 rounded-lg border border-violet-500/20 bg-violet-950/20 p-2"
                    @mousedown.stop
                  >
                    <p class="text-[9px] font-medium text-violet-200/90 shrink-0">
                      已生成 {{ ecomDetailPromptPlanCount(n) }} 条提示词（可编辑）
                    </p>
                    <div
                      v-for="(row, pidx) in n.data.promptPlans"
                      :key="row.id || pidx"
                      class="rounded-md border border-white/8 bg-black/30 px-2 py-1.5 space-y-1"
                    >
                      <p class="text-[9px] text-orange-200/85 truncate" :title="row.label">
                        {{ row.label }}
                        <span v-if="row.size" class="text-gray-500"> · {{ row.size }}</span>
                      </p>
                      <textarea
                        :value="row.prompt"
                        rows="4"
                        class="w-full min-h-[4.5rem] resize-y rounded border border-white/10 bg-[#0c0c10] px-2 py-1 text-[9px] leading-snug text-gray-300 outline-none focus:border-violet-500/40"
                        placeholder="生图提示词"
                        @input="setEcomDetailPromptPlanText(n, pidx, $event)"
                        @mousedown.stop
                      ></textarea>
                    </div>
                  </div>
                  <div
                    v-if="(n.data.outputImages || []).length"
                    class="grid grid-cols-2 gap-1.5 max-h-[220px] overflow-y-auto scrollbar-thin shrink-0"
                  >
                    <a
                      v-for="(img, idx) in n.data.outputImages"
                      :key="img.id || idx"
                      :href="img.url"
                      target="_blank"
                      rel="noopener"
                      class="block rounded-lg overflow-hidden border border-white/10 bg-black/40 aspect-[3/4] hover:border-orange-400/40"
                      :title="img.label"
                      @mousedown.stop
                    >
                      <img
                        v-if="img.url"
                        :src="img.url"
                        alt=""
                        loading="lazy"
                        class="w-full h-full object-cover"
                      />
                    </a>
                  </div>
                  <div
                    v-else-if="!ecomDetailPromptPlanCount(n)"
                    class="flex flex-1 min-h-[120px] items-center justify-center rounded-lg border border-dashed border-white/10 bg-black/25 text-center px-3"
                  >
                    <p class="text-[10px] text-gray-500 leading-relaxed">
                      填写商品信息并选择 Skill，点击 ↑ 先生成提示词；确认后再点出图
                    </p>
                  </div>
                  <div class="space-y-2 shrink-0" @mousedown.stop>
                    <input
                      v-model="n.data.productName"
                      type="text"
                      placeholder="商品名称"
                      class="w-full rounded-lg border border-white/10 bg-[#16161c] px-2.5 py-1.5 text-[11px] text-gray-100 outline-none focus:border-orange-500/40"
                    />
                    <textarea
                      v-model="n.data.sellingPoints"
                      rows="3"
                      placeholder="核心卖点（每行一条更佳）"
                      class="w-full rounded-lg border border-white/10 bg-[#16161c] px-2.5 py-1.5 text-[11px] text-gray-200 outline-none resize-none focus:border-orange-500/40"
                    ></textarea>
                    <NgcNodeSelect
                      :value="n.data.platform"
                      :options="ECOM_DETAIL_PLATFORMS"
                      size="md"
                      accent="orange"
                      @input="v => $set(n.data, 'platform', v)"
                    />
                    <div class="space-y-1">
                      <label class="text-[9px] text-gray-500">详情图文字语言</label>
                      <NgcNodeSelect
                        :value="n.data.outputLanguage"
                        :options="ECOM_DETAIL_OUTPUT_LANGUAGES"
                        size="md"
                        accent="orange"
                        @input="
                          v => {
                            $set(n.data, 'outputLanguage', v)
                            onEcomDetailOutputLanguageChange(n)
                          }
                        "
                      />
                      <p
                        v-if="n.data.outputLanguage === 'en'"
                        class="text-[9px] text-amber-200/80 leading-snug"
                      >
                        生成的主图/详情图上的卖点、标题等文案将使用英文
                      </p>
                    </div>
                    <div class="space-y-1">
                      <label class="text-[9px] text-gray-500">Skill</label>
                      <NgcNodeSelect
                        :value="n.data.selectedSkillId || ''"
                        :options="ecomSkillDropdownOptions()"
                        size="md"
                        accent="violet"
                        @input="v => onEcomDetailSkillSelectValue(n, v)"
                      />
                      <!-- <p
                        v-if="ecomDetailSkillSummary(n)"
                        class="text-[9px] text-gray-500 leading-snug line-clamp-2"
                        :title="ecomDetailSkillSummary(n)"
                      >
                        {{ ecomDetailSkillSummary(n) }}
                      </p> -->
                      <!-- <p
                        v-if="ecomDetailIsPromptExpertSkill(n)"
                        class="text-[9px] text-violet-300/90 leading-snug"
                      >
                        上游图先尝试视觉模型解析，失败则用 DeepSeek 结合节点描述推断；再生成提示词
                      </p> -->
                      <p
                        v-if="ecomDetailIsVisualPromptSkill(n)"
                        class="text-[9px] text-amber-200/90 leading-snug"
                      >
                        App/小程序：8+ 张提示词，严格保持界面 UI 一致；可编辑后点出图
                      </p>
                    </div>
                  </div>
                  <div class="relative shrink-0 space-y-2" @mousedown.stop>
                    <div class="space-y-1" @mousedown.stop>
                      <label class="text-[9px] text-gray-500">出图模型</label>
                      <button
                        type="button"
                        class="flex h-8 w-full min-w-0 items-center justify-center gap-1 rounded-lg border border-white/10 bg-[#18181c] px-1.5 text-[10px] text-gray-300 outline-none hover:bg-white/[0.05]"
                        :class="
                          ecomDetailImageModelPickerNodeId === n.id
                            ? 'border-orange-500/50 ring-1 ring-orange-500/25'
                            : ''
                        "
                        title="Seedream / GPT 等出图模型"
                        @click.stop="toggleEcomDetailImageModelPicker(n)"
                      >
                        <i class="fas fa-microchip shrink-0 text-[9px] text-orange-300/90"></i>
                        <span class="min-w-0 flex-1 truncate text-left">{{
                          ecomDetailImageModelLabel(n)
                        }}</span>
                        <i
                          class="fas shrink-0 text-[8px] opacity-70"
                          :class="
                            ecomDetailImageModelPickerNodeId === n.id
                              ? 'fa-chevron-up'
                              : 'fa-chevron-down'
                          "
                        ></i>
                      </button>
                    </div>
                    <div class="space-y-1" @mousedown.stop>
                      <label class="text-[9px] text-gray-500">DeepSeek 模型</label>
                      <button
                        type="button"
                        class="flex h-8 w-full min-w-0 items-center justify-center gap-1 rounded-lg border border-white/10 bg-[#18181c] px-1.5 text-[10px] text-gray-300 outline-none hover:bg-white/[0.05]"
                        :class="
                          ecomDetailDeepseekPickerNodeId === n.id
                            ? 'border-violet-500/50 ring-1 ring-violet-500/25'
                            : ''
                        "
                        title="出图前用 DeepSeek 优化各模板位提示词"
                        @click.stop="toggleEcomDetailDeepseekPicker(n)"
                      >
                        <i class="fas fa-brain shrink-0 text-[9px] text-violet-300/90"></i>
                        <span class="min-w-0 flex-1 truncate text-left">{{
                          ecomDetailDeepseekModelLabel(n)
                        }}</span>
                        <i
                          class="fas shrink-0 text-[8px] opacity-70"
                          :class="
                            ecomDetailDeepseekPickerNodeId === n.id
                              ? 'fa-chevron-up'
                              : 'fa-chevron-down'
                          "
                        ></i>
                      </button>
                      <!-- 暂时隐藏：DeepSeek 优化开关 / 识图模型 / 模板位选择 -->
                      <!--
                      <label class="flex items-center gap-1.5 text-[9px] text-gray-500 cursor-pointer">
                        <input
                          type="checkbox"
                          class="rounded border-white/20"
                          :checked="n.data.useDeepseekPrompt !== false"
                          @change="setEcomDetailUseDeepseek(n, $event)"
                        />
                        出图前用 DeepSeek 优化提示词
                      </label>
                      <input
                        v-model="n.data.visionModel"
                        type="text"
                        placeholder="识图模型 ID（可选，方舟视觉 endpoint）"
                        class="w-full rounded-lg border border-white/10 bg-[#16161c] px-2 py-1 text-[10px] text-gray-400 outline-none focus:border-cyan-500/35"
                        title="留空则自动尝试 doubao-1.5-vision 等；若报不支持 image 可填控制台视觉模型 ID"
                      />
                      -->
                    </div>
                    <!--
                    <div class="flex flex-wrap gap-1">
                      <button
                        v-for="slot in ECOM_DETAIL_SLOT_DEFS"
                        :key="slot.id"
                        type="button"
                        class="rounded-md border px-2 py-0.5 text-[9px] transition-colors"
                        :class="
                          (n.data.slots && n.data.slots[slot.id])
                            ? 'border-orange-500/45 bg-orange-600/15 text-orange-100'
                            : 'border-white/10 text-gray-500 hover:border-white/20'
                        "
                        :title="slot.hint"
                        @click.stop="toggleEcomDetailSlot(n, slot.id)"
                      >
                        {{ slot.label }}
                      </button>
                    </div>
                    -->
                    <p
                      v-if="(n.data.progress || '').trim()"
                      class="text-[9px] text-orange-200/80 truncate"
                    >
                      {{ n.data.progress }}
                    </p>
                    <div
                      class="flex items-center justify-between gap-2 border-t border-white/[0.06] pt-2"
                      @mousedown.stop
                    >
                      <span class="text-[10px] text-gray-500 tabular-nums shrink-0">
                        <template v-if="ecomDetailPromptPlanCount(n)">
                          {{ ecomDetailPromptPlanCount(n) }} 条提示词
                          <span class="text-gray-600"> · </span>
                        </template>
                        <template v-else>
                          {{ ecomDetailEnabledCount(n) }} 位 ·
                        </template>
                        <span
                          v-if="ecomDetailPromptPlanCount(n)"
                          class="text-amber-200/90"
                        >
                          出图
                          <i class="fas fa-bolt text-amber-400 text-[9px]"></i>
                          {{ ngcFormatCatalogCredits(ecomDetailRenderCreditDisplay(n)) }}
                        </span>
                      </span>
                      <div class="flex items-center gap-1 shrink-0">
                        <button
                          type="button"
                          class="ngc-node-run-btn"
                          :class="{ 'ngc-node-run-btn--wide': ecomDetailHasGeneratedContent(n) }"
                          :disabled="isNodeRunning(n.id)"
                          :title="
                            ecomDetailHasGeneratedContent(n)
                              ? '重新生成提示词（将覆盖现有计划与下游图片节点）'
                              : '按 Skill / 模板位生成提示词（不调用生图）'
                          "
                          @click.stop="onEcomDetailGenerateClick(n)"
                        >
                          <template v-if="ecomDetailHasGeneratedContent(n)">
                            <i class="fas fa-redo ngc-node-run-btn__icon ngc-node-run-btn__icon--sm" aria-hidden="true"></i>
                            <span class="ngc-node-run-btn__text">重新生成</span>
                          </template>
                          <i v-else class="fas fa-arrow-up ngc-node-run-btn__icon" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                    <div
                      v-show="ecomDetailImageModelPickerNodeId === n.id"
                      class="ngc-inline-model-picker ngc-inline-model-picker--node-anchor"
                      @mousedown.stop
                    >
                      <div class="ngc-inline-model-picker__head">
                        <span class="ngc-inline-model-picker__title">出图模型</span>
                        <button
                          type="button"
                          class="ngc-inline-model-picker__close"
                          title="关闭"
                          @click="closeEcomDetailImageModelPickerModal"
                        >
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                      <div class="ngc-inline-model-picker__list">
                        <button
                          v-for="im in ecomImageModelOptions"
                          :key="'ecim-' + n.id + '-' + (im.id || '_')"
                          type="button"
                          class="ngc-inline-model-picker__item"
                          :class="
                            String(n.data.seedreamModel || '').trim() ===
                            String(im.id != null ? im.id : '').trim()
                              ? 'ngc-inline-model-picker__item--active'
                              : ''
                          "
                          @click.stop="setEcomDetailSeedreamModel(n, im.id)"
                        >
                          <span
                            class="ngc-inline-model-picker__icon"
                          >
                            <i class="fas fa-image text-[9px] text-orange-200/85"></i>
                          </span>
                          <span class="min-w-0 flex-1">{{ im.label }}</span>
                        </button>
                      </div>
                    </div>
                    <div
                      v-show="ecomDetailDeepseekPickerNodeId === n.id"
                      class="ngc-inline-model-picker ngc-inline-model-picker--node-anchor"
                      @mousedown.stop
                    >
                      <div class="ngc-inline-model-picker__head">
                        <span class="ngc-inline-model-picker__title">DeepSeek</span>
                        <button
                          type="button"
                          class="ngc-inline-model-picker__close"
                          title="关闭"
                          @click="closeEcomDetailDeepseekPickerModal"
                        >
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                      <div class="ngc-inline-model-picker__list">
                        <button
                          v-for="m in storyboardModelOptions"
                          :key="'ecds-' + n.id + '-' + m.id"
                          type="button"
                          class="ngc-inline-model-picker__item"
                          :class="
                            String(n.data.deepseekModel || '').trim() ===
                            String(m.id || '').trim()
                              ? 'ngc-inline-model-picker__item--active'
                              : ''
                          "
                          @click.stop="setEcomDetailDeepseekModel(n, m.id)"
                        >
                          <span
                            class="ngc-inline-model-picker__icon"
                          >
                            <i class="fas fa-brain text-[9px] text-violet-200/85"></i>
                          </span>
                          <span class="min-w-0 flex-1">{{ m.label }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="n.type === 'uiDesign'">
                <p class="text-[9px] leading-snug text-gray-500">
                  内置 <strong class="text-indigo-300/90">UI设计专家</strong>：从
                  <strong class="text-gray-400">20 种 UI 风格</strong> 中选择 → 填产品名 → 可选
                  <strong class="text-gray-400">解析参考图风格</strong> → ↑ 生成 8+ 屏提示词。
                </p>
                <div class="space-y-1.5" @mousedown.stop>
                  <div
                    class="rounded-lg border border-cyan-500/25 bg-cyan-950/15 p-2 space-y-1.5"
                  >
                    <div class="flex items-center justify-between gap-1.5">
                      <p class="text-[9px] font-medium text-cyan-200/90 min-w-0 truncate">
                        参考 AI 设计风格
                        <span
                          v-if="uiDesignUpstreamRefCount(n)"
                          class="text-gray-500 font-normal"
                        >
                          · {{ uiDesignUpstreamRefCount(n) }} 张参考图
                        </span>
                      </p>
                      <button
                        type="button"
                        class="shrink-0 rounded-md border border-cyan-500/40 bg-cyan-900/35 px-1.5 py-0.5 text-[8px] text-cyan-100 hover:bg-cyan-700/30 disabled:opacity-35"
                        :disabled="!uiDesignUpstreamRefCount(n) || isNodeRunning(n.id)"
                        title="从上游参考图提取可复用 UI 视觉风格（不照搬参考图的产品功能）"
                        @click.stop="runAnalyzeUiDesignUpstreamStyle(n)"
                      >
                        <i class="fas fa-palette text-[7px] mr-0.5"></i>解析风格
                      </button>
                    </div>
                    <p class="text-[8px] text-gray-500 leading-snug">
                      参考图只决定「长什么样」；下方「待设计产品」决定做哪些页面（如点餐、点单、订单）。
                    </p>
                    <p
                      v-if="!uiDesignUpstreamRefCount(n)"
                      class="text-[8px] text-amber-200/70 leading-snug"
                    >
                      请连线上游「图片」节点（已出图或含风格描述）
                    </p>
                    <!-- <input
                      v-model="n.data.visionModel"
                      type="text"
                      class="h-7 w-full rounded-lg border border-white/10 bg-[#0f0f12] px-2 text-[9px] text-gray-400 outline-none focus:border-cyan-500/35"
                      placeholder="识图模型 ID（可选，方舟视觉 endpoint）"
                      title="留空则自动尝试 doubao-1.5-vision 等"
                      @mousedown.stop
                      @keydown.stop
                    /> -->
                    <label
                      class="flex items-center gap-1.5 text-[8px] text-gray-500 cursor-pointer"
                      @mousedown.stop
                    >
                      <input
                        type="checkbox"
                        class="rounded border-white/20"
                        :checked="n.data.applyUpstreamStyleToFields !== false"
                        @change="setUiDesignApplyUpstreamStyle(n, $event)"
                      />
                      解析后写入设计风格与主题色
                    </label>
                    <div
                      v-if="uiDesignReferenceStylePreview(n)"
                      class="max-h-[88px] overflow-y-auto rounded border border-cyan-500/15 bg-black/25 p-1.5"
                    >
                      <p
                        v-if="n.data.upstreamImageAnalysisMethod"
                        class="text-[7px] text-gray-600 mb-0.5"
                      >
                        {{ uiDesignUpstreamAnalysisMethodLabel(n) }} · 将用于下方产品界面
                      </p>
                      <p
                        class="text-[8px] text-gray-400 leading-snug whitespace-pre-wrap"
                        :title="uiDesignReferenceStylePreview(n)"
                      >
                        {{ uiDesignReferenceStylePreview(n) }}
                      </p>
                    </div>
                  </div>
                  <NgcNodeSelect
                    :value="n.data.platform"
                    :options="UI_DESIGN_PLATFORMS"
                    size="sm"
                    @input="v => $set(n.data, 'platform', v)"
                  />
                </div>
                <p class="text-[9px] font-medium text-indigo-200/85">待设计产品</p>
                <input
                  v-model="n.data.projectName"
                  type="text"
                  class="w-full rounded-lg border border-white/10 bg-[#0f0f12] px-2 py-1.5 text-[11px] text-gray-200 outline-none focus:border-indigo-500/35"
                  placeholder="你的产品，如：宠物上门服务App、点餐小程序"
                  @mousedown.stop
                  @keydown.stop
                />
                <textarea
                  v-model="n.data.brief"
                  rows="4"
                  class="w-full min-h-[72px] rounded-lg bg-[#0f0f12] border border-white/10 px-2 py-2 text-[11px] leading-relaxed text-gray-200 outline-none resize-y focus:border-indigo-500/35"
                  placeholder="核心功能与页面：如扫码点餐、菜单分类、购物车、订单、我的…"
                  @mousedown.stop
                  @keydown.stop
                />
                <div class="space-y-1.5" @mousedown.stop>
                  <div class="space-y-1">
                    <label class="text-[9px] text-gray-500">设计风格（可解析后自动填入）</label>
                    <NgcNodeSelect
                      :value="n.data.designStyleId"
                      :options="UI_DESIGN_BUILTIN_STYLES"
                      size="sm"
                      accent="indigo"
                      @input="v => $set(n.data, 'designStyleId', v)"
                    />
                    <p
                      v-if="uiDesignStyleSummary(n)"
                      class="text-[9px] text-indigo-300/80 leading-snug line-clamp-2"
                      :title="uiDesignStyleSummary(n)"
                    >
                      {{ uiDesignStyleSummary(n) }}
                    </p>
                  </div>
                  <input
                    v-if="n.data.designStyleId === UI_DESIGN_STYLE_CUSTOM_ID"
                    v-model="n.data.designStyleCustom"
                    type="text"
                    class="h-8 w-full rounded-lg border border-white/10 bg-[#0f0f12] px-2 text-[10px] text-gray-200 outline-none"
                    placeholder="描述你的自定义 UI 风格…"
                    @keydown.stop
                  />
                  <input
                    v-else
                    v-model="n.data.designStyleCustom"
                    type="text"
                    class="h-8 w-full rounded-lg border border-dashed border-white/10 bg-[#0f0f12]/60 px-2 text-[10px] text-gray-400 outline-none"
                    placeholder="风格微调（可选）"
                    @keydown.stop
                  />
                  <div class="grid grid-cols-2 gap-2" @mousedown.stop>
                    <div class="space-y-0.5">
                      <label class="text-[9px] text-gray-500">主色</label>
                      <div
                        class="flex h-8 items-center gap-1.5 rounded-lg border border-white/10 bg-[#0f0f12] px-1.5"
                      >
                        <input
                          type="color"
                          class="ui-design-color-swatch h-6 w-8 shrink-0 cursor-pointer rounded border border-white/15 bg-transparent p-0"
                          :value="uiDesignThemeColorForPicker(n, 'primary')"
                          title="点击选择主色"
                          @input="setUiDesignThemeColorFromPicker(n, 'primary', $event)"
                          @mousedown.stop
                        />
                        <input
                          type="text"
                          class="min-w-0 flex-1 bg-transparent text-[10px] text-gray-200 outline-none font-mono uppercase"
                          :value="n.data.themeColorPrimary"
                          placeholder="#3B82F6"
                          title="主色 HEX"
                          @change="setUiDesignThemeColorFromHex(n, 'primary', $event)"
                          @keydown.stop
                        />
                      </div>
                    </div>
                    <div class="space-y-0.5">
                      <label class="text-[9px] text-gray-500">辅色</label>
                      <div
                        class="flex h-8 items-center gap-1.5 rounded-lg border border-white/10 bg-[#0f0f12] px-1.5"
                      >
                        <input
                          type="color"
                          class="ui-design-color-swatch h-6 w-8 shrink-0 cursor-pointer rounded border border-white/15 bg-transparent p-0"
                          :value="uiDesignThemeColorForPicker(n, 'secondary')"
                          title="点击选择辅色"
                          @input="setUiDesignThemeColorFromPicker(n, 'secondary', $event)"
                          @mousedown.stop
                        />
                        <input
                          type="text"
                          class="min-w-0 flex-1 bg-transparent text-[10px] text-gray-200 outline-none font-mono uppercase"
                          :value="n.data.themeColorSecondary"
                          placeholder="#64748B"
                          title="辅色 HEX"
                          @change="setUiDesignThemeColorFromHex(n, 'secondary', $event)"
                          @keydown.stop
                        />
                      </div>
                    </div>
                  </div>
                  <div class="grid grid-cols-2 gap-1.5" @mousedown.stop>
                    <div class="space-y-0.5">
                      <label class="text-[9px] text-gray-500">展示方式</label>
                      <NgcNodeSelect
                        :value="n.data.displayMode"
                        :options="UI_DESIGN_DISPLAY_MODES"
                        size="sm"
                        menu-up
                        @input="v => $set(n.data, 'displayMode', v)"
                      />
                    </div>
                    <div class="space-y-0.5">
                      <label class="text-[9px] text-gray-500">界面 / 图片节点</label>
                      <NgcNodeSelect
                        :value="n.data.screenCount"
                        :options="uiDesignScreenCountDropdownOptions()"
                        size="sm"
                        accent="indigo"
                        number-value
                        menu-up
                        @input="
                          v => {
                            $set(n.data, 'screenCount', v)
                            syncUiDesignCreditDisplay(n)
                          }
                        "
                      />
                    </div>
                  </div>
                </div>
                <textarea
                  v-model="n.data.extraPrompt"
                  rows="2"
                  class="w-full rounded-lg bg-[#0f0f12] border border-white/10 px-2 py-1.5 text-[10px] text-gray-300 outline-none resize-y"
                  placeholder="补充：屏数、组件库偏好、无障碍等（可选）"
                  @mousedown.stop
                  @keydown.stop
                />
                <div
                  v-if="uiDesignScreenPlanCount(n)"
                  class="rounded-lg bg-indigo-950/25 border border-indigo-500/25 px-2 py-1.5"
                  @mousedown.stop
                >
                  <div class="flex items-center justify-between gap-1.5 mb-1">
                    <p class="text-[8px] font-medium text-indigo-300/90 min-w-0 truncate">
                      已生成 {{ uiDesignScreenPlanCount(n) }} 张界面提示词（可编辑）
                    </p>
                    <button
                      type="button"
                      class="shrink-0 rounded-md border border-indigo-500/35 bg-indigo-900/30 px-1.5 py-0.5 text-[8px] text-indigo-100/95 hover:bg-indigo-600/25 disabled:opacity-35"
                      :disabled="isNodeRunning(n.id)"
                      title="将本节点内各屏提示词覆盖写入下游图片节点（无图片节点时会先创建）"
                      @click.stop="syncUiDesignPlansToImageNodes(n)"
                    >
                      <i class="fas fa-sync-alt text-[7px] mr-0.5"></i>同步到图片节点
                    </button>
                  </div>
                  <div class="max-h-[min(24vh,180px)] overflow-y-auto space-y-1.5">
                    <div
                      v-for="(plan, pi) in n.data.screenPlans"
                      :key="'ui-plan-' + n.id + '-' + pi"
                      class="rounded border border-white/[0.06] bg-[#0f0f12]/80 p-1.5"
                    >
                      <p class="text-[8px] text-gray-500 mb-0.5 truncate">{{ plan.label }}</p>
                      <textarea
                        v-model="plan.prompt"
                        rows="2"
                        class="w-full rounded bg-transparent text-[9px] text-gray-300 outline-none resize-y"
                        @mousedown.stop
                        @keydown.stop
                      />
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="n.data.promptRaw"
                  class="rounded-lg bg-indigo-950/20 border border-indigo-500/20 px-2 py-1.5 text-[9px] text-gray-400 whitespace-pre-wrap max-h-[min(20vh,140px)] overflow-y-auto"
                >
                  {{ n.data.promptRaw.slice(0, 600) }}{{ n.data.promptRaw.length > 600 ? '…' : '' }}
                </div>
                <div class="relative mt-auto flex flex-col gap-2 border-t border-white/[0.06] pt-2" @mousedown.stop>
                  <div class="flex flex-wrap items-center justify-between gap-2">
                    <div class="min-w-0 flex-1 max-w-[48%]" @mousedown.stop>
                      <button
                        type="button"
                        class="flex h-8 w-full items-center gap-1 rounded-lg border border-white/10 bg-[#18181c] px-1.5 text-[10px] text-gray-300 hover:bg-white/[0.05]"
                        :class="
                          uiDesignDeepseekPickerNodeId === n.id
                            ? 'border-sky-500/50 ring-1 ring-sky-500/25'
                            : ''
                        "
                        title="策划所用 DeepSeek 模型"
                        @click.stop="toggleUiDesignDeepseekPicker(n)"
                      >
                        <i class="fas fa-brain text-[9px] text-indigo-300/90 shrink-0"></i>
                        <span class="min-w-0 flex-1 truncate text-left">{{
                          uiDesignDeepseekModelLabel(n)
                        }}</span>
                      </button>
                    </div>
                    <div class="min-w-0 flex-1 max-w-[48%]" @mousedown.stop>
                      <button
                        type="button"
                        class="flex h-8 w-full items-center gap-1 rounded-lg border border-white/10 bg-[#18181c] px-1.5 text-[10px] text-gray-300 hover:bg-white/[0.05]"
                        :class="
                          uiDesignImageModelPickerNodeId === n.id
                            ? 'border-sky-500/50 ring-1 ring-sky-500/25'
                            : ''
                        "
                        title="出图所用 Seedream 模型"
                        @click.stop="toggleUiDesignImageModelPicker(n)"
                      >
                        <i class="far fa-image text-[9px] shrink-0"></i>
                        <span class="min-w-0 flex-1 truncate text-left">{{
                          uiDesignImageModelLabel(n)
                        }}</span>
                      </button>
                    </div>
                  </div>
                  <div class="flex items-center justify-between gap-2">
                    <span class="text-[9px] text-gray-500 tabular-nums">
                      <template v-if="uiDesignScreenPlanCount(n)">
                        {{ uiDesignScreenPlanCount(n) }} 屏
                        <span class="text-gray-600"> · </span>
                        出图
                        <i class="fas fa-bolt text-amber-400 text-[8px]"></i>
                        {{ ngcFormatCatalogCredits(uiDesignRenderCreditDisplay(n)) }}
                      </template>
                      <template v-else>
                        {{ uiDesignConfiguredScreenCount(n) }} 屏
                        <span class="text-gray-600"> · </span>
                        策划
                        <i class="fas fa-bolt text-amber-400 text-[8px]"></i>
                        {{ ngcFormatCatalogCredits(uiDesignCreditDisplay(n)) }}
                      </template>
                    </span>
                    <div class="flex items-center gap-1.5">
                      <button
                        type="button"
                        class="ngc-node-run-btn"
                        :disabled="isNodeRunning(n.id)"
                        title="按 Skill 生成提示词并拆分到下游图片节点（不调用生图）"
                        @click.stop="runSingleUiDesignNode(n)"
                      >
                        <i class="fas fa-arrow-up ngc-node-run-btn__icon" aria-hidden="true"></i>
                      </button>
                      <button
                        v-if="uiDesignScreenPlanCount(n)"
                        type="button"
                        class="flex h-8 w-8 items-center justify-center rounded-full border border-indigo-500/40 bg-indigo-950/50 text-indigo-100 hover:bg-indigo-600/30 disabled:opacity-35"
                        :disabled="isNodeRunning(n.id)"
                        title="确保下游图片节点存在后，按各图片节点上的提示词分别执行 Seedream 出图"
                        @click.stop="runUiDesignRenderImages(n)"
                      >
                        <i class="fas fa-image text-xs"></i>
                      </button>
                    </div>
                  </div>
                  <div
                    v-show="uiDesignDeepseekPickerNodeId === n.id"
                    class="ngc-inline-model-picker ngc-inline-model-picker--node-anchor"
                    @mousedown.stop
                  >
                    <div class="ngc-inline-model-picker__head">
                      <span class="ngc-inline-model-picker__title">策划模型</span>
                      <button
                        type="button"
                        class="ngc-inline-model-picker__close"
                        title="关闭"
                        @click="uiDesignDeepseekPickerNodeId = null"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                    <div class="ngc-inline-model-picker__list">
                      <button
                        v-for="m in storyboardModelOptions"
                        :key="'uid-ds-' + n.id + '-' + m.id"
                        type="button"
                        class="ngc-inline-model-picker__item"
                        :class="
                          String(n.data.deepseekModel || '').trim() === String(m.id || '').trim()
                            ? 'ngc-inline-model-picker__item--active'
                            : ''
                        "
                        @click.stop="setUiDesignDeepseekModel(n, m.id)"
                      >
                        <span class="ngc-inline-model-picker__icon">
                          <i class="fas fa-brain text-[10px] text-violet-200/90"></i>
                        </span>
                        <span class="ngc-inline-model-picker__label">{{ m.label }}</span>
                      </button>
                    </div>
                  </div>
                  <div
                    v-show="uiDesignImageModelPickerNodeId === n.id"
                    class="ngc-inline-model-picker ngc-inline-model-picker--node-anchor"
                    @mousedown.stop
                  >
                    <div class="ngc-inline-model-picker__head">
                      <span class="ngc-inline-model-picker__title">出图模型</span>
                      <button
                        type="button"
                        class="ngc-inline-model-picker__close"
                        @click="uiDesignImageModelPickerNodeId = null"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                    <div class="ngc-inline-model-picker__list">
                      <button
                        v-for="m in imageModelOptions"
                        :key="'uid-img-' + n.id + '-' + m.id"
                        type="button"
                        class="ngc-inline-model-picker__item"
                        :class="
                          String(n.data.seedreamModel || '').trim() === String(m.id || '').trim()
                            ? 'ngc-inline-model-picker__item--active'
                            : ''
                        "
                        @click.stop="setUiDesignImageModel(n, m.id)"
                      >
                        <span class="ngc-inline-model-picker__icon">
                          <i class="fas fa-image text-[10px] text-sky-200/90"></i>
                        </span>
                        <span class="ngc-inline-model-picker__label">{{ m.label }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="n.type === 'directorDeck'">
                <div class="flex flex-1 flex-col gap-2 rounded-xl border border-white/[0.08] bg-[#0e1210] p-2.5">
                  <div
                    class="relative w-full shrink-0 overflow-hidden rounded-lg border border-emerald-500/25 bg-black/45 aspect-video"
                    title="导演台导出 / 下游图片预览"
                    @mousedown.stop
                  >
                    <img
                      v-if="directorDeckMainPreviewUrl(n)"
                      :src="directorDeckMainPreviewUrl(n)"
                      class="absolute inset-0 h-full w-full object-contain"
                      alt="导演台或下游图片预览"
                      draggable="false"
                      @mousedown.stop
                    />
                    <div
                      v-else
                      class="absolute inset-0 flex flex-col items-center justify-center gap-1.5 px-2 text-center"
                    >
                      <i class="fas fa-image text-[22px] text-white/12"></i>
                      <span class="text-[8px] leading-snug text-gray-600">
                        在导演台「保存返回」后此处显示导出预览；或连接下游图片节点出图后显示该图
                      </span>
                    </div>
                  </div>
                  <p class="text-[9px] leading-snug text-gray-500">
                    机位关键帧、关节假人、导出 JSON / 预览图等在<strong class="text-emerald-200/90">独立全屏页</strong>操作。「保存返回」或带下游图片时的导出，会把预览同步到<strong class="text-gray-400">本卡片</strong>；若已连下游图片节点，也会显示其出图结果。
                  </p>
                  <router-link
                    :to="directorDeckOpenRoute(n)"
                    class="flex h-9 w-full shrink-0 items-center justify-center gap-2 rounded-lg bg-emerald-600/85 text-[11px] font-semibold text-white shadow hover:bg-emerald-500/95"
                    @click.native.stop="onBeforeOpenDirectorDeck"
                  >
                    <i class="fas fa-external-link-alt text-[10px] opacity-90"></i>
                    打开 3D 导演台
                  </router-link>
                  <div
                    v-if="String(directorDeckMainPreviewUrl(n) || '').trim() && directorDeckDownstreamMediaTargets(n).length"
                    class="flex max-w-full items-center gap-1.5 overflow-x-auto rounded-lg border border-white/[0.06] bg-black/30 px-1.5 py-1 scrollbar-thin"
                    @mousedown.stop
                  >
                    <!-- <span class="shrink-0 text-[8px] text-gray-500">同步到下游：</span>
                    <button
                      v-for="m in directorDeckDownstreamMediaTargets(n)"
                      :key="m.id"
                      type="button"
                      class="shrink-0 rounded-md border border-emerald-500/30 bg-emerald-900/25 px-2 py-0.5 text-[8px] text-emerald-100/95 hover:bg-emerald-800/35"
                      :title="
                        m.type === 'image'
                          ? '将当前导演台预览写入「图片' + imageNodeIndex(m) + '」'
                          : '将当前导演台预览写入「视频' + videoNodeIndex(m) + '」参考图'
                      "
                      @click.stop="applyDirectorShotToDownstream(n, m.id)"
                    >
                      <template v-if="m.type === 'image'">图片{{ imageNodeIndex(m) }}</template>
                      <template v-else>视频{{ videoNodeIndex(m) }}</template>
                    </button> -->
                  </div>
                </div>
              </template>
            </div>
          </div>

          <!-- 与当前选中节点相连的线段：置于未选中节点之上、选中节点之下，避免被其它卡片盖住 -->
          <svg
            v-if="ngcEdgesForegroundVisible.length"
            class="ngc-edges-svg ngc-edges-svg--incident-front absolute overflow-visible"
            :style="{
              width: '1px',
              height: '1px',
              left: 0,
              top: 0,
              zIndex: ngcIncidentEdgesLayerZ
            }"
          >
            <defs>
              <linearGradient id="ngc-edge-flow-grad-front" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stop-color="#22d3ee" stop-opacity="0.15" />
                <stop offset="35%" stop-color="#e879f9" stop-opacity="1" />
                <stop offset="50%" stop-color="#ffffff" stop-opacity="1" />
                <stop offset="65%" stop-color="#a78bfa" stop-opacity="1" />
                <stop offset="100%" stop-color="#22d3ee" stop-opacity="0.15" />
              </linearGradient>
            </defs>
            <g v-for="e in ngcEdgesForegroundVisible" :key="'egf-' + e.id">
              <path
                :d="ngcForegroundEdgePathById[e.id] || ''"
                fill="none"
                stroke="transparent"
                stroke-width="18"
                vector-effect="non-scaling-stroke"
                class="ngc-edge-hit"
                @mousedown.stop="selectEdge(e, $event)"
              />
              <path
                :d="ngcForegroundEdgePathById[e.id] || ''"
                fill="none"
                pointer-events="none"
                :stroke="selectedEdgeId === e.id ? 'rgba(56,189,248,0.45)' : 'rgba(168,85,247,0.35)'"
                :stroke-width="selectedEdgeId === e.id ? 7 : 5"
                stroke-linecap="round"
                vector-effect="non-scaling-stroke"
                class="ngc-edge-aura"
              />
              <path
                :d="ngcForegroundEdgePathById[e.id] || ''"
                fill="none"
                pointer-events="none"
                :stroke="
                  selectedEdgeId === e.id ? 'rgba(147,197,253,0.95)' : 'rgba(192,132,252,0.72)'
                "
                :stroke-width="selectedEdgeId === e.id ? 3.2 : 2.2"
                stroke-linecap="round"
                vector-effect="non-scaling-stroke"
                class="ngc-edge-core"
              />
              <path
                :d="ngcForegroundEdgePathById[e.id] || ''"
                pathLength="100"
                fill="none"
                pointer-events="none"
                stroke="url(#ngc-edge-flow-grad-front)"
                :stroke-width="selectedEdgeId === e.id ? 2.8 : 2"
                stroke-linecap="round"
                stroke-dasharray="18 82"
                vector-effect="non-scaling-stroke"
                class="ngc-edge-stream"
                :class="[
                  selectedEdgeId === e.id ? 'ngc-edge-stream--selected' : '',
                  !ngcEdgeStreamActiveForEdge(e) ? 'ngc-edge-stream--fx-off' : ''
                ]"
                :style="{ animationDelay: edgeStreamDelaySec(e) }"
              />
            </g>
          </svg>

          <!-- 选中图片节点：预览区上方的快捷工具条（世界坐标，随缩放） -->
          <div
            v-if="selectedImageToolbarStyle && selectedImageToolbarNode"
            ref="ngcImageToolbarEl"
            class="ngc-image-node-toolbar absolute flex flex-col items-stretch gap-0"
            :style="selectedImageToolbarStyle"
            @mousedown.stop
          >
            <div style="margin-top: -50px;"
              class="flex max-w-full items-center gap-0.5 self-center overflow-x-auto rounded-xl border border-white/[0.12] bg-[#1c1c24]/98 px-1.5 py-1 shadow-[0_8px_32px_rgba(0,0,0,0.55)] backdrop-blur-sm scrollbar-thin"
            >
              <button
                type="button"
                class="inline-flex shrink-0 items-center gap-1 rounded-lg px-2 py-1 text-[10px] text-gray-200 hover:bg-white/[0.08]"
                title="在提示词末尾插入 720° 全景生成指令（可再点执行出图）"
                @click.stop="append720PanoramaInstructionToImageNode(selectedImageToolbarNode)"
              >
                <i class="fas fa-street-view text-[11px] text-sky-300/90"></i>
                <span class="whitespace-nowrap">720 全景</span>
                <span
                  class="rounded px-1 py-px text-[7px] font-bold uppercase tracking-wide bg-sky-500 text-white"
                  >NEW</span
                >
              </button>
              <button
                type="button"
                class="inline-flex shrink-0 items-center gap-1 rounded-lg px-2 py-1 text-[10px] text-gray-200 hover:bg-white/[0.08]"
                title="多角度（即将接入）"
                @click.stop="toastImageToolbarSoon('多角度')"
              >
                <i class="fas fa-cube text-[11px] text-violet-300/90"></i>
                <span class="whitespace-nowrap">多角度</span>
              </button>
              <button
                type="button"
                class="inline-flex shrink-0 items-center gap-1 rounded-lg px-2 py-1 text-[10px] text-gray-200 hover:bg-white/[0.08]"
                title="打光（即将接入）"
                @click.stop="toastImageToolbarSoon('打光')"
              >
                <i class="fas fa-lightbulb text-[11px] text-amber-300/90"></i>
                <span class="whitespace-nowrap">打光</span>
              </button>
              <button
                type="button"
                data-ngc-img-toolbar-trigger="nine"
                class="inline-flex shrink-0 items-center gap-0.5 rounded-lg px-2 py-1 text-[10px] text-gray-200 hover:bg-white/[0.08]"
                title="九宫格"
                @click.stop="toggleImageToolbarMenu('nine')"
              >
                <i class="fas fa-th text-[11px] text-gray-300"></i>
                <span class="whitespace-nowrap">九宫格</span>
                <i class="fas fa-chevron-down text-[8px] text-gray-500"></i>
              </button>
              <button
                type="button"
                data-ngc-img-toolbar-trigger="redraw"
                class="inline-flex shrink-0 items-center gap-0.5 rounded-lg px-2 py-1 text-[10px] text-gray-200 hover:bg-white/[0.08]"
                title="重绘"
                @click.stop="toggleImageToolbarMenu('redraw')"
              >
                <i class="fas fa-pen-square text-[11px] text-gray-300"></i>
                <span class="whitespace-nowrap">重绘</span>
                <i class="fas fa-chevron-down text-[8px] text-gray-500"></i>
              </button>
              <button
                type="button"
                data-ngc-img-toolbar-trigger="split"
                class="inline-flex shrink-0 items-center gap-0.5 rounded-lg px-2 py-1 text-[10px] text-gray-200 hover:bg-white/[0.08]"
                title="宫格切分"
                @click.stop="toggleImageToolbarMenu('split')"
              >
                <i class="fas fa-border-all text-[11px] text-gray-300"></i>
                <span class="whitespace-nowrap">宫格切分</span>
                <i class="fas fa-chevron-down text-[8px] text-gray-500"></i>
              </button>
              <span class="mx-0.5 h-5 w-px shrink-0 bg-white/[0.12]"></span>
              <button
                type="button"
                class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-gray-300 hover:bg-white/[0.08]"
                title="涂抹 / 选区（即将接入）"
                @click.stop="toastImageToolbarSoon('选区涂抹')"
              >
                <i class="fas fa-paint-brush text-[12px]"></i>
              </button>
              <button
                type="button"
                class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-gray-300 hover:bg-white/[0.08]"
                title="翻转（即将接入）"
                @click.stop="toastImageToolbarSoon('翻转 / 旋转')"
              >
                <i class="fas fa-sync-alt text-[12px]"></i>
              </button>
              <button
                type="button"
                class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-sky-200/90 hover:bg-white/[0.08]"
                title="下载当前出图"
                @click.stop="downloadImageNodeOutput(selectedImageToolbarNode)"
              >
                <i class="fas fa-download text-[12px]"></i>
              </button>
              <button
                type="button"
                class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-violet-200/90 hover:bg-white/[0.08]"
                title="大图预览"
                @click.stop="openImageNodeLargePreview(selectedImageToolbarNode)"
              >
                <i class="fas fa-expand-alt text-[12px]"></i>
              </button>
            </div>
            <div
              v-if="imageToolbarMenu && imageToolbarDropdownLayout"
              class="ngc-image-node-toolbar-dropdown absolute z-[120] shadow-2xl rounded-lg border"
              :class="
                imageToolbarMenu === 'redraw'
                  ? 'border-white/[0.12] bg-[#1c1c24] py-0.5 w-max'
                  : 'border-white/[0.14] bg-[#25252e] py-1'
              "
              :style="imageToolbarDropdownStyle"
            >
              <template v-if="imageToolbarMenu === 'nine'">
                <button
                  v-for="opt in imageToolbarNineOptions"
                  :key="opt"
                  type="button"
                  class="w-full px-3 py-1.5 text-left text-[10px] text-gray-300 hover:bg-white/[0.06]"
                  @click.stop="toastImageToolbarSoon(opt)"
                >
                  {{ opt }}
                </button>
              </template>
              <template v-else-if="imageToolbarMenu === 'redraw'">
                <button
                  type="button"
                  class="inline-flex items-center gap-0.5 rounded-md px-2 py-1 text-left text-[10px] text-gray-200 hover:bg-white/[0.08]"
                  @click.stop="enterImageInpaintModeFromToolbar()"
                >
                  <i class="fas fa-pen-square text-[11px] text-gray-300"></i>
                  <span class="whitespace-nowrap">局部重绘</span>
                </button>
              </template>
              <template v-else-if="imageToolbarMenu === 'split'">
                <button
                  v-for="opt in imageToolbarSplitOptions"
                  :key="opt"
                  type="button"
                  class="w-full px-3 py-1.5 text-left text-[10px] text-gray-300 hover:bg-white/[0.06]"
                  @click.stop="toastImageToolbarSoon(opt)"
                >
                  {{ opt }}
                </button>
              </template>
            </div>
          </div>

          <!-- 选中连线：点击处剪刀删除（逆缩放保持按钮约固定屏幕大小） -->
          <div
            v-if="selectedEdgeCutWrapStyle"
            class="ngc-edge-cut-wrap absolute z-[50000] pointer-events-none"
            :style="selectedEdgeCutWrapStyle"
          >
            <button
              type="button"
              class="ngc-edge-cut pointer-events-auto flex h-9 w-9 items-center justify-center rounded-full border border-white/20 bg-[#1a1a22]/95 text-gray-100 shadow-lg shadow-black/40 hover:border-rose-400/55 hover:bg-rose-950/50 hover:text-rose-100"
              title="删除此连线"
              @mousedown.stop
              @click.stop="deleteSelectedEdge"
            >
              <i class="fas fa-cut text-[13px]"></i>
            </button>
          </div>
        </div>

        <div
          v-if="addMenu"
          class="ngc-add-menu fixed z-50 text-xs"
          :style="{ left: addMenu.sx + 'px', top: addMenu.sy + 'px' }"
          @mousedown.stop
        >
          <button
            v-for="opt in addOptions"
            :key="opt.type"
            type="button"
            class="ngc-add-menu-item"
            @click="addNodeAt(opt.type, addMenu.wx, addMenu.wy); addMenu = null"
          >
            {{ opt.label }}
          </button>
        </div>

        <div
          v-if="connectMenu"
          class="ngc-connect-menu fixed z-[55] w-[220px] rounded-2xl border border-white/[0.1] bg-[#1a1a22] shadow-2xl text-[11px] text-gray-200 overflow-hidden"
          :style="{ left: connectMenu.sx + 'px', top: connectMenu.sy + 'px' }"
          @mousedown.stop
        >
          <p class="px-3.5 py-2.5 text-[11px] font-medium text-gray-100 border-b border-white/[0.06]">
            {{ connectMenu.anchorMode === 'in' ? '接入上游节点' : '引用该节点生成' }}
          </p>
          <div class="py-1.5 px-1">
            <button
              v-for="(item, idx) in connectMenuOptions"
              :key="idx"
              type="button"
              class="w-full flex items-center gap-3 px-2.5 py-2 text-left rounded-lg transition-colors"
              :class="
                item.disabled
                  ? 'opacity-45 cursor-not-allowed text-gray-500'
                  : 'hover:bg-white/[0.06] text-gray-200'
              "
              @click="onConnectMenuPick(item)"
            >
              <span
                class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/[0.06] border border-white/[0.05]"
              >
                <i :class="[item.icon, 'text-[15px] text-gray-100']"></i>
              </span>
              <span class="flex-1 min-w-0">{{ item.label }}</span>
              <span
                v-if="item.beta"
                class="text-[9px] px-1.5 py-0.5 rounded-md bg-white/[0.08] text-gray-400 shrink-0"
              >
                Beta
              </span>
            </button>
          </div>
        </div>

        <!-- 画布小地图：缩略节点与连线、视口框；拖拽平移 · 单击将点击处移到视口中心 -->
        <div
          v-if="showMinimap"
          class="absolute bottom-3 right-3 z-[35] flex max-w-[calc(100%-1.5rem)] flex-col gap-1 rounded-xl border border-white/[0.1] bg-[#121218]/95 p-1.5 shadow-[0_8px_32px_rgba(0,0,0,0.45)] backdrop-blur-sm select-none"
          @mousedown.stop
        >
          <div class="flex items-center justify-between gap-2 px-0.5">
            <span class="text-[9px] font-medium uppercase tracking-wider text-gray-500">导航</span>
            <button
              type="button"
              class="flex h-5 w-5 shrink-0 items-center justify-center rounded text-gray-500 hover:bg-white/[0.08] hover:text-gray-300"
              title="隐藏（顶部可勾选「小地图」恢复）"
              @click.stop="showMinimap = false"
            >
              <i class="fas fa-times text-[10px]"></i>
            </button>
          </div>
          <svg
            ref="ngcMinimapSvg"
            class="ngc-minimap-svg block cursor-grab rounded border border-white/[0.06] bg-[#0d0d11] active:cursor-grabbing"
            width="184"
            height="118"
            :viewBox="`${ngcMinimapSpec.minX} ${ngcMinimapSpec.minY} ${ngcMinimapSpec.vbW} ${ngcMinimapSpec.vbH}`"
            preserveAspectRatio="xMidYMid meet"
            @mousedown.prevent="onMinimapMouseDown"
          >
            <rect
              :x="ngcMinimapSpec.minX"
              :y="ngcMinimapSpec.minY"
              :width="ngcMinimapSpec.vbW"
              :height="ngcMinimapSpec.vbH"
              fill="rgba(10,10,14,0.98)"
            />
            <g v-for="e in ngcMinimapEdgesSample" :key="'mme-' + e.id">
              <line
                :x1="e.x1"
                :y1="e.y1"
                :x2="e.x2"
                :y2="e.y2"
                stroke="rgba(167,139,250,0.28)"
                :stroke-width="ngcMinimapSpec.edgeStroke"
                stroke-linecap="round"
              />
            </g>
            <g v-for="n in nodes" :key="'mmn-' + n.id">
              <rect
                v-if="n && n.id != null"
                :x="Number(n.x) || 0"
                :y="Number(n.y) || 0"
                :width="Math.max(8, Number(n.w) || 200)"
                :height="Math.max(8, Number(n.h) || 100)"
                rx="3"
                fill="rgba(139,92,246,0.2)"
                stroke="rgba(255,255,255,0.07)"
                :stroke-width="ngcMinimapSpec.nodeStroke"
              />
            </g>
            <rect
              :x="ngcMinimapSpec.view.x"
              :y="ngcMinimapSpec.view.y"
              :width="Math.max(4, ngcMinimapSpec.view.w)"
              :height="Math.max(4, ngcMinimapSpec.view.h)"
              fill="rgba(56,189,248,0.09)"
              stroke="rgba(56,189,248,0.82)"
              :stroke-width="ngcMinimapSpec.viewStroke"
            />
          </svg>
          <p class="max-w-[184px] px-0.5 text-[8px] leading-snug text-gray-600">
            拖拽平移视窗 · 单击将目标移到中心
          </p>
        </div>
      </div>

      <!-- 上游缩略图右键：删除入边引用 -->
      <div
        v-if="ngcUpstreamThumbMenu"
        class="ngc-upstream-thumb-menu fixed z-[270] min-w-[148px] rounded-xl border border-white/[0.12] bg-[#1a1a22] py-1 shadow-2xl text-[11px] text-gray-200"
        :style="{ left: ngcUpstreamThumbMenu.left + 'px', top: ngcUpstreamThumbMenu.top + 'px' }"
        @mousedown.stop
        @contextmenu.prevent
      >
        <button
          type="button"
          class="flex w-full items-center gap-2 px-3 py-2 text-left text-red-200/95 hover:bg-red-500/15"
          @click="confirmRemoveUpstreamThumbRef"
        >
          <i class="fas fa-unlink text-[10px] opacity-90" aria-hidden="true"></i>
          删除引用上游节点
        </button>
      </div>

      <!-- 上游素材缩略图点击：图片大图预览 / 音频播放（遮罩层） -->
      <div
        v-if="upstreamPreview"
        class="ngc-upstream-preview fixed inset-0 z-[240] flex items-center justify-center bg-black/80 p-4"
        @mousedown.self="closeUpstreamPreview"
      >
        <div
          class="relative w-full max-w-4xl max-h-[92vh] overflow-hidden rounded-2xl border border-white/15 bg-[#141418] shadow-2xl"
          @mousedown.stop
        >
          <button
            type="button"
            class="absolute right-2 top-2 z-10 flex h-9 w-9 items-center justify-center rounded-full border border-white/15 bg-black/55 text-gray-200 hover:bg-white/10"
            title="关闭"
            @click="closeUpstreamPreview"
          >
            <i class="fas fa-times"></i>
          </button>
          <div class="border-b border-white/[0.06] px-3 py-2.5 pr-14">
            <p class="truncate text-xs font-medium text-gray-100">{{ upstreamPreview.title }}</p>
            <p class="mt-0.5 text-[10px] text-gray-500">Esc 或点击空白处关闭 · Alt+点击缩略图可定位上游节点</p>
          </div>
          <div class="flex max-h-[calc(92vh-88px)] min-h-[100px] items-center justify-center bg-black/40 p-4">
            <img
              v-if="upstreamPreview.kind === 'image'"
              :src="upstreamPreview.url"
              alt=""
              draggable="false"
              class="max-h-[calc(92vh-120px)] max-w-full rounded-lg object-contain shadow-lg select-none"
              @dragstart.prevent
            />
            <audio
              v-else-if="upstreamPreview.kind === 'audio'"
              :key="upstreamPreview.url"
              :src="upstreamPreview.url"
              controls
              autoplay
              class="w-full max-w-md"
              @mousedown.stop
            />
            <pre
              v-else
              class="max-h-[58vh] w-full overflow-auto whitespace-pre-wrap break-words rounded-lg border border-white/[0.06] bg-[#0c0c10] p-3 text-left font-sans text-[11px] leading-relaxed text-gray-300"
            >{{ upstreamPreview.snippet }}</pre>
          </div>
        </div>
      </div>

      <!-- 局部重绘：大屏在线编辑（画笔 / 矩形 / 橡皮，与卡片内画布同步） -->
      <div
        v-if="inpaintOnlineEditorNode"
        class="fixed inset-0 z-[99990] flex flex-col bg-black/90 backdrop-blur-[2px]"
        @mousedown.self="closeInpaintOnlineEditor"
      >
        <div
          class="shrink-0 flex flex-wrap items-center gap-1.5 border-b border-white/[0.08] bg-[#0f0f12]/95 px-4 py-2.5"
          @mousedown.stop
          @pointerdown.stop
        >
          <div class="mr-auto min-w-0 pr-2">
            <div class="text-sm font-semibold text-gray-100">局部重绘 · 在线编辑</div>
            <div class="text-[10px] text-gray-500 mt-0.5 leading-snug">
              画笔/矩形挖出重绘区（洞内为棋盘格示意透明）；橡皮恢复保留；其余区域为清晰底图。完成后导出蒙版提交生成。
            </div>
          </div>
          <span class="text-[9px] text-violet-200/80 font-medium whitespace-nowrap px-0.5">工具</span>
          <button
            type="button"
            class="flex h-8 w-8 items-center justify-center rounded-md border text-[10px] transition-colors"
            :class="
              (inpaintOnlineEditorNode.data.inpaintDrawTool || 'brush') === 'brush'
                ? 'border-violet-400/50 bg-violet-600/25 text-violet-100'
                : 'border-white/10 text-gray-400 hover:bg-white/[0.06]'
            "
            title="画笔（[ ] 调节粗细；画布上按住 Alt 滚轮）"
            @click.stop="setInpaintDrawTool(inpaintOnlineEditorNode, 'brush')"
          >
            <i class="fas fa-paint-brush"></i>
          </button>
          <button
            type="button"
            class="flex h-8 w-8 items-center justify-center rounded-md border text-[10px] transition-colors"
            :class="
              inpaintOnlineEditorNode.data.inpaintDrawTool === 'rect'
                ? 'border-violet-400/50 bg-violet-600/25 text-violet-100'
                : 'border-white/10 text-gray-400 hover:bg-white/[0.06]'
            "
            title="矩形选区（按住 Shift 拖正方形）"
            @click.stop="setInpaintDrawTool(inpaintOnlineEditorNode, 'rect')"
          >
            <i class="far fa-square"></i>
          </button>
          <button
            type="button"
            class="flex h-8 w-8 items-center justify-center rounded-md border text-[10px] transition-colors"
            :class="
              inpaintOnlineEditorNode.data.inpaintDrawTool === 'erase'
                ? 'border-violet-400/50 bg-violet-600/25 text-violet-100'
                : 'border-white/10 text-gray-400 hover:bg-white/[0.06]'
            "
            title="橡皮（恢复保留区）"
            @click.stop="setInpaintDrawTool(inpaintOnlineEditorNode, 'erase')"
          >
            <i class="fas fa-eraser"></i>
          </button>
          <label class="flex items-center gap-1 text-[9px] text-gray-500 whitespace-nowrap">
            <i class="fas fa-circle-notch text-[8px] opacity-70"></i>
            <input
              v-model.number="inpaintOnlineEditorNode.data.inpaintBrushSize"
              type="range"
              min="2"
              max="128"
              step="1"
              class="w-28 h-1 accent-violet-400"
              @mousedown.stop
            />
            <span class="tabular-nums text-gray-400 w-8 text-right">{{ Math.round(inpaintOnlineEditorNode.data.inpaintBrushSize || 28) }}</span>
          </label>
          <button
            type="button"
            class="flex h-8 w-8 items-center justify-center rounded-md border border-white/10 text-gray-400 hover:bg-white/[0.06]"
            title="撤销"
            @click.stop="inpaintUndo(inpaintOnlineEditorNode)"
          >
            <i class="fas fa-undo text-[10px]"></i>
          </button>
          <button
            type="button"
            class="flex h-8 w-8 items-center justify-center rounded-md border border-white/10 text-gray-400 hover:bg-white/[0.06]"
            title="重做"
            @click.stop="inpaintRedo(inpaintOnlineEditorNode)"
          >
            <i class="fas fa-redo text-[10px]"></i>
          </button>
          <button
            type="button"
            class="ml-auto text-[10px] px-3 py-1.5 rounded-md border border-emerald-500/35 text-emerald-200/90 hover:bg-emerald-900/30"
            title="应用蒙版并退出重绘"
            @click.stop="finishImageInpaintMode(inpaintOnlineEditorNode)"
          >
            完成
          </button>
          <button
            type="button"
            class="text-[10px] px-2 py-1.5 rounded-md text-gray-500 hover:text-rose-300"
            title="关闭编辑器（同步笔触回卡片）"
            @click.stop="closeInpaintOnlineEditor"
          >
            关闭
          </button>
          <button
            type="button"
            class="ml-auto flex h-9 w-9 items-center justify-center rounded-full border border-white/15 bg-black/40 text-gray-200 hover:bg-white/10"
            title="关闭"
            @click.stop="closeInpaintOnlineEditor"
          >
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="flex flex-1 min-h-0 items-center justify-center overflow-auto p-4">
          <div
            :data-ngc-inpaint-wrap-modal="inpaintOnlineEditorNode.id"
            class="relative flex max-h-[min(82vh,920px)] max-w-[min(96vw,1280px)] items-center justify-center cursor-crosshair touch-none"
            @pointerdown.stop.prevent="inpaintWrapPointerDown($event, inpaintOnlineEditorNode, 'modal')"
            @mousedown.stop.prevent="inpaintWrapPointerDown($event, inpaintOnlineEditorNode, 'modal')"
            @wheel="inpaintWrapWheel($event, inpaintOnlineEditorNode)"
          >
            <img
              v-if="imageNodeDisplaySrc(inpaintOnlineEditorNode)"
              :data-ngc-inpaint-base-img="inpaintOnlineEditorNode.id"
              :src="imageNodeDisplaySrc(inpaintOnlineEditorNode)"
              alt=""
              draggable="false"
              class="relative z-0 max-h-[min(82vh,920px)] max-w-[min(96vw,1280px)] w-auto h-auto object-contain select-none pointer-events-none shadow-2xl"
              @dragstart.prevent
              @load="onInpaintModalBaseImgLoad(inpaintOnlineEditorNode)"
            />
            <canvas
              :data-ngc-inpaint-canvas="inpaintOnlineEditorNode.id"
              class="pointer-events-none touch-none cursor-crosshair absolute z-[100]"
              style="left: 0; top: 0; width: 0; height: 0"
            ></canvas>
          </div>
        </div>
      </div>

      <!-- 图片 / 分镜节点：风格库（与对话工作流同源） -->
      <div
        v-if="showImageStyleLibrary"
        class="fixed inset-0 z-[250] bg-black/45 backdrop-blur-[1px]"
        @mousedown="closeImageStyleLibrary"
      ></div>
      <div
        v-if="showImageStyleLibrary"
        class="fixed left-1/2 top-1/2 z-[260] w-[min(96%,520px)] max-h-[min(88vh,640px)] -translate-x-1/2 -translate-y-1/2"
        @mousedown.stop
      >
        <div
          class="flex h-[min(88vh,640px)] max-h-[min(88vh,640px)] flex-col overflow-hidden rounded-3xl border border-white/[0.10] bg-[#1b1b1f]/95 shadow-[0_30px_120px_rgba(0,0,0,0.70)]"
        >
          <div class="shrink-0 px-5 pt-5 pb-3 flex items-center justify-between gap-3">
            <div class="min-w-0">
              <div class="text-lg font-black text-gray-100 tracking-tight">风格库</div>
              <div v-if="ngcStyleLibraryTargetLabel" class="mt-1 truncate text-[10px] text-gray-500">
                {{ ngcStyleLibraryTargetLabel }}
              </div>
            </div>
            <div class="flex items-center gap-2 shrink-0">
              <button
                v-if="ngcStyleLibraryTargetNode && ngcStyleLibraryTargetNode.data.workflowStyle"
                type="button"
                class="h-8 px-3 rounded-full bg-white/[0.06] hover:bg-white/[0.10] border border-white/[0.10] text-[12px] text-gray-200 font-semibold"
                title="清除当前节点已选风格"
                @click="clearWorkflowStyleForPickerTarget"
              >
                清除
              </button>
              <button
                type="button"
                class="w-9 h-9 rounded-full bg-white/[0.06] hover:bg-white/[0.10] border border-white/[0.10] text-gray-300 flex items-center justify-center"
                title="关闭"
                @click="closeImageStyleLibrary"
              >
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
          <div class="shrink-0 px-5 pb-3">
            <div class="flex flex-wrap gap-2">
              <button
                v-for="t in ngcStyleCategoryTabs"
                :key="'ngc-st-' + t.id"
                type="button"
                class="h-8 px-3 rounded-full border text-[12px] font-semibold transition-colors"
                :class="
                  ngcStyleTab === t.id
                    ? 'bg-white/[0.12] text-white border-white/[0.14]'
                    : 'bg-white/[0.06] hover:bg-white/[0.10] text-gray-300 border-white/[0.10]'
                "
                @click="ngcOnStyleCategoryTabClick(t)"
              >
                {{ t.label }}
              </button>
            </div>
          </div>
          <div
            ref="ngcStyleLibraryScroll"
            class="min-h-0 flex-1 overflow-y-auto px-5 pb-5 scrollbar-thin"
            @scroll="ngcOnStyleLibraryScroll"
          >
            <p
              v-if="ngcStylePanelLoading || ngcStyleCategoryLoading"
              class="py-6 text-center text-[11px] text-gray-500"
            >
              加载风格中…
            </p>
            <div v-else class="grid grid-cols-3 sm:grid-cols-4 gap-3">
              <button
                v-for="s in ngcFilteredStyles"
                :key="'ngc-s-' + s.id"
                type="button"
                class="group rounded-2xl border transition-colors overflow-hidden aspect-[3/4] text-left"
                :class="
                  ngcStyleLibraryTargetNode &&
                  ngcStyleLibraryTargetNode.data.workflowStyle &&
                  ngcStyleLibraryTargetNode.data.workflowStyle.id === s.id
                    ? 'border-fuchsia-500/50 bg-fuchsia-500/10'
                    : 'border-white/[0.10] bg-white/[0.04] hover:bg-white/[0.07]'
                "
                :title="s.name"
                @click="selectWorkflowStyle(s)"
              >
                <div class="h-full w-full p-3 flex flex-col justify-between">
                  <div
                    class="w-full rounded-xl bg-gradient-to-br from-white/[0.10] to-white/[0.02] border border-white/[0.10] flex-1 flex items-center justify-center overflow-hidden"
                  >
                    <img
                      v-if="s.thumb"
                      :src="s.thumb"
                      alt=""
                      draggable="false"
                      loading="lazy"
                      decoding="async"
                      class="w-full h-full object-cover opacity-95 select-none"
                      @dragstart.prevent
                    />
                    <span v-else class="text-[22px] font-black tracking-tight text-white/80">{{
                      s.badge || 'S'
                    }}</span>
                  </div>
                  <div class="pt-2 text-center">
                    <div class="text-[12px] font-bold text-gray-100 truncate">{{ s.name }}</div>
                    <div
                      v-if="String(s.tab || '') !== 'mine'"
                      class="text-[10px] text-gray-400 truncate mt-0.5"
                    >
                      {{ s.desc || '' }}
                    </div>
                  </div>
                </div>
              </button>
            </div>
            <p
              v-if="!ngcStylePanelLoading && !ngcStyleCategoryLoading && !ngcFilteredStyles.length"
              class="py-8 text-center text-[11px] text-gray-500"
            >
              暂无风格，请切换分类或先在对话工作流中添加「我的风格」
            </p>
            <p
              v-if="ngcShouldShowStyleLoadMore"
              class="pt-2 text-center text-[10px] text-gray-500"
            >
              向下滚动加载更多…
            </p>
          </div>
        </div>
      </div>

      <!-- 画布内确认弹窗（替代原生 confirm） -->
      <transition name="ngc-confirm-fade">
        <div
          v-if="ngcConfirmDialog"
          class="ngc-confirm-root fixed inset-0 z-[280] flex items-center justify-center p-4"
          role="dialog"
          aria-modal="true"
          :aria-label="ngcConfirmDialog.title || '确认'"
          @mousedown.self="resolveNgcConfirm(false)"
        >
          <div class="absolute inset-0 bg-black/72 backdrop-blur-[6px]" aria-hidden="true"></div>
          <div
            class="ngc-confirm-panel relative z-10 w-full max-w-[400px] overflow-hidden rounded-2xl border border-white/[0.1] bg-[#14141a] shadow-[0_24px_80px_-12px_rgba(0,0,0,0.85)]"
            @mousedown.stop
          >
            <div
              class="ngc-confirm-panel-accent h-1 w-full"
              :class="
                ngcConfirmDialog.tone === 'danger'
                  ? 'ngc-confirm-panel-accent--danger'
                  : 'ngc-confirm-panel-accent--amber'
              "
            ></div>
            <div class="px-6 pb-6 pt-5">
              <div class="flex items-start gap-4">
                <div
                  class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border"
                  :class="
                    ngcConfirmDialog.tone === 'danger'
                      ? 'border-rose-500/30 bg-rose-500/12 text-rose-200'
                      : 'border-amber-500/35 bg-amber-500/12 text-amber-200'
                  "
                >
                  <i
                    class="fas text-lg"
                    :class="
                      ngcConfirmDialog.tone === 'danger' ? 'fa-exclamation-triangle' : 'fa-redo'
                    "
                    aria-hidden="true"
                  ></i>
                </div>
                <div class="min-w-0 flex-1 pt-0.5">
                  <h3 class="text-[15px] font-semibold leading-snug tracking-tight text-white">
                    {{ ngcConfirmDialog.title }}
                  </h3>
                  <p class="mt-2 text-[12px] leading-relaxed text-gray-400">
                    {{ ngcConfirmDialog.message }}
                  </p>
                </div>
              </div>
              <div class="mt-6 flex items-center justify-end gap-2.5">
                <button
                  type="button"
                  class="ngc-confirm-btn ngc-confirm-btn--ghost h-9 min-w-[88px] rounded-xl px-4 text-[12px] font-medium text-gray-300"
                  @click="resolveNgcConfirm(false)"
                >
                  {{ ngcConfirmDialog.cancelText || '取消' }}
                </button>
                <button
                  type="button"
                  class="ngc-confirm-btn ngc-confirm-btn--primary h-9 min-w-[96px] rounded-xl px-4 text-[12px] font-semibold text-white"
                  :class="
                    ngcConfirmDialog.tone === 'danger'
                      ? 'ngc-confirm-btn--danger'
                      : 'ngc-confirm-btn--amber'
                  "
                  @click="resolveNgcConfirm(true)"
                >
                  {{ ngcConfirmDialog.confirmText || '确定' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <WorkflowAssetPanelModal
        :visible="ngcCharacterLibModal.visible"
        :anchor-rect="ngcCharacterLibModal.anchorRect"
        @close="closeNgcCharacterLibrary"
        @pick-asset="onNgcCharacterAssetPicked"
      />
    </div>
  </div>
</template>

<script>
import { showErrorToast, showSuccessToast } from '@/utils/toast'
import {
  blobFromLoadedImageElement,
  downloadImageFile,
  extractUploadsPath,
  fixImageUrl
} from '@/utils/helpers'
import { consumeCanvasNodeHandoff } from '@/utils/canvasNodeHandoff'
import { canvasLaunchNodeLabel } from '@/constants/canvasLaunchNodeOptions'

/** 从 3D 导演台导出 PNG 回写图片节点（与 DirectorDeck3D 共用 key） */
const NGC_DIRECTOR_PNG_SESSION_KEY = 'ngc_director_png_v1'
const NGC_LAST_OPENED_CANVAS_KEY = 'ngc_last_opened_canvas'
import {
  deleteNodeCanvas,
  fetchNodeCanvasDetail,
  fetchNodeCanvasList,
  saveNodeCanvas
} from '@/utils/nodeCanvasApi'
import { addAssetsToLibrary } from '@/utils/assetLibraryApi'
import NgcNodeSelect from '@/components/NgcNodeSelect.vue'
import WorkflowAssetPanelModal from '@/components/WorkflowAssetPanelModal.vue'
import { getAnchorRect } from '@/utils/workflowPopoverAnchor'
import {
  directorDeckUpstreamImageUrl,
  firstDownstreamImageNodeIdFromDeck,
  exportNodeText,
  gatherUpstreamAudioUrls,
  gatherUpstreamImageMetaForEcom,
  gatherUpstreamImageUrls,
  gatherUpstreamText,
  gatherUpstreamTextForImagePrompt,
  gatherUpstreamVideoUrls,
  gatherUpstreamSpeechText,
  effectiveWorkflowStyleForImageNode,
  effectiveImageAspectKeyForImageNode,
  effectiveVideoRatioForVideoNode,
  gatherUpstreamStoryboardAspectRatio,
  pickFirstImageThumb,
  predecessorIds,
  sleep,
  topoSort
} from '@/utils/nodeGraphRunner'
import {
  synthesizeClonedVoice,
  uploadNodeAudioFile,
  synthesizeVolcDoubaoTts,
  registerVolcDoubaoCloneVoice,
  normalizeVolcTtsBracketText
} from '@/utils/nodeAudioTts'
import { volcChatComplete } from '@/utils/nodeCanvasVolcChat'
import { generateSeedreamImages, pickFirstSeedreamImageUrl } from '@/utils/seedreamImageApi'
import { fetchUserCenterConfig } from '@/utils/bannerApi'
import {
  ECOM_DETAIL_BUILTIN_SKILLS,
  ECOM_DETAIL_DEEPSEEK_SYSTEM,
  ECOM_DETAIL_DEFAULT_OUTPUT_LANGUAGE,
  ECOM_DETAIL_OUTPUT_LANGUAGES,
  ECOM_DETAIL_PLATFORMS,
  ECOM_DETAIL_SLOT_DEFS,
  buildEcomDetailSlotPrompt,
  getEnabledEcomDetailSlots,
  isEcomPromptExpertSkill,
  isEcomVisualPromptSkill,
  normalizeEcomDetailSlots,
  resolveEcomDetailSkill,
  ECOM_UPSTREAM_IMAGE_ANALYSIS_PROMPT,
  buildEcomUpstreamImageVisionMessages
} from '@/utils/ecomDetailNode'
import {
  SCRIPT_WRITE_DEEPSEEK_SYSTEM_PROMPT,
  SCRIPT_WRITE_GENRE_OPTIONS,
  SCRIPT_WRITE_LENGTH_OPTIONS,
  SCRIPT_WRITE_SELECT_CUSTOM,
  exportScriptWriteNodeText,
  resolveScriptWriteGenre,
  resolveScriptWriteLengthHint
} from '@/utils/scriptWriteNode'
import {
  STORYBOARD_LANGUAGE_OPTIONS,
  STORYBOARD_ASPECT_RATIO_OPTIONS,
  STORYBOARD_DEEPSEEK_SYSTEM_PROMPT,
  SCRIPT_TO_STORYBOARD_BUNDLE_JSON_PROMPT,
  buildImageAspectKeyFromStoryboardRatio,
  buildStoryboardPreferencesUserBlock,
  resolveStoryboardAspectRatio,
  storyboardAspectRatioFromNode
} from '@/utils/storyboardNodeOptions'
import {
  STORYBOARD_VIDEO_NODE_MAX_SEC,
  STORYBOARD_VIDEO_NODE_MIN_SEC,
  buildTimelineStyleShotBody,
  formatShotsAsTimelineStoryboard,
  groupStoryboardShotsForVideoNodes,
  parseTimelineStoryboardSegments
} from '@/utils/storyboardTimelineFormat'
import {
  UI_DESIGN_PLATFORMS,
  UI_DESIGN_BUILTIN_STYLES,
  UI_DESIGN_STYLE_CUSTOM_ID,
  UI_DESIGN_DEFAULT_STYLE_ID,
  UI_DESIGN_DEFAULT_PRIMARY,
  UI_DESIGN_DEFAULT_SECONDARY,
  UI_DESIGN_DISPLAY_MODES,
  UI_SIZE_MAIN,
  UI_SIZE_DETAIL,
  UI_DESIGN_DEFAULT_SCREEN_COUNT,
  normalizeUiDesignScreenCount,
  uiDesignScreenCountDropdownOptions as getUiDesignScreenCountDropdownOptions,
  normalizeUiDesignStyleId,
  alignUiDesignToPlan,
  exportUiDesignNodeText,
  parseUiDesignSections,
  resolveUiDesignStyleText,
  uiDesignOutputUrls,
  uiDesignStyleSummary as getUiDesignStyleSummary
} from '@/utils/uiDesignNode'
import {
  buildUiDesignExpertUserMessage,
  getUiDesignExpertBuiltinSkill,
  uiDesignExpertSystemForSkill
} from '@/utils/uiDesignExpertSkill'
import {
  alignEcomPromptExpertToPlan,
  buildEcomPromptExpertUserMessage,
  ecomPromptExpertSystemForSkill,
  getEcomPromptExpertBuiltinSkill,
  ECOM_SKILL_PROMPT_EXPERT_ID,
  mergeEcomDetailSkillList,
  parseEcomPromptExpertSections
} from '@/utils/ecomPromptExpertSkill'
import {
  alignEcomAppPromptExpertToPlan,
  buildEcomVisualPromptUserMessage,
  ecomVisualPromptSystemForSkill,
  parseEcomPromptExpertSections as parseEcomAppPromptSections
} from '@/utils/ecomVisualPromptSkill'
import {
  ecomPlanSizeToAspectKey,
  normalizeEcomPromptPlanRow,
  resolveEcomSeedreamOutputSize
} from '@/utils/ecomSeedreamSizes'
import {
  inferEcomProductAnalysisFromText,
  tryEcomVisionImageAnalysis
} from '@/utils/ecomUpstreamImageAnalyze'
import {
  UI_UPSTREAM_STYLE_VISION_PREFIX,
  buildUiUpstreamStyleParseHints,
  inferUiDesignStyleFromUpstreamText,
  parseUiDesignStyleFromAnalysis
} from '@/utils/uiDesignUpstreamStyleAnalyze'
import { uploadVideoMediaFile } from '@/utils/videoImageApi'
import {
  buildWorkflowStylePromptSuffix,
  cloneWorkflowStylePlain,
  fetchWorkflowStyleCategoriesList,
  isWorkflowStyleSet,
  mergeWorkflowStyleSearchResponse,
  pickWorkflowStyleRef,
  postWorkflowStyleSearch,
  workflowStyleFromStoryboardNode
} from '@/utils/workflowStyleApi'
import {
  appendWorkflowStyleMetaForCharacterDesigner,
  buildFinalCharacterSheetPaintPrompt,
  characterSheetStyleRefImages,
  nodeNeedsCharacterDesignerLlm,
  resolveNodeImagePaintModelId,
  streamCharacterDesignerPaintPrompt
} from '@/utils/characterDesignerImage'
import {
  createSeedanceVideoTask,
  getSeedanceVideoTask,
  pickSeedanceTaskVideoUrl
} from '@/utils/seedanceVideoApi'
import {
  createHappyHorseVideoTask,
  getHappyHorseVideoTask,
  isHappyHorseVideoModel,
  pickHappyHorseTaskVideoUrl
} from '@/utils/happyhorseVideoApi'
import {
  NGC_LLM_MODEL_OPTIONS,
  NGC_IMAGE_MODEL_OPTIONS,
  NGC_VIDEO_MODEL_OPTIONS,
  NGC_AUDIO_MODEL_OPTIONS
} from '@/constants/nodeGraphCanvasModelOptions'
import {
  NGC_MODEL_KIND,
  assertUserHasCredits,
  assertModelsOnShelf,
  calcRequiredCreditsFromCatalog,
  catalogCreditsLine,
  collectNodeRunModelTargets,
  fetchModelsList,
  MODEL_OFF_SHELF_MESSAGE,
  findModelInCatalog,
  getApiErrorMessage as getModelsApiErrorMessage,
  isModelInCatalog,
  mergeCanvasModelOptions,
  resolveVideoModelChargeId,
  resolveVideoCreditsPerSecond
} from '@/utils/modelsListApi'
import { NGC_VIDEO_RESOLUTIONS } from '@/constants/videoResolutionPricing'
import { fetchCreditsUserProfile } from '@/utils/creditsRechargeApi'
import { requestBalanceBillingModal } from '@/utils/balanceBillingGate'
import { hasAuthToken, openLoginModal } from '@/utils/loginGate'
import {
  VOLC_TTS_SPEAKER_PRESETS,
  VOLC_SPEAKER_CUSTOM_ID,
  VOLC_TTS_DEFAULT_SPEAKER_ID,
  getVolcTtsResourceIdForSpeaker,
  inferVolcSpeakerPick
} from '@/constants/volcTtsSpeakers'
function genId() {
  return `n-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`
}

function genEdgeId() {
  return `e-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`
}

/**
 * 解析提示词框内「@提及」：当前行最后一个 @ 起至光标，filter 仅含字母数字与中文（用于筛选）。
 * @returns {{ anchorStart: number, filter: string } | null}
 */
function getAssetMentionContext(text, caretPos) {
  const t = text == null ? '' : String(text)
  const pos = Math.min(Math.max(0, Number(caretPos) || 0), t.length)
  const before = t.slice(0, pos)
  const lineStart = before.lastIndexOf('\n') + 1
  const line = before.slice(lineStart)
  const at = line.lastIndexOf('@')
  if (at === -1) return null
  const afterAt = line.slice(at + 1)
  if (!/^[\w\u4e00-\u9fa5]*$/.test(afterAt)) return null
  return { anchorStart: lineStart + at, filter: afterAt }
}

/** 续集：名称归一化（NFKC、去零宽与空白），用于稳定匹配前一集「人物/道具/场景」 */
function normStoryboardContinuityName(s) {
  let t = String(s || '').trim()
  try {
    if (typeof t.normalize === 'function') t = t.normalize('NFKC')
  } catch (e) {
    /* ignore */
  }
  return t
    .replace(/[\uFEFF\u200B-\u200D\u2060]/g, '')
    .replace(/[\s\u3000]+/g, '')
    .toLowerCase()
}

/** 去掉「名称」里常见前缀/括号后再归一化，便于与前一集图片节点对齐 */
function stripContinuityAssetDecorators(raw) {
  let s = String(raw == null ? '' : raw).trim()
  try {
    if (typeof s.normalize === 'function') s = s.normalize('NFKC')
  } catch (e) {
    /* ignore */
  }
  s = s.replace(/^[\s\u3000「『【"'“‘]+/g, '')
  s = s.replace(/[\s\u3000」』】"'”’]+$/g, '')
  s = s.replace(
    /^(?:人物|角色|主角|配角|道具|物品|场景|环境|地点|舞台)\s*[:：．.·\-—\s]+/i,
    ''
  )
  s = s.replace(/^(?:the|a|an)\s+/i, '')
  s = s.replace(/(?:（[^）]{1,16}）|\([^)]{1,16}\))$/g, '')
  return s.trim()
}

/** 续集资产字典键：与 buildCanonicalMaps / 模型返回名称 使用同一规则 */
function continuityAssetLookupKey(name) {
  return normStoryboardContinuityName(stripContinuityAssetDecorators(name))
}

/** 镜号 / 视频节点标题序号 → 整理布局时的数字排序键 */
function parseStoryboardShotNumberSortKey(raw) {
  const s = String(raw == null ? '' : raw).trim()
  if (!s) return NaN
  const m = s.match(/\d+/)
  if (!m) return NaN
  const n = parseInt(m[0], 10)
  return Number.isFinite(n) ? n : NaN
}

function mergeStoryboardLinesIntoVideoPromptBody(sh, base) {
  let out = String(base || '').trim()
  const dia = String(sh && sh.dialogue != null ? sh.dialogue : '')
    .trim()
    .replace(/\r\n/g, '\n')
  const sfx = String(sh && sh.sfx != null ? sh.sfx : '')
    .trim()
    .replace(/\r\n/g, '\n')
  const chunks = []
  if (dia && dia !== '无') {
    if (!out || out.indexOf(dia) === -1) chunks.push(`【角色台词】${dia}`)
  }
  if (sfx && sfx !== '无') {
    if (!out || out.indexOf(sfx) === -1) chunks.push(`【音效】${sfx}`)
  }
  if (!chunks.length) return out
  return out ? `${out}\n\n${chunks.join('\n')}` : chunks.join('\n')
}

function stripJsonArrayFromModelText(text) {
  let t = String(text || '').trim()
  const fence = /```(?:json)?\s*([\s\S]*?)```/i.exec(t)
  if (fence) t = fence[1].trim()
  const a = t.indexOf('[')
  const b = t.lastIndexOf(']')
  if (a === -1 || b <= a) {
    const err = new Error('模型返回中未找到 JSON 数组')
    err.code = 'NO_JSON_ARRAY'
    throw err
  }
  try {
    return JSON.parse(t.slice(a, b + 1))
  } catch (e) {
    const err = new Error(`JSON 解析失败：${e && e.message ? e.message : String(e)}`)
    err.code = 'JSON_PARSE'
    throw err
  }
}

function stripJsonObjectFromModelText(text) {
  let t = String(text || '').trim()
  const fence = /```(?:json)?\s*([\s\S]*?)```/i.exec(t)
  if (fence) t = fence[1].trim()
  const a = t.indexOf('{')
  const b = t.lastIndexOf('}')
  if (a === -1 || b <= a) {
    const err = new Error('模型返回中未找到 JSON 对象')
    err.code = 'NO_JSON_OBJECT'
    throw err
  }
  try {
    return JSON.parse(t.slice(a, b + 1))
  } catch (e) {
    const err = new Error(`JSON 解析失败：${e && e.message ? e.message : String(e)}`)
    err.code = 'JSON_PARSE'
    throw err
  }
}

/** 人物索引 / 道具索引 / 场景索引：统一为从 0 开始的非负整数数组 */
function normStoryboardIndexList(v) {
  if (v == null) return []
  if (Array.isArray(v)) {
    const o = []
    for (const x of v) {
      const n = Math.round(Number(x))
      if (!Number.isNaN(n) && n >= 0) o.push(n)
    }
    return o
  }
  const n = Math.round(Number(v))
  return Number.isNaN(n) || n < 0 ? [] : [n]
}

/** 文本节点默认走 DeepSeek OpenAI 兼容接口（后端需配置 DEEPSEEK_API_KEY 或 sys DeepSeekApiKey） */
const LLM_DEFAULT_MODEL = 'deepseek-v4-flash'
const DEEPSEEK_CHAT_BASE = 'https://api.deepseek.com'

/** 本机最近保存的画布元数据；完整 state 见 node_canvas_state_v1_{uuid} */
const NODE_CANVAS_RECENT_LS = 'node_canvas_recent_projects_v1'
const NODE_CANVAS_STATE_PREFIX = 'node_canvas_state_v1_'
/** 编辑防抖写本机；接口返回/提交成功后更快同步云端 */
const NGC_EDIT_AUTOSAVE_MS = 600
const NGC_CLOUD_SAVE_DEBOUNCE_MS = 1000
const NGC_CLOUD_SAVE_AFTER_API_MS = 500

/** 豆包语音合成 2.0 控制台：默认 / 语音指令 / 引入上文 */
const VOLC_TTS_EXPRESS_MODE_OPTIONS = [
  { value: 'default', label: '默认' },
  { value: 'voice_instruction', label: '语音指令' },
  { value: 'prior_context', label: '引入上文' }
]

/** 音频节点：直接使用上传/上游文件，或文生音频（豆包 TTS 等） */
const AUDIO_INPUT_MODES = {
  upload: 'upload',
  tts: 'tts'
}

/** 图片节点：本地上传/上游出图，或 Seedream 文生图 */
const IMAGE_INPUT_MODES = {
  upload: 'upload',
  generate: 'generate'
}

/** 比例 × 1K/2K/4K → 后端 size（与 Seedream / API易 等 WxH 约定一致） */
function buildImageAspectPresets() {
  const defs = [
    { slug: 'adaptive', short: '自适应', sizes: { '1k': '1280x720', '2k': '2560x1440', '4k': '3840x2160' } },
    { slug: '1x1', short: '1:1', sizes: { '1k': '1024x1024', '2k': '2048x2048', '4k': '4096x4096' } },
    { slug: '9x16', short: '9:16', sizes: { '1k': '720x1280', '2k': '1440x2560', '4k': '2160x3840' } },
    { slug: '16x9', short: '16:9', sizes: { '1k': '1280x720', '2k': '2560x1440', '4k': '3840x2160' } },
    { slug: '3x4', short: '3:4', sizes: { '1k': '768x1024', '2k': '1536x2048', '4k': '2304x3072' } },
    { slug: '4x3', short: '4:3', sizes: { '1k': '1024x768', '2k': '2048x1536', '4k': '3072x2304' } },
    { slug: '3x2', short: '3:2', sizes: { '1k': '1200x800', '2k': '2400x1600', '4k': '3600x2400' } },
    { slug: '2x3', short: '2:3', sizes: { '1k': '800x1200', '2k': '1600x2400', '4k': '2400x3600' } },
    { slug: '4x5', short: '4:5', sizes: { '1k': '1024x1280', '2k': '1638x2048', '4k': '2048x2560' } },
    { slug: '5x4', short: '5:4', sizes: { '1k': '1280x1024', '2k': '2048x1638', '4k': '2560x2048' } },
    { slug: '21x9', short: '21:9', sizes: { '1k': '1280x549', '2k': '2560x1097', '4k': '3840x1646' } }
  ]
  const tiers = ['1k', '2k', '4k']
  const tierLab = { '1k': '1K', '2k': '2K', '4k': '4K' }
  const out = []
  for (const d of defs) {
    for (const t of tiers) {
      const key = `${d.slug}_${t}`
      out.push({
        key,
        label: `${d.short} · ${tierLab[t]}`,
        size: d.sizes[t],
        ratioSlug: d.slug,
        tier: t,
        ratioLabel: d.short
      })
    }
  }
  return out
}
const IMAGE_ASPECT_PRESETS = buildImageAspectPresets()

/** 画幅选择器：与参考 UI 一致的三行比例网格 */
const NGC_IMAGE_ASPECT_RATIO_GRID = [
  ['adaptive', '1x1', '9x16', '16x9', '3x4'],
  ['4x3', '3x2', '2x3', '4x5', '5x4'],
  ['21x9']
]

/** 提示词内锚点，用于去重与识别「720° 全景」生成约束 */
const NGC_720_PANORAMA_MARKER = '【NGC·720全景】'
/** 追加到图片节点提示词末尾，引导文生图输出等距圆柱全景贴图 */
const NGC_720_PANORAMA_INSTRUCTION = `${NGC_720_PANORAMA_MARKER}
请生成一张可用于环境贴图的**等距圆柱投影（equirectangular）360°/720° 全景图**：
- 宽高比约 **2:1**（水平方向环绕一整圈），画面**左右边缘须无缝衔接**，无黑边、无可见垂直接缝；
- 地平线大致位于画面垂直中部，垂直方向覆盖约上下各 90° 视场，整体连续、无「多平面硬拼」感；
- 曝光与色彩一致、细节清晰、无明显拉伸畸变；场景内容与用户描述及上游参考（若有）一致；
- 输出为**单张静态全景帧**（非 HTML/非立方体贴图集），适合全景查看或作为三维场景环境背景。`.trim()

/** 蒙版逻辑层：纯白 opaque = 保留；透明 = 重绘洞（与常见修图软件一致）。显示层单独画棋盘格，仅在洞内，其它区域完全透出底图。 */
const INPAINT_MASK_PRESERVE_WHITE = 'rgba(255,255,255,1)'
/** 棋盘格单元格（CSS px，与画布像素一致） */
const INPAINT_CHECKER_CELL = 10
/** 蒙版频繁 getImageData（撤销栈/提交）；Chrome 建议 willReadFrequently，否则控制台告警且读回较慢 */
const INPAINT_2D_CTX = { willReadFrequently: true }

const DEFAULT_NODE = {
  note: { w: 220, h: 160, data: () => ({ body: '', status: '' }) },
  /** 分镜脚本：草稿 body；执行后写入 output（DeepSeek V4），下游优先用整理稿 */
  storyboard: {
    w: 300,
    h: 520,
    data: () => ({
      body: '',
      output: '',
      status: '',
      model: 'deepseek-v4-flash',
      workflowStyle: null,
      storyboardLanguage: 'zh',
      /** 16:9 | 9:16，下游图片/视频节点继承 */
      storyboardAspectRatio: '16:9',
      /** 续集：''=自动上游分镜；'_none_'=不续接；否则为指定前一集分镜节点 id */
      continuityFromStoryboardId: ''
    })
  },
  /** 剧本创作：梗概 → DeepSeek 生成完整剧本，下游可接分镜脚本 */
  scriptWrite: {
    w: 300,
    h: 460,
    data: () => ({
      body: '',
      output: '',
      status: '',
      model: 'deepseek-v4-flash',
      genrePick: '',
      genreCustom: '',
      lengthHintPick: '',
      lengthHintCustom: '',
      /** 兼容旧画布 */
      genre: '',
      lengthHint: ''
    })
  },
  llm: {
    w: 308,
    h: 420,
    data: () => ({
      prompt: '',
      output: '',
      status: '',
      textMode: 'write',
      model: LLM_DEFAULT_MODEL,
      inlineVideoUrl: ''
    })
  },
  image: {
    w: 336,
    h: 520,
    data: () => ({
      prompt: '',
      imageUrl: '',
      /** 上传模式：本机文件 URL（与上游取图逻辑同音频 referenceAudioUrl） */
      referenceImageUrl: '',
      imageInputMode: IMAGE_INPUT_MODES.generate,
      status: '',
      seedreamModel: '',
      aspectKey: '16x9_2k',
      imageCount: 1,
      /** 电商详情图下发：精确 WxH，优先于 aspectKey */
      seedreamSizeOverride: '',
      panelExpanded: false,
      /** 与对话工作流风格库同源：{ id, name, prompt, thumb, refUrl, refDataUrl, ... } */
      workflowStyle: null,
      uiMark: false,
      uiFocus: false,
      /** 开启后出图前先走 preset=character_designer（后端 characterDesignerSystemPrompt） */
      uiCharacterDesign: false,
      /** GPT-Image-2 局部重绘蒙版（上传后的 URL，透明区为重绘区） */
      inpaintMaskUrl: '',
      /** 真：显示画笔工具条并在预览上绘制蒙版（与顶部工具条「重绘→局部重绘」联动） */
      imageInpaintMode: false,
      /** brush | rect | erase */
      inpaintDrawTool: 'brush',
      inpaintBrushSize: 28,
      /** 画笔颜色（十六进制），笔触叠在图上标示重绘区 */
      inpaintBrushColor: '#ff3355'
    })
  },
  /** 电商详情图：按模板位批量出图（Seedream） */
  ecomDetail: {
    w: 368,
    h: 580,
    data: () => {
      const expert = getEcomPromptExpertBuiltinSkill()
      return {
      productName: '',
      sellingPoints: '',
      extraPrompt: '',
      platform: 'taobao',
      outputLanguage: ECOM_DETAIL_DEFAULT_OUTPUT_LANGUAGE,
      selectedSkillId: expert.id || ECOM_SKILL_PROMPT_EXPERT_ID,
      selectedSkill: {
        id: expert.id,
        title: expert.title,
        desc: expert.desc,
        prompt: expert.prompt,
        image: expert.image || '',
        systemPrompt: expert.systemPrompt,
        batchMode: expert.batchMode,
        singlePromptMode: expert.singlePromptMode
      },
      /** 各模板位出图前用 DeepSeek 优化提示词 */
      deepseekModel: 'deepseek-v4-flash',
      /** 方舟视觉模型 ID，留空则自动尝试候选列表 */
      visionModel: '',
      useDeepseekPrompt: true,
      seedreamModel: 'doubao-seedream-5-0-260128',
      status: '',
      slots: normalizeEcomDetailSlots(null),
      /** DeepSeek / Skill 生成的出图计划（先提示词，再 Seedream） */
      promptPlans: [],
      promptRaw: '',
      /** DeepSeek 多模态解析上游参考图 */
      upstreamImageAnalysis: '',
      referenceImageUrls: [],
      /** 上次「出图」自动创建的图片节点 id，再次出图会先移除 */
      spawnedImageNodeIds: [],
      outputImages: [],
      progress: ''
      }
    }
  },
  video: {
    w: 368,
    h: 640,
    data: () => ({
      prompt: '',
      videoUrl: '',
      /** 图生视频参考图（如从 3D 导演台同步）；执行时与上游 gather 结果合并传入 Seedance */
      referenceImageUrl: '',
      taskId: '',
      status: '',
      videoMode: 'ref',
      seedanceModel: '',
      ratio: '16:9',
      resolution: '720p',
      duration: 15,
      /** 是否期望生成带音频（当前 Seedance 创建任务未单独传参，仅保存偏好） */
      seedanceGenerateAudio: true,
      panelExpanded: false,
      uiHd: false,
      uiMark: false,
      uiCam: false,
      uiCharLib: false,
      /** 分镜解析生成的镜号（如 01），用于画布「整理」时自上而下排序 */
      storyboardShotNo: '',
      storyboardShotSort: null
    })
  },
  audio: {
    w: 340,
    /** 逻辑高度（连线端口 / 画布范围）；视觉高度随内容收缩，由 syncAudioNodeHeight 同步 */
    h: 440,
    data: () => ({
      synthText: '',
      tryMode: 'a2v',
      /** upload：本节点输出为上传/上游音频；tts：文生音频（下方完整合成面板） */
      audioInputMode: AUDIO_INPUT_MODES.tts,
      model: 'volc-doubao-tts-2',
      referenceAudioUrl: '',
      voiceId: '',
      volcSpeakerId: '',
      /** 下拉选中项：预设 speaker id 或 __custom__ */
      volcSpeakerPick: VOLC_TTS_DEFAULT_SPEAKER_ID,
      volcPublicSpeaker: VOLC_TTS_DEFAULT_SPEAKER_ID,
      cloneScriptText: '',
      audioUrl: '',
      status: '',
      maxChars: 50000,
      /** default：句内 [ ] 表现力；voice_instruction / prior_context：见控制台合成模式 */
      volcTtsExpressMode: 'default',
      volcVoiceInstruction: '',
      volcPriorContext: '',
      /** 豆包 TTS：音调/语速/音量偏置 -10～10，0 为控制台默认 */
      volcAudioPitch: 0,
      volcAudioSpeed: 0,
      volcAudioVolume: 0
    })
  },
  /** 3D 导演台：画布内入口，全功能在独立页 */
  directorDeck: {
    w: 300,
    h: 320,
    data: () => ({
      /** 导演台「保存返回 / 导出预览」写回本节点的 data URL 或 URL，用于卡片主预览 */
      directorShotPreviewUrl: ''
    })
  },
  /** UI 设计：DeepSeek 多屏界面提示词 → 拆分图片节点 */
  uiDesign: {
    w: 352,
    h: 560,
    data: () => ({
      projectName: '',
      brief: '',
      extraPrompt: '',
      platform: 'app',
      designStyleId: UI_DESIGN_DEFAULT_STYLE_ID,
      designStyleCustom: '',
      themeColorPrimary: UI_DESIGN_DEFAULT_PRIMARY,
      themeColorSecondary: UI_DESIGN_DEFAULT_SECONDARY,
      displayMode: 'frameless',
      screenCount: UI_DESIGN_DEFAULT_SCREEN_COUNT,
      selectedSkill: null,
      deepseekModel: 'deepseek-v4-flash',
      seedreamModel: 'doubao-seedream-5-0-260128',
      status: '',
      progress: '',
      screenPlans: [],
      promptRaw: '',
      upstreamImageAnalysis: '',
      /** 从参考图提取的 AI 视觉风格（策划时应用于待设计产品） */
      referenceStyleGuide: '',
      upstreamImageAnalysisMethod: '',
      visionModel: '',
      /** 解析上游风格后是否写入 designStyleId / 主题色 */
      applyUpstreamStyleToFields: true,
      referenceImageUrls: [],
      spawnedImageNodeIds: [],
      /** 批量出图结果摘要（子图片节点 imageUrl 仍为主数据源） */
      outputImages: [],
      creditDisplay: 0
    })
  }
}

export default {
  name: 'NodeGraphCanvas',
  components: {
    NgcNodeSelect,
    WorkflowAssetPanelModal
  },
  directives: {
    /** 将 n.data.prompt 中的 [图片N] 等解析为内联芯片 DOM；外部写入 model 时同步（非聚焦态） */
    promptChipsEditor: {
      inserted(el, binding, vnode) {
        vnode.context.$nextTick(() => {
          vnode.context.hydratePromptEditor(binding.value, el)
        })
      },
      update(el, binding, vnode) {
        const vm = vnode.context
        const n = binding.value
        if (!n || !n.data) return
        const focused = document.activeElement === el
        if (focused) {
          const rafKey = '__ngcChipThumbRaf'
          const prev = el[rafKey]
          if (prev) cancelAnimationFrame(prev)
          el[rafKey] = requestAnimationFrame(() => {
            el[rafKey] = 0
            vm.syncPromptChipThumbnails(n, el)
          })
          return
        }
        const cur = vm.serializePromptEditorRoot(el)
        const model = n.data.prompt != null ? String(n.data.prompt) : ''
        if (cur !== model) vm.hydratePromptEditor(n, el)
        else vm.syncPromptChipThumbnails(n, el)
      }
    }
  },
  data() {
    return {
      projectUuid: '',
      projectTitle: '未命名画布',
      projectList: [],
      listError: '',
      nodes: [],
      edges: [],
      viewport: { panX: 80, panY: 60, scale: 1 },
      /** select：默认交互；hand：左键拖移平移画布 */
      canvasTool: 'select',
      selectedId: null,
      /** 递增分配 zStack，点击节点时置顶（高于默认 1，盖住其它节点与下层 SVG） */
      nodeZStack: 100,
      /** 选中的连线 id，用于高亮与点击处「剪刀」删除 */
      selectedEdgeId: null,
      /** 选中连线上剪刀按钮在贝塞尔曲线上的参数 t（0～1，随点击位置更新） */
      selectedEdgeCutT: null,
      showGrid: true,
      showMinimap: true,
      /** 小地图拖拽：window 级监听与临时状态 */
      _minimapDrag: null,
      _minimapBoundMove: null,
      _minimapBoundUp: null,
      /** 窗口尺寸变化时刷新小地图视口框（依赖 viewEl 尺寸） */
      viewLayoutTick: 0,
      saving: false,
      autoSaving: false,
      autoSaveHint: '',
      _autosavePaused: false,
      _lastCloudSaveFingerprint: '',
      _pendingCloudSaveAfterRun: false,
      _autoSaveHintTimer: null,
      /** 按项目 uuid 标记「执行画布」进行中（切换项目后互不干扰） */
      ngcGraphRuns: {},
      /** 切换走后仍在后台执行的项目快照（nodes 引用保持，异步结果可写回） */
      ngcProjectWorkingCopies: {},
      /** 忽略过期的云端加载结果 */
      ngcLoadProjectToken: 0,
      /** 正在单独执行的节点 id → true */
      runningNodeIds: {},
      isPanning: false,
      panStart: null,
      /** 画布平移：mousemove 不写 viewport，避免每帧整页 Vue 重绘；用 rAF 写 DOM，松手再同步 */
      _panDomRaf: 0,
      dragNode: null,
      /** 拖线：含 sx0,sy0、sessionId；out=右口，in=左口 */
      linkDragState: null,
      /** 松手在空白处：引用该节点生成 */
      connectMenu: null,
      addMenu: null,
      saveTimer: null,
      cloudSaveTimer: null,
      /** 删除节点/连线前的快照，用于撤销（最多 20 条） */
      deleteUndoStack: [],
      _boundMove: null,
      _boundUp: null,
      showAddBar: false,
      /** 图片/视频提示词 @ 引用：{ nodeId, anchorStart, caretEnd, filter, highlightIndex } */
      assetMention: null,
      _assetMentionBlurTimer: null,
      /** 点击上游缩略图：大图 / 音频 / 文本片段预览 */
      upstreamPreview: null,
      /** 上游缩略图右键菜单 { nodeId, ref, left, top } */
      ngcUpstreamThumbMenu: null,
      /** 视频节点 · 角色库弹窗 */
      ngcCharacterLibModal: {
        visible: false,
        nodeId: '',
        anchorRect: null
      },
      /** `${imageNodeId}\\0${upstreamNodeId}` → 上游缩略图加载失败 */
      upstreamThumbBad: {},
      /** 图片节点顶部工具条：九宫格 / 重绘 / 宫格切分 下拉 */
      imageToolbarMenu: null,
      /** 下拉相对 .ngc-image-node-toolbar 的像素定位（由当前触发按钮测量） */
      imageToolbarDropdownLayout: null,
      imageToolbarNineOptions: ['经典九宫格', '黄金分割参考', '对角线辅助'],
      imageToolbarSplitOptions: ['2×2 切分', '3×3 切分', '导出宫格图'],
      /** 图片节点风格库（与 ConversationWorkflow 同源接口与 localStorage） */
      showImageStyleLibrary: false,
      imageStyleLibraryNodeId: null,
      ngcStyleCategoryList: [],
      ngcStyleTab: 'all',
      ngcStyleCategoryMap: {},
      ngcStyleCategoryLoading: false,
      ngcStylePanelLoading: false,
      ngcStyleMine: [],
      ngcStyleRecent: [],
      _ngcStyleMineLoaded: false,
      _ngcStyleRecentLoaded: false,
      _ngcStyleScrollRaf: 0,
      _ngcStyleLastAutoLoadAt: 0,
      /** 节点卡片随内容增高后，用 rAF 合并写回 n.h（连线端口 / fitView） */
      _syncNodeHeightsRaf: 0,
      ngcBulkVideoDownloadRunning: false,
      /** 图片节点「加入角色库」进行中（节点 id） */
      ngcImageAssetSavingId: '',
      /** @ 素材菜单位置计算合并到每帧一次 */
      _promptMentionLayoutRaf: 0,
      /** updated 触发的全节点高度测量防抖（ms） */
      _syncHeightsUpdatedTimer: null,
      /** nodes 深度变更时芯片缩略图防抖，避免大量节点 + 拖动每帧触发全图扫描 */
      _nodesChipSyncDebounceTimer: null,
      /** 图片节点画布内局部重绘：绘制会话与撤销栈（不入项目 JSON）；勿用 _ 前缀 — Vue2 data 中下划线字段不可靠 */
      inpaintStrokeSession: null,
      inpaintRectSession: null,
      inpaintUndoStacks: {},
      inpaintRedoStacks: {},
      inpaintDocMoveHandler: null,
      inpaintDocUpHandler: null,
      inpaintDocTouchMoveHandler: null,
      inpaintDocTouchEndHandler: null,
      /** true：文档级监听用 pointer*；false：mousemove/mouseup + touch 回退 */
      inpaintDocListenersPointer: false,
      /** 矩形拖拽时 move/up 绑在 window 捕获阶段（pointer capture 下 document/wrap 可能收不到） */
      inpaintRectListenerRoot: null,
      /** 局部重绘大屏在线编辑器：当前节点 id（与卡片内画布互斥显示） */
      inpaintOnlineEditorNodeId: null,
      /** 离屏蒙版：白=保留、透明=洞；DOM canvas 仅铺棋盘预览（不入 JSON） */
      inpaintMaskBuffers: {},
      volcTtsSpeakerPresets: VOLC_TTS_SPEAKER_PRESETS,
      volcSpeakerCustomId: VOLC_SPEAKER_CUSTOM_ID,
      volcTtsExpressModeOptions: VOLC_TTS_EXPRESS_MODE_OPTIONS,
      /** 图片节点：画幅/分辨率弹出选择（替代原下拉） */
      imageAspectPickerNodeId: null,
      imageModelPickerNodeId: null,
      storyboardModelPickerNodeId: null,
      ecomDetailDeepseekPickerNodeId: null,
      ecomDetailImageModelPickerNodeId: null,
      uiDesignDeepseekPickerNodeId: null,
      uiDesignImageModelPickerNodeId: null,
      UI_DESIGN_PLATFORMS,
      UI_DESIGN_BUILTIN_STYLES,
      UI_DESIGN_STYLE_CUSTOM_ID,
      UI_DESIGN_DISPLAY_MODES,
      ngcUiDesignExpertSkill: getUiDesignExpertBuiltinSkill(),
      llmModelPickerNodeId: null,
      videoModelPickerNodeId: null,
      audioModelPickerNodeId: null,
      /** 视频节点：比例/清晰度/时长/生成音频 合并弹层（当前打开的节点 id） */
      videoSpecPanelNodeId: null,
      ECOM_DETAIL_PLATFORMS,
      ECOM_DETAIL_OUTPUT_LANGUAGES,
      SCRIPT_WRITE_GENRE_OPTIONS,
      SCRIPT_WRITE_LENGTH_OPTIONS,
      SCRIPT_WRITE_SELECT_CUSTOM,
      STORYBOARD_LANGUAGE_OPTIONS,
      STORYBOARD_ASPECT_RATIO_OPTIONS,
      ECOM_DETAIL_SLOT_DEFS,
      ngcEcomDetailSkills: [],
      /** GET /modelslist 上架模型（含 credits） */
      ngcModelsCatalog: [],
      ngcModelsCatalogLoading: false,
      ngcModelsCatalogError: '',
      /** 顶栏剩余积分（/user） */
      ngcToolbarRemainingCredits: null,
      ngcToolbarCreditsLoading: false,
      /** 画布内自定义确认弹窗 */
      ngcConfirmDialog: null
    }
  },
  computed: {
    /** 仅当前打开项目的画布批量执行中 */
    graphRunning() {
      const pu = String(this.projectUuid || '')
      return !!(pu && this.ngcGraphRuns && this.ngcGraphRuns[pu])
    },
    autoSaveHintTone() {
      const t = String(this.autoSaveHint || '')
      if (/失败|错误|保留/.test(t)) return 'warn'
      if (/正在|同步|保存中/.test(t)) return 'pending'
      return 'ok'
    },
    layerStyle() {
      const v = this.viewport
      return {
        transform: `translate3d(${v.panX}px, ${v.panY}px, 0) scale(${v.scale})`,
        transformOrigin: '0 0',
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%'
      }
    },
    hasVideoNodesToDownload() {
      return (this.nodes || []).some(
        n => n && n.type === 'video' && n.data && String(n.data.videoUrl || '').trim()
      )
    },
    /** 仅随布局变化而变：避免其它节点改 prompt/body 等触发全量边 path 与 map 重算 */
    ngcNodeLayoutRev() {
      const list = Array.isArray(this.nodes) ? this.nodes : []
      let h = ((list.length * 73856093) >>> 0) ^ 913357
      for (let i = 0; i < list.length; i++) {
        const n = list[i]
        if (!n || n.id == null) continue
        const x = Number(n.x) || 0
        const y = Number(n.y) || 0
        const w = Number(n.w) || 0
        const hh = Number(n.h) || 0
        h = Math.imul(h ^ x, 16777619) >>> 0
        h = Math.imul(h ^ y, 16777619) >>> 0
        h = Math.imul(h ^ w, 16777619) >>> 0
        h = Math.imul(h ^ hh, 16777619) >>> 0
        const zs = n.zStack != null ? Number(n.zStack) : 0
        h = Math.imul(h ^ zs, 16777619) >>> 0
      }
      const d = this.dragNode
      if (d && !this.inpaintStrokeSession && !this.inpaintRectSession) {
        const cx = Math.round(d.pendingClientX != null ? d.pendingClientX : d.sx)
        const cy = Math.round(d.pendingClientY != null ? d.pendingClientY : d.sy)
        h = Math.imul(h ^ cx, 16777619) >>> 0
        h = Math.imul(h ^ cy, 16777619) >>> 0
        const sid = String(d.id || '')
        for (let j = 0; j < sid.length; j++) {
          h = Math.imul(h ^ sid.charCodeAt(j), 16777619) >>> 0
        }
      }
      const v = this.viewport
      h = Math.imul(h ^ Math.round((Number(v.panX) || 0) * 4), 16777619) >>> 0
      h = Math.imul(h ^ Math.round((Number(v.panY) || 0) * 4), 16777619) >>> 0
      h = Math.imul(h ^ Math.round((Number(v.scale) || 1) * 1000), 16777619) >>> 0
      const el = this.edges
      if (Array.isArray(el)) {
        h = Math.imul(h ^ el.length, 16777619) >>> 0
        for (let i = 0; i < el.length; i++) {
          const e = el[i]
          if (!e) continue
          h = Math.imul(h ^ i, 16777619) >>> 0
          if (e.id != null) h = Math.imul(h ^ String(e.id).length, 16777619) >>> 0
          if (e.from && e.from.nodeId) h = Math.imul(h ^ String(e.from.nodeId).length, 16777619) >>> 0
          if (e.to && e.to.nodeId) h = Math.imul(h ^ String(e.to.nodeId).length, 16777619) >>> 0
        }
      }
      return h
    },
    /** id → node；重建由 ngcNodeLayoutRev 驱动，与「纯文案编辑」解耦 */
    ngcNodeIdMap() {
      void this.ngcNodeLayoutRev
      const m = Object.create(null)
      const list = Array.isArray(this.nodes) ? this.nodes : []
      for (let i = 0; i < list.length; i++) {
        const n = list[i]
        if (n && n.id != null) m[n.id] = n
      }
      return m
    },
    /**
     * 当前视口在世界坐标下的外扩矩形；null 表示不做裁剪（平移/拖线/连线菜单与初始化）。
     */
    ngcViewportWorldBounds() {
      if (this.isPanning || this.linkDragState || this.connectMenu) {
        return null
      }
      const el = this.$refs.viewEl
      if (!el || el.clientWidth < 8 || el.clientHeight < 8) {
        return null
      }
      const rw = el.clientWidth
      const rh = el.clientHeight
      const v = this.viewport
      const sc = Math.max(0.25, Math.min(2, Number(v.scale) || 1))
      const panX = Number(v.panX) || 0
      const panY = Number(v.panY) || 0
      const pad = 420 / sc
      return {
        minX: (-panX) / sc - pad,
        minY: (-panY) / sc - pad,
        maxX: (rw - panX) / sc + pad,
        maxY: (rh - panY) / sc + pad,
        sc
      }
    },
    /** 底层 SVG：无选中节点时为全部边；有选中节点时为「与该节点无关」的边（避免与置顶层重复绘制） */
    ngcEdgesBackground() {
      const list = Array.isArray(this.edges) ? this.edges : []
      const sid = this.selectedId
      if (!sid) return list
      return list.filter(e => {
        const f = e && e.from && e.from.nodeId
        const t = e && e.to && e.to.nodeId
        return !(f === sid || t === sid)
      })
    },
    /** 视口裁剪后的底层边（减少 SVG path 与 hit 区数量） */
    ngcEdgesBackgroundVisible() {
      const base = this.ngcEdgesBackground
      const b = this.ngcViewportWorldBounds
      if (!b) return base
      const sid = this.selectedEdgeId
      return base.filter(e => {
        if (sid && e && e.id === sid) return true
        return this.ngcEdgeRoughlyInViewport(e, b)
      })
    },
    /** 与当前选中节点相连的边，单独一层 SVG + z-index，盖在未置顶节点之上 */
    ngcEdgesForeground() {
      const sid = this.selectedId
      if (!sid) return []
      const list = Array.isArray(this.edges) ? this.edges : []
      return list.filter(e => {
        const f = e && e.from && e.from.nodeId
        const t = e && e.to && e.to.nodeId
        return f === sid || t === sid
      })
    },
    ngcEdgesForegroundVisible() {
      const base = this.ngcEdgesForeground
      const b = this.ngcViewportWorldBounds
      if (!b) return base
      const sid = this.selectedEdgeId
      return base.filter(e => {
        if (sid && e && e.id === sid) return true
        return this.ngcEdgeRoughlyInViewport(e, b)
      })
    },
    ngcIncidentEdgesLayerZ() {
      const sid = this.selectedId
      if (!sid) return 1
      const n = this.ngcNodeIdMap[sid]
      const z = n && n.zStack != null ? Number(n.zStack) : 1
      if (!Number.isFinite(z)) return 2
      return Math.max(2, Math.floor(z) - 1)
    },
    ngcNodesVisibleInViewport() {
      const list = Array.isArray(this.nodes) ? this.nodes : []
      const b = this.ngcViewportWorldBounds
      if (!b) {
        return list
      }
      const dragId = this.dragNode && this.dragNode.id ? String(this.dragNode.id) : ''
      return list.filter(n => {
        if (!n || !n.id) return false
        if (dragId && n.id === dragId) return true
        const pos = this.nodeWorldXYForLayout(n)
        const x1 = pos.x
        const y1 = pos.y
        const w = Number(n.w) || 280
        const h = Math.max(Number(n.h) || 160, 72)
        const x2 = x1 + w
        const y2 = y1 + h
        return !(x2 < b.minX || x1 > b.maxX || y2 < b.minY || y1 > b.maxY)
      })
    },
    /** 底层每条边只算一次 path d，四条 path 共用（原先每帧 4× 字符串拼接） */
    ngcBackgroundEdgePathById() {
      const vis = this.ngcEdgesBackgroundVisible
      const o = Object.create(null)
      for (let i = 0; i < vis.length; i++) {
        const e = vis[i]
        if (e && e.id != null) o[e.id] = this.edgePath(e)
      }
      return o
    },
    ngcForegroundEdgePathById() {
      const vis = this.ngcEdgesForegroundVisible
      const o = Object.create(null)
      for (let i = 0; i < vis.length; i++) {
        const e = vis[i]
        if (e && e.id != null) o[e.id] = this.edgePath(e)
      }
      return o
    },
    gridStyle() {
      const s = 24 * this.viewport.scale
      return {
        backgroundColor: '#1a1a1a',
        backgroundImage:
          'radial-gradient(circle at center, rgba(255,255,255,0.14) 1px, transparent 1px)',
        backgroundSize: `${s}px ${s}px`,
        backgroundPosition: `${this.viewport.panX}px ${this.viewport.panY}px`,
        opacity: this.showGrid ? 1 : 0,
        transition: 'opacity 0.2s ease'
      }
    },
    /** 小地图：世界坐标 viewBox 与视口矩形、描边宽度（随图幅缩放） */
    ngcMinimapSpec() {
      void this.ngcNodeLayoutRev
      void this.viewLayoutTick
      const nodes = Array.isArray(this.nodes) ? this.nodes : []
      const el = this.$refs && this.$refs.viewEl
      const rw = el && el.clientWidth >= 8 ? el.clientWidth : 960
      const rh = el && el.clientHeight >= 8 ? el.clientHeight : 640
      const v = this.viewport
      const sc = Math.max(0.25, Math.min(2, Number(v.scale) || 1))
      const panX = Number(v.panX) || 0
      const panY = Number(v.panY) || 0
      const vx0 = (-panX) / sc
      const vy0 = (-panY) / sc
      const vx1 = (rw - panX) / sc
      const vy1 = (rh - panY) / sc
      let minX = Math.min(vx0, vx1)
      let minY = Math.min(vy0, vy1)
      let maxX = Math.max(vx0, vx1)
      let maxY = Math.max(vy0, vy1)
      for (let i = 0; i < nodes.length; i++) {
        const n = nodes[i]
        if (!n || n.id == null) continue
        const x = Number(n.x) || 0
        const y = Number(n.y) || 0
        const w = Number(n.w) || 240
        const h = Number(n.h) || 120
        minX = Math.min(minX, x)
        minY = Math.min(minY, y)
        maxX = Math.max(maxX, x + w)
        maxY = Math.max(maxY, y + h)
      }
      const margin = 200
      minX -= margin
      minY -= margin
      maxX += margin
      maxY += margin
      const vbW = Math.max(480, maxX - minX)
      const vbH = Math.max(360, maxY - minY)
      const strokeBase = Math.max(vbW, vbH)
      return {
        minX,
        minY,
        vbW,
        vbH,
        view: {
          x: vx0,
          y: vy0,
          w: Math.max(8, vx1 - vx0),
          h: Math.max(8, vy1 - vy0)
        },
        viewStroke: Math.max(strokeBase * 0.0045, 10),
        edgeStroke: Math.max(strokeBase * 0.0012, 3),
        nodeStroke: Math.max(strokeBase * 0.0018, 5)
      }
    },
    /** 小地图连线采样，避免极大边数拖慢 SVG */
    ngcMinimapEdgesSample() {
      void this.ngcNodeLayoutRev
      const es = Array.isArray(this.edges) ? this.edges : []
      const m = this.ngcNodeIdMap
      const out = []
      const max = 220
      for (let i = 0; i < es.length && out.length < max; i++) {
        const e = es[i]
        if (!e || !e.from || !e.to) continue
        const a = m[e.from.nodeId]
        const b = m[e.to.nodeId]
        if (!a || !b) continue
        const aw = Math.max(8, Number(a.w) || 200)
        const ah = Math.max(8, Number(a.h) || 100)
        const bw = Math.max(8, Number(b.w) || 200)
        const bh = Math.max(8, Number(b.h) || 100)
        const ax = (Number(a.x) || 0) + aw / 2
        const ay = (Number(a.y) || 0) + ah / 2
        const bx = (Number(b.x) || 0) + bw / 2
        const by = (Number(b.y) || 0) + bh / 2
        out.push({ id: e.id, x1: ax, y1: ay, x2: bx, y2: by })
      }
      return out
    },
    viewCanvasCursorClass() {
      if (this.isPanning) return 'cursor-grabbing'
      if (this.canvasTool === 'hand') return 'cursor-grab'
      return 'cursor-default'
    },
    ngcToolbarCreditsDisplay() {
      if (!hasAuthToken()) return '登录查看'
      if (this.ngcToolbarCreditsLoading && this.ngcToolbarRemainingCredits == null) return '…'
      const v = Number(this.ngcToolbarRemainingCredits)
      if (!Number.isFinite(v)) return '—'
      return v.toLocaleString('en-US')
    },
    inpaintOnlineEditorNode() {
      const id = this.inpaintOnlineEditorNodeId
      if (id == null) return null
      return this.ngcNodeIdMap[id] || null
    },
    imageAspectPickerNode() {
      const id = this.imageAspectPickerNodeId
      if (id == null || id === '') return null
      const n = this.ngcNodeIdMap[id]
      if (!n || n.type !== 'image' || !n.data) return null
      return n
    },
    imageModelPickerNode() {
      const id = this.imageModelPickerNodeId
      if (id == null || id === '') return null
      const n = this.ngcNodeIdMap[id]
      if (!n || n.type !== 'image' || !n.data) return null
      return n
    },
    addOptions() {
      return [
        // { type: 'note', label: '注释' },
        { type: 'scriptWrite', label: '剧本创作' },
        { type: 'storyboard', label: '分镜脚本' },
        { type: 'llm', label: '文本节点' },
        { type: 'image', label: '图片' },
        { type: 'ecomDetail', label: '电商详情图' },
        { type: 'uiDesign', label: 'UI 设计' },
        { type: 'video', label: '视频' },
        { type: 'audio', label: '音频节点' },
        { type: 'directorDeck', label: '3D 导演台' }
      ]
    },
    llmModelOptions() {
      return mergeCanvasModelOptions(this.ngcModelsCatalog, NGC_MODEL_KIND.LLM)
    },
    /** 分镜节点仅允许 DeepSeek V4 系列（走 DeepSeek OpenAI 兼容接口） */
    storyboardModelOptions() {
      return (this.llmModelOptions || []).filter(m => {
        const id = String(m && m.id != null ? m.id : '')
        return id.startsWith('deepseek-v4')
      })
    },
    textModeChoices() {
      return [
        { key: 'write', label: '自己编写内容', icon: 'far fa-file-alt' },
        { key: 't2v', label: '文生视频', icon: 'fas fa-play-circle' },
        { key: 'img2prompt', label: '图片反推提示词', icon: 'far fa-image' },
        { key: 't2music', label: '文字生音乐', icon: 'fas fa-volume-up' }
      ]
    },
    ngcStyleLibraryTargetNode() {
      const id = this.imageStyleLibraryNodeId
      if (!id) return null
      return this.nodes.find(x => x.id === id) || null
    },
    imageStyleLibraryTargetNode() {
      return this.ngcStyleLibraryTargetNode
    },
    ngcStyleLibraryTargetLabel() {
      const n = this.ngcStyleLibraryTargetNode
      if (!n) return ''
      if (n.type === 'image') return `图片节点 ${this.imageNodeIndex(n)}`
      if (n.type === 'storyboard') return `分镜脚本 ${this.storyboardNodeIndex(n)}`
      return `节点：${String(n.type || '')}`
    },
    imageStyleLibraryTargetLabel() {
      return this.ngcStyleLibraryTargetLabel
    },
    ngcStyleCategoryTabs() {
      const list = Array.isArray(this.ngcStyleCategoryList) ? this.ngcStyleCategoryList : []
      if (list.length > 0) {
        const fixed = [
          { id: 'all', label: '全部' },
          { id: 'mine', label: '我的风格' },
          { id: 'recent', label: '最近使用' }
        ]
        return fixed.concat(
          list
            .filter(x => x && x.id != null)
            .map(x => ({
              id: String(x.id),
              label: String(x.name || x.title || x.label || '未命名')
            }))
        )
      }
      return [
        { id: 'all', label: '全部' },
        { id: 'mine', label: '我的风格' },
        { id: 'recent', label: '最近使用' },
        { id: 'ip', label: 'IP风格' }
      ]
    },
    ngcShouldShowStyleLoadMore() {
      const hasCats = Array.isArray(this.ngcStyleCategoryList) && this.ngcStyleCategoryList.length > 0
      if (!hasCats) return false
      const tab = String(this.ngcStyleTab || '')
      if (!tab || tab === 'mine' || tab === 'recent' || tab === 'ip') return false
      const cur = this.ngcStyleCategoryMap && this.ngcStyleCategoryMap[tab]
      if (!cur) return true
      return !cur.finished
    },
    ngcFilteredStyles() {
      const tab = String(this.ngcStyleTab || 'all')
      const mine = Array.isArray(this.ngcStyleMine) ? this.ngcStyleMine : []
      const recent = Array.isArray(this.ngcStyleRecent) ? this.ngcStyleRecent : []
      const hasCats = Array.isArray(this.ngcStyleCategoryList) ? this.ngcStyleCategoryList.length > 0 : false
      if (tab === 'mine') return mine
      if (tab === 'recent') return recent
      if (!hasCats) {
        if (tab === 'ip') return []
        return mine
      }
      const bucket = this.ngcStyleCategoryMap && this.ngcStyleCategoryMap[tab]
      const remote = bucket && Array.isArray(bucket.list) ? bucket.list : []
      return remote
    },
    linkDragPath() {
      const ld = this.linkDragState
      if (!ld) return ''
      const mx = (ld.x1 + ld.x2) / 2
      return `M ${ld.x1} ${ld.y1} C ${mx} ${ld.y1}, ${mx} ${ld.y2}, ${ld.x2} ${ld.y2}`
    },
    /** 松手后菜单仍打开时，保留浅蓝预览线（与拖线一致） */
    connectMenuPreviewPath() {
      const m = this.connectMenu
      if (!m || this.linkDragState) return ''
      const n = this.ngcNodeIdMap[m.refId]
      if (!n) return ''
      const p0 = m.anchorMode === 'in' ? this.portIn(n) : this.portOut(n)
      const x2 = m.wx
      const y2 = m.wy
      const mx = (p0.x + x2) / 2
      return `M ${p0.x} ${p0.y} C ${mx} ${p0.y}, ${mx} ${y2}, ${x2} ${y2}`
    },
    /** 选中连线上剪刀按钮的定位（世界坐标 + 逆缩放） */
    selectedEdgeCutWrapStyle() {
      void this.ngcNodeLayoutRev
      if (!this.selectedEdgeId || this.linkDragState) return null
      const e = this.edges.find(x => x.id === this.selectedEdgeId)
      if (!e) return null
      const c = this.edgeBezierControls(e)
      if (!c) return null
      const tRaw = Number(this.selectedEdgeCutT)
      const t = Number.isFinite(tRaw) ? Math.min(1, Math.max(0, tRaw)) : 0.5
      const p = this.cubicBezierPoint(c.p0, c.p1, c.p2, c.p3, t)
      const s = Math.max(0.25, Math.min(2, Number(this.viewport.scale) || 1))
      return {
        left: `${p.x}px`,
        top: `${p.y}px`,
        transform: `translate(-50%, -50%) scale(${1 / s})`
      }
    },
    /** 当前选中且为图片节点时，用于预览区上方工具条 */
    selectedImageToolbarNode() {
      const id = this.selectedId
      if (!id) return null
      const n = this.ngcNodeIdMap[id]
      if (!n || n.type !== 'image') return null
      return n
    },
    /** 工具条锚在节点横向中心、紧贴预览区上沿上方（世界坐标） */
    selectedImageToolbarStyle() {
      const n = this.selectedImageToolbarNode
      if (!n) return null
      const headerH = 38
      const bodyPadTop = 8
      /** 工具条底边与预览区上沿的间距（世界坐标；略大则整条工具条上移，与节点边框留出明显缝） */
      const clearance = 30
      const barH = 34
      const top = n.y + headerH + bodyPadTop - barH - clearance
      const w = Math.max(120, Number(n.w) || 320)
      const cx = n.x + w / 2
      const maxW = Math.max(280, Math.min(680, w + 200))
      return {
        position: 'absolute',
        left: `${cx}px`,
        top: `${top}px`,
        transform: 'translateX(-50%)',
        zIndex: 49980,
        maxWidth: `${maxW}px`
      }
    },
    /** 图片工具条下拉：锚在对应按钮正下方 */
    imageToolbarDropdownStyle() {
      const L = this.imageToolbarDropdownLayout
      if (!L) return {}
      if (L.autoWidth) {
        return {
          left: `${L.left}px`,
          top: `${L.top}px`
        }
      }
      const o = {
        left: `${L.left}px`,
        top: `${L.top}px`,
        minWidth: `${L.minWidth}px`
      }
      if (L.width != null) {
        o.width = `${L.width}px`
        o.maxWidth = `${L.width}px`
      }
      return o
    },
    videoModeTabs() {
      return [
        { key: 't2v', label: '文生视频' },
        { key: 'ref', label: '全能参考' },
        { key: 'i2v', label: '图生视频' },
        { key: 'frames', label: '首尾帧' },
        { key: 'imgref', label: '图片参考' }
      ]
    },
    videoModelOptions() {
      return mergeCanvasModelOptions(this.ngcModelsCatalog, NGC_MODEL_KIND.VIDEO)
    },
    ngcVideoResolutionOptions() {
      return NGC_VIDEO_RESOLUTIONS
    },
    /** 视频画幅弹窗：与后端 normalizeSeedanceRatio 一致（含 adaptive） */
    videoSpecRatioGrid() {
      return [
        ['adaptive', '16:9', '4:3', '1:1'],
        ['3:4', '9:16', '21:9']
      ]
    },
    connectMenuOptions() {
      return [
        { nodeType: 'llm', label: '文本', icon: 'fas fa-align-left', disabled: false },
        { nodeType: 'image', label: '图片', icon: 'far fa-image', disabled: false },
        {
          nodeType: 'ecomDetail',
          label: '电商详情图',
          icon: 'fas fa-store',
          disabled: false
        },
        {
          nodeType: 'uiDesign',
          label: 'UI 设计',
          icon: 'fas fa-mobile-alt',
          disabled: false
        },
        { nodeType: 'video', label: '视频', icon: 'fas fa-video', disabled: false },
        {
          label: '视频合成',
          icon: 'fas fa-cut',
          disabled: true,
          beta: true,
          hint: '视频合成暂未接入'
        },
        { nodeType: 'audio', label: '音频', icon: 'fas fa-music', disabled: false },
        {
          nodeType: 'scriptWrite',
          label: '剧本创作',
          icon: 'fas fa-pen-fancy',
          disabled: false
        },
        {
          nodeType: 'storyboard',
          label: '分镜脚本',
          icon: 'fas fa-list-ol',
          disabled: false
        },
        {
          nodeType: 'directorDeck',
          label: '3D 导演台',
          icon: 'fas fa-clapperboard',
          disabled: false
        },
        { nodeType: 'note', label: '脚本', icon: 'fas fa-film', disabled: false, beta: true }
      ]
    },
    ngcImageResolutionTiers() {
      return [
        { id: '1k', label: '1K' },
        { id: '2k', label: '2K' },
        { id: '4k', label: '4K' }
      ]
    },
    ngcImageAspectRatioGrid() {
      return NGC_IMAGE_ASPECT_RATIO_GRID
    },
    gptInpaintCapableSeedreamModels() {
      return ['gpt-image-2', 'gpt-image-2-all', 'gpt-image-2-vip']
    },
    apiYiSingleImageSeedreamModels() {
      return ['gpt-image-2', 'gpt-image-2-all', 'gpt-image-2-vip', 'nano-banana-2']
    },
    ecomImageModelOptions() {
      return this.imageModelOptions || []
    },
    imageModelOptions() {
      return mergeCanvasModelOptions(this.ngcModelsCatalog, NGC_MODEL_KIND.IMAGE)
    },
    imageCountChoices() {
      return [1, 2, 4]
    },
    audioModelOptions() {
      return mergeCanvasModelOptions(this.ngcModelsCatalog, NGC_MODEL_KIND.AUDIO)
    }
  },
  watch: {
    selectedEdgeId(val) {
      if (!val) this.selectedEdgeCutT = null
    },
    nodes: {
      handler() {
        this.scheduleAutosave()
        if (this._nodesChipSyncDebounceTimer != null) {
          clearTimeout(this._nodesChipSyncDebounceTimer)
          this._nodesChipSyncDebounceTimer = null
        }
        this._nodesChipSyncDebounceTimer = setTimeout(() => {
          this._nodesChipSyncDebounceTimer = null
          this.flushPromptChipThumbnailsForAllImageVideoNodes()
        }, 280)
      },
      deep: true
    },
    edges: {
      handler() {
        if (this.selectedEdgeId && !this.edges.some(e => e.id === this.selectedEdgeId)) {
          this.selectedEdgeId = null
        }
        this.scheduleAutosave()
        this.$nextTick(() => {
          this.nodes.forEach(n => {
            if (n.type !== 'image' && n.type !== 'video') return
            const el = document.querySelector(`[data-prompt-editor][data-prompt-node-id="${n.id}"]`)
            if (!el || document.activeElement === el) return
            this.hydratePromptEditor(n, el)
          })
        })
      },
      deep: true
    },
    viewport: {
      handler() {
        this.scheduleAutosave()
        if (this.imageToolbarMenu) {
          this.$nextTick(() => this.measureImageToolbarDropdown())
        }
      },
      deep: true
    },
    imageToolbarMenu(v) {
      if (v == null) {
        this.imageToolbarDropdownLayout = null
      } else {
        this.$nextTick(() => this.measureImageToolbarDropdown())
      }
    },
    projectTitle() {
      this.scheduleAutosave()
    },
    graphRunning(isRunning) {
      if (!isRunning) {
        this.flushPendingCloudSaveAfterRun(400)
      }
    },
    selectedId() {
      this.imageToolbarMenu = null
    },
    '$route.query': {
      handler() {
        this.$nextTick(() => {
          try {
            this.applyRouteNgcDirectorReturn()
          } catch {
            /* ignore */
          }
        })
      },
      deep: true
    }
  },
  mounted() {
    this._promptModelSyncTimers = Object.create(null)
    this.projectUuid = genId()
    this.bindGlobalPointer()
    window.addEventListener('keydown', this.onKey)
    window.addEventListener('resize', this.syncActiveInpaintSurfacesOnResize, { passive: true })
    this.refreshList()
    this.refreshNgcToolbarCredits()
    this.loadEcomDetailSkills()
    this.loadNgcModelsCatalog()
    window.addEventListener('focus', this.refreshNgcToolbarCredits)
    this.$nextTick(() => this.reconcileUiDesignSkillsOnNodes())
    const q = this.$route.query && this.$route.query.canvas
    const cid = q != null ? (Array.isArray(q) ? q[0] : q) : ''
    if (cid) {
      this.loadRemoteProject(String(cid))
    } else {
      this.$nextTick(() => {
        try {
          this.applyRouteNgcDirectorReturn()
        } catch {
          /* ignore */
        }
        try {
          this.applyHomeCanvasNodeHandoff()
        } catch {
          /* ignore */
        }
      })
    }
    document.addEventListener('click', this.onDocClick, false)
    document.addEventListener('mousedown', this.onDocMouseDown, false)
    this.$nextTick(() => this.scheduleSyncNodeVisualHeights())
  },
  updated() {
    if (
      this.dragNode &&
      !this.inpaintStrokeSession &&
      !this.inpaintRectSession
    ) {
      return
    }
    if (this._syncHeightsUpdatedTimer != null) clearTimeout(this._syncHeightsUpdatedTimer)
    this._syncHeightsUpdatedTimer = setTimeout(() => {
      this._syncHeightsUpdatedTimer = null
      this.scheduleSyncNodeVisualHeights()
    }, 180)
  },
  beforeDestroy() {
    if (this._promptModelSyncTimers) {
      for (const k of Object.keys(this._promptModelSyncTimers)) {
        clearTimeout(this._promptModelSyncTimers[k])
        delete this._promptModelSyncTimers[k]
      }
    }
    if (this._syncNodeHeightsRaf) {
      cancelAnimationFrame(this._syncNodeHeightsRaf)
      this._syncNodeHeightsRaf = 0
    }
    if (this._nodesChipSyncDebounceTimer != null) {
      clearTimeout(this._nodesChipSyncDebounceTimer)
      this._nodesChipSyncDebounceTimer = null
    }
    window.removeEventListener('keydown', this.onKey)
    window.removeEventListener('focus', this.refreshNgcToolbarCredits)
    window.removeEventListener('resize', this.syncActiveInpaintSurfacesOnResize)
    if (this._inpaintWinResizeRaf) {
      cancelAnimationFrame(this._inpaintWinResizeRaf)
      this._inpaintWinResizeRaf = 0
    }
    document.removeEventListener('click', this.onDocClick, false)
    document.removeEventListener('mousedown', this.onDocMouseDown, false)
    this.clearAssetMentionBlurTimer()
    this._unbindMinimapWindow()
    this.unbindGlobalPointer()
    this._unbindInpaintDocListeners()
    this.inpaintOnlineEditorNodeId = null
    this.inpaintMaskBuffers = {}
    if (this._dragNodeRaf) {
      cancelAnimationFrame(this._dragNodeRaf)
      this._dragNodeRaf = 0
    }
    if (this._panDomRaf) {
      cancelAnimationFrame(this._panDomRaf)
      this._panDomRaf = 0
    }
    if (this.dragNode) {
      this.applyDragNodePositionFromPending(this.dragNode, true)
      this.dragNode = null
    }
    if (this.saveTimer) {
      clearTimeout(this.saveTimer)
      this.saveTimer = null
    }
    if (this.cloudSaveTimer) {
      clearTimeout(this.cloudSaveTimer)
      this.cloudSaveTimer = null
    }
    if (this._autoSaveHintTimer) {
      clearTimeout(this._autoSaveHintTimer)
      this._autoSaveHintTimer = null
    }
    try {
      this.persistRecentProjectSnapshot()
    } catch {
      /* ignore */
    }
    if (this._promptMentionLayoutRaf) {
      cancelAnimationFrame(this._promptMentionLayoutRaf)
      this._promptMentionLayoutRaf = 0
    }
    if (this._syncHeightsUpdatedTimer != null) {
      clearTimeout(this._syncHeightsUpdatedTimer)
      this._syncHeightsUpdatedTimer = null
    }
  },
  methods: {
    nodeTitle(n) {
      const labels = {
        note: '注释',
        storyboard: '分镜脚本',
        scriptWrite: '剧本创作',
        llm: '文本节点',
        image: '图片节点',
        video: '视频节点',
        audio: '音频节点',
        directorDeck: '3D 导演台',
        ecomDetail: '电商详情图',
        uiDesign: 'UI 设计'
      }
      return labels[n.type] || n.type
    },
    _hasActiveRunsForProject(projectUuid) {
      const pu = String(projectUuid || '').trim()
      if (!pu) return false
      const nodeRuns = Object.values(this.runningNodeIds || {}).some(
        m => m && String(m.projectUuid || '') === pu
      )
      if (nodeRuns) return true
      return !!(this.ngcGraphRuns && this.ngcGraphRuns[pu])
    },
    _hasRunsBlockingCurrentProjectSave() {
      const pu = String(this.projectUuid || '')
      if (!pu) return false
      if (this.ngcGraphRuns && this.ngcGraphRuns[pu]) return true
      return Object.values(this.runningNodeIds || {}).some(
        m => m && String(m.projectUuid || '') === pu
      )
    },
    findNodeForRun(nodeId, runProjectUuid) {
      const id = String(nodeId || '')
      const pu = String(runProjectUuid || '')
      if (!id) return null
      if (pu === String(this.projectUuid || '')) {
        return (this.nodes || []).find(x => String(x.id) === id) || null
      }
      const wc = this.ngcProjectWorkingCopies[pu]
      if (wc && Array.isArray(wc.nodes)) {
        return wc.nodes.find(x => String(x.id) === id) || null
      }
      return null
    },
    prepareProjectSwitch(leavingUuid) {
      const leaving = String(leavingUuid || '').trim()
      if (!leaving) return
      if (this._hasActiveRunsForProject(leaving)) {
        const wc = this.ngcProjectWorkingCopies[leaving]
        if (wc) {
          wc.nodes = this.nodes
          wc.edges = this.edges
          wc.viewport = { ...this.viewport }
          wc.projectTitle = this.projectTitle
        } else {
          this.$set(this.ngcProjectWorkingCopies, leaving, {
            nodes: this.nodes,
            edges: this.edges,
            viewport: { ...this.viewport },
            projectTitle: this.projectTitle
          })
        }
      }
      if (this.cloudSaveTimer) {
        clearTimeout(this.cloudSaveTimer)
        this.cloudSaveTimer = null
      }
      this._lastCloudSaveFingerprint = ''
    },
    _resolveProjectTitle(id, row) {
      const wc = this.ngcProjectWorkingCopies[id]
      if (wc && wc.projectTitle && String(wc.projectTitle).trim()) {
        return String(wc.projectTitle).trim()
      }
      if (row && row.title && String(row.title).trim()) {
        return String(row.title).trim()
      }
      const recent = (this.readRecentProjectsFromStorage() || []).find(x => x && x.uuid === id)
      if (recent && recent.title && String(recent.title).trim()) {
        return String(recent.title).trim()
      }
      return '未命名画布'
    },
    _applyWorkingCopyState(id, wc) {
      if (!wc) return false
      this.projectUuid = id
      this.projectTitle = this._resolveProjectTitle(id, null)
      this.applyState({ nodes: wc.nodes, edges: wc.edges, viewport: wc.viewport })
      this.selectedId = null
      this.selectedEdgeId = null
      try {
        sessionStorage.setItem(NGC_LAST_OPENED_CANVAS_KEY, id)
      } catch {
        /* ignore */
      }
      return true
    },
    async persistDetachedProject(projectUuid) {
      const uuid = String(projectUuid || '').trim()
      if (!uuid) return
      const wc = this.ngcProjectWorkingCopies[uuid]
      if (!wc) return
      try {
        const state = {
          version: 1,
          nodes: wc.nodes,
          edges: wc.edges,
          viewport: { ...(wc.viewport || {}) }
        }
        const json = JSON.stringify(state)
        try {
          localStorage.setItem(NODE_CANVAS_STATE_PREFIX + uuid, json)
        } catch {
          /* quota 等 */
        }
        const thumb = pickFirstImageThumb(wc.nodes)
        const title =
          (wc.projectTitle && String(wc.projectTitle).trim()) || '未命名画布'
        try {
          let arr = this.readRecentProjectsFromStorage()
          const rec = {
            uuid,
            title,
            thumb_url: thumb ? String(thumb).trim() : '',
            updated_at: new Date().toISOString()
          }
          arr = [rec, ...arr.filter(x => x && x.uuid !== uuid)].slice(0, 40)
          localStorage.setItem(NODE_CANVAS_RECENT_LS, JSON.stringify(arr))
        } catch {
          /* ignore */
        }
        if (this.hasAuthTokenForCloudSave()) {
          await saveNodeCanvas({
            uuid,
            title,
            thumb_url: thumb,
            state
          })
        }
      } catch (e) {
        console.warn('[NodeGraphCanvas] detached persist failed', e)
      }
      if (!this._hasActiveRunsForProject(uuid)) {
        this.$delete(this.ngcProjectWorkingCopies, uuid)
      }
    },
    isNodeRunning(nodeId) {
      const id = nodeId != null ? String(nodeId) : ''
      if (!id) return false
      const cur = String(this.projectUuid || '')
      const meta = this.runningNodeIds[id]
      if (!meta) return false
      if (meta === true) return true
      if (typeof meta === 'object' && meta.projectUuid) {
        return String(meta.projectUuid) === cur
      }
      return true
    },
    beginNodeRunning(nodeId, runProjectUuid) {
      const id = nodeId != null ? String(nodeId) : ''
      if (!id) return
      const pu =
        runProjectUuid != null && String(runProjectUuid).trim()
          ? String(runProjectUuid).trim()
          : String(this.projectUuid || '')
      this.$set(this.runningNodeIds, id, {
        projectUuid: pu,
        nodeId: id
      })
    },
    endNodeRunning(nodeId) {
      const id = nodeId != null ? String(nodeId) : ''
      if (!id) return
      const meta = this.runningNodeIds[id]
      const runPu =
        meta && typeof meta === 'object' && meta.projectUuid
          ? String(meta.projectUuid)
          : String(this.projectUuid || '')
      const n = this.findNodeForRun(id, runPu)
      const st = n && n.data ? String(n.data.status || '').trim() : ''
      const ok = st === '完成' || st === '提示词就绪'
      this.$delete(this.runningNodeIds, id)
      if (!this._hasActiveRunsForProject(runPu) && this.ngcGraphRuns && this.ngcGraphRuns[runPu]) {
        this.$delete(this.ngcGraphRuns, runPu)
      }
      if (ok) {
        if (runPu === String(this.projectUuid || '')) {
          this.persistProjectAfterMutation({ cloudDelayMs: NGC_CLOUD_SAVE_AFTER_API_MS })
        } else {
          this.persistDetachedProject(runPu).catch(e => {
            console.warn('[NodeGraphCanvas] detached persist after run failed', e)
          })
        }
      }
      if (runPu === String(this.projectUuid || '')) {
        this.flushPendingCloudSaveAfterRun(400)
      }
      if (hasAuthToken()) {
        this.refreshNgcToolbarCredits()
      }
    },
    directorDeckNodeIndex(n) {
      let k = 0
      for (const x of this.nodes) {
        if (x.type === 'directorDeck') k += 1
        if (x.id === n.id) return k
      }
      return k || 1
    },
    /** 主预览：优先本节点「保存返回」截图，否则 BFS 最近下游图片节点的出图（与 gatherUpstreamImageUrls 一致） */
    directorDeckMainPreviewUrl(deckNode) {
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      return directorDeckUpstreamImageUrl(deckNode, map, this.edges)
    },
    /** 从导演台沿出边 BFS，收集可达的下游图片 / 视频节点（一键同步导演台预览） */
    directorDeckDownstreamMediaTargets(deckNode) {
      const start = String(deckNode && deckNode.id || '').trim()
      if (!start) return []
      const visited = new Set([start])
      const queue = [start]
      const out = []
      while (queue.length && out.length < 8) {
        const cur = queue.shift()
        for (const e of this.edges) {
          const from = e && e.from && e.from.nodeId
          if (from !== cur) continue
          const to = e.to && e.to.nodeId
          if (!to || visited.has(to)) continue
          visited.add(to)
          queue.push(to)
          const node = this.nodes.find(x => x.id === to)
          if (node && (node.type === 'image' || node.type === 'video')) out.push(node)
        }
      }
      return out
    },
    /**
     * 将本节点已保存的导演台预览图写入下游：图片节点写入 imageUrl；视频节点写入 referenceImageUrl（图生视频）。
     */
    applyDirectorShotToDownstream(deckNode, targetNodeId) {
      const d = deckNode && deckNode.data
      const fromShot = d && typeof d === 'object' ? String(d.directorShotPreviewUrl || '').trim() : ''
      const url = fromShot || this.directorDeckMainPreviewUrl(deckNode)
      if (!url) {
        showErrorToast('暂无可用预览图：请先在导演台保存返回，或连接下游图片节点并出图')
        return
      }
      const id = String(targetNodeId || '').trim()
      const node = id ? this.nodes.find(x => x.id === id && (x.type === 'image' || x.type === 'video')) : null
      if (!node || !node.data) {
        showErrorToast('目标不是有效的图片或视频节点')
        return
      }
      if (node.type === 'image') {
        this.$set(node.data, 'imageUrl', url)
        showSuccessToast('已写入图片节点')
      } else {
        this.$set(node.data, 'referenceImageUrl', url)
        showSuccessToast('已写入视频节点参考图')
      }
      this.scheduleAutosave()
    },
    /** 打开导演台时带上画布项目 id、下游图片节点 id，便于导出后跳回并写入 */
    directorDeckOpenRoute(deckNode) {
      const q = { ngc: '1', deck: deckNode.id }
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      const img = firstDownstreamImageNodeIdFromDeck(deckNode.id, map, this.edges)
      if (img) q.img = img
      let canvasQ = this.$route.query && this.$route.query.canvas
      canvasQ = canvasQ != null ? (Array.isArray(canvasQ) ? canvasQ[0] : canvasQ) : ''
      if (!String(canvasQ || '').trim()) {
        try {
          canvasQ = sessionStorage.getItem(NGC_LAST_OPENED_CANVAS_KEY) || ''
        } catch {
          canvasQ = ''
        }
      }
      if (!String(canvasQ || '').trim()) {
        const u = String(this.projectUuid || '').trim()
        if (u) canvasQ = u
      }
      if (String(canvasQ || '').trim()) q.canvas = String(canvasQ).trim()
      return { path: '/director-deck', query: q }
    },
    /** 进入导演台前写入本机快照，避免「保存返回」时 ?canvas= 加载不到云端项目 */
    onBeforeOpenDirectorDeck() {
      try {
        this.persistRecentProjectSnapshot()
        sessionStorage.setItem(NGC_LAST_OPENED_CANVAS_KEY, String(this.projectUuid || '').trim())
      } catch {
        /* ignore */
      }
    },
    ngcNormalizeQueryVal(val) {
      if (val == null) return ''
      const s = Array.isArray(val) ? val[0] : val
      return String(s || '').trim()
    },
    /** 导演台 sessionStorage 回传：v3 为云端 URL，v2 为 dataUrl */
    ngcDirectorShotPayloadUrl(o) {
      if (!o || typeof o !== 'object') return ''
      const v = Number(o.v)
      if (v === 3) {
        const u = o.imageUrl != null ? String(o.imageUrl).trim() : ''
        if (/^https?:\/\//i.test(u) || (u.length > 1 && u.startsWith('/'))) return u
        return ''
      }
      if (v === 2 && o.dataUrl && typeof o.dataUrl === 'string') return o.dataUrl
      return ''
    },
    /** 将视口平移到节点居中并选中（从导演台返回时用） */
    focusViewportOnNode(nodeId) {
      const id = String(nodeId || '').trim()
      const n = id ? this.nodes.find(x => x.id === id) : null
      const el = this.$refs.viewEl
      if (!n || !el) return
      const rw = el.clientWidth
      const rh = el.clientHeight
      if (rw < 32 || rh < 32) return
      const pad = 140
      const nw = Math.max(40, Number(n.w) || 0) + pad * 2
      const nh = Math.max(40, Number(n.h) || 0) + pad * 2
      const s = Math.min(rw / nw, rh / nh, 1.15)
      this.viewport.scale = Math.min(2, Math.max(0.35, s))
      this.viewport.panX = rw / 2 - (Number(n.x) + Number(n.w) / 2) * this.viewport.scale
      this.viewport.panY = rh / 2 - (Number(n.y) + Number(n.h) / 2) * this.viewport.scale
    },
    /**
     * 从导演台返回：?ngcDirectorShot=1 同步导出图到导演台与下游图片；兼容 ?ngcDirPng=1。
     */
    applyRouteNgcDirectorReturn() {
      const q = this.$route.query || {}
      const focusId = this.ngcNormalizeQueryVal(q.focusNode)
      const shot = q.ngcDirectorShot === '1' || q.ngcDirectorShot === 1
      const dirPng = q.ngcDirPng === '1' || q.ngcDirPng === 1
      const once = q.ngcFocus === '1' || q.ngcFocus === 1
      if (!this.nodes.length) return

      if (shot) {
        if (!focusId) {
          try {
            sessionStorage.removeItem(NGC_DIRECTOR_PNG_SESSION_KEY)
          } catch {
            /* ignore */
          }
          const nextQ = { ...q }
          delete nextQ.ngcDirectorShot
          this.$router.replace({ path: this.$route.path, query: nextQ }).catch(() => {})
          return
        }
        let wrote = false
        try {
          const raw = sessionStorage.getItem(NGC_DIRECTOR_PNG_SESSION_KEY)
          if (raw) {
            const o = JSON.parse(raw)
            const previewUrl = this.ngcDirectorShotPayloadUrl(o)
            if (previewUrl) {
              const imgId = String(o.imageNodeId || '').trim()
              if (imgId) {
                const imgNode = this.nodes.find(x => x.id === imgId && x.type === 'image')
                if (imgNode && imgNode.data) {
                  this.$set(imgNode.data, 'imageUrl', previewUrl)
                  wrote = true
                }
              }
              const deckId = String(o.deckId || '').trim()
              if (deckId) {
                const deckNode = this.nodes.find(x => x.id === deckId && x.type === 'directorDeck')
                if (deckNode && deckNode.data) {
                  this.$set(deckNode.data, 'directorShotPreviewUrl', previewUrl)
                  wrote = true
                }
              }
            }
          }
        } catch {
          /* ignore */
        }
        try {
          sessionStorage.removeItem(NGC_DIRECTOR_PNG_SESSION_KEY)
        } catch {
          /* ignore */
        }
        const nextQ = { ...q }
        delete nextQ.ngcDirectorShot
        this.$router.replace({ path: this.$route.path, query: nextQ }).catch(() => {})
        if (this.nodes.some(x => x.id === focusId)) {
          this.selectedId = focusId
          this.$nextTick(() => {
            this.focusViewportOnNode(focusId)
            if (wrote) {
              showSuccessToast('导演台预览已同步到节点')
              this.persistProjectAfterMutation({ cloudDelayMs: NGC_CLOUD_SAVE_AFTER_API_MS })
            }
          })
        }
        return
      }

      if (dirPng) {
        if (!focusId) return
        const node = this.nodes.find(x => x.id === focusId)
        if (!node || node.type !== 'image') {
          try {
            sessionStorage.removeItem(NGC_DIRECTOR_PNG_SESSION_KEY)
          } catch {
            /* ignore */
          }
          const nextQ = { ...q }
          delete nextQ.ngcDirPng
          this.$router.replace({ path: this.$route.path, query: nextQ }).catch(() => {})
          return
        }
        let applied = false
        try {
          const raw = sessionStorage.getItem(NGC_DIRECTOR_PNG_SESSION_KEY)
          if (raw) {
            const o = JSON.parse(raw)
            const previewUrl = this.ngcDirectorShotPayloadUrl(o)
            if (previewUrl && o.imageNodeId === focusId) {
              this.$set(node.data, 'imageUrl', previewUrl)
              applied = true
            }
            if (previewUrl && String(o.deckId || '').trim()) {
              const deckNode = this.nodes.find(x => x.id === o.deckId && x.type === 'directorDeck')
              if (deckNode && deckNode.data) {
                this.$set(deckNode.data, 'directorShotPreviewUrl', previewUrl)
              }
            }
          }
        } catch {
          /* ignore */
        }
        try {
          sessionStorage.removeItem(NGC_DIRECTOR_PNG_SESSION_KEY)
        } catch {
          /* ignore */
        }
        const nextQ = { ...q }
        delete nextQ.ngcDirPng
        this.$router.replace({ path: this.$route.path, query: nextQ }).catch(() => {})
        this.selectedId = focusId
        this.$nextTick(() => {
          this.focusViewportOnNode(focusId)
          if (applied) showSuccessToast('导出演播图已写入图片节点')
        })
        return
      }

      if (once && focusId && this.nodes.some(x => x.id === focusId)) {
        const nextQ = { ...q }
        delete nextQ.ngcFocus
        this.$router.replace({ path: this.$route.path, query: nextQ }).catch(() => {})
        this.selectedId = focusId
        this.$nextTick(() => this.focusViewportOnNode(focusId))
      }
    },
    textNodeIndex(n) {
      let k = 0
      for (const x of this.nodes) {
        if (x.type === 'llm') k += 1
        if (x.id === n.id) return k
      }
      return k || 1
    },
    storyboardNodeIndex(n) {
      let k = 0
      for (const x of this.nodes) {
        if (x.type === 'storyboard') k += 1
        if (x.id === n.id) return k
      }
      return k || 1
    },
    scriptWriteNodeIndex(n) {
      let k = 0
      for (const x of this.nodes) {
        if (x.type === 'scriptWrite') k += 1
        if (x.id === n.id) return k
      }
      return k || 1
    },
    scriptWriteCreditDisplay(n) {
      if (!n || n.type !== 'scriptWrite' || !n.data) return 0
      const c = Number(n.data.creditDisplay)
      if (c > 0) return c
      return this.ngcCreditsForModelId(n.data.model, NGC_MODEL_KIND.LLM, n)
    },
    storyboardCreditDisplay(n) {
      if (!n || n.type !== 'storyboard' || !n.data) return 0
      const c = Number(n.data.creditDisplay)
      if (c > 0) return c
      return this.ngcCreditsForModelId(n.data.model, NGC_MODEL_KIND.LLM, n)
    },
    scriptWriteHasGeneratedContent(n) {
      if (!n || n.type !== 'scriptWrite' || !n.data) return false
      return !!String(n.data.output || '').trim()
    },
    storyboardContinuityDropdownOptions(n) {
      const base = [
        { id: '', label: '自动（上游分镜连线）' },
        { id: '_none_', label: '不续接' }
      ]
      const extra = this.storyboardContinuitySelectOptions(n) || []
      for (let i = 0; i < extra.length; i++) {
        const p = extra[i]
        if (!p || !p.id) continue
        base.push({
          id: p.id,
          label: `指定前一集：${p.label || p.id}`
        })
      }
      return base
    },
    imageCountDropdownOptions() {
      return (this.imageCountChoices || []).map(c => ({
        id: c,
        label: `${c}张`
      }))
    },
    volcTtsExpressDropdownOptions() {
      return (this.volcTtsExpressModeOptions || []).map(m => ({
        id: m.value,
        label: m.label
      }))
    },
    volcSpeakerDropdownOptions() {
      const opts = (this.volcTtsSpeakerPresets || []).map(p => ({
        id: p.id,
        label: p.label
      }))
      opts.push({
        id: this.volcSpeakerCustomId,
        label: '自定义 speaker ID…'
      })
      return opts
    },
    ecomSkillDropdownOptions() {
      return (this.ngcEcomDetailSkills || []).map(sk => ({
        id: sk.id,
        label: sk.title || sk.id
      }))
    },
    onEcomDetailSkillSelectValue(n, skillId) {
      this.onEcomDetailSkillSelect(n, { target: { value: skillId } })
    },
    reconcileStoryboardNodePickFields(n) {
      if (!n || n.type !== 'storyboard' || !n.data) return
      const d = n.data
      if (d.workflowStyle === undefined) this.$set(d, 'workflowStyle', null)
      else if (d.workflowStyle != null && typeof d.workflowStyle !== 'object') {
        this.$set(d, 'workflowStyle', null)
      }
      let lang = d.storyboardLanguage != null ? String(d.storyboardLanguage).trim() : ''
      if (!lang) {
        lang =
          d.outputLanguage != null
            ? String(d.outputLanguage).trim()
            : 'zh'
      }
      if (lang === 'en' || lang === 'english') this.$set(d, 'storyboardLanguage', 'en')
      else this.$set(d, 'storyboardLanguage', 'zh')
      this.$set(d, 'storyboardAspectRatio', resolveStoryboardAspectRatio(d))
    },
    reconcileScriptWritePickFields(n) {
      if (!n || n.type !== 'scriptWrite' || !n.data) return
      const d = n.data
      const genreIds = new Set(SCRIPT_WRITE_GENRE_OPTIONS.map(o => o.id))
      const lenIds = new Set(SCRIPT_WRITE_LENGTH_OPTIONS.map(o => o.id))
      if (d.genrePick == null) {
        const legacy = String(d.genre || '').trim()
        if (!legacy) this.$set(d, 'genrePick', '')
        else if (genreIds.has(legacy)) this.$set(d, 'genrePick', legacy)
        else {
          this.$set(d, 'genrePick', SCRIPT_WRITE_SELECT_CUSTOM)
          this.$set(d, 'genreCustom', legacy)
        }
      }
      if (d.genreCustom == null) this.$set(d, 'genreCustom', '')
      if (d.lengthHintPick == null) {
        const legacyLen = String(d.lengthHint || '').trim()
        if (!legacyLen) this.$set(d, 'lengthHintPick', '')
        else if (lenIds.has(legacyLen)) this.$set(d, 'lengthHintPick', legacyLen)
        else {
          this.$set(d, 'lengthHintPick', SCRIPT_WRITE_SELECT_CUSTOM)
          this.$set(d, 'lengthHintCustom', legacyLen)
        }
      }
      if (d.lengthHintCustom == null) this.$set(d, 'lengthHintCustom', '')
    },
    canvasNodeVerticalSortKey(n) {
      if (!n) return 0
      const y = Number(n.y) || 0
      const x = Number(n.x) || 0
      return y * 1000000 + x
    },
    nodesOfTypeSortedByCanvasPosition(type) {
      return (this.nodes || [])
        .filter(n => n && n.type === type)
        .sort((a, b) => this.canvasNodeVerticalSortKey(a) - this.canvasNodeVerticalSortKey(b))
    },
    nodeTypeIndexByCanvasPosition(n, type) {
      if (!n || n.type !== type) return 1
      const list = this.nodesOfTypeSortedByCanvasPosition(type)
      const idx = list.findIndex(x => x.id === n.id)
      return idx >= 0 ? idx + 1 : 1
    },
    imageNodeIndex(n) {
      return this.nodeTypeIndexByCanvasPosition(n, 'image')
    },
    videoNodeIndex(n) {
      return this.nodeTypeIndexByCanvasPosition(n, 'video')
    },
    /** 画布「整理」：视频节点按镜号 / 画布位置自上而下 */
    videoNodeLayoutSortKey(n) {
      if (!n || n.type !== 'video' || !n.data) return this.canvasNodeVerticalSortKey(n)
      const d = n.data
      if (d.storyboardShotSort != null && Number.isFinite(Number(d.storyboardShotSort))) {
        return Number(d.storyboardShotSort)
      }
      const fromNo = parseStoryboardShotNumberSortKey(d.storyboardShotNo)
      if (Number.isFinite(fromNo)) return fromNo
      const pm = String(d.prompt || '').match(/镜号\s*([0-9]+)/)
      if (pm && pm[1]) return parseInt(pm[1], 10)
      return this.canvasNodeVerticalSortKey(n)
    },
    imageNodeLayoutSortKey(n) {
      return this.canvasNodeVerticalSortKey(n)
    },
    compareNodesForTidyLayout(a, b) {
      const aVideo = a && a.type === 'video'
      const bVideo = b && b.type === 'video'
      const aImage = a && a.type === 'image'
      const bImage = b && b.type === 'image'
      if (aVideo && bVideo) {
        const dk = this.videoNodeLayoutSortKey(a) - this.videoNodeLayoutSortKey(b)
        if (dk !== 0) return dk
        return this.canvasNodeVerticalSortKey(a) - this.canvasNodeVerticalSortKey(b)
      }
      if (aImage && bImage) {
        const dk = this.imageNodeLayoutSortKey(a) - this.imageNodeLayoutSortKey(b)
        if (dk !== 0) return dk
        return this.canvasNodeVerticalSortKey(a) - this.canvasNodeVerticalSortKey(b)
      }
      if (aVideo && !bVideo) return 1
      if (!aVideo && bVideo) return -1
      return String(a.id).localeCompare(String(b.id))
    },
    /** 整理后：视频镜号 / 排序键与自上而下序号对齐；标题「视频节点 N」与 y 一致 */
    syncNodeSequenceNumbersAfterTidyLayout() {
      const videos = this.nodesOfTypeSortedByCanvasPosition('video')
      videos.forEach((n, i) => {
        if (!n || !n.data) return
        const seq = i + 1
        this.$set(n.data, 'storyboardShotSort', seq)
        this.$set(n.data, 'storyboardShotNo', String(seq).padStart(2, '0'))
      })
    },
    audioNodeIndex(n) {
      let k = 0
      for (const x of this.nodes) {
        if (x.type === 'audio') k += 1
        if (x.id === n.id) return k
      }
      return k || 1
    },
    ecomDetailNodeIndex(n) {
      let k = 0
      for (const x of this.nodes) {
        if (x.type === 'ecomDetail') k += 1
        if (x.id === n.id) return k
      }
      return k || 1
    },
    uiDesignNodeIndex(n) {
      let k = 0
      for (const x of this.nodes) {
        if (x.type === 'uiDesign') k += 1
        if (x.id === n.id) return k
      }
      return k || 1
    },
    uiDesignScreenPlanCount(n) {
      if (!n || n.type !== 'uiDesign' || !n.data || !Array.isArray(n.data.screenPlans)) return 0
      return n.data.screenPlans.filter(p => p && String(p.prompt || '').trim()).length
    },
    uiDesignConfiguredScreenCount(n) {
      if (!n || !n.data) return UI_DESIGN_DEFAULT_SCREEN_COUNT
      if (this.uiDesignScreenPlanCount(n)) return this.uiDesignScreenPlanCount(n)
      return normalizeUiDesignScreenCount(n.data.screenCount)
    },
    uiDesignRenderCreditDisplay(n) {
      const cnt = Math.max(1, this.uiDesignConfiguredScreenCount(n))
      const model = String(
        (n && n.data && n.data.seedreamModel) || 'doubao-seedream-5-0-260128'
      ).trim()
      const total = calcRequiredCreditsFromCatalog(
        this.ngcModelsCatalog,
        model,
        NGC_MODEL_KIND.IMAGE,
        { times: cnt }
      )
      return total > 0 ? total : 0
    },
    uiDesignCreditDisplay(n) {
      if (!n || n.type !== 'uiDesign' || !n.data) return 0
      if (this.uiDesignScreenPlanCount(n)) {
        return this.uiDesignRenderCreditDisplay(n)
      }
      const ds = String(n.data.deepseekModel || 'deepseek-v4-flash').trim()
      const per = calcRequiredCreditsFromCatalog(
        this.ngcModelsCatalog,
        ds,
        NGC_MODEL_KIND.LLM,
        { times: 1 }
      )
      return per > 0 ? per : 0
    },
    toggleUiDesignDeepseekPicker(n) {
      if (!n || n.type !== 'uiDesign') return
      if (this.uiDesignDeepseekPickerNodeId === n.id) {
        this.uiDesignDeepseekPickerNodeId = null
        return
      }
      this.uiDesignImageModelPickerNodeId = null
      this.uiDesignDeepseekPickerNodeId = n.id
    },
    toggleUiDesignImageModelPicker(n) {
      if (!n || n.type !== 'uiDesign') return
      if (this.uiDesignImageModelPickerNodeId === n.id) {
        this.uiDesignImageModelPickerNodeId = null
        return
      }
      this.uiDesignDeepseekPickerNodeId = null
      this.uiDesignImageModelPickerNodeId = n.id
    },
    setUiDesignDeepseekModel(n, modelId) {
      if (!n || n.type !== 'uiDesign' || !n.data) return
      this.$set(n.data, 'deepseekModel', String(modelId || '').trim())
      this.uiDesignDeepseekPickerNodeId = null
      this.$set(n.data, 'creditDisplay', this.uiDesignCreditDisplay(n))
    },
    setUiDesignImageModel(n, modelId) {
      if (!n || n.type !== 'uiDesign' || !n.data) return
      this.$set(n.data, 'seedreamModel', String(modelId || '').trim())
      this.uiDesignImageModelPickerNodeId = null
      this.$set(n.data, 'creditDisplay', this.uiDesignCreditDisplay(n))
    },
    uiDesignDeepseekModelLabel(n) {
      const id = n && n.data ? String(n.data.deepseekModel || '').trim() : ''
      const hit = (this.storyboardModelOptions || []).find(m => String(m.id) === id)
      return (hit && hit.label) || id || 'DeepSeek'
    },
    uiDesignImageModelLabel(n) {
      const id = n && n.data ? String(n.data.seedreamModel || '').trim() : ''
      const hit = (this.imageModelOptions || []).find(m => String(m.id) === id)
      return (hit && hit.label) || id || 'Seedream'
    },
    uiDesignScreenCountDropdownOptions() {
      return getUiDesignScreenCountDropdownOptions()
    },
    uiDesignStyleSummary(n) {
      if (!n || !n.data) return ''
      return getUiDesignStyleSummary(n.data)
    },
    uiDesignUpstreamRefCount(n) {
      if (!n || n.type !== 'uiDesign') return 0
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      return this.uiDesignGatherReferenceUrls(n.id, map).length
    },
    uiDesignReferenceStylePreview(n) {
      if (!n || !n.data) return ''
      const g = String(n.data.referenceStyleGuide || n.data.upstreamImageAnalysis || '').trim()
      return g.length > 480 ? `${g.slice(0, 480)}…` : g
    },
    uiDesignUpstreamAnalysisMethodLabel(n) {
      const m = String((n && n.data && n.data.upstreamImageAnalysisMethod) || '').trim()
      if (m === 'vision') return '多模态识图'
      if (m === 'text_infer') return '根据上游描述推断'
      return m ? m : ''
    },
    setUiDesignApplyUpstreamStyle(n, ev) {
      if (!n || n.type !== 'uiDesign' || !n.data) return
      const checked = !!(ev && ev.target && ev.target.checked)
      this.$set(n.data, 'applyUpstreamStyleToFields', checked)
    },
    normalizeUiDesignHexColor(raw, fallback) {
      const fb = String(fallback || UI_DESIGN_DEFAULT_PRIMARY).trim()
      const s = String(raw || '').trim()
      if (/^#[0-9a-fA-F]{6}$/.test(s)) return s.toUpperCase()
      if (/^#[0-9a-fA-F]{3}$/.test(s)) {
        const r = s[1]
        const g = s[2]
        const b = s[3]
        return `#${r}${r}${g}${g}${b}${b}`.toUpperCase()
      }
      return fb
    },
    uiDesignThemeColorForPicker(n, which) {
      if (!n || !n.data) {
        return which === 'secondary' ? UI_DESIGN_DEFAULT_SECONDARY : UI_DESIGN_DEFAULT_PRIMARY
      }
      const fb =
        which === 'secondary' ? UI_DESIGN_DEFAULT_SECONDARY : UI_DESIGN_DEFAULT_PRIMARY
      const key = which === 'secondary' ? 'themeColorSecondary' : 'themeColorPrimary'
      return this.normalizeUiDesignHexColor(n.data[key], fb)
    },
    setUiDesignThemeColorFromPicker(n, which, ev) {
      if (!n || n.type !== 'uiDesign' || !n.data) return
      const key = which === 'secondary' ? 'themeColorSecondary' : 'themeColorPrimary'
      const fb =
        which === 'secondary' ? UI_DESIGN_DEFAULT_SECONDARY : UI_DESIGN_DEFAULT_PRIMARY
      const v = this.normalizeUiDesignHexColor(
        ev && ev.target ? ev.target.value : '',
        fb
      )
      this.$set(n.data, key, v)
    },
    setUiDesignThemeColorFromHex(n, which, ev) {
      if (!n || n.type !== 'uiDesign' || !n.data) return
      const key = which === 'secondary' ? 'themeColorSecondary' : 'themeColorPrimary'
      const fb =
        which === 'secondary' ? UI_DESIGN_DEFAULT_SECONDARY : UI_DESIGN_DEFAULT_PRIMARY
      const v = this.normalizeUiDesignHexColor(
        ev && ev.target ? ev.target.value : '',
        fb
      )
      this.$set(n.data, key, v)
    },
    applyParsedUiDesignStyle(node, parsed) {
      if (!node || !node.data || !parsed) return
      if (node.data.applyUpstreamStyleToFields === false) return
      const styleId = normalizeUiDesignStyleId(parsed.builtinStyleId)
      if (styleId) {
        this.$set(node.data, 'designStyleId', styleId)
      }
      const keywords = String(parsed.styleKeywords || '').trim()
      if (styleId === UI_DESIGN_STYLE_CUSTOM_ID && keywords) {
        this.$set(node.data, 'designStyleCustom', keywords)
      } else if (keywords) {
        this.$set(node.data, 'designStyleCustom', keywords)
      }
      if (parsed.primaryColor) {
        this.$set(node.data, 'themeColorPrimary', parsed.primaryColor)
      }
      if (parsed.secondaryColor) {
        this.$set(node.data, 'themeColorSecondary', parsed.secondaryColor)
      }
    },
    async loadEcomDetailSkills() {
      // 暂时仅展示「电商图片生图提示词专家」，其余 Skill 已注释
      // try {
      //   const { skills } = await fetchUserCenterConfig()
      //   const api = Array.isArray(skills) ? skills : []
      //   this.ngcEcomDetailSkills = mergeEcomDetailSkillList(api, ECOM_DETAIL_BUILTIN_SKILLS)
      // } catch {
      //   this.ngcEcomDetailSkills = mergeEcomDetailSkillList([], ECOM_DETAIL_BUILTIN_SKILLS)
      // }
      this.ngcEcomDetailSkills = mergeEcomDetailSkillList([], ECOM_DETAIL_BUILTIN_SKILLS)
      this.reconcileEcomDetailSkillsOnNodes()
    },
    async loadNgcModelsCatalog() {
      if (this.ngcModelsCatalogLoading) return
      this.ngcModelsCatalogLoading = true
      try {
        const rows = await fetchModelsList()
        this.ngcModelsCatalog = Array.isArray(rows) ? rows : []
        this.ngcModelsCatalogError = ''
        this.reconcileAllNodesModelsWithCatalog()
        for (const n of this.nodes) {
          this.syncNodeCreditDisplayFromModel(n)
        }
      } catch (e) {
        this.ngcModelsCatalog = []
        this.ngcModelsCatalogError = getModelsApiErrorMessage(e) || '模型列表加载失败'
      } finally {
        this.ngcModelsCatalogLoading = false
      }
    },
    reconcileAllNodesModelsWithCatalog() {
      for (const n of this.nodes) {
        this.reconcileNodeModelWithCatalog(n)
      }
    },
    ngcEnsureModelInCatalog(n, field, kind, options) {
      if (!n || !n.data) return
      const opts = Array.isArray(options) ? options : []
      if (!opts.length) return
      const raw = n.data[field] != null ? String(n.data[field]).trim() : ''
      if (!raw) {
        const first = opts[0]
        if (first && first.id != null) {
          this.$set(n.data, field, String(first.id))
        }
        return
      }
      const chargeId =
        kind === NGC_MODEL_KIND.VIDEO ? resolveVideoModelChargeId(raw) : raw
      if (isModelInCatalog(this.ngcModelsCatalog, chargeId, kind)) {
        return
      }
      const first = opts[0]
      if (first && first.id != null) {
        this.$set(n.data, field, String(first.id))
      }
    },
    /** 新建 image / video 节点：默认选中模型列表第一项 */
    applyDefaultModelForNewNode(n) {
      if (!n || !n.data) return
      if (n.type === 'image') {
        this.ngcEnsureModelInCatalog(
          n,
          'seedreamModel',
          NGC_MODEL_KIND.IMAGE,
          this.imageModelOptions
        )
      } else if (n.type === 'video') {
        this.ngcEnsureModelInCatalog(
          n,
          'seedanceModel',
          NGC_MODEL_KIND.VIDEO,
          this.videoModelOptions
        )
      }
    },
    reconcileNodeModelWithCatalog(n) {
      if (!n || !n.data) return
      if (!this.ngcModelsCatalog || !this.ngcModelsCatalog.length) return
      const t = n.type
      if (t === 'llm') {
        this.ngcEnsureModelInCatalog(n, 'model', NGC_MODEL_KIND.LLM, this.llmModelOptions)
      } else if (t === 'storyboard' || t === 'scriptWrite') {
        this.ngcEnsureModelInCatalog(
          n,
          'model',
          NGC_MODEL_KIND.LLM,
          this.storyboardModelOptions
        )
      } else if (t === 'image') {
        this.ngcEnsureModelInCatalog(
          n,
          'seedreamModel',
          NGC_MODEL_KIND.IMAGE,
          this.imageModelOptions
        )
      } else if (t === 'video') {
        this.ngcEnsureModelInCatalog(
          n,
          'seedanceModel',
          NGC_MODEL_KIND.VIDEO,
          this.videoModelOptions
        )
      } else if (t === 'audio') {
        this.ngcEnsureModelInCatalog(n, 'model', NGC_MODEL_KIND.AUDIO, this.audioModelOptions)
      } else if (t === 'ecomDetail') {
        this.ngcEnsureModelInCatalog(
          n,
          'deepseekModel',
          NGC_MODEL_KIND.LLM,
          this.storyboardModelOptions
        )
        this.ngcEnsureModelInCatalog(
          n,
          'seedreamModel',
          NGC_MODEL_KIND.IMAGE,
          this.ecomImageModelOptions
        )
      } else if (t === 'uiDesign') {
        this.ngcEnsureModelInCatalog(
          n,
          'deepseekModel',
          NGC_MODEL_KIND.LLM,
          this.storyboardModelOptions
        )
        this.ngcEnsureModelInCatalog(
          n,
          'seedreamModel',
          NGC_MODEL_KIND.IMAGE,
          this.imageModelOptions
        )
      }
    },
    ngcModelOptionCreditsLine(m, kind) {
      const id = m && m.id != null ? String(m.id).trim() : ''
      const chargeId =
        id ||
        (m && m.backendDefault
          ? String(m.backendDefault).trim()
          : kind === NGC_MODEL_KIND.VIDEO
            ? resolveVideoModelChargeId('')
            : '')
      return catalogCreditsLine(this.ngcModelsCatalog, chargeId, kind)
    },
    ngcResolveChargeModelId(modelId, kind) {
      if (kind === NGC_MODEL_KIND.VIDEO) {
        return resolveVideoModelChargeId(modelId)
      }
      return String(modelId != null ? modelId : '').trim()
    },
    ngcMergedModelOptions(kind) {
      const k = kind || NGC_MODEL_KIND.IMAGE
      if (k === NGC_MODEL_KIND.LLM) return this.llmModelOptions || []
      if (k === NGC_MODEL_KIND.IMAGE) return this.imageModelOptions || []
      if (k === NGC_MODEL_KIND.VIDEO) return this.videoModelOptions || []
      if (k === NGC_MODEL_KIND.AUDIO) return this.audioModelOptions || []
      return []
    },
    ngcCreditsForModelId(modelId, kind, node) {
      const id = this.ngcResolveChargeModelId(modelId, kind)
      if (!id) return 0
      const hit = findModelInCatalog(this.ngcModelsCatalog, id, kind)
      if (!hit) return 0
      if (kind === NGC_MODEL_KIND.VIDEO && node && node.data) {
        return resolveVideoCreditsPerSecond(hit, node.data.resolution)
      }
      return Number(hit.credits) || 0
    },
    ngcNodeModelKind(n) {
      if (!n) return ''
      if (n.type === 'llm' || n.type === 'storyboard' || n.type === 'scriptWrite') {
        return NGC_MODEL_KIND.LLM
      }
      if (n.type === 'image') return NGC_MODEL_KIND.IMAGE
      if (n.type === 'video') return NGC_MODEL_KIND.VIDEO
      if (n.type === 'audio') return NGC_MODEL_KIND.AUDIO
      return ''
    },
    ngcNodeCurrentModelId(n) {
      if (!n || !n.data) return ''
      if (n.type === 'image') return String(n.data.seedreamModel != null ? n.data.seedreamModel : '')
      if (n.type === 'video') return String(n.data.seedanceModel != null ? n.data.seedanceModel : '')
      return String(n.data.model != null ? n.data.model : '')
    },
    syncNodeCreditDisplayFromModel(n) {
      if (!n || !n.data) return
      const t = n.type
      let c = 0
      if (t === 'llm' || t === 'storyboard' || t === 'scriptWrite') {
        c = this.ngcCreditsForModelId(n.data.model, NGC_MODEL_KIND.LLM, n)
      } else if (t === 'image') {
        c = this.ngcCreditsForModelId(n.data.seedreamModel, NGC_MODEL_KIND.IMAGE, n)
      } else if (t === 'video') {
        c = this.ngcCreditsForModelId(n.data.seedanceModel, NGC_MODEL_KIND.VIDEO, n)
      } else if (t === 'audio') {
        c = this.ngcCreditsForModelId(n.data.model, NGC_MODEL_KIND.AUDIO, n)
      } else {
        return
      }
      if (c > 0) this.$set(n.data, 'creditDisplay', c)
      else if (n.data.creditDisplay != null) this.$delete(n.data, 'creditDisplay')
    },
    ngcRequiredCreditsForRun(n, opts = {}) {
      if (!n || !n.data) return 0
      const t = n.type
      if (t === 'image') {
        if (String(n.data.imageInputMode || '') === 'upload') return 0
        const model = String(n.data.seedreamModel || '').trim()
        const cnt = Math.min(8, Math.max(1, Number(n.data.imageCount) || 1))
        const kind =
          model === 'character-designer' ? NGC_MODEL_KIND.LLM : NGC_MODEL_KIND.IMAGE
        return calcRequiredCreditsFromCatalog(this.ngcModelsCatalog, model, kind, {
          times: cnt
        })
      }
      if (t === 'video') {
        const model = this.ngcResolveChargeModelId(n.data.seedanceModel, NGC_MODEL_KIND.VIDEO)
        const dur = Math.min(15, Math.max(1, Number(n.data.duration) || 5))
        const fromCatalog = calcRequiredCreditsFromCatalog(
          this.ngcModelsCatalog,
          model,
          NGC_MODEL_KIND.VIDEO,
          {
            duration: dur,
            times: 1,
            resolution: n.data.resolution
          }
        )
        return fromCatalog > 0 ? fromCatalog : 0
      }
      if (t === 'llm' || t === 'storyboard' || t === 'scriptWrite') {
        const model = String(n.data.model || '').trim()
        return calcRequiredCreditsFromCatalog(
          this.ngcModelsCatalog,
          model,
          NGC_MODEL_KIND.LLM,
          { times: 1 }
        )
      }
      if (t === 'audio') {
        if (String(n.data.audioInputMode || '') === 'upload') return 0
        const model = String(n.data.model || '').trim()
        return calcRequiredCreditsFromCatalog(
          this.ngcModelsCatalog,
          model,
          NGC_MODEL_KIND.AUDIO,
          { times: 1 }
        )
      }
      if (t === 'ecomDetail') {
        if (opts.renderImages) {
          const plans = Array.isArray(n.data.promptPlans) ? n.data.promptPlans : []
          const model = String(n.data.seedreamModel || 'doubao-seedream-5-0-260128').trim()
          return calcRequiredCreditsFromCatalog(
            this.ngcModelsCatalog,
            model,
            NGC_MODEL_KIND.IMAGE,
            { times: Math.max(1, plans.length) }
          )
        }
        return this.ecomDetailCreditDisplay(n)
      }
      if (t === 'uiDesign') {
        if (opts.renderImages) {
          const plans = Array.isArray(n.data.screenPlans) ? n.data.screenPlans : []
          const model = String(n.data.seedreamModel || 'doubao-seedream-5-0-260128').trim()
          return calcRequiredCreditsFromCatalog(
            this.ngcModelsCatalog,
            model,
            NGC_MODEL_KIND.IMAGE,
            { times: Math.max(1, plans.length) }
          )
        }
        return this.uiDesignCreditDisplay(n)
      }
      return 0
    },
    async ensureNgcModelOnShelfBeforeRun(n, opts = {}) {
      const targets = collectNodeRunModelTargets(n, opts)
      if (!targets.length) return
      if (!this.ngcModelsCatalog.length && !this.ngcModelsCatalogLoading) {
        await this.loadNgcModelsCatalog()
      }
      if (this.ngcModelsCatalogLoading) {
        throw new Error('模型定价加载中，请稍后重试')
      }
      assertModelsOnShelf(this.ngcModelsCatalog, targets)
    },
    async refreshNgcToolbarCredits() {
      if (!hasAuthToken()) {
        this.ngcToolbarRemainingCredits = null
        this.ngcToolbarCreditsLoading = false
        return
      }
      this.ngcToolbarCreditsLoading = true
      try {
        const profile = await fetchCreditsUserProfile()
        this.ngcToolbarRemainingCredits = Number(profile && profile.score) || 0
      } catch {
        /* 保留上次数值 */
      } finally {
        this.ngcToolbarCreditsLoading = false
      }
    },
    onNgcToolbarCreditsClick() {
      requestBalanceBillingModal()
      if (hasAuthToken()) this.refreshNgcToolbarCredits()
    },
    async ensureNgcScoreBeforeRun(n, opts = {}) {
      if (!hasAuthToken()) {
        openLoginModal()
        throw new Error('请先登录')
      }
      await this.ensureNgcModelOnShelfBeforeRun(n, opts)
      const required = this.ngcRequiredCreditsForRun(n, opts)
      if (required <= 0) return
      const label =
        opts.label ||
        (n && n.type === 'image'
          ? '生成图片'
          : n && n.type === 'video'
            ? '生成视频'
            : '执行模型')
      await assertUserHasCredits({ required, label })
    },
    ngcNodeSingleCreditHint(n) {
      if (!n || !n.data) return 0
      const kind = this.ngcNodeModelKind(n)
      if (!kind) return 0
      return this.ngcCreditsForModelId(this.ngcNodeCurrentModelId(n), kind)
    },
    ngcNodeCreditBoltText(n) {
      if (this.ngcModelsCatalogLoading) return '…'
      const c = this.ngcNodeSingleCreditHint(n)
      return c > 0 ? String(c) : '—'
    },
    ngcFormatCatalogCredits(amount) {
      if (this.ngcModelsCatalogLoading) return '…'
      const c = Number(amount)
      return c > 0 ? String(c) : '—'
    },
    /**
     * 切换节点模型（仅写入 model_id + 刷新定价展示，不扣积分）
     * 扣费在点击执行时由 ensureNgcScoreBeforeRun / 后端 volc_* 等接口完成
     */
    async ngcChargeAndApplyModel(n, opts) {
      if (!n || !n.data || !opts || !opts.field) return false
      const kind = opts.kind || NGC_MODEL_KIND.IMAGE
      const field = opts.field
      let nextVal = opts.modelId != null ? String(opts.modelId) : ''
      if (typeof opts.normalize === 'function') {
        nextVal = opts.normalize(nextVal)
      }
      const nextCharge = this.ngcResolveChargeModelId(nextVal, kind)
      if (!nextCharge) {
        showErrorToast('请选择有效模型')
        return false
      }
      if (!isModelInCatalog(this.ngcModelsCatalog, nextCharge, kind)) {
        showErrorToast(MODEL_OFF_SHELF_MESSAGE)
        return false
      }
      this.$set(n.data, field, nextVal)
      this.syncNodeCreditDisplayFromModel(n)
      if (opts.onClose) opts.onClose()
      this.scheduleAutosave()
      this.$nextTick(() => this.scheduleSyncNodeVisualHeights())
      return true
    },
    reconcileEcomDetailSkillsOnNodes() {
      const fallback = getEcomPromptExpertBuiltinSkill()
      for (const n of this.nodes) {
        if (n.type !== 'ecomDetail' || !n.data) continue
        const id = String(n.data.selectedSkillId || '').trim()
        const hit = id
          ? resolveEcomDetailSkill({ id }, this.ngcEcomDetailSkills)
          : null
        const use = hit || fallback
        if (!id || !hit) {
          this.$set(n.data, 'selectedSkillId', use.id)
        }
        this.$set(n.data, 'selectedSkill', this.ecomDetailSkillPayload(use))
        if (isEcomPromptExpertSkill(use) || isEcomVisualPromptSkill(use)) {
          this.$set(n.data, 'useDeepseekPrompt', true)
        }
      }
    },
    ecomDetailSkillPayload(hit) {
      if (!hit) return null
      return {
        id: hit.id,
        title: hit.title,
        desc: hit.desc,
        prompt: hit.prompt,
        image: hit.image,
        systemPrompt: hit.systemPrompt,
        batchMode: hit.batchMode,
        singlePromptMode: hit.singlePromptMode
      }
    },
    ecomDetailIsVisualPromptSkill(n) {
      const sk = resolveEcomDetailSkill(
        n && n.data ? n.data.selectedSkill : null,
        this.ngcEcomDetailSkills
      )
      return isEcomVisualPromptSkill(sk)
    },
    ecomDetailIsPromptExpertSkill(n) {
      const sk = resolveEcomDetailSkill(
        n && n.data ? n.data.selectedSkill : null,
        this.ngcEcomDetailSkills
      )
      return isEcomPromptExpertSkill(sk)
    },
    ecomDetailSkillSummary(n) {
      if (!n || !n.data) return ''
      const sk = resolveEcomDetailSkill(n.data.selectedSkill, this.ngcEcomDetailSkills)
      if (!sk) return ''
      return String(sk.desc || sk.prompt || '').trim()
    },
    onEcomDetailOutputLanguageChange(n) {
      if (!n || n.type !== 'ecomDetail' || !n.data) return
      this.scheduleAutosave()
    },
    onEcomDetailSkillSelect(n, ev) {
      if (!n || n.type !== 'ecomDetail' || !n.data) return
      let id = ev && ev.target ? String(ev.target.value || '').trim() : ''
      if (!id) id = ECOM_SKILL_PROMPT_EXPERT_ID
      this.$set(n.data, 'selectedSkillId', id)
      const hit =
        (this.ngcEcomDetailSkills || []).find(s => s && String(s.id) === id) ||
        getEcomPromptExpertBuiltinSkill()
      this.$set(n.data, 'selectedSkill', this.ecomDetailSkillPayload(hit))
      if (isEcomPromptExpertSkill(hit) || isEcomVisualPromptSkill(hit)) {
        this.$set(n.data, 'useDeepseekPrompt', true)
      }
      this.$set(n.data, 'creditDisplay', this.ecomDetailCreditDisplay(n))
      this.scheduleAutosave()
    },
    toggleEcomDetailSlot(n, slotId) {
      if (!n || n.type !== 'ecomDetail' || !n.data) return
      const slots = normalizeEcomDetailSlots(n.data.slots)
      const id = String(slotId || '').trim()
      if (!id || !Object.prototype.hasOwnProperty.call(slots, id)) return
      slots[id] = !slots[id]
      this.$set(n.data, 'slots', slots)
      this.$set(n.data, 'creditDisplay', this.ecomDetailCreditDisplay(n))
      this.scheduleAutosave()
    },
    ecomDetailEnabledCount(n) {
      return getEnabledEcomDetailSlots(n && n.data ? n.data.slots : null).length
    },
    ecomDetailPromptPlanCount(n) {
      const arr = n && n.data && Array.isArray(n.data.promptPlans) ? n.data.promptPlans : []
      return arr.length
    },
    ecomDetailHasGeneratedContent(n) {
      return this.ecomDetailPromptPlanCount(n) > 0
    },
    onEcomDetailGenerateClick(n) {
      if (!n || n.type !== 'ecomDetail' || this.isNodeRunning(n.id)) return
      const planCnt = this.ecomDetailPromptPlanCount(n)
      if (this.ecomDetailHasGeneratedContent(n)) {
        const spawnedCnt = Array.isArray(n.data && n.data.spawnedImageNodeIds)
          ? n.data.spawnedImageNodeIds.length
          : 0
        let confirmMsg = `当前节点已有 ${planCnt} 条提示词。继续将重新生成全部提示词并覆盖现有内容`
        if (spawnedCnt) {
          confirmMsg += `，已拆分的 ${spawnedCnt} 个下游图片节点也会被替换`
        }
        confirmMsg += '，并会再次消耗积分。'
        this.openNgcConfirm({
          title: '重新生成提示词',
          message: confirmMsg,
          confirmText: '重新生成',
          cancelText: '取消',
          tone: 'amber'
        }).then(ok => {
          if (ok) this.runSingleEcomDetailNode(n)
        })
        return
      }
      this.runSingleEcomDetailNode(n)
    },
    setEcomDetailPromptPlanText(n, pidx, ev) {
      if (!n || n.type !== 'ecomDetail' || !n.data || !Array.isArray(n.data.promptPlans)) return
      const i = Number(pidx)
      if (i < 0 || i >= n.data.promptPlans.length) return
      const val = ev && ev.target != null ? String(ev.target.value) : ''
      this.$set(n.data.promptPlans[i], 'prompt', val)
      this.scheduleAutosave()
    },
    ecomDetailRenderCreditDisplay(n) {
      const cnt = Math.max(
        1,
        this.ecomDetailPromptPlanCount(n) || this.ecomDetailEnabledCount(n)
      )
      const model = String(
        (n && n.data && n.data.seedreamModel) || 'doubao-seedream-5-0-260128'
      ).trim()
      const total = calcRequiredCreditsFromCatalog(
        this.ngcModelsCatalog,
        model,
        NGC_MODEL_KIND.IMAGE,
        { times: cnt }
      )
      return total > 0 ? total : 0
    },
    ecomDetailCreditDisplay(n) {
      if (this.ecomDetailPromptPlanCount(n)) {
        return this.ecomDetailRenderCreditDisplay(n)
      }
      const ds = String(
        (n && n.data && n.data.deepseekModel) || 'deepseek-v4-flash'
      ).trim()
      const expertTimes =
        this.ecomDetailIsPromptExpertSkill(n) || this.ecomDetailIsVisualPromptSkill(n)
          ? 8
          : Math.max(1, this.ecomDetailEnabledCount(n))
      const per = calcRequiredCreditsFromCatalog(
        this.ngcModelsCatalog,
        ds,
        NGC_MODEL_KIND.LLM,
        { times: 1 }
      )
      return per > 0 ? per * expertTimes : 0
    },
    async runSingleEcomDetailNode(n) {
      if (!n || n.type !== 'ecomDetail' || this.isNodeRunning(n.id)) return
      const isRegenerate = this.ecomDetailHasGeneratedContent(n)
      try {
        await this.ensureNgcScoreBeforeRun(n, {
          label: isRegenerate ? '重新生成电商提示词' : '生成电商提示词'
        })
      } catch (e) {
        showErrorToast(e && e.message ? String(e.message) : '积分不足~')
        return
      }
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      this.beginNodeRunning(n.id)
      this.$set(n.data, 'status', 'running')
      this.$set(n.data, 'progress', '')
      try {
        await this.executeEcomDetailNode(n, n.id, map)
        this.$set(n.data, 'status', '提示词就绪')
        this.$set(n.data, 'progress', '')
        const planCnt = this.ecomDetailPromptPlanCount(n)
        let spawnedCnt = 0
        if (planCnt > 0) {
          spawnedCnt = this.spawnEcomDetailImageNodes(n)
          this.$nextTick(() => this.scheduleSyncNodeVisualHeights())
        }
        if (spawnedCnt > 0) {
          showSuccessToast(
            isRegenerate
              ? `已重新生成 ${planCnt} 条提示词，并更新 ${spawnedCnt} 个图片节点`
              : `已生成 ${planCnt} 条提示词，并拆分到 ${spawnedCnt} 个图片节点`
          )
        } else {
          showSuccessToast(
            planCnt
              ? isRegenerate
                ? `已重新生成 ${planCnt} 条提示词`
                : `已生成 ${planCnt} 条提示词`
              : isRegenerate
                ? '提示词已重新生成'
                : '提示词生成完成'
          )
        }
      } catch (err) {
        this.$set(n.data, 'status', '失败')
        this.$set(n.data, 'progress', '')
        showErrorToast(err && err.message ? String(err.message) : String(err))
      } finally {
        this.endNodeRunning(n.id)
      }
    },
    async runEcomDetailRenderImages(n) {
      if (!n || n.type !== 'ecomDetail' || this.isNodeRunning(n.id)) return
      if (!this.ecomDetailPromptPlanCount(n)) {
        showErrorToast('请先生成提示词')
        return
      }
      try {
        await this.ensureNgcScoreBeforeRun(n, {
          renderImages: true,
          label: '电商批量出图'
        })
      } catch (e) {
        showErrorToast(e && e.message ? String(e.message) : '积分不足~')
        return
      }
      this.beginNodeRunning(n.id)
      this.$set(n.data, 'status', 'running')
      this.$set(n.data, 'progress', '')
      try {
        const cnt = await this.spawnAndRunEcomDetailImageNodes(n)
        this.$set(n.data, 'status', '完成')
        this.$set(n.data, 'progress', '')
        showSuccessToast(cnt ? `已创建并出图 ${cnt} 个图片节点` : '出图完成')
      } catch (err) {
        this.$set(n.data, 'status', '失败')
        this.$set(n.data, 'progress', '')
        showErrorToast(err && err.message ? String(err.message) : String(err))
      } finally {
        this.endNodeRunning(n.id)
      }
    },
    ecomImagePredecessorIds(ecomId) {
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      const out = []
      for (const pid of predecessorIds(ecomId, this.edges)) {
        const p = map[pid]
        if (!p) continue
        if (p.type === 'image' || p.type === 'directorDeck') {
          out.push(pid)
        }
      }
      return out
    },
    clearEcomSpawnedImageNodes(n) {
      if (!n || !n.data) return
      const ids = Array.isArray(n.data.spawnedImageNodeIds)
        ? n.data.spawnedImageNodeIds.slice()
        : []
      if (!ids.length) return
      const idSet = new Set(ids)
      this.edges = this.edges.filter(
        e => !idSet.has(e.from.nodeId) && !idSet.has(e.to.nodeId)
      )
      this.nodes = this.nodes.filter(x => !idSet.has(x.id))
      this.$set(n.data, 'spawnedImageNodeIds', [])
    },
    /**
     * 将 promptPlans 拆成独立图片节点（写入 prompt，不自动 Seedream 出图）
     * @returns {number} 新建图片节点数量
     */
    spawnEcomDetailImageNodes(ecomNode) {
      const plans = Array.isArray(ecomNode.data.promptPlans) ? ecomNode.data.promptPlans : []
      if (!plans.length || !ecomNode) return 0

      this.clearEcomSpawnedImageNodes(ecomNode)

      const def = DEFAULT_NODE.image
      if (!def) return 0

      const seedreamModel =
        ecomNode.data.seedreamModel != null && String(ecomNode.data.seedreamModel).trim()
          ? String(ecomNode.data.seedreamModel).trim()
          : 'doubao-seedream-5-0-260128'
      const refUrls = Array.isArray(ecomNode.data.referenceImageUrls)
        ? ecomNode.data.referenceImageUrls.map(u => String(u || '').trim()).filter(Boolean)
        : []
      const ref0 = refUrls.length ? refUrls[0] : ''
      const imgPredIds = this.ecomImagePredecessorIds(ecomNode.id)

      const gapX = 36
      const gapY = 20
      const cols = 2
      const spawnedIds = []

      for (let i = 0; i < plans.length; i++) {
        const plan = plans[i]
        const col = i % cols
        const row = Math.floor(i / cols)
        const id = genId()
        const size = resolveEcomSeedreamOutputSize(
          String(plan.size || '').trim(),
          Number(plan.index) >= 1 && Number(plan.index) <= 3
        )
        const imgNode = {
          id,
          type: 'image',
          x: Math.round(ecomNode.x + ecomNode.w + gapX + col * (def.w + gapX)),
          y: Math.round(ecomNode.y + row * (def.h + gapY)),
          w: def.w,
          h: def.h,
          data: {
            ...def.data(),
            prompt: String(plan.prompt || '').trim(),
            status: '',
            seedreamModel,
            aspectKey: ecomPlanSizeToAspectKey(size),
            seedreamSizeOverride: size,
            imageCount: 1,
            imageInputMode: IMAGE_INPUT_MODES.generate,
            referenceImageUrl: ref0
          }
        }
        this.nodes.push(imgNode)
        this.bringNodeToFront(imgNode)
        spawnedIds.push(id)
        this.syncNodeCreditDisplayFromModel(imgNode)

        for (let j = 0; j < imgPredIds.length; j++) {
          this.tryConnect(imgPredIds[j], id)
        }
        this.tryConnect(ecomNode.id, id)
      }

      this.$set(ecomNode.data, 'spawnedImageNodeIds', spawnedIds)
      this.scheduleAutosave()
      return spawnedIds.length
    },
    async spawnAndRunEcomDetailImageNodes(ecomNode) {
      const plans = Array.isArray(ecomNode.data.promptPlans) ? ecomNode.data.promptPlans : []
      if (!plans.length) throw new Error('请先生成提示词')

      const spawnedIds = this.spawnEcomDetailImageNodes(ecomNode)
      if (!spawnedIds) throw new Error('未能创建图片节点')

      const idSet = new Set(
        Array.isArray(ecomNode.data.spawnedImageNodeIds) ? ecomNode.data.spawnedImageNodeIds : []
      )
      const spawnedOrder = Array.isArray(ecomNode.data.spawnedImageNodeIds)
        ? ecomNode.data.spawnedImageNodeIds.slice()
        : []
      const nodeById = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      const created = []
      for (let i = 0; i < spawnedOrder.length; i++) {
        const node = nodeById[spawnedOrder[i]]
        const plan = plans[i]
        if (!node || node.type !== 'image' || !plan) continue
        const label = String(plan.label || `图${i + 1}`).trim()
        created.push({ node, plan, label })
      }

      const out = []
      for (let i = 0; i < created.length; i++) {
        const { node, plan, label } = created[i]
        this.$set(
          ecomNode.data,
          'progress',
          `出图 ${i + 1}/${created.length}：${label}`
        )
        this.beginNodeRunning(node.id)
        this.$set(node.data, 'status', 'running')
        try {
          const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
          await this.executeImageNode(node, node.id, map)
        } finally {
          this.endNodeRunning(node.id)
        }
        this.$set(node.data, 'status', '完成')
        const url = String(node.data.imageUrl || '').trim()
        if (!url) throw new Error(`${label}：未返回图片`)
        out.push({
          id: plan.id || `out-${i}-${Date.now()}`,
          slotId: plan.slotId || '',
          label,
          url
        })
        if (i < created.length - 1) await sleep(400)
      }

      this.$set(ecomNode.data, 'outputImages', out)
      this.$set(ecomNode.data, 'creditDisplay', this.ecomDetailCreditDisplay(ecomNode))
      this.scheduleAutosave()
      return out.length
    },
    uiDesignGatherReferenceUrls(id, map) {
      return gatherUpstreamImageUrls(id, map, this.edges)
    },
    async analyzeUiDesignUpstreamImages(node, id, map, opts = {}) {
      const silent = !!(opts && opts.silent)
      const force = !!(opts && opts.force)
      const refs = this.uiDesignGatherReferenceUrls(id, map).slice(0, 4)
      const prevKey = JSON.stringify(
        (Array.isArray(node.data.referenceImageUrls) ? node.data.referenceImageUrls : []).slice(0, 4)
      )
      const curKey = JSON.stringify(refs)
      const cached = String(
        node.data.referenceStyleGuide || node.data.upstreamImageAnalysis || ''
      ).trim()
      if (!refs.length) {
        this.$set(node.data, 'upstreamImageAnalysis', '')
        this.$set(node.data, 'referenceStyleGuide', '')
        this.$set(node.data, 'upstreamImageAnalysisMethod', '')
        this.$set(node.data, 'referenceImageUrls', [])
        return ''
      }
      this.$set(node.data, 'referenceImageUrls', refs)
      if (!force && cached && prevKey === curKey) {
        return cached
      }

      const name = String(node.data.projectName || '').trim()
      const brief = String(node.data.brief || '').trim()
      const hintParts = [
        buildUiUpstreamStyleParseHints({ targetProductName: name })
      ]
      if (brief) hintParts.push(`待设计产品补充说明（仅作后续策划参考，本次勿分析为参考图内容）：\n${brief}`)
      const upstreamText = gatherUpstreamTextForImagePrompt(id, map, this.edges)
      if (upstreamText) {
        hintParts.push(`上游文本（可能含参考图描述，仅提取视觉风格）：\n${upstreamText}`)
      }
      const textHints = hintParts.join('\n\n')
      const mapObj = map || Object.fromEntries(this.nodes.map(x => [x.id, x]))

      this.$set(
        node.data,
        'progress',
        `解析参考 AI 设计风格（${refs.length} 张）…`
      )

      const visionOverride = String(node.data.visionModel || '').trim()
      const visionMessages = buildEcomUpstreamImageVisionMessages(refs, textHints)
      if (visionMessages && visionMessages[0].content && visionMessages[0].content[0]) {
        visionMessages[0].content[0].text =
          UI_UPSTREAM_STYLE_VISION_PREFIX +
          '\n\n' +
          String(visionMessages[0].content[0].text || '')
      }

      const visionRes = await tryEcomVisionImageAnalysis({
        imageUrls: refs,
        textHints,
        visionModel: visionOverride,
        chat: (model, messages) => volcChatComplete({ model, messages })
      })

      let text = visionRes.text || ''
      let method = visionRes.method || ''

      if (!text) {
        this.$set(node.data, 'progress', '视觉模型不可用，根据上游图片描述推断风格…')
        const upstreamMeta = gatherUpstreamImageMetaForEcom(id, mapObj, this.edges)
        let dsModel = String(node.data.deepseekModel || 'deepseek-v4-flash').trim()
        if (!dsModel.startsWith('deepseek-v4')) dsModel = 'deepseek-v4-flash'
        const dsBaseUrl = this.resolveLlmChatBaseUrl(dsModel)
        text = await inferUiDesignStyleFromUpstreamText({
          imageUrls: refs,
          upstreamMeta,
          textHints,
          model: dsModel,
          baseUrl: dsBaseUrl || undefined,
          chat: (model, messages, baseUrl) =>
            volcChatComplete({
              model,
              baseUrl: baseUrl || undefined,
              messages
            })
        })
        method = 'text_infer'
        if (text && !silent) {
          showSuccessToast(
            '识图模型不可用，已根据上游图片节点描述推断界面风格'
          )
        }
      }

      text = String(text || '').trim()
      if (!text) {
        throw new Error(
          '无法解析上游风格：请确保上游图片节点已出图或填写描述，或在「识图模型 ID」填入方舟视觉模型'
        )
      }

      const parsed = parseUiDesignStyleFromAnalysis(text)
      const guide = parsed.analysisBody || text
      this.$set(node.data, 'referenceStyleGuide', guide)
      this.$set(node.data, 'upstreamImageAnalysis', guide)
      this.$set(node.data, 'upstreamImageAnalysisMethod', method)
      this.applyParsedUiDesignStyle(node, parsed)
      return guide
    },
    async runAnalyzeUiDesignUpstreamStyle(n) {
      if (!n || n.type !== 'uiDesign' || this.isNodeRunning(n.id)) return
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      const refs = this.uiDesignGatherReferenceUrls(n.id, map)
      if (!refs.length) {
        showErrorToast('请先连线上游图片节点（需已出图或填写节点描述）')
        return
      }
      this.beginNodeRunning(n.id)
      this.$set(n.data, 'progress', '')
      try {
        await this.analyzeUiDesignUpstreamImages(n, n.id, map, { silent: false, force: true })
        this.$set(n.data, 'progress', '')
        const applied = n.data.applyUpstreamStyleToFields !== false
        const product = String(n.data.projectName || '').trim()
        showSuccessToast(
          applied
            ? product
              ? `已提取参考 AI 风格，将用于设计「${product}」`
              : '已提取参考 AI 风格，请填写待设计产品后点 ↑ 策划'
            : '已提取参考 AI 风格（未改写下方风格/主题色，策划时仍会引用）'
        )
        this.scheduleAutosave()
      } catch (err) {
        this.$set(n.data, 'progress', '')
        showErrorToast(err && err.message ? String(err.message) : String(err))
      } finally {
        this.endNodeRunning(n.id)
      }
    },
    async buildUiDesignPromptContext(node, id, map) {
      const name = String(node.data.projectName || '').trim()
      const brief = String(node.data.brief || '').trim()
      const upstreamText = gatherUpstreamTextForImagePrompt(id, map, this.edges)
      const refs = this.uiDesignGatherReferenceUrls(id, map)
      let referenceStyleGuide = ''
      if (refs.length) {
        referenceStyleGuide = await this.analyzeUiDesignUpstreamImages(node, id, map, {
          silent: true
        })
      } else {
        this.$set(node.data, 'upstreamImageAnalysis', '')
        this.$set(node.data, 'referenceStyleGuide', '')
        this.$set(node.data, 'referenceImageUrls', [])
      }
      if (!name && !brief && !upstreamText.trim() && !referenceStyleGuide) {
        throw new Error('请填写待设计产品（如点餐小程序），或连参考图并解析 AI 风格')
      }
      if (referenceStyleGuide && !name) {
        throw new Error('已解析参考 AI 风格，请填写待设计产品名称（如：点餐小程序）后再策划')
      }
      return {
        projectName: name,
        brief,
        designStyleId: normalizeUiDesignStyleId(node.data.designStyleId),
        designStyleCustom: String(node.data.designStyleCustom || '').trim(),
        themeColorPrimary: String(node.data.themeColorPrimary || UI_DESIGN_DEFAULT_PRIMARY).trim(),
        themeColorSecondary: String(node.data.themeColorSecondary || UI_DESIGN_DEFAULT_SECONDARY).trim(),
        displayMode: String(node.data.displayMode || 'frameless').trim(),
        screenCount: normalizeUiDesignScreenCount(node.data.screenCount),
        extraPrompt: String(node.data.extraPrompt || '').trim(),
        platform: String(node.data.platform || 'app'),
        upstreamText,
        referenceStyleGuide,
        upstreamImageInfo: referenceStyleGuide
      }
    },
    reconcileUiDesignSkillOnNode(n) {
      if (!n || n.type !== 'uiDesign' || !n.data) return
      const expert = getUiDesignExpertBuiltinSkill()
      this.$set(n.data, 'selectedSkill', {
        id: expert.id,
        title: expert.title,
        desc: expert.desc,
        prompt: expert.prompt,
        systemPrompt: expert.systemPrompt,
        batchMode: expert.batchMode
      })
    },
    reconcileUiDesignSkillsOnNodes() {
      for (const n of this.nodes) {
        this.reconcileUiDesignSkillOnNode(n)
      }
    },
  /**
   * UI 设计专家：生成 screenPlans，并默认自动拆分到图片节点
   * @returns {{ planCount: number, spawnedCount: number }}
   */
    async executeUiDesignNode(node, id, map, opts = {}) {
      const spawnImages = !opts || opts.spawnImages !== false
      this.reconcileUiDesignSkillOnNode(node)
      const skill = node.data.selectedSkill || getUiDesignExpertBuiltinSkill()
      const promptCtx = await this.buildUiDesignPromptContext(node, id, map)
      const screenCount = normalizeUiDesignScreenCount(node.data.screenCount)
      let dsModel = String(node.data.deepseekModel || 'deepseek-v4-flash').trim()
      if (!dsModel.startsWith('deepseek-v4')) dsModel = 'deepseek-v4-flash'
      const dsBaseUrl = this.resolveLlmChatBaseUrl(dsModel)
      const system = uiDesignExpertSystemForSkill(skill)
      const productLabel = String(promptCtx.projectName || '').trim() || '产品'
      const styleHint = String(promptCtx.referenceStyleGuide || '').trim()
        ? `，视觉对齐参考 AI 风格`
        : ''
      this.$set(
        node.data,
        'progress',
        `DeepSeek：为「${productLabel}」规划界面${styleHint}…`
      )
      const batchText = await volcChatComplete({
        model: dsModel,
        baseUrl: dsBaseUrl || undefined,
        messages: [
          { role: 'system', content: system },
          { role: 'user', content: buildUiDesignExpertUserMessage(promptCtx) }
        ]
      })
      const parsed = parseUiDesignSections(batchText)
      const plans = alignUiDesignToPlan(parsed, promptCtx)
      const screenPlans = plans
        .filter(p => p && String(p.prompt || '').trim())
        .slice(0, screenCount)
        .map((plan, i) =>
          normalizeEcomPromptPlanRow({
            id: `ui-${plan.index}-${Date.now()}-${i}`,
            slotId: `ui-screen-${plan.index}`,
            label: plan.label,
            size: plan.size,
            prompt: plan.prompt,
            index: plan.index
          })
        )
      this.$set(node.data, 'screenPlans', screenPlans)
      this.$set(node.data, 'promptRaw', String(batchText || '').trim())
      this.$set(node.data, 'creditDisplay', this.uiDesignCreditDisplay(node))

      let spawnedCount = 0
        if (spawnImages && screenPlans.length) {
        this.$set(node.data, 'progress', '正在拆分到图片节点…')
        spawnedCount = this.spawnUiDesignImageNodes(node)
        if (spawnedCount > 0) {
          this.$nextTick(() => this.scheduleSyncNodeVisualHeights())
        }
      }
      this.$set(node.data, 'progress', '')
      return { planCount: screenPlans.length, spawnedCount }
    },
    /** 与 screenPlans 条数一致且存在的下游图片节点数量 */
    uiDesignValidSpawnedImageCount(uiNode) {
      if (!uiNode || !uiNode.data) return 0
      const plans = (uiNode.data.screenPlans || []).filter(
        p => p && String(p.prompt || '').trim()
      )
      if (!plans.length) return 0
      const order = Array.isArray(uiNode.data.spawnedImageNodeIds)
        ? uiNode.data.spawnedImageNodeIds
        : []
      const nodeById = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      const valid = order.filter(id => {
        const node = nodeById[id]
        return node && node.type === 'image'
      })
      return valid.length === plans.length ? valid.length : 0
    },
    syncUiDesignSpawnedImageNodesFromPlans(uiNode, opts = {}) {
      if (!uiNode || uiNode.type !== 'uiDesign' || !uiNode.data) return
      const keepPrompt = opts.keepPrompt !== false
      const plans = (uiNode.data.screenPlans || []).filter(
        p => p && String(p.prompt || '').trim()
      )
      const order = Array.isArray(uiNode.data.spawnedImageNodeIds)
        ? uiNode.data.spawnedImageNodeIds
        : []
      const nodeById = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      const seedreamModel =
        uiNode.data.seedreamModel != null && String(uiNode.data.seedreamModel).trim()
          ? String(uiNode.data.seedreamModel).trim()
          : 'doubao-seedream-5-0-260128'
      const refUrls = Array.isArray(uiNode.data.referenceImageUrls)
        ? uiNode.data.referenceImageUrls.map(u => String(u || '').trim()).filter(Boolean)
        : []
      const ref0 = refUrls.length ? refUrls[0] : ''
      for (let i = 0; i < order.length && i < plans.length; i++) {
        const node = nodeById[order[i]]
        const plan = plans[i]
        if (!node || node.type !== 'image' || !plan) continue
        const planIdx = Number(plan.index) || i + 1
        const rawSize = String(plan.size || '').trim()
        const isMain = planIdx <= 3 && !rawSize.includes('1536')
        const size = resolveEcomSeedreamOutputSize(
          rawSize || (isMain ? UI_SIZE_MAIN : UI_SIZE_DETAIL),
          isMain
        )
        const label = String(plan.label || `第${planIdx}张`).trim()
        this.$set(node.data, 'spawnedFromUiDesignId', uiNode.id)
        this.$set(node.data, 'spawnPlanIndex', planIdx)
        this.$set(node.data, 'spawnPlanLabel', label)
        this.$set(node.data, 'seedreamModel', seedreamModel)
        this.$set(node.data, 'aspectKey', ecomPlanSizeToAspectKey(size))
        this.$set(node.data, 'seedreamSizeOverride', size)
        if (ref0) this.$set(node.data, 'referenceImageUrl', ref0)
        if (!keepPrompt) {
          this.$set(node.data, 'prompt', String(plan.prompt || '').trim())
        }
        this.syncNodeCreditDisplayFromModel(node)
      }
    },
    /**
     * 若下游图片节点已存在且数量匹配则复用，否则按 screenPlans 重建
     * @returns {number}
     */
    ensureUiDesignSpawnedImageNodes(uiNode) {
      const plans = (uiNode.data.screenPlans || []).filter(
        p => p && String(p.prompt || '').trim()
      )
      if (!plans.length) return 0
      if (this.uiDesignValidSpawnedImageCount(uiNode) === plans.length) {
        this.syncUiDesignSpawnedImageNodesFromPlans(uiNode, { keepPrompt: true })
        return plans.length
      }
      return this.spawnUiDesignImageNodes(uiNode)
    },
    /** 将 screenPlans 的文案、尺寸、标签同步到下游图片节点（覆盖图片节点 prompt） */
    syncUiDesignPlansToImageNodes(n) {
      if (!n || n.type !== 'uiDesign' || this.isNodeRunning(n.id)) return
      const plans = (n.data.screenPlans || []).filter(
        p => p && String(p.prompt || '').trim()
      )
      if (!plans.length) {
        showErrorToast('请先生成或填写界面提示词')
        return
      }
      const spawnedCnt = this.ensureUiDesignSpawnedImageNodes(n)
      if (!spawnedCnt) {
        showErrorToast('未能创建或匹配下游图片节点')
        return
      }
      this.syncUiDesignSpawnedImageNodesFromPlans(n, { keepPrompt: false })
      const order = Array.isArray(n.data.spawnedImageNodeIds)
        ? n.data.spawnedImageNodeIds.slice()
        : []
      this.$nextTick(() => {
        for (const id of order) {
          const img = this.nodes.find(x => x.id === id && x.type === 'image')
          if (!img) continue
          const el = document.querySelector(`[data-prompt-node-id="${id}"]`)
          if (el) this.hydratePromptEditor(img, el)
        }
        this.scheduleSyncNodeVisualHeights()
      })
      this.scheduleAutosave()
      showSuccessToast(`已同步 ${spawnedCnt} 个图片节点的描述与尺寸`)
    },
    async runSingleUiDesignNode(n) {
      if (!n || n.type !== 'uiDesign' || this.isNodeRunning(n.id)) return
      try {
        await this.ensureNgcScoreBeforeRun(n, { label: 'UI 界面策划' })
      } catch (e) {
        showErrorToast(e && e.message ? String(e.message) : '积分不足~')
        return
      }
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      this.beginNodeRunning(n.id)
      this.$set(n.data, 'status', 'running')
      this.$set(n.data, 'progress', '')
      try {
        const { planCount, spawnedCount } = await this.executeUiDesignNode(n, n.id, map)
        this.$set(n.data, 'status', planCount ? '提示词就绪' : '完成')
        if (spawnedCount > 0) {
          showSuccessToast(
            `已生成 ${planCount} 条提示词，并拆分到 ${spawnedCount} 个图片节点（可编辑各节点描述后点「出图」）`
          )
        } else if (planCount > 0) {
          showSuccessToast(`已生成 ${planCount} 条提示词，但未能创建图片节点`)
        } else {
          showSuccessToast('策划完成，请检查模型返回格式')
        }
      } catch (err) {
        this.$set(n.data, 'status', '失败')
        this.$set(n.data, 'progress', '')
        showErrorToast(err && err.message ? String(err.message) : String(err))
      } finally {
        this.endNodeRunning(n.id)
      }
    },
    uiDesignImagePredecessorIds(uiId) {
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      const out = []
      for (const pid of predecessorIds(uiId, this.edges)) {
        const p = map[pid]
        if (!p) continue
        if (p.type === 'image' || p.type === 'directorDeck' || p.type === 'uiDesign') {
          out.push(pid)
        }
      }
      return out
    },
    clearUiDesignSpawnedImageNodes(n) {
      if (!n || !n.data) return
      const ids = Array.isArray(n.data.spawnedImageNodeIds)
        ? n.data.spawnedImageNodeIds.slice()
        : []
      if (!ids.length) return
      const idSet = new Set(ids)
      this.edges = this.edges.filter(
        e => !idSet.has(e.from.nodeId) && !idSet.has(e.to.nodeId)
      )
      this.nodes = this.nodes.filter(x => !idSet.has(x.id))
      this.$set(n.data, 'spawnedImageNodeIds', [])
    },
    spawnUiDesignImageNodes(uiNode) {
      const plans = Array.isArray(uiNode.data.screenPlans) ? uiNode.data.screenPlans : []
      if (!plans.length || !uiNode) return 0
      this.clearUiDesignSpawnedImageNodes(uiNode)
      const def = DEFAULT_NODE.image
      if (!def) return 0
      const seedreamModel =
        uiNode.data.seedreamModel != null && String(uiNode.data.seedreamModel).trim()
          ? String(uiNode.data.seedreamModel).trim()
          : 'doubao-seedream-5-0-260128'
      const refUrls = Array.isArray(uiNode.data.referenceImageUrls)
        ? uiNode.data.referenceImageUrls.map(u => String(u || '').trim()).filter(Boolean)
        : []
      const ref0 = refUrls.length ? refUrls[0] : ''
      const imgPredIds = this.uiDesignImagePredecessorIds(uiNode.id)
      const gapX = 36
      const gapY = 20
      const cols = 2
      const spawnedIds = []
      const plat = String(uiNode.data.platform || 'app').trim()
      for (let i = 0; i < plans.length; i++) {
        const plan = plans[i]
        const col = i % cols
        const row = Math.floor(i / cols)
        const id = genId()
        const rawSize = String(plan.size || '').trim()
        const planIdx = Number(plan.index) || i + 1
        const isMain = planIdx <= 3 && !rawSize.includes('1536')
        const size = resolveEcomSeedreamOutputSize(
          rawSize || (isMain ? UI_SIZE_MAIN : UI_SIZE_DETAIL),
          isMain
        )
        const planLabel = String(plan.label || `第${planIdx}张`).trim()
        const imgNode = {
          id,
          type: 'image',
          x: Math.round(uiNode.x + uiNode.w + gapX + col * (def.w + gapX)),
          y: Math.round(uiNode.y + row * (def.h + gapY)),
          w: def.w,
          h: def.h,
          data: {
            ...def.data(),
            prompt: String(plan.prompt || '').trim(),
            status: '',
            seedreamModel,
            aspectKey: ecomPlanSizeToAspectKey(size),
            seedreamSizeOverride: size,
            imageCount: 1,
            imageInputMode: IMAGE_INPUT_MODES.generate,
            referenceImageUrl: ref0,
            spawnedFromUiDesignId: uiNode.id,
            spawnPlanIndex: planIdx,
            spawnPlanLabel: planLabel
          }
        }
        this.nodes.push(imgNode)
        this.bringNodeToFront(imgNode)
        spawnedIds.push(id)
        this.syncNodeCreditDisplayFromModel(imgNode)
        for (let j = 0; j < imgPredIds.length; j++) {
          this.tryConnect(imgPredIds[j], id)
        }
        this.tryConnect(uiNode.id, id)
      }
      this.$set(uiNode.data, 'spawnedImageNodeIds', spawnedIds)
      this.scheduleAutosave()
      return spawnedIds.length
    },
    async spawnAndRunUiDesignImageNodes(uiNode) {
      const plans = (uiNode.data.screenPlans || []).filter(
        p => p && String(p.prompt || '').trim()
      )
      if (!plans.length) throw new Error('请先生成界面提示词')

      const spawnedCnt = this.ensureUiDesignSpawnedImageNodes(uiNode)
      if (!spawnedCnt) throw new Error('未能创建图片节点')

      const spawnedOrder = Array.isArray(uiNode.data.spawnedImageNodeIds)
        ? uiNode.data.spawnedImageNodeIds.slice()
        : []
      const nodeById = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      const created = []
      for (let i = 0; i < spawnedOrder.length; i++) {
        const node = nodeById[spawnedOrder[i]]
        const plan = plans[i]
        if (!node || node.type !== 'image') continue
        const label = String(
          node.data.spawnPlanLabel || (plan && plan.label) || `屏${i + 1}`
        ).trim()
        const prompt = String(node.data.prompt || '').trim()
        if (!prompt) {
          throw new Error(`${label}：图片节点提示词为空，请先填写描述`)
        }
        created.push({ node, plan, label })
      }
      if (!created.length) throw new Error('没有可出图的图片节点')

      const out = []
      for (let i = 0; i < created.length; i++) {
        const { node, plan, label } = created[i]
        this.$set(
          uiNode.data,
          'progress',
          `出图 ${i + 1}/${created.length}：${label}`
        )
        this.beginNodeRunning(node.id)
        this.$set(node.data, 'status', 'running')
        try {
          const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
          await this.executeImageNode(node, node.id, map)
        } finally {
          this.endNodeRunning(node.id)
        }
        this.$set(node.data, 'status', '完成')
        const url = String(node.data.imageUrl || '').trim()
        if (!url) throw new Error(`${label}：未返回图片`)
        out.push({
          id: (plan && plan.id) || `ui-out-${i}-${Date.now()}`,
          slotId: (plan && plan.slotId) || '',
          label,
          url
        })
        if (i < created.length - 1) await sleep(400)
      }

      this.$set(uiNode.data, 'outputImages', out)
      this.$set(uiNode.data, 'creditDisplay', this.uiDesignCreditDisplay(uiNode))
      this.scheduleAutosave()
      return created.length
    },
    async runUiDesignRenderImages(n) {
      if (!n || n.type !== 'uiDesign' || this.isNodeRunning(n.id)) return
      if (!this.uiDesignScreenPlanCount(n)) {
        showErrorToast('请先生成界面提示词')
        return
      }
      try {
        await this.ensureNgcScoreBeforeRun(n, {
          renderImages: true,
          label: 'UI 批量出图'
        })
      } catch (e) {
        showErrorToast(e && e.message ? String(e.message) : '积分不足~')
        return
      }
      this.beginNodeRunning(n.id)
      this.$set(n.data, 'status', 'running')
      this.$set(n.data, 'progress', '')
      try {
        const cnt = await this.spawnAndRunUiDesignImageNodes(n)
        this.$set(n.data, 'status', '完成')
        this.$set(n.data, 'progress', '')
        showSuccessToast(
          cnt ? `已按 ${cnt} 个图片节点的描述分别出图` : '出图完成'
        )
      } catch (err) {
        this.$set(n.data, 'status', '失败')
        this.$set(n.data, 'progress', '')
        showErrorToast(err && err.message ? String(err.message) : String(err))
      } finally {
        this.endNodeRunning(n.id)
      }
    },
    ecomDetailGatherReferenceUrls(id, map, skill) {
      let refs = gatherUpstreamImageUrls(id, map, this.edges)
      if (skill && skill.image) {
        const su = String(skill.image).trim()
        if (su && !refs.includes(su)) refs = [su, ...refs]
      }
      return refs
    },
    async analyzeEcomUpstreamImages(node, id, map, skill) {
      const refs = this.ecomDetailGatherReferenceUrls(id, map, skill)
      this.$set(node.data, 'referenceImageUrls', refs.slice(0, 4))
      if (!refs.length) {
        this.$set(node.data, 'upstreamImageAnalysis', '')
        this.$set(node.data, 'upstreamImageAnalysisMethod', '')
        return ''
      }
      const hintParts = []
      const name = String(node.data.productName || '').trim()
      const points = String(node.data.sellingPoints || '').trim()
      if (name) hintParts.push(`商品名称：${name}`)
      if (points) hintParts.push(`核心卖点：\n${points}`)
      const extra = String(node.data.extraPrompt || '').trim()
      if (extra) hintParts.push(`补充要求：${extra}`)
      const upstreamText = gatherUpstreamTextForImagePrompt(id, map, this.edges)
      if (upstreamText) hintParts.push(`上游文案：\n${upstreamText}`)
      const textHints = hintParts.join('\n\n')
      const mapObj = map || Object.fromEntries(this.nodes.map(x => [x.id, x]))

      this.$set(
        node.data,
        'progress',
        `解析上游商品图（${Math.min(refs.length, 4)} 张）…`
      )

      const visionOverride = String(node.data.visionModel || '').trim()
      const outputLanguage = String(node.data.outputLanguage || ECOM_DETAIL_DEFAULT_OUTPUT_LANGUAGE)
      const visionRes = await tryEcomVisionImageAnalysis({
        imageUrls: refs,
        textHints,
        visionModel: visionOverride,
        outputLanguage,
        chat: (model, messages) =>
          volcChatComplete({ model, messages })
      })

      let text = visionRes.text || ''
      let method = visionRes.method || ''

      if (!text) {
        this.$set(node.data, 'progress', '视觉模型不可用，DeepSeek 文本推断商品信息…')
        const upstreamMeta = gatherUpstreamImageMetaForEcom(id, mapObj, this.edges)
        let dsModel = String(node.data.deepseekModel || 'deepseek-v4-flash').trim()
        if (!dsModel.startsWith('deepseek-v4')) dsModel = 'deepseek-v4-flash'
        const dsBaseUrl = this.resolveLlmChatBaseUrl(dsModel)
        text = await inferEcomProductAnalysisFromText({
          imageUrls: refs,
          upstreamMeta,
          textHints,
          outputLanguage,
          model: dsModel,
          baseUrl: dsBaseUrl || undefined,
          chat: (model, messages, baseUrl) =>
            volcChatComplete({
              model,
              baseUrl: baseUrl || undefined,
              messages
            })
        })
        method = 'text_infer'
        if (text) {
          showSuccessToast(
            '识图模型不可用，已用 DeepSeek 根据上游描述推断商品信息（出图仍会对齐参考图）'
          )
        }
      }

      text = String(text || '').trim()
      if (!text) {
        throw new Error(
          '无法解析上游商品图：请在节点填写商品信息，或为上游图片节点填写描述，或在「识图模型 ID」填入方舟已开通的视觉模型'
        )
      }

      this.$set(node.data, 'upstreamImageAnalysis', text)
      this.$set(node.data, 'upstreamImageAnalysisMethod', method)
      return text
    },
    async buildEcomDetailPromptContext(node, id, map) {
      const skill = resolveEcomDetailSkill(node.data.selectedSkill, this.ngcEcomDetailSkills)
      const name = String(node.data.productName || '').trim()
      const points = String(node.data.sellingPoints || '').trim()
      const upstreamText = gatherUpstreamTextForImagePrompt(id, map, this.edges)
      const refs = this.ecomDetailGatherReferenceUrls(id, map, skill)
      let upstreamImageInfo = ''
      if (refs.length) {
        upstreamImageInfo = await this.analyzeEcomUpstreamImages(node, id, map, skill)
      } else {
        this.$set(node.data, 'upstreamImageAnalysis', '')
        this.$set(node.data, 'referenceImageUrls', [])
      }
      if (!name && !points && !upstreamText.trim() && !upstreamImageInfo) {
        throw new Error('请填写商品信息，或接入上游图片/文本节点')
      }
      return {
        productName: name,
        sellingPoints: points,
        extraPrompt: String(node.data.extraPrompt || '').trim(),
        platform: String(node.data.platform || 'taobao'),
        outputLanguage: String(node.data.outputLanguage || ECOM_DETAIL_DEFAULT_OUTPUT_LANGUAGE),
        upstreamText,
        upstreamImageInfo,
        skill
      }
    },
    async executeEcomDetailNode(node, id, map) {
      const skillEarly = resolveEcomDetailSkill(node.data.selectedSkill, this.ngcEcomDetailSkills)
      if (isEcomPromptExpertSkill(skillEarly)) {
        return this.executeEcomDetailPromptExpert(node, id, map, skillEarly)
      }
      if (isEcomVisualPromptSkill(skillEarly)) {
        return this.executeEcomDetailVisualPrompt(node, id, map, skillEarly)
      }
      const enabled = getEnabledEcomDetailSlots(node.data && node.data.slots)
      if (!enabled.length) throw new Error('请至少勾选一个详情图模板位')
      const promptCtx = await this.buildEcomDetailPromptContext(node, id, map)
      let dsModel = String(node.data.deepseekModel || 'deepseek-v4-flash').trim()
      if (!dsModel.startsWith('deepseek-v4')) dsModel = 'deepseek-v4-flash'
      const useDs = node.data.useDeepseekPrompt !== false
      const dsBaseUrl = this.resolveLlmChatBaseUrl(dsModel)
      const skill = promptCtx.skill
      const dsSystem =
        skill && skill.systemPrompt
          ? String(skill.systemPrompt).trim()
          : ECOM_DETAIL_DEEPSEEK_SYSTEM

      const plans = []
      for (let i = 0; i < enabled.length; i++) {
        const slot = enabled[i]
        let prompt = buildEcomDetailSlotPrompt(slot.id, promptCtx)
        if (useDs) {
          this.$set(
            node.data,
            'progress',
            `DeepSeek ${i + 1}/${enabled.length}：${slot.label}`
          )
          const draft = prompt
          const refined = await volcChatComplete({
            model: dsModel,
            baseUrl: dsBaseUrl || undefined,
            messages: [
              { role: 'system', content: dsSystem },
              {
                role: 'user',
                content: `版式模板：${slot.label}\n\n${draft}`
              }
            ]
          })
          const t = String(refined || '').trim()
          if (t) prompt = t
        } else {
          this.$set(
            node.data,
            'progress',
            `提示词 ${i + 1}/${enabled.length}：${slot.label}`
          )
        }
        const slotSize = resolveEcomSeedreamOutputSize(
          this.imagePresetSize(slot.aspectKey),
          slot.id === 'hero'
        )
        plans.push(
          normalizeEcomPromptPlanRow({
            id: `${slot.id}-${Date.now()}-${i}`,
            slotId: slot.id,
            label: slot.label,
            size: slotSize,
            prompt
          })
        )
      }
      this.$set(node.data, 'promptPlans', plans)
      this.$set(node.data, 'promptRaw', '')
      this.$set(node.data, 'creditDisplay', this.ecomDetailCreditDisplay(node))
    },
    async executeEcomDetailVisualPrompt(node, id, map, skill) {
      const promptCtx = await this.buildEcomDetailPromptContext(node, id, map)
      promptCtx.skill = skill || promptCtx.skill
      let dsModel = String(node.data.deepseekModel || 'deepseek-v4-flash').trim()
      if (!dsModel.startsWith('deepseek-v4')) dsModel = 'deepseek-v4-flash'
      const dsBaseUrl = this.resolveLlmChatBaseUrl(dsModel)
      const system = ecomVisualPromptSystemForSkill(skill)

      this.$set(node.data, 'progress', 'DeepSeek：策划 8 张 App 电商图提示词…')
      const batchText = await volcChatComplete({
        model: dsModel,
        baseUrl: dsBaseUrl || undefined,
        messages: [
          { role: 'system', content: system },
          { role: 'user', content: buildEcomVisualPromptUserMessage(promptCtx) }
        ]
      })
      const parsed = parseEcomAppPromptSections(batchText)
      const plans = alignEcomAppPromptExpertToPlan(parsed, promptCtx)
      const extraParsed = (parsed || []).filter(p => p.index > 8)
      for (const ex of extraParsed) {
        plans.push(
          normalizeEcomPromptPlanRow({
            index: ex.index,
            label: ex.label || `第${ex.index}张`,
            size: ex.size || '',
            prompt: ex.prompt
          })
        )
      }
      const promptPlans = plans.map((plan, i) =>
        normalizeEcomPromptPlanRow({
          id: `app-expert-${plan.index}-${Date.now()}-${i}`,
          slotId: `app-expert-${plan.index}`,
          label: plan.label,
          size: plan.size,
          prompt: plan.prompt,
          index: plan.index
        })
      )
      this.$set(node.data, 'promptPlans', promptPlans)
      this.$set(node.data, 'promptRaw', String(batchText || '').trim())
      this.$set(node.data, 'creditDisplay', this.ecomDetailCreditDisplay(node))
    },
    async executeEcomDetailPromptExpert(node, id, map, skill) {
      const promptCtx = await this.buildEcomDetailPromptContext(node, id, map)
      promptCtx.skill = skill || promptCtx.skill
      let dsModel = String(node.data.deepseekModel || 'deepseek-v4-flash').trim()
      if (!dsModel.startsWith('deepseek-v4')) dsModel = 'deepseek-v4-flash'
      const dsBaseUrl = this.resolveLlmChatBaseUrl(dsModel)
      const system = ecomPromptExpertSystemForSkill(skill, promptCtx.outputLanguage)

      this.$set(node.data, 'progress', 'DeepSeek：策划 8 张电商图提示词…')
      const batchText = await volcChatComplete({
        model: dsModel,
        baseUrl: dsBaseUrl || undefined,
        messages: [
          { role: 'system', content: system },
          { role: 'user', content: buildEcomPromptExpertUserMessage(promptCtx) }
        ]
      })
      const parsed = parseEcomPromptExpertSections(batchText, promptCtx.outputLanguage)
      const plans = alignEcomPromptExpertToPlan(parsed, promptCtx)
      const extraParsed = (parsed || []).filter(p => p.index > 8)
      for (const ex of extraParsed) {
        plans.push(
          normalizeEcomPromptPlanRow({
            index: ex.index,
            label: ex.label || `第${ex.index}张`,
            size: ex.size || '',
            prompt: ex.prompt
          })
        )
      }

      const promptPlans = plans.map((plan, i) =>
        normalizeEcomPromptPlanRow({
          id: `expert-${plan.index}-${Date.now()}-${i}`,
          slotId: `expert-${plan.index}`,
          label: plan.label,
          size: plan.size,
          prompt: plan.prompt,
          index: plan.index
        })
      )
      this.$set(node.data, 'promptPlans', promptPlans)
      this.$set(node.data, 'promptRaw', String(batchText || '').trim())
      this.$set(node.data, 'creditDisplay', this.ecomDetailCreditDisplay(node))
    },
    async executeEcomDetailRenderImages(node, id, map) {
      const plans = Array.isArray(node.data.promptPlans) ? node.data.promptPlans : []
      if (!plans.length) throw new Error('请先生成提示词')
      const skill = resolveEcomDetailSkill(node.data.selectedSkill, this.ngcEcomDetailSkills)
      let refs =
        Array.isArray(node.data.referenceImageUrls) && node.data.referenceImageUrls.length
          ? node.data.referenceImageUrls.map(u => String(u || '').trim()).filter(Boolean)
          : this.ecomDetailGatherReferenceUrls(id, map, skill)
      const model =
        node.data.seedreamModel != null && String(node.data.seedreamModel).trim()
          ? String(node.data.seedreamModel).trim()
          : 'doubao-seedream-5-0-260128'

      const out = []
      for (let i = 0; i < plans.length; i++) {
        const plan = plans[i]
        const prompt = String(plan.prompt || '').trim()
        if (!prompt) throw new Error(`${plan.label || '条目'}：提示词为空`)
        this.$set(
          node.data,
          'progress',
          `出图 ${i + 1}/${plans.length}：${plan.label || ''}`
        )
        const size = resolveEcomSeedreamOutputSize(
          String(plan.size || '').trim(),
          Number(plan.index) >= 1 && Number(plan.index) <= 3
        )
        const res = await generateSeedreamImages({
          prompt,
          n: 1,
          model,
          size,
          ...(refs.length ? { image: refs[0], images: refs.slice(0, 16) } : {})
        })
        const url = pickFirstSeedreamImageUrl(res)
        if (!url) throw new Error(`${plan.label || '条目'}：未返回图片`)
        out.push({
          id: plan.id || `out-${i}-${Date.now()}`,
          slotId: plan.slotId || '',
          label: plan.label || '',
          url
        })
        if (i < plans.length - 1) await sleep(400)
      }
      this.$set(node.data, 'outputImages', out)
      this.$set(node.data, 'creditDisplay', this.ecomDetailCreditDisplay(node))
    },
    volcTtsExpressModeIsDefault(n) {
      if (!n || !n.data) return true
      const m = String(n.data.model || '').trim()
      const volc =
        m === 'volc-doubao-tts-2' ||
        m === 'volc-doubao-tts-2-expressive' ||
        m === 'volc-doubao-icl-2'
      if (!volc) return true
      return String(n.data.volcTtsExpressMode || 'default') === 'default'
    },
    insertAudioTag(n, kind) {
      if (!n || n.type !== 'audio' || !n.data) return
      if (kind === 'tone' && !this.volcTtsExpressModeIsDefault(n)) return
      const cur = String(n.data.synthText || '')
      /** 与豆包语音合成 2.0 控制台一致：句前方括号表现力描述，默认示例可改 */
      const ins =
        kind === 'pause'
          ? '<#>'
          : '[声音结结巴巴，但努力想表现出强硬]'
      const next = cur + (cur && !/\s$/.test(cur) ? ' ' : '') + ins + ' '
      this.$set(n.data, 'synthText', next)
    },
    setAudioInputMode(n, mode) {
      if (!n || n.type !== 'audio' || !n.data) return
      const m = mode === 'upload' ? 'upload' : 'tts'
      this.$set(n.data, 'audioInputMode', m)
      this.$nextTick(() => this.syncAudioNodeHeight(n))
    },
    setImageInputMode(n, mode) {
      if (!n || n.type !== 'image' || !n.data) return
      const m = mode === 'upload' ? 'upload' : 'generate'
      this.$set(n.data, 'imageInputMode', m)
      this.syncImageNodeLayoutHeight(n)
      this.$nextTick(() => this.scheduleSyncNodeVisualHeights())
    },
    async onImageNodeFile(n, event) {
      const input = event && event.target
      const file = input && input.files && input.files[0]
      if (input) input.value = ''
      if (!file || !n || n.type !== 'image') return
      if (!file.type.startsWith('image/')) {
        showErrorToast('请选择图片文件')
        return
      }
      try {
        const url = await uploadVideoMediaFile({ file, relative: true })
        this.$set(n.data, 'referenceImageUrl', url)
        this.$set(n.data, 'imageUrl', url)
        this.$set(n.data, 'status', '完成')
        showSuccessToast('已上传并已作为节点输出')
        this.scheduleAutosave()
        this.syncImageNodeLayoutHeight(n)
        this.$nextTick(() => {
          this.scheduleSyncNodeVisualHeights()
          requestAnimationFrame(() => this.scheduleSyncNodeVisualHeights())
        })
      } catch (err) {
        showErrorToast(err && err.message ? String(err.message) : '上传失败')
      }
    },
    clearImageNodeUploadedImage(n) {
      if (!n || n.type !== 'image' || !n.data) return
      if (!this.imageNodeHasOwnImageData(n)) return
      this.pushDeleteUndoSnapshot()
      this.$set(n.data, 'imageUrl', '')
      this.$set(n.data, 'referenceImageUrl', '')
      if (String(n.data.status || '').trim() === '完成') {
        this.$set(n.data, 'status', '')
      }
      const input = document.getElementById('ngc-img-in-' + n.id)
      if (input) input.value = ''
      showSuccessToast('已清除上传图片')
      this.scheduleAutosave()
      this.syncImageNodeLayoutHeight(n)
      this.$nextTick(() => {
        this.scheduleSyncNodeVisualHeights()
        requestAnimationFrame(() => this.scheduleSyncNodeVisualHeights())
      })
    },
    /** 图片节点逻辑高度（连线端口 / 适应画布）；清除预览后需立即重算避免底栏错位 */
    syncImageNodeLayoutHeight(n) {
      if (!n || n.type !== 'image' || !n.data) return
      const header = 40
      const shell = 16
      let body = shell + 78
      const mode = String(n.data.imageInputMode || 'generate')
      if (mode === 'generate' && n.data.imageInpaintMode) body += 48
      if (this.imageNodeHasOwnImageData(n)) body += 172
      if (mode === 'upload') body += 132
      if (mode === 'generate') {
        body += 54
        body += n.data.panelExpanded ? 128 : 96
        body += 46
      }
      this.$set(n, 'h', Math.min(880, Math.max(220, header + body)))
    },
    async onImageNodeInpaintMaskFile(n, event) {
      const input = event && event.target
      const file = input && input.files && input.files[0]
      if (input) input.value = ''
      if (!file || !n || n.type !== 'image' || !n.data) return
      if (!file.type.startsWith('image/')) {
        showErrorToast('请选择蒙版图片')
        return
      }
      try {
        const url = await uploadVideoMediaFile({ file, relative: true })
        this.$set(n.data, 'inpaintMaskUrl', url)
        showSuccessToast('蒙版已上传')
      } catch (err) {
        showErrorToast(err && err.message ? String(err.message) : '蒙版上传失败')
      }
    },
    /** 根据模式与内容估算节点逻辑高度，供连线端口与画布范围使用 */
    syncAudioNodeHeight(n) {
      if (!n || n.type !== 'audio' || !n.data) return
      const header = 36
      const modeRow = 58
      let body = 0
      if (String(n.data.audioInputMode || 'tts') === 'upload') {
        // 说明文案 + 选文件行 + 内边距；有音频时再加 controls 条
        body = 112 + (n.data.referenceAudioUrl || n.data.audioUrl ? 44 : 0)
      } else {
        body = Math.max(400, Number(n.h) || 440)
      }
      const up = this.upstreamVisualThumbRefsForNode(n).length ? 40 : 0
      const total = Math.min(920, Math.max(140, header + modeRow + body + up))
      this.$set(n, 'h', total)
    },
    /** 节点内容区不再内滚后，按 DOM 实际高度写回 n.h，保证连线端口与「适应」范围正确 */
    scheduleSyncNodeVisualHeights() {
      if (this._syncNodeHeightsRaf) return
      this._syncNodeHeightsRaf = requestAnimationFrame(() => {
        this._syncNodeHeightsRaf = 0
        this.syncNodeVisualHeightsFromDom()
      })
    },
    syncNodeVisualHeightsFromDom() {
      const root = this.$refs.viewEl
      if (!root || !this.nodes || !this.nodes.length) return
      for (const n of this.nodes) {
        if (!n || n.id == null) continue
        const el = root.querySelector(`[data-ngc-node-box="${String(n.id)}"]`)
        if (!el) continue
        const h = Math.round(el.offsetHeight)
        if (h > 0) {
          const cur = Math.round(Number(n.h) || 0)
          if (h !== cur) this.$set(n, 'h', h)
        }
      }
    },
    async onAudioNodeFile(n, event) {
      const input = event && event.target
      const file = input && input.files && input.files[0]
      if (input) input.value = ''
      if (!file || !n || n.type !== 'audio') return
      if (!file.type.startsWith('audio/')) {
        showErrorToast('请选择音频文件')
        return
      }
      try {
        const url = await uploadNodeAudioFile(file)
        this.$set(n.data, 'referenceAudioUrl', url)
        this.$set(n.data, 'voiceId', '')
        if (String(n.data.audioInputMode || 'tts') === 'upload') {
          this.$set(n.data, 'audioUrl', url)
          showSuccessToast('已上传并已作为节点输出')
        } else {
          showSuccessToast('参考音频已上传')
        }
        this.$nextTick(() => this.syncAudioNodeHeight(n))
      } catch (err) {
        showErrorToast(err && err.message ? String(err.message) : '上传失败')
      }
    },
    videoPreviewResolutionLabel(n) {
      if (!n || !n.data) return '—'
      const ratio = String(this.effectiveVideoRatio(n)).trim()
      const res = String(n.data.resolution || '720p').trim().toLowerCase()
      const table = {
        '16:9': { '480p': '854 × 480', '720p': '1280 × 720', '1080p': '1920 × 1080' },
        '9:16': { '480p': '480 × 854', '720p': '720 × 1280', '1080p': '1080 × 1920' },
        '1:1': { '480p': '480 × 480', '720p': '720 × 720', '1080p': '1080 × 1080' },
        '4:3': { '480p': '640 × 480', '720p': '960 × 720', '1080p': '1440 × 1080' },
        '3:4': { '480p': '480 × 640', '720p': '720 × 960', '1080p': '1080 × 1440' },
        '21:9': { '480p': '854 × 360', '720p': '1280 × 540', '1080p': '1920 × 810' },
        adaptive: { '480p': '854 × 480', '720p': '1280 × 720', '1080p': '1920 × 1080' }
      }
      const row = table[ratio] || table['16:9']
      return row[res] || row['720p']
    },
    videoNodeCreditHint(n) {
      if (!n || !n.data) return 0
      const model = this.ngcResolveChargeModelId(
        n.data.seedanceModel,
        NGC_MODEL_KIND.VIDEO
      )
      const dur = Math.min(15, Math.max(1, Number(n.data.duration) || 5))
      const total = calcRequiredCreditsFromCatalog(
        this.ngcModelsCatalog,
        model,
        NGC_MODEL_KIND.VIDEO,
        { duration: dur, times: 1, resolution: n.data.resolution }
      )
      return total > 0 ? total : 0
    },
    onVideoResolutionPick(n, rv) {
      if (!n || n.type !== 'video' || !n.data) return
      this.$set(n.data, 'resolution', rv)
      this.syncNodeCreditDisplayFromModel(n)
      this.scheduleAutosave()
    },
    onVideoDurationInput(n, ev) {
      if (!n || n.type !== 'video' || !n.data) return
      const v = Math.min(15, Math.max(1, Math.round(Number(ev.target.value) || 5)))
      this.$set(n.data, 'duration', v)
      this.syncNodeCreditDisplayFromModel(n)
      this.scheduleAutosave()
    },
    toggleVideoPanelExpand(n) {
      if (!n || n.type !== 'video' || !n.data) return
      this.$set(n.data, 'panelExpanded', !n.data.panelExpanded)
      this.$nextTick(() => this.scheduleSyncNodeVisualHeights())
    },
    toggleVideoSpecPanel(n) {
      if (!n || n.type !== 'video') return
      if (this.videoSpecPanelNodeId === n.id) {
        this.videoSpecPanelNodeId = null
      } else {
        this.closeInlineCanvasPickers()
        this.videoSpecPanelNodeId = n.id
        this.bringNodeToFront(n)
      }
    },
    videoSpecRatioButtonLabel(slug) {
      if (slug === 'adaptive') return '自动'
      return String(slug || '')
    },
    ngcVideoRatioMiniStyle(slug) {
      const map = {
        adaptive: { w: 18, h: 11 },
        '16:9': { w: 18, h: 10 },
        '4:3': { w: 16, h: 12 },
        '1:1': { w: 13, h: 13 },
        '3:4': { w: 11, h: 15 },
        '9:16': { w: 10, h: 18 },
        '21:9': { w: 22, h: 9 }
      }
      const o = map[slug] || map['16:9']
      return {
        width: `${o.w}px`,
        height: `${o.h}px`,
        display: 'block'
      }
    },
    videoSpecSummaryRatioText(n) {
      if (!n || !n.data) return '16:9'
      const r = String(this.effectiveVideoRatio(n)).trim()
      if (r === 'adaptive') return '自动'
      if (this.videoRatioIsInherited(n) && (r === '16:9' || r === '9:16')) {
        return `${r}·分镜`
      }
      return r
    },
    videoSpecResolutionUi(n) {
      if (!n || !n.data) return '720P'
      const s = String(n.data.resolution || '720p').trim().toLowerCase()
      if (s === '480p') return '480P'
      if (s === '1080p') return '1080P'
      return '720P'
    },
    upstreamThumbBadKey(n, ref) {
      if (!n || !ref) return ''
      return `${n.id}\0${ref.nodeId}`
    },
    isUpstreamThumbBad(n, ref) {
      return !!this.upstreamThumbBad[this.upstreamThumbBadKey(n, ref)]
    },
    markUpstreamThumbBad(n, ref) {
      const k = this.upstreamThumbBadKey(n, ref)
      if (k) this.$set(this.upstreamThumbBad, k, true)
    },
    /** 图片 / 视频 / 音频节点：与入边一致的上游引用（缩略图或文本摘要） */
    upstreamRefsForNode(n) {
      if (
        !n ||
        (n.type !== 'image' && n.type !== 'video' && n.type !== 'audio') ||
        !this.edges
      )
        return []
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      const out = []
      let badge = 0
      for (const pid of predecessorIds(n.id, this.edges)) {
        const p = map[pid]
        if (!p) continue
        if (p.type === 'image') {
          badge += 1
          const u = p.data && p.data.imageUrl ? String(p.data.imageUrl).trim() : ''
          const ak = p.data && p.data.storyboardAssetKind ? String(p.data.storyboardAssetKind) : ''
          const an = p.data && p.data.storyboardAssetName != null ? String(p.data.storyboardAssetName).trim() : ''
          let title = `图片节点 ${this.imageNodeIndex(p)}`
          if (ak === 'character') title = an ? `人物·${an}` : '人物'
          else if (ak === 'prop') title = an ? `道具·${an}` : '道具'
          else if (ak === 'scene') title = an ? `场景·${an}` : '场景'
          out.push({
            key: `img-${p.id}`,
            kind: 'image',
            url: u,
            badge,
            nodeId: p.id,
            title
          })
        } else if (p.type === 'llm') {
          const raw = p.data && (p.data.output || p.data.prompt) ? String(p.data.output || p.data.prompt).trim() : ''
          if (!raw) continue
          badge += 1
          out.push({
            key: `llm-${p.id}`,
            kind: 'text',
            snippet: raw.length > 28 ? raw.slice(0, 28) + '…' : raw,
            badge,
            nodeId: p.id,
            title: `文本节点 ${this.textNodeIndex(p)}`
          })
        } else if (p.type === 'note') {
          const raw = p.data && p.data.body ? String(p.data.body).trim() : ''
          if (!raw) continue
          badge += 1
          out.push({
            key: `note-${p.id}`,
            kind: 'text',
            snippet: raw.length > 28 ? raw.slice(0, 28) + '…' : raw,
            badge,
            nodeId: p.id,
            title: '注释'
          })
        } else if (p.type === 'storyboard') {
          const raw =
            (p.data && String(p.data.output || '').trim()) ||
            (p.data && p.data.body ? String(p.data.body).trim() : '')
          if (!raw) continue
          badge += 1
          out.push({
            key: `sb-${p.id}`,
            kind: 'text',
            snippet: raw.length > 28 ? raw.slice(0, 28) + '…' : raw,
            badge,
            nodeId: p.id,
            title: `分镜脚本 ${this.storyboardNodeIndex(p)}`
          })
        } else if (p.type === 'scriptWrite') {
          const raw = exportScriptWriteNodeText(p)
          if (!raw) continue
          badge += 1
          out.push({
            key: `sw-${p.id}`,
            kind: 'text',
            snippet: raw.length > 28 ? raw.slice(0, 28) + '…' : raw,
            badge,
            nodeId: p.id,
            title: `剧本创作 ${this.scriptWriteNodeIndex(p)}`
          })
        } else if (p.type === 'audio') {
          badge += 1
          const au =
            (p.data && p.data.audioUrl && String(p.data.audioUrl).trim()) ||
            (p.data && p.data.referenceAudioUrl && String(p.data.referenceAudioUrl).trim()) ||
            ''
          out.push({
            key: `aud-${p.id}`,
            kind: 'audio',
            badge,
            nodeId: p.id,
            title: `音频节点 ${this.audioNodeIndex(p)}`,
            audioUrl: au
          })
        } else if (p.type === 'ecomDetail') {
          const urls =
            p.data && Array.isArray(p.data.outputImages)
              ? p.data.outputImages.map(x => (x && x.url ? String(x.url).trim() : '')).filter(Boolean)
              : []
          if (!urls.length) continue
          badge += 1
          out.push({
            key: `ecom-${p.id}`,
            kind: 'image',
            url: urls[0],
            badge,
            nodeId: p.id,
            title: `电商详情图 ${this.ecomDetailNodeIndex(p)}`
          })
        } else if (p.type === 'uiDesign') {
          const raw = exportUiDesignNodeText(p)
          if (raw) {
            badge += 1
            out.push({
              key: `ui-t-${p.id}`,
              kind: 'text',
              snippet: raw.length > 28 ? raw.slice(0, 28) + '…' : raw,
              badge,
              nodeId: p.id,
              title: `UI 设计 ${this.uiDesignNodeIndex(p)}`
            })
          }
          const uiUrls = uiDesignOutputUrls(p, map)
          if (uiUrls.length) {
            badge += 1
            out.push({
              key: `ui-i-${p.id}`,
              kind: 'image',
              url: uiUrls[0],
              badge,
              nodeId: p.id,
              title: `UI 设计 ${this.uiDesignNodeIndex(p)}`
            })
          }
        } else if (p.type === 'directorDeck') {
          const u = directorDeckUpstreamImageUrl(p, map, this.edges)
          if (!u) continue
          badge += 1
          out.push({
            key: `deck-${p.id}`,
            kind: 'image',
            url: u,
            badge,
            nodeId: p.id,
            title: `3D 导演台 ${this.directorDeckNodeIndex(p)}`
          })
        }
      }
      return out
    },
    /**
     * 图片 / 视频 / 音频节点顶部「全能参考」横条：只展示可图、可听、导演台等可预览上游；
     * 不展示分镜脚本 / 文本 / 注释（避免「剧本解析」长文占一格，且与 [图片N] 语义无关）。
     * 「@」提及与 findUpstreamRefBySnippet 仍用 upstreamRefsForNode。
     */
    upstreamVisualThumbRefsForNode(n) {
      if (!n || (n.type !== 'image' && n.type !== 'video' && n.type !== 'audio')) return []
      return this.upstreamRefsForNode(n).filter(r => r && r.kind !== 'text')
    },
    /**
     * 按「人物/道具/场景 + 绑定名称」在全画布查找已有素材图（续集或重解析时避免同名重复建节点）。
     * 优先级：前一集锚点分镜生成 → 本分镜已生成 → 无 spawned 归属（手动画的同类节点）。
     */
    findStoryboardAssetImageNodeIdByBoundName(sbNode, kind, entryName, anchorStoryboardId) {
      if (!sbNode || (kind !== 'character' && kind !== 'prop' && kind !== 'scene')) return ''
      const want = continuityAssetLookupKey(entryName)
      if (!want) return ''
      const anchorSid = String(anchorStoryboardId || '').trim()
      const selfSid = String(sbNode.id || '').trim()
      const rows = []
      for (const n of this.nodes) {
        if (!n || n.type !== 'image' || !n.data) continue
        if (String(n.data.storyboardAssetKind || '').trim() !== kind) continue
        const nk = continuityAssetLookupKey(n.data.storyboardAssetName)
        if (!nk || nk !== want) continue
        const sid = String(n.data.spawnedFromStoryboardId || '').trim()
        let rank = 50
        if (anchorSid && sid === anchorSid) rank = 0
        else if (selfSid && sid === selfSid) rank = 10
        else if (!sid) rank = 20
        else rank = 40
        rows.push({ id: n.id, rank })
      }
      rows.sort((a, b) => a.rank - b.rank || String(a.id).localeCompare(String(b.id)))
      return rows.length ? rows[0].id : ''
    },
    /** 将 contenteditable 内芯片还原为 [图片N] 等纯文本（与接口一致）；遍历 DOM，避免每键 cloneNode 卡顿 */
    serializePromptEditorRoot(root) {
      if (!root) return ''
      try {
        let out = ''
        const walk = parent => {
          for (let i = 0; i < parent.childNodes.length; i++) {
            const cn = parent.childNodes[i]
            if (cn.nodeType === 3) {
              out += (cn.textContent || '').replace(/\u200b/g, '')
            } else if (cn.nodeType === 1 && cn.classList && cn.classList.contains('ngc-prompt-chip')) {
              out += cn.getAttribute('data-snippet') || ''
            } else if (cn.nodeType === 1 && cn.tagName === 'BR') {
              out += '\n'
            } else if (cn.nodeType === 1) {
              walk(cn)
            }
          }
        }
        walk(root)
        return out
      } catch (err) {
        return ''
      }
    },
    getSerializedCaretOffset(root) {
      try {
        const sel = window.getSelection()
        if (!sel.rangeCount || !root.contains(sel.anchorNode)) {
          return this.serializePromptEditorRoot(root).length
        }
        const r = sel.getRangeAt(0)
        const pre = r.cloneRange()
        pre.selectNodeContents(root)
        pre.setEnd(r.startContainer, r.startOffset)
        const wrap = document.createElement('div')
        wrap.appendChild(pre.cloneContents())
        return this.serializePromptEditorRoot(wrap).length
      } catch (err) {
        return 0
      }
    },
    setCaretAtPlainOffset(root, offset) {
      const sel = window.getSelection()
      const range = document.createRange()
      let remain = Math.max(0, offset | 0)
      let placed = false
      const walk = parent => {
        for (let i = 0; i < parent.childNodes.length; i++) {
          if (placed) return
          const cn = parent.childNodes[i]
          if (cn.nodeType === 3) {
            const raw = cn.textContent || ''
            const len = raw.length
            if (remain <= len) {
              range.setStart(cn, Math.min(remain, len))
              range.collapse(true)
              placed = true
              return
            }
            remain -= len
          } else if (cn.nodeType === 1 && cn.classList && cn.classList.contains('ngc-prompt-chip')) {
            const sl = (cn.getAttribute('data-snippet') || '').length
            if (remain < sl) {
              if (remain === 0) range.setStartBefore(cn)
              else range.setStartAfter(cn)
              range.collapse(true)
              placed = true
              return
            }
            remain -= sl
          } else if (cn.nodeType === 1 && cn.tagName === 'BR') {
            if (remain <= 0) {
              range.setStartBefore(cn)
              range.collapse(true)
              placed = true
              return
            }
            remain -= 1
          } else if (cn.nodeType === 1) {
            walk(cn)
          }
        }
      }
      walk(root)
      if (!placed) {
        range.selectNodeContents(root)
        range.collapse(false)
      }
      sel.removeAllRanges()
      sel.addRange(range)
    },
    /**
     * 与 setCaretAtPlainOffset 相同遍历规则，但不改选区；用于测量 @ 在视口中的位置。
     * @returns {Range|null}
     */
    domRangeAtSerializedOffset(root, offset) {
      if (!root) return null
      try {
        const range = document.createRange()
        let remain = Math.max(0, offset | 0)
        let placed = false
        const walk = parent => {
          for (let i = 0; i < parent.childNodes.length && !placed; i++) {
            const cn = parent.childNodes[i]
            if (cn.nodeType === 3) {
              const raw = cn.textContent || ''
              const len = raw.length
              if (remain <= len) {
                range.setStart(cn, Math.min(remain, len))
                range.collapse(true)
                placed = true
                return
              }
              remain -= len
            } else if (cn.nodeType === 1 && cn.classList && cn.classList.contains('ngc-prompt-chip')) {
              const sl = (cn.getAttribute('data-snippet') || '').length
              if (remain < sl) {
                if (remain === 0) range.setStartBefore(cn)
                else range.setStartAfter(cn)
                range.collapse(true)
                placed = true
                return
              }
              remain -= sl
            } else if (cn.nodeType === 1 && cn.tagName === 'BR') {
              if (remain <= 0) {
                range.setStartBefore(cn)
                range.collapse(true)
                placed = true
                return
              }
              remain -= 1
            } else if (cn.nodeType === 1) {
              walk(cn)
            }
          }
        }
        walk(root)
        if (!placed) {
          range.selectNodeContents(root)
          range.collapse(false)
        }
        return range
      } catch {
        return null
      }
    },
    /** 将 @ 素材列表定位在输入框内 @ 字符旁（相对外层 .relative，已按画布 scale 换算） */
    computeAssetMentionMenuPos(el, anchorStart) {
      const wrap = el && el.parentElement
      if (!wrap || !el.getBoundingClientRect) return {}
      const range = this.domRangeAtSerializedOffset(el, anchorStart)
      if (!range) return {}
      const rects = range.getClientRects()
      let br = rects && rects.length ? rects[0] : null
      if (!br || (br.width === 0 && br.height === 0)) {
        try {
          br = range.getBoundingClientRect()
        } catch {
          return {}
        }
      }
      const wrapRect = wrap.getBoundingClientRect()
      const scale = Math.max(0.25, Math.min(2, Number(this.viewport && this.viewport.scale) || 1))
      let left = (br.left - wrapRect.left) / scale
      let top = (br.bottom - wrapRect.top) / scale + 2
      const menuW = 248
      const pad = 4
      const wrapW = wrap.offsetWidth || Math.max(1, Math.round(wrapRect.width / scale))
      left = Math.round(left)
      top = Math.round(top)
      if (left + menuW > wrapW - pad) left = Math.max(pad, wrapW - menuW - pad)
      if (left < pad) left = pad
      const menuMaxH = 220
      const wrapH = wrap.offsetHeight || Math.round(wrapRect.height / scale)
      if (top + menuMaxH > wrapH - pad) {
        const above = (br.top - wrapRect.top) / scale - menuMaxH - 4
        if (above >= pad) top = Math.round(above)
      }
      return { menuLeft: left, menuTop: top, menuWidth: menuW }
    },
    assetMentionMenuStyle(n) {
      const m = this.assetMention
      if (!m || !n || m.nodeId !== n.id) return {}
      const w = m.menuWidth != null ? m.menuWidth : 240
      if (m.menuLeft == null || m.menuTop == null) {
        return { left: 0, right: 0, top: '100%', marginTop: '2px' }
      }
      return {
        left: `${m.menuLeft}px`,
        top: `${m.menuTop}px`,
        width: `${w}px`,
        minWidth: '200px'
      }
    },
    syncPromptEditorEmptyAttr(el, plainPrecomputed) {
      if (!el || !el.hasAttribute || !el.hasAttribute('data-prompt-editor')) return
      const plain = plainPrecomputed != null ? String(plainPrecomputed) : this.serializePromptEditorRoot(el)
      el.setAttribute('data-empty', plain.length === 0 ? '1' : '0')
    },
    snippetToChipLabel(snippet) {
      const s = String(snippet || '')
      const im = /^\[图片(\d+)\]$/.exec(s)
      const au = /^\[音频(\d+)\]$/.exec(s)
      const tx = /^\[参考(\d+)\]$/.exec(s)
      if (im) return `图片${im[1]}`
      if (au) return `音频${au[1]}`
      if (tx) return `参考${tx[1]}`
      return s
    },
    findUpstreamRefBySnippet(n, snippet) {
      const refs = this.upstreamRefsForNode(n)
      const s = String(snippet || '')
      const im = /^\[图片(\d+)\]$/.exec(s)
      if (im) {
        const idx = parseInt(im[1], 10)
        if (!Number.isFinite(idx) || idx < 1) return null
        const images = refs.filter(r => r && r.kind === 'image')
        return images[idx - 1] || null
      }
      const au = /^\[音频(\d+)\]$/.exec(s)
      if (au) {
        const idx = parseInt(au[1], 10)
        if (!Number.isFinite(idx) || idx < 1) return null
        const audios = refs.filter(r => r && r.kind === 'audio')
        return audios[idx - 1] || null
      }
      const tx = /^\[参考(\d+)\]$/.exec(s)
      if (tx) {
        const idx = parseInt(tx[1], 10)
        if (!Number.isFinite(idx) || idx < 1) return null
        const texts = refs.filter(r => r && r.kind === 'text')
        return texts[idx - 1] || null
      }
      return null
    },
    /** 上游图片/音频 URL 变化时刷新芯片缩略图（不重建整段 HTML，避免打断输入光标） */
    syncPromptChipThumbnails(n, el) {
      if (!el || !n) return
      const sameUrl = (a, b) => {
        const x = a != null ? String(a).trim() : ''
        const y = b != null ? String(b).trim() : ''
        if (x === y) return true
        try {
          return new URL(x, window.location.href).href === new URL(y, window.location.href).href
        } catch {
          return false
        }
      }
      try {
        el.querySelectorAll('.ngc-prompt-chip').forEach(chip => {
          const snippet = chip.getAttribute('data-snippet') || ''
          const ref = this.findUpstreamRefBySnippet(n, snippet)
          if (ref && ref.nodeId) {
            chip.setAttribute('data-upstream-node-id', ref.nodeId)
            chip.setAttribute(
              'title',
              ref.title ? `${ref.title} · 点击定位节点` : '点击定位上游节点'
            )
          }
          if (!chip.__ngcChipNavBound) {
            chip.__ngcChipNavBound = true
            const onChipPointer = e => {
              this.onPromptChipClick(n, snippet, e)
            }
            chip.addEventListener('mousedown', onChipPointer)
            chip.addEventListener('click', onChipPointer)
          }
          const thumb = chip.querySelector('.ngc-prompt-chip__thumb')
          if (!thumb) return
          const url = ref && ref.kind === 'image' && ref.url ? String(ref.url).trim() : ''
          if (url) {
            const k = this.upstreamThumbBadKey(n, ref)
            if (k && this.upstreamThumbBad[k]) this.$delete(this.upstreamThumbBad, k)
            let img = thumb.querySelector('img.ngc-prompt-chip__img')
            if (!img) {
              thumb.innerHTML = ''
              img = document.createElement('img')
              img.className = 'ngc-prompt-chip__img'
              img.setAttribute('draggable', 'false')
              img.alt = ''
              img.addEventListener('error', () => {
                if (ref) this.markUpstreamThumbBad(n, ref)
              })
              thumb.appendChild(img)
            }
            if (!sameUrl(img.src, url)) img.src = url
          } else {
            thumb.innerHTML = ''
            const ic = document.createElement('i')
            ic.className =
              ref && ref.kind === 'audio'
                ? 'fas fa-music ngc-prompt-chip__ico'
                : 'fas fa-align-left ngc-prompt-chip__ico'
            thumb.appendChild(ic)
          }
        })
      } catch {
        /* ignore */
      }
    },
    /** 防抖后批量刷新所有图片/视频节点的 @ 芯片缩略图（跳过正在编辑的编辑器） */
    flushPromptChipThumbnailsForAllImageVideoNodes() {
      this.$nextTick(() => {
        this.nodes.forEach(n => {
          if (n.type !== 'image' && n.type !== 'video') return
          const el = document.querySelector(`[data-prompt-editor][data-prompt-node-id="${n.id}"]`)
          if (!el) return
          if (document.activeElement === el || el.contains(document.activeElement)) return
          this.syncPromptChipThumbnails(n, el)
        })
      })
    },
    /** 拖动中未提交 n.x/n.y 时，用预览坐标参与布局（节点盒与连线端口一致） */
    nodeWorldXYForLayout(n) {
      if (!n) return { x: 0, y: 0 }
      const d = this.dragNode
      if (
        d &&
        n.id === d.id &&
        !this.inpaintStrokeSession &&
        !this.inpaintRectSession
      ) {
        const cx = d.pendingClientX != null ? d.pendingClientX : d.sx
        const cy = d.pendingClientY != null ? d.pendingClientY : d.sy
        const sc = Number(this.viewport.scale) || 1
        return {
          x: d.ox + (cx - d.sx) / sc,
          y: d.oy + (cy - d.sy) / sc
        }
      }
      return { x: Number(n.x) || 0, y: Number(n.y) || 0 }
    },
    nodeBoxLayoutStyle(n) {
      if (!n) return {}
      const pos = this.nodeWorldXYForLayout(n)
      return {
        left: pos.x + 'px',
        top: pos.y + 'px',
        width: n.w + 'px',
        height: 'auto',
        minHeight: '0',
        zIndex: n.zStack != null ? n.zStack : 1
      }
    },
    buildPromptChipElement(n, snippet) {
      const span = document.createElement('span')
      span.className = 'ngc-prompt-chip'
      span.setAttribute('contenteditable', 'false')
      span.setAttribute('data-snippet', snippet)
      span.setAttribute('spellcheck', 'false')
      const ref = this.findUpstreamRefBySnippet(n, snippet)
      if (ref && ref.nodeId) {
        span.setAttribute('data-upstream-node-id', ref.nodeId)
        const tip = ref.title ? `${ref.title} · 点击定位节点` : '点击定位上游节点'
        span.setAttribute('title', tip)
      } else {
        span.setAttribute('title', '未找到对应上游节点')
      }
      const onChipPointer = e => {
        this.onPromptChipClick(n, snippet, e)
      }
      span.addEventListener('mousedown', onChipPointer)
      span.addEventListener('click', onChipPointer)
      const thumb = document.createElement('span')
      thumb.className = 'ngc-prompt-chip__thumb'
      if (ref && ref.kind === 'image' && ref.url) {
        const img = document.createElement('img')
        img.className = 'ngc-prompt-chip__img'
        img.setAttribute('draggable', 'false')
        img.src = ref.url
        img.alt = ''
        img.addEventListener('error', () => {
          if (ref) this.markUpstreamThumbBad(n, ref)
        })
        thumb.appendChild(img)
      } else if (ref && ref.kind === 'audio') {
        const ic = document.createElement('i')
        ic.className = 'fas fa-music ngc-prompt-chip__ico'
        thumb.appendChild(ic)
      } else {
        const ic = document.createElement('i')
        ic.className = 'fas fa-align-left ngc-prompt-chip__ico'
        thumb.appendChild(ic)
      }
      const lab = document.createElement('span')
      lab.className = 'ngc-prompt-chip__label'
      lab.textContent = this.snippetToChipLabel(snippet)
      span.appendChild(thumb)
      span.appendChild(lab)
      return span
    },
    hydratePromptEditor(n, el) {
      if (!el || !n || !n.data) return
      const text = n.data.prompt != null ? String(n.data.prompt) : ''
      el.innerHTML = ''
      const re = /(\[图片(\d+)\]|\[音频(\d+)\]|\[参考(\d+)\])/g
      let last = 0
      let m
      while ((m = re.exec(text))) {
        if (m.index > last) el.appendChild(document.createTextNode(text.slice(last, m.index)))
        el.appendChild(this.buildPromptChipElement(n, m[1]))
        last = re.lastIndex
      }
      if (last < text.length) el.appendChild(document.createTextNode(text.slice(last)))
      this.syncPromptEditorEmptyAttr(el)
      this.syncPromptChipThumbnails(n, el)
      try {
        el.setAttribute('data-ngc-prompt-hydrated', '1')
      } catch {
        /* ignore */
      }
    },
    /** 项目加载 / 切换后：用 model 灌入所有图片、视频提示词编辑器 */
    hydrateAllPromptEditorsFromModel() {
      for (const n of this.nodes || []) {
        if (!n || (n.type !== 'image' && n.type !== 'video') || !n.data) continue
        const el = document.querySelector(
          `[data-prompt-editor][data-prompt-node-id="${n.id}"]`
        )
        if (!el) continue
        this.hydratePromptEditor(n, el)
      }
    },
    onPromptEditorPaste(n, e) {
      if (!e || !e.clipboardData) return
      e.preventDefault()
      const plain = e.clipboardData.getData('text/plain') || ''
      try {
        document.execCommand('insertText', false, plain)
      } catch (err) {
        /* ignore */
      }
      const el = e.target
      this.$nextTick(() => {
        if (el && el.getAttribute && el.getAttribute('data-prompt-editor') != null) {
          const key = String(n.id)
          const timers = this._promptModelSyncTimers
          if (timers && timers[key]) {
            clearTimeout(timers[key])
            delete timers[key]
          }
          const s = this.serializePromptEditorRoot(el)
          this.$set(n.data, 'prompt', s)
          this.syncPromptEditorEmptyAttr(el, s)
          this.refreshAssetMentionFromEvent(n, el, s)
        }
      })
    },
    /** 将 contenteditable 内容立即写回 n.data.prompt，并取消该节点的防抖定时器 */
    flushPromptModelFromDom(n) {
      if (!n || !n.data || n.id == null) return
      const key = String(n.id)
      const timers = this._promptModelSyncTimers
      if (timers && timers[key]) {
        clearTimeout(timers[key])
        delete timers[key]
      }
      if (n.type !== 'image' && n.type !== 'video') return
      const el = document.querySelector(`[data-prompt-editor][data-prompt-node-id="${key}"]`)
      if (!el) return
      const latest = this.serializePromptEditorRoot(el)
      const prev = n.data.prompt != null ? String(n.data.prompt) : ''
      if (!latest && prev && el.getAttribute('data-ngc-prompt-hydrated') !== '1') {
        return
      }
      if (latest !== prev) this.$set(n.data, 'prompt', latest)
    },
    /** 保存 / 跑图前同步所有图片、视频提示词，避免防抖导致 state 落后 */
    flushAllPromptEditorsFromDom() {
      for (const n of this.nodes || []) {
        if (n && (n.type === 'image' || n.type === 'video')) this.flushPromptModelFromDom(n)
      }
    },
    /** 中文输入法上屏后立即同步 model 与 @ 菜单 */
    onPromptCompositionEnd(n, e) {
      const el = e && e.target
      if (!el || !n || !n.data) return
      if (el.getAttribute('data-prompt-editor') == null) return
      const key = String(n.id)
      const timers = this._promptModelSyncTimers
      if (timers && timers[key]) {
        clearTimeout(timers[key])
        delete timers[key]
      }
      const plain = this.serializePromptEditorRoot(el)
      this.$set(n.data, 'prompt', plain)
      this.syncPromptEditorEmptyAttr(el, plain)
      this.refreshAssetMentionFromEvent(n, el, plain)
    },
    clearAssetMentionBlurTimer() {
      if (this._assetMentionBlurTimer) {
        clearTimeout(this._assetMentionBlurTimer)
        this._assetMentionBlurTimer = null
      }
    },
    cancelCloseAssetMentionTimer() {
      this.clearAssetMentionBlurTimer()
    },
    /**
     * @ 素材列表可滚动时：滚轮在列表未触顶/底前只在本容器内滚动，不链式带动外层 contenteditable。
     * 配合 .ngc-asset-mention 的 overscroll-behavior: contain。
     */
    onNgAssetMentionWheel(e) {
      const el = e && e.currentTarget
      if (!el) return
      if (el.scrollHeight <= el.clientHeight + 1) return
      const st = el.scrollTop
      const ch = el.clientHeight
      const sh = el.scrollHeight
      const dy = e.deltaY
      const eps = 2
      if (dy > 0 && st + ch < sh - eps) {
        e.stopPropagation()
      } else if (dy < 0 && st > eps) {
        e.stopPropagation()
      }
    },
    /** 上游素材缩略图横条：滚轮横向滑动，避免被节点宽度裁切 */
    onUpstreamThumbStripWheel(e) {
      const el = e && e.currentTarget
      if (!el || el.scrollWidth <= el.clientWidth + 1) return
      const delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY
      if (!delta) return
      el.scrollLeft += delta
    },
    openNgcCharacterLibrary(n, e) {
      if (!n || n.type !== 'video') return
      this.closeInlineCanvasPickers()
      this.closeUpstreamThumbMenu()
      const btn = e && e.currentTarget
      this.ngcCharacterLibModal = {
        visible: true,
        nodeId: n.id,
        anchorRect: getAnchorRect(btn)
      }
    },
    closeNgcCharacterLibrary() {
      this.ngcCharacterLibModal = {
        visible: false,
        nodeId: '',
        anchorRect: null
      }
    },
    onNgcCharacterAssetPicked(asset) {
      const mid = this.ngcCharacterLibModal
      const nodeId = mid && mid.nodeId ? String(mid.nodeId) : ''
      this.closeNgcCharacterLibrary()
      if (!nodeId || !asset || !asset.url) return
      const videoNode = this.nodes.find(x => x.id === nodeId && x.type === 'video')
      if (!videoNode) return
      this.attachCharacterAssetToVideoNode(videoNode, asset)
    },
    /** 角色库选中：建/连图片节点并写入 [图片N] 引用 */
    attachCharacterAssetToVideoNode(videoNode, asset) {
      const url = String((asset && asset.url) || '').trim()
      if (!url) {
        showErrorToast('该角色资产无可用图片')
        return
      }
      const title = String((asset && asset.title) || '角色').trim() || '角色'
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      for (const pid of predecessorIds(videoNode.id, this.edges)) {
        const p = map[pid]
        if (!p || p.type !== 'image') continue
        if (String((p.data && p.data.imageUrl) || '').trim() === url) {
          this.appendVideoPromptImageRef(videoNode, p.id)
          showSuccessToast(`已引用角色「${title}」`)
          this.focusUpstreamNode(p.id)
          return
        }
      }
      const def = DEFAULT_NODE.image
      if (!def) return
      const gapX = 40
      const id = genId()
      const imgNode = {
        id,
        type: 'image',
        x: Math.round(Number(videoNode.x) - Number(def.w || 280) - gapX),
        y: Math.round(Number(videoNode.y)),
        w: def.w,
        h: def.h,
        data: {
          ...def.data(),
          prompt: title,
          imageUrl: url,
          imageInputMode: IMAGE_INPUT_MODES.upload,
          storyboardAssetKind: 'character',
          storyboardAssetName: title
        }
      }
      this.pushDeleteUndoSnapshot()
      this.nodes.push(imgNode)
      this.bringNodeToFront(imgNode)
      this.tryConnect(id, videoNode.id)
      this.scheduleAutosave()
      this.appendVideoPromptImageRef(videoNode, id)
      showSuccessToast(`已添加角色「${title}」并连至本视频节点`)
      this.$nextTick(() => {
        this.scheduleSyncNodeVisualHeights()
        const el = document.querySelector(
          `[data-prompt-editor][data-prompt-node-id="${videoNode.id}"]`
        )
        if (el) this.hydratePromptEditor(videoNode, el)
      })
    },
    appendVideoPromptImageRef(videoNode, imageNodeId) {
      if (!videoNode || !imageNodeId) return
      const images = this.upstreamRefsForNode(videoNode).filter(r => r && r.kind === 'image')
      const idx = images.findIndex(r => r.nodeId === imageNodeId)
      if (idx < 0) return
      const snippet = `[图片${idx + 1}]`
      let prompt = String((videoNode.data && videoNode.data.prompt) || '')
      if (prompt.indexOf(snippet) !== -1) return
      const sep = prompt.trim() ? (/\s$/.test(prompt) ? '' : ' ') : ''
      this.$set(videoNode.data, 'prompt', `${prompt}${sep}${snippet}`)
    },
    scheduleCloseAssetMention(n) {
      this.clearAssetMentionBlurTimer()
      this._assetMentionBlurTimer = setTimeout(() => {
        this._assetMentionBlurTimer = null
        if (this.assetMention && n && this.assetMention.nodeId === n.id) {
          this.assetMention = null
        }
      }, 200)
    },
    onPromptBlur(n) {
      this.flushPromptModelFromDom(n)
      this.scheduleCloseAssetMention(n)
    },
    onPromptFocus(n) {
      this.cancelCloseAssetMentionTimer()
      if (!n || !n.data) return
      const el = document.querySelector(`[data-prompt-editor][data-prompt-node-id="${n.id}"]`)
      if (el) {
        const model = n.data.prompt != null ? String(n.data.prompt) : ''
        const cur = this.serializePromptEditorRoot(el)
        if (cur !== model) this.hydratePromptEditor(n, el)
        this.$nextTick(() => this.refreshAssetMentionFromEvent(n, el))
      }
    },
    assetRefKindLabel(ref) {
      if (!ref) return ''
      if (ref.kind === 'image') return '图片'
      if (ref.kind === 'audio') return '音频'
      return '参考'
    },
    assetInsertSnippet(ref) {
      if (!ref) return ''
      const b = ref.badge
      if (ref.kind === 'image') return `[图片${b}]`
      if (ref.kind === 'audio') return `[音频${b}]`
      return `[参考${b}]`
    },
    assetMentionFilterRefs(n, filter) {
      const refs = this.upstreamRefsForNode(n)
      const f = (filter != null ? String(filter) : '').trim().toLowerCase()
      if (!f) return refs
      return refs.filter(r => {
        const badge = String(r.badge)
        const kindZh = r.kind === 'image' ? '图片' : r.kind === 'audio' ? '音频' : '参考'
        const blob = `${kindZh}${badge} ${r.title || ''} ${badge}`.toLowerCase()
        return blob.includes(f)
      })
    },
    assetMentionFilteredRefs(n) {
      if (!this.assetMention || !n || this.assetMention.nodeId !== n.id) return []
      return this.assetMentionFilterRefs(n, this.assetMention.filter)
    },
    refreshAssetMentionFromEvent(n, el, serializedText) {
      if (!el || el.getAttribute('data-prompt-editor') == null || !n.data) return
      const text = serializedText != null ? String(serializedText) : this.serializePromptEditorRoot(el)
      const caret = this.getSerializedCaretOffset(el)
      const ctx = getAssetMentionContext(text, caret)
      if (!ctx) {
        if (this.assetMention && this.assetMention.nodeId === n.id) this.assetMention = null
        return
      }
      const refs = this.assetMentionFilterRefs(n, ctx.filter)
      const prev = this.assetMention && this.assetMention.nodeId === n.id ? this.assetMention : null
      const filterChanged = !prev || prev.filter !== ctx.filter
      let hi = filterChanged ? 0 : prev.highlightIndex || 0
      if (refs.length) hi = Math.min(Math.max(0, hi), refs.length - 1)
      else hi = 0
      const pos = this.computeAssetMentionMenuPos(el, ctx.anchorStart)
      this.assetMention = {
        nodeId: n.id,
        anchorStart: ctx.anchorStart,
        caretEnd: caret,
        filter: ctx.filter,
        highlightIndex: hi,
        ...pos
      }
    },
    onPromptEditorInput(n, e) {
      if (!n || (n.type !== 'image' && n.type !== 'video')) return
      const el = e && e.target
      if (!el || el.getAttribute('data-prompt-editor') == null) return
      if (e && e.isComposing) return
      const plain = this.serializePromptEditorRoot(el)
      this.syncPromptEditorEmptyAttr(el, plain)
      const timers = this._promptModelSyncTimers
      const key = String(n.id)
      if (timers[key]) clearTimeout(timers[key])
      timers[key] = setTimeout(() => {
        delete timers[key]
        const el2 = document.querySelector(`[data-prompt-editor][data-prompt-node-id="${key}"]`)
        if (!el2 || !n.data) return
        const latest = this.serializePromptEditorRoot(el2)
        const prev = n.data.prompt != null ? String(n.data.prompt) : ''
        if (latest !== prev) this.$set(n.data, 'prompt', latest)
      }, 200)
      if (this._promptMentionLayoutRaf) cancelAnimationFrame(this._promptMentionLayoutRaf)
      this._promptMentionLayoutRaf = requestAnimationFrame(() => {
        this._promptMentionLayoutRaf = 0
        if (document.activeElement === el || (el.contains && el.contains(document.activeElement))) {
          this.refreshAssetMentionFromEvent(n, el, plain)
        }
      })
    },
    onNodePromptKeydown(n, e) {
      if (!n || !e) return
      const activeMention =
        this.assetMention && this.assetMention.nodeId === n.id ? this.assetMention : null
      const list = activeMention ? this.assetMentionFilteredRefs(n) : []
      if (activeMention) {
        if (e.key === 'Escape') {
          this.assetMention = null
          e.preventDefault()
          e.stopPropagation()
          return
        }
        if (list.length) {
          if (e.key === 'ArrowDown') {
            this.assetMention = {
              ...this.assetMention,
              highlightIndex: (this.assetMention.highlightIndex + 1) % list.length
            }
            e.preventDefault()
            e.stopPropagation()
            return
          }
          if (e.key === 'ArrowUp') {
            const ni = (this.assetMention.highlightIndex - 1 + list.length) % list.length
            this.assetMention = { ...this.assetMention, highlightIndex: ni }
            e.preventDefault()
            e.stopPropagation()
            return
          }
          if (e.key === 'Enter' && !e.shiftKey) {
            const ref = list[this.assetMention.highlightIndex]
            if (ref) this.applyAssetMentionPick(n, ref)
            e.preventDefault()
            e.stopPropagation()
            return
          }
        } else if (e.key === 'Enter' && !e.shiftKey) {
          this.assetMention = null
          e.preventDefault()
          e.stopPropagation()
          return
        }
      }
      e.stopPropagation()
    },
    applyAssetMentionPick(n, ref) {
      this.cancelCloseAssetMentionTimer()
      const m = this.assetMention
      if (!m || !n.data || m.nodeId !== n.id || !ref) {
        this.assetMention = null
        return
      }
      const text = n.data.prompt != null ? String(n.data.prompt) : ''
      const ins = this.assetInsertSnippet(ref)
      const caretEnd = Math.min(m.caretEnd, text.length)
      const anchor = Math.min(m.anchorStart, caretEnd)
      const newText = text.slice(0, anchor) + ins + text.slice(caretEnd)
      this.$set(n.data, 'prompt', newText)
      this.assetMention = null
      const pos = anchor + ins.length
      const el = document.querySelector(`[data-prompt-editor][data-prompt-node-id="${n.id}"]`)
      this.$nextTick(() => {
        if (el && el.getAttribute('data-prompt-editor') != null) {
          this.hydratePromptEditor(n, el)
          this.setCaretAtPlainOffset(el, pos)
          el.focus()
        }
      })
    },
    closeUpstreamPreview() {
      this.upstreamPreview = null
    },
    toggleImageToolbarMenu(key) {
      this.imageToolbarMenu = this.imageToolbarMenu === key ? null : key
    },
    measureImageToolbarDropdown() {
      const key = this.imageToolbarMenu
      if (!key) return
      const root = this.$refs.ngcImageToolbarEl
      if (!root || !root.getBoundingClientRect) return
      const btn = root.querySelector(`[data-ngc-img-toolbar-trigger="${key}"]`)
      if (!btn || !btn.getBoundingClientRect) return
      /** 画布层带 scale；getBoundingClientRect 为屏幕像素，需换算为与节点/toolbar 一致的世界坐标 */
      const sc = Math.max(0.25, Math.min(2, Number(this.viewport && this.viewport.scale) || 1))
      const rb = root.getBoundingClientRect()
      const bb = btn.getBoundingClientRect()
      const gapWorld = key === 'redraw' ? 2 : 3
      let left = Math.round((bb.left - rb.left) / sc)
      const top = Math.round((bb.bottom - rb.top) / sc) + gapWorld
      const bw = Math.round(bb.width / sc)
      const rootWW = Math.round(rb.width / sc)
      if (key === 'redraw') {
        const estW = Math.max(bw, 88)
        if (rootWW > 0 && estW <= rootWW) {
          left = Math.max(0, Math.min(left, rootWW - estW))
        }
        this.imageToolbarDropdownLayout = { left, top, autoWidth: true }
        return
      }
      const minWidth = Math.max(bw + 8, 168)
      if (rootWW > 0 && minWidth <= rootWW) {
        left = Math.max(0, Math.min(left, rootWW - minWidth))
      }
      this.imageToolbarDropdownLayout = { left, top, minWidth }
    },
    toastImageToolbarSoon(label) {
      this.imageToolbarMenu = null
      showSuccessToast(`${label} 即将接入节点画布`)
    },
    /** 与 executeImageNode 一致：风格参考优先，再接上游图 */
    primaryRefUrlForImageNode(n) {
      if (!n || n.type !== 'image' || !n.data) return ''
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      const ws = effectiveWorkflowStyleForImageNode(n, map, this.edges)
      const styleRef = pickWorkflowStyleRef(ws)
      const imgs = gatherUpstreamImageUrls(n.id, map, this.edges)
      const merged = (styleRef ? [styleRef] : []).concat(imgs).filter(Boolean)
      return merged.length ? String(merged[0]).trim() : ''
    },
    /** 本节点是否已有文生图结果或本地上传图（不含仅上游参考） */
    imageNodeHasOwnImageData(n) {
      if (!n || n.type !== 'image' || !n.data) return false
      return !!(
        String(n.data.imageUrl || '').trim() || String(n.data.referenceImageUrl || '').trim()
      )
    },
    /** 预览区仅展示本节点 imageUrl / 上传图，不展示上游 BFS 参考 */
    imageNodeOwnPreviewSrc(n) {
      if (!n || !n.data) return ''
      return (
        String(n.data.imageUrl || '').trim() || String(n.data.referenceImageUrl || '').trim()
      )
    },
    imageNodeDisplaySrc(n) {
      if (!n || !n.data) return ''
      const own = this.imageNodeOwnPreviewSrc(n)
      if (own) return own
      return this.primaryRefUrlForImageNode(n)
    },
    enterImageInpaintModeFromToolbar() {
      const n = this.selectedImageToolbarNode
      if (!n) {
        showErrorToast('请先选中画布上的图片节点')
        return
      }
      this.enterImageInpaintMode(n)
    },
    enterImageInpaintMode(n) {
      if (!n || n.type !== 'image' || !n.data) return
      this.inpaintOnlineEditorNodeId = null
      if (String(n.data.imageInputMode || 'generate') !== 'generate') {
        showErrorToast('局部重绘需在「文生图」模式下使用')
        this.imageToolbarMenu = null
        return
      }
      const base = this.imageNodeDisplaySrc(n)
      if (!base) {
        showErrorToast('请先生成图片，或连接上游图片 / 选择带参考图的风格作为底图')
        this.imageToolbarMenu = null
        return
      }
      const m = String(n.data.seedreamModel || '').trim()
      if (!this.gptInpaintCapableSeedreamModels.includes(m)) {
        this.$set(n.data, 'seedreamModel', 'gpt-image-2')
        showSuccessToast('已切换为 GPT-Image-2（局部重绘）')
      }
      this.imageToolbarMenu = null
      this.$set(n.data, 'imageInpaintMode', true)
      if (n.data.inpaintDrawTool == null) this.$set(n.data, 'inpaintDrawTool', 'brush')
      if (n.data.inpaintBrushSize == null) this.$set(n.data, 'inpaintBrushSize', 28)
      if (n.data.inpaintBrushColor == null) this.$set(n.data, 'inpaintBrushColor', '#ff3355')
      this.$nextTick(() => {
        this.initInpaintCanvas(n)
        // 进入重绘后自动打开大屏编辑（与「局部重绘」入口预期一致）
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.openInpaintOnlineEditor(n, 0)
          })
        })
      })
    },
    _getInpaintSurfaceElements(n, surface) {
      if (!n || !n.id) return null
      const wrapSel =
        surface === 'modal'
          ? `[data-ngc-inpaint-wrap-modal="${n.id}"]`
          : `[data-ngc-inpaint-wrap="${n.id}"]`
      const wrap = document.querySelector(wrapSel)
      if (!wrap) return null
      const img = wrap.querySelector('img[data-ngc-inpaint-base-img]')
      const cv = wrap.querySelector('canvas[data-ngc-inpaint-canvas]')
      if (!img || !cv) return null
      return { wrap, img, cv }
    },
    _getInpaintElements(n) {
      if (!n || !n.id) return null
      const surface = this.inpaintOnlineEditorNodeId === n.id ? 'modal' : 'inline'
      return this._getInpaintSurfaceElements(n, surface)
    },
    /** 离屏蒙版位图（与当前编辑表面同尺寸），所有画笔/撤销仅改此层 */
    _getInpaintMaskCanvas(n) {
      if (!n || !n.id) return null
      if (!this.inpaintMaskBuffers[n.id]) {
        const cv = document.createElement('canvas')
        cv.width = 1
        cv.height = 1
        /** 禁止默认「全透明」占位：首次 sync 会把 1×1 拉伸到全图，透明会被当成整图重绘洞 → 仅见棋盘格 */
        const x = cv.getContext('2d', INPAINT_2D_CTX)
        if (x) {
          x.fillStyle = INPAINT_MASK_PRESERVE_WHITE
          x.fillRect(0, 0, 1, 1)
        }
        this.$set(this.inpaintMaskBuffers, n.id, cv)
      }
      return this.inpaintMaskBuffers[n.id]
    },
    /** 缓存的棋盘 pattern（createPattern） */
    _inpaintCheckerPattern() {
      if (this._ngcInpaintCheckerPat) return this._ngcInpaintCheckerPat
      const c = INPAINT_CHECKER_CELL
      const tile = document.createElement('canvas')
      tile.width = c * 2
      tile.height = c * 2
      const x = tile.getContext('2d')
      x.fillStyle = '#e0e0e0'
      x.fillRect(0, 0, c, c)
      x.fillRect(c, c, c, c)
      x.fillStyle = '#ffffff'
      x.fillRect(c, 0, c, c)
      x.fillRect(0, c, c, c)
      this._ngcInpaintCheckerPat = x.createPattern(tile, 'repeat')
      return this._ngcInpaintCheckerPat
    },
    /**
     * 根据离屏蒙版把「洞口」画成棋盘格；保留区画布像素全透明，底图完全清晰。
     * 先在离屏 scratch 上画满再一次性 blit 到显示 canvas，避免 clearRect 当帧露出底图造成「笔画闪一下没了」。
     */
    _inpaintCompositeDisplay(n, surface) {
      const surf = surface || (this.inpaintOnlineEditorNodeId === n.id ? 'modal' : 'inline')
      const el = this._getInpaintSurfaceElements(n, surf)
      const maskCv = this._getInpaintMaskCanvas(n)
      if (!el || !maskCv || maskCv.width < 1 || maskCv.height < 1) return
      const { cv: dcv } = el
      const mw = maskCv.width
      const mh = maskCv.height
      const dimsClose = (a, b) =>
        a === b || (Math.abs(a - b) <= 2 && Math.min(a, b) >= 1)

      let holeCv = this._inpaintHoleScratch
      if (!holeCv) {
        holeCv = document.createElement('canvas')
        this._inpaintHoleScratch = holeCv
      }
      if (holeCv.width !== mw || holeCv.height !== mh) {
        holeCv.width = mw
        holeCv.height = mh
      }
      const md = maskCv.getContext('2d', INPAINT_2D_CTX).getImageData(0, 0, mw, mh)
      const hctx = holeCv.getContext('2d')
      const hd = hctx.createImageData(mw, mh)
      const u = md.data
      const o = hd.data
      for (let i = 0; i < u.length; i += 4) {
        const hole = !this._inpaintRgbNearPreserveMask(u[i], u[i + 1], u[i + 2], u[i + 3])
        const a = hole ? 255 : 0
        o[i] = 255
        o[i + 1] = 255
        o[i + 2] = 255
        o[i + 3] = a
      }
      /** 矩形拖拽中：并入选区为洞；与下方描边共用同一套整数像素边界，避免与 float 描边错 1px 出黑缝 */
      const rs = this.inpaintRectSession
      let rectHoleXa = 0
      let rectHoleYa = 0
      let rectHoleXb = 0
      let rectHoleYb = 0
      let rectHoleOk = false
      if (rs && rs.n && String(rs.n.id) === String(n.id) && rs.x0 != null && rs.y0 != null) {
        const rx1 = rs.x1 != null ? rs.x1 : rs.x0
        const ry1 = rs.y1 != null ? rs.y1 : rs.y0
        rectHoleXa = Math.max(0, Math.floor(Math.min(rs.x0, rx1)))
        rectHoleYa = Math.max(0, Math.floor(Math.min(rs.y0, ry1)))
        rectHoleXb = Math.min(mw, Math.ceil(Math.max(rs.x0, rx1)))
        rectHoleYb = Math.min(mh, Math.ceil(Math.max(rs.y0, ry1)))
        rectHoleOk = rectHoleXb > rectHoleXa && rectHoleYb > rectHoleYa
        if (rectHoleOk) {
          for (let py = rectHoleYa; py < rectHoleYb; py++) {
            let row = (py * mw + rectHoleXa) * 4
            for (let px = rectHoleXa; px < rectHoleXb; px++) {
              o[row + 3] = 255
              row += 4
            }
          }
        }
      }
      hctx.putImageData(hd, 0, 0)

      let scratch = this._inpaintDispScratch
      if (!scratch) {
        scratch = document.createElement('canvas')
        this._inpaintDispScratch = scratch
      }
      if (scratch.width !== mw || scratch.height !== mh) {
        scratch.width = mw
        scratch.height = mh
      }
      const sctx = scratch.getContext('2d', INPAINT_2D_CTX)
      sctx.imageSmoothingEnabled = false
      const pat = this._inpaintCheckerPattern()
      if (!pat) return
      sctx.globalCompositeOperation = 'source-over'
      sctx.clearRect(0, 0, mw, mh)
      sctx.fillStyle = pat
      sctx.fillRect(0, 0, mw, mh)
      sctx.globalCompositeOperation = 'destination-in'
      sctx.drawImage(holeCv, 0, 0)
      sctx.globalCompositeOperation = 'source-over'
      /** 选区描边：与洞边界同一整数框 + 向内缩进，避免 stroke 跨洞/底图接缝产生 1px 黑边 */
      if (rectHoleOk && rs && rs.n && String(rs.n.id) === String(n.id)) {
        const rwI = rectHoleXb - rectHoleXa
        const rhI = rectHoleYb - rectHoleYa
        const scale = Math.min(mw, mh)
        const lineW = Math.max(1, Math.min(2.5, Math.round(scale * 0.0055)))
        const inset = lineW + 1.5
        if (rwI > inset * 2 + 2 && rhI > inset * 2 + 2) {
          sctx.save()
          sctx.lineJoin = 'miter'
          sctx.lineCap = 'butt'
          sctx.strokeStyle = 'rgba(51, 65, 85, 0.78)'
          sctx.lineWidth = lineW
          const sx = rectHoleXa + inset
          const sy = rectHoleYa + inset
          const sw = rwI - 2 * inset
          const sh = rhI - 2 * inset
          sctx.strokeRect(sx + lineW * 0.5, sy + lineW * 0.5, sw - lineW, sh - lineW)
          sctx.restore()
        }
      }

      /**
       * 必须先完成离屏 scratch，最后再改 dcv.width/height（否则会清空显示位图）。
       * 若先清空再跑 getImageData/像素循环，浏览器可能在长时间同步 JS 期间把空白 canvas 合成一帧 → 「画完一闪没了」。
       */
      if (!dimsClose(dcv.width, mw) || !dimsClose(dcv.height, mh)) {
        dcv.width = mw
        dcv.height = mh
      }
      const dctx = dcv.getContext('2d', INPAINT_2D_CTX)
      dctx.imageSmoothingEnabled = false
      dctx.globalCompositeOperation = 'source-over'
      /** scratch 洞外为全透明，source-over 不会盖住旧像素 → 矩形拖动会叠出多重影 */
      dctx.clearRect(0, 0, dcv.width, dcv.height)
      dctx.drawImage(scratch, 0, 0)
    },
    /** 蒙版变更后立即刷新预览（勿用 rAF 推迟，否则笔画晚一帧显示、像闪一下消失） */
    _inpaintAfterMaskMutation(n) {
      if (!n || !n.id) return
      const surf = this.inpaintOnlineEditorNodeId === n.id ? 'modal' : 'inline'
      this._inpaintCompositeDisplay(n, surf)
    },
    /**
     * 窗口缩放 / 侧栏变化后重算蒙版 CSS 位置与尺寸，避免 canvas 与底图错位导致「有时看不见笔触」。
     */
    syncActiveInpaintSurfacesOnResize() {
      if (typeof window === 'undefined') return
      this.viewLayoutTick = (this.viewLayoutTick || 0) + 1
      if (this._inpaintWinResizeRaf) cancelAnimationFrame(this._inpaintWinResizeRaf)
      this._inpaintWinResizeRaf = requestAnimationFrame(() => {
        this._inpaintWinResizeRaf = 0
        try {
          for (const n of this.nodes) {
            if (!n || n.type !== 'image' || !n.data || !n.data.imageInpaintMode) continue
            const surf = this.inpaintOnlineEditorNodeId === n.id ? 'modal' : 'inline'
            this.syncInpaintCanvasSize(n, surf)
          }
        } catch (_) {}
      })
    },
    /**
     * 任何可能触发大范围 Vue 重绘的操作之后（云端保存、列表刷新、applyState 等），
     * 按离屏蒙版重新对齐尺寸并合成棋盘层，避免显示 canvas 被替换后只剩空白或旧帧。
     */
    _resyncAllInpaintSurfaces() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          try {
            for (const n of this.nodes) {
              if (!n || n.type !== 'image' || !n.data || !n.data.imageInpaintMode) continue
              const surf = this.inpaintOnlineEditorNodeId === n.id ? 'modal' : 'inline'
              this.syncInpaintCanvasSize(n, surf)
              this._inpaintCompositeDisplay(n, surf)
            }
          } catch (_) {}
        })
      })
    },
    /**
     * 画布状态从存储恢复后：内存中的蒙版缓冲已丢失并会按需重建；延迟一拍对齐底图并合成预览，
     * 避免占位蒙版为透明时拉伸成全图「洞」→ 仅棋盘格盖住底图。
     */
    resyncInpaintNodesAfterProjectLoad() {
      this._resyncAllInpaintSurfaces()
    },
    /**
     * 切换画笔/矩形/橡皮：取消未完成的拖拽，并在 Vue 更新布局后重新对齐+合成棋盘层，避免工具条重绘时预览闪一下消失。
     */
    setInpaintDrawTool(n, tool) {
      if (!n || !n.data) return
      const tid = n.id
      if (this.inpaintRectSession && this.inpaintRectSession.n && this.inpaintRectSession.n.id === tid) {
        this.inpaintRectSession = null
        this._unbindInpaintDocListeners()
      }
      if (this.inpaintStrokeSession && this.inpaintStrokeSession.n && this.inpaintStrokeSession.n.id === tid) {
        this.inpaintStrokeSession = null
        this._unbindInpaintDocListeners()
      }
      this.$set(n.data, 'inpaintDrawTool', tool)
      if (!n.data.imageInpaintMode) return
      this.$nextTick(() => {
        const surf = this.inpaintOnlineEditorNodeId === n.id ? 'modal' : 'inline'
        this.syncInpaintCanvasSize(n, surf)
        this._inpaintCompositeDisplay(n, surf)
      })
    },
    /**
     * 对齐蒙版画布与底图 img 的显示区域。
     * 注意：对 canvas 设置 width/height 会清空位图；若尺寸未变则绝不能赋值，否则每笔 pointerdown 都会 wipe（表现为「画了没反应」）。
     */
    syncInpaintCanvasSize(n, surface) {
      let surf =
        surface || (this.inpaintOnlineEditorNodeId === n.id ? 'modal' : 'inline')
      /** 大屏正在编辑该节点时，禁止按卡片 inline 表面缩放共享蒙版（否则缩略图尺寸会冲掉 modal 上刚画的笔触） */
      if (surf === 'inline' && this.inpaintOnlineEditorNodeId === n.id) {
        surf = 'modal'
      }
      const el = this._getInpaintSurfaceElements(n, surf)
      if (!el) return
      const { wrap, img, cv: dcv } = el

      const maskCv = this._getInpaintMaskCanvas(n)
      if (!maskCv) return
      const ow = maskCv.width
      const oh = maskCv.height

      /** 优先 offset：pointerdown 当帧 getBoundingClientRect 偶发 0～1px，若据此缩放蒙版会整张变成「小块棋盘拉伸铺满」 */
      let left
      let top
      let w
      let h
      if (img.offsetParent === wrap) {
        left = img.offsetLeft
        top = img.offsetTop
        w = Math.max(1, Math.round(img.offsetWidth))
        h = Math.max(1, Math.round(img.offsetHeight))
        if (w < 8 || h < 8) {
          const ir = img.getBoundingClientRect()
          const rw = Math.max(1, Math.round(ir.width))
          const rh = Math.max(1, Math.round(ir.height))
          if (rw >= 8 && rh >= 8) {
            w = rw
            h = rh
          }
        }
      } else {
        const ir = img.getBoundingClientRect()
        const wr = wrap.getBoundingClientRect()
        left = Math.round(ir.left - wr.left + wrap.scrollLeft)
        top = Math.round(ir.top - wr.top + wrap.scrollTop)
        w = Math.max(1, Math.round(ir.width))
        h = Math.max(1, Math.round(ir.height))
        if (w < 8 || h < 8) {
          const cw = Math.max(1, Math.round(img.clientWidth || 0))
          const ch = Math.max(1, Math.round(img.clientHeight || 0))
          if (cw >= 8 && ch >= 8) {
            w = cw
            h = ch
          } else {
            const owi = Math.max(1, Math.round(img.offsetWidth))
            const ohi = Math.max(1, Math.round(img.offsetHeight))
            if (owi >= 8 && ohi >= 8) {
              w = owi
              h = ohi
            }
          }
        }
      }

      const MIN_SYNC_PX = 8
      if ((w < MIN_SYNC_PX || h < MIN_SYNC_PX) && ow >= 32 && oh >= 32) {
        return { needReset: false, cv: dcv }
      }

      dcv.style.left = `${left}px`
      dcv.style.top = `${top}px`
      dcv.style.width = `${w}px`
      dcv.style.height = `${h}px`
      /** 避免 pointerdown+mousedown 两次 sync 时因取整差 1px 反复改 width/height 清空位图 */
      const dimsClose = (a, b) =>
        a === b || (Math.abs(a - b) <= 2 && Math.min(a, b) >= 1)
      if (dimsClose(ow, w) && dimsClose(oh, h)) {
        /**
         * 显示 canvas 的位图尺寸必须与离屏蒙版一致；不要用布局 w、h 赋给 canvas.width，
         * 否则 ow≈w 差 1px 时会：sync 把 dcv 改成 w → composite 又按 mask 改回 ow → 反复清空闪烁。
         * CSS 仍用布局 w×h 拉伸，坐标换算用 getBoundingClientRect，与位图分辨率无关。
         */
        const dimBitmap = (a, b) =>
          a === b || (Math.abs(a - b) <= 2 && Math.min(a, b) >= 1)
        const mw = maskCv.width
        const mh = maskCv.height
        let clearedBitmap = false
        if (!dimBitmap(dcv.width, mw) || !dimBitmap(dcv.height, mh)) {
          dcv.width = mw
          dcv.height = mh
          clearedBitmap = true
        }
        if (clearedBitmap) {
          this._inpaintCompositeDisplay(n, surf)
        }
        return { needReset: false, cv: dcv }
      }

      const mctx = maskCv.getContext('2d', INPAINT_2D_CTX)
      if (!mctx) return { needReset: false, cv: dcv }

      if (ow >= 1 && oh >= 1 && n.data && n.data.imageInpaintMode) {
        const tmp = document.createElement('canvas')
        tmp.width = ow
        tmp.height = oh
        tmp.getContext('2d').drawImage(maskCv, 0, 0)
        maskCv.width = w
        maskCv.height = h
        mctx.drawImage(tmp, 0, 0, ow, oh, 0, 0, w, h)
      } else {
        maskCv.width = w
        maskCv.height = h
        if (n.data && n.data.imageInpaintMode) {
          this._inpaintFillMaskPreserveWhite(mctx, w, h)
        }
      }
      const mw = maskCv.width
      const mh = maskCv.height
      if (!dimsClose(dcv.width, mw) || !dimsClose(dcv.height, mh)) {
        dcv.width = mw
        dcv.height = mh
      }
      this._inpaintCompositeDisplay(n, surf)
      return { needReset: true, cv: dcv }
    },
    /** 离屏蒙版：整块纯白表示「全部保留」 */
    _inpaintFillMaskPreserveWhite(ctx, w, h) {
      if (!ctx || w < 1 || h < 1) return
      ctx.setTransform(1, 0, 0, 1, 0, 0)
      ctx.globalAlpha = 1
      ctx.globalCompositeOperation = 'source-over'
      ctx.fillStyle = INPAINT_MASK_PRESERVE_WHITE
      ctx.fillRect(0, 0, w, h)
    },
    initInpaintCanvas(n, surface) {
      const surf = surface != null ? surface : 'inline'
      const el = this._getInpaintSurfaceElements(n, surf)
      if (!el || !n.data.imageInpaintMode) return
      const sync = this.syncInpaintCanvasSize(n, surf)
      if (!sync) return
      const maskCv = this._getInpaintMaskCanvas(n)
      const ctx = maskCv && maskCv.getContext('2d', INPAINT_2D_CTX)
      if (!ctx || maskCv.width < 1) return
      this._inpaintFillMaskPreserveWhite(ctx, maskCv.width, maskCv.height)
      const snap = ctx.getImageData(0, 0, maskCv.width, maskCv.height)
      this.inpaintUndoStacks[n.id] = { snapshots: [snap], idx: 0 }
      this.inpaintRedoStacks[n.id] = []
      this._inpaintCompositeDisplay(n, surf)
    },
    /**
     * 兼容旧版雾层 / 淡紫：统一压成纯白 opaque，便于棋盘预览与导出。
     */
    _inpaintNormalizePreserveTint(ctx, w, h) {
      if (!ctx || w < 1 || h < 1) return
      const d = ctx.getImageData(0, 0, w, h)
      const u = d.data
      for (let i = 0; i < u.length; i += 4) {
        const r = u[i]
        const g = u[i + 1]
        const b = u[i + 2]
        const a = u[i + 3]
        if (this._inpaintRgbNearPreserveMask(r, g, b, a)) {
          u[i] = 255
          u[i + 1] = 255
          u[i + 2] = 255
          u[i + 3] = 255
        }
      }
      ctx.putImageData(d, 0, 0)
    },
    /** 蒙版像素属于「保留区」（纯白opaque / 旧版雾层 / 淡紫） */
    _inpaintRgbNearPreserveMask(r, g, b, a) {
      if (a < 10) return false
      if (a > 215 && r > 242 && g > 242 && b > 242) return true
      if (a >= 10 && a <= 95 && r > 235 && g > 235 && b > 235) return true
      const pr = 0xdd
      const pg = 0xd6
      const pb = 0xfe
      if (
        Math.abs(r - pr) < 48 &&
        Math.abs(g - pg) < 48 &&
        Math.abs(b - pb) < 48 &&
        a > 35
      ) {
        return true
      }
      if (r > 245 && g > 245 && b > 245 && a > 95 && a < 230) return true
      return false
    },
    /** 导出 API 蒙版时：true 表示该像素对应「要重绘」→ PNG 里写透明 */
    _inpaintPixelExportsTransparentInMask(r, g, b, a) {
      if (a < 10) return true
      if (this._inpaintRgbNearPreserveMask(r, g, b, a)) return false
      return true
    },
    _cloneImageData(d) {
      if (!d || !d.data) return d
      const c = new ImageData(new Uint8ClampedArray(d.data), d.width, d.height)
      return c
    },
    _getInpaintHist(n) {
      if (!n || !n.id) return { snapshots: [], idx: 0 }
      const stacks = this.inpaintUndoStacks
      if (!stacks) return { snapshots: [], idx: 0 }
      return stacks[n.id] || { snapshots: [], idx: 0 }
    },
    _commitInpaintStrokeEnd(n) {
      if (!n || !n.id) return
      const maskCv = this._getInpaintMaskCanvas(n)
      if (!maskCv) return
      const ctx = maskCv.getContext('2d', INPAINT_2D_CTX)
      const cur = ctx.getImageData(0, 0, maskCv.width, maskCv.height)
      const h = this._getInpaintHist(n)
      const snaps = (h.snapshots || []).slice(0, h.idx + 1)
      snaps.push(this._cloneImageData(cur))
      const maxSnaps = 22
      let idx = snaps.length - 1
      while (snaps.length > maxSnaps) {
        snaps.shift()
        idx = snaps.length - 1
      }
      this.inpaintUndoStacks[n.id] = { snapshots: snaps, idx }
    },
    inpaintUndo(n) {
      const h = this._getInpaintHist(n)
      if (h.idx <= 0) return
      const maskCv = this._getInpaintMaskCanvas(n)
      if (!maskCv) return
      const nextIdx = h.idx - 1
      const d = h.snapshots[nextIdx]
      maskCv.getContext('2d', INPAINT_2D_CTX).putImageData(d, 0, 0)
      this.inpaintUndoStacks[n.id] = { snapshots: h.snapshots, idx: nextIdx }
      this._inpaintAfterMaskMutation(n)
    },
    inpaintRedo(n) {
      const h = this._getInpaintHist(n)
      if (h.idx >= h.snapshots.length - 1) return
      const maskCv = this._getInpaintMaskCanvas(n)
      if (!maskCv) return
      const nextIdx = h.idx + 1
      const d = h.snapshots[nextIdx]
      maskCv.getContext('2d', INPAINT_2D_CTX).putImageData(d, 0, 0)
      this.inpaintUndoStacks[n.id] = { snapshots: h.snapshots, idx: nextIdx }
      this._inpaintAfterMaskMutation(n)
    },
    /**
     * 等待大屏里底图完成布局，避免蒙版 canvas 仅 1px 导致点击全落在「空白区」、完全无反应。
     */
    waitInpaintModalLayoutReady(n) {
      return new Promise(resolve => {
        let frames = 0
        const max = 90
        const step = () => {
          this.syncInpaintCanvasSize(n, 'modal')
          const modal = this._getInpaintSurfaceElements(n, 'modal')
          const img = modal && modal.img
          const ir = img ? img.getBoundingClientRect() : { width: 0, height: 0 }
          const cv = modal && modal.cv
          const ok =
            cv && cv.width >= 32 && cv.height >= 32 && ir.width >= 32 && ir.height >= 32
          if (ok || frames++ >= max) {
            resolve(ok)
            return
          }
          requestAnimationFrame(step)
        }
        requestAnimationFrame(step)
      })
    },
    onInpaintModalBaseImgLoad(n) {
      if (!n || this.inpaintOnlineEditorNodeId !== n.id) return
      this.$nextTick(() => {
        this.syncInpaintCanvasSize(n, 'modal')
      })
    },
    /**
     * 卡片内预览图 load：大屏在线编辑时蒙版位图与 modal 底图对齐，勿再用 inline 尺寸去缩放共享 mask（会把第一笔抹掉/闪没）。
     */
    onInpaintInlineBaseImgLoad(n) {
      if (!n || !n.data || !n.data.imageInpaintMode) return
      if (this.inpaintOnlineEditorNodeId === n.id) return
      this.$nextTick(() => {
        this.syncInpaintCanvasSize(n, 'inline')
      })
    },
    /**
     * 屏幕坐标 → 蒙版位图坐标所用的「可见内容」矩形。
     * 显示 canvas 常带 width:0;height:0 直至 sync 完成，此时 getBoundingClientRect 近 0×0，
     * 若仍用 Math.max(w,1) 映射会把整段位移压进 1px → 坐标锁在 (0,0)、矩形预览缩成左上角红点。
     */
    _inpaintScreenMapRect(el) {
      if (!el || !el.cv) return null
      const cr = el.cv.getBoundingClientRect()
      if (cr.width >= 4 && cr.height >= 4) {
        return { left: cr.left, top: cr.top, width: cr.width, height: cr.height }
      }
      if (el.img) {
        const ir = el.img.getBoundingClientRect()
        if (ir.width >= 4 && ir.height >= 4) {
          return { left: ir.left, top: ir.top, width: ir.width, height: ir.height }
        }
        if (cr.width < 1 && cr.height < 1 && ir.width > 0 && ir.height > 0) {
          return { left: ir.left, top: ir.top, width: ir.width, height: ir.height }
        }
      }
      if (cr.width > 0 && cr.height > 0) {
        return { left: cr.left, top: cr.top, width: cr.width, height: cr.height }
      }
      return null
    },
    _inpaintCanvasCoords(n, clientX, clientY) {
      const el = this._getInpaintElements(n)
      if (!el || !el.cv) return null
      const map = this._inpaintScreenMapRect(el)
      if (!map) return null
      let cw = el.cv.width
      let ch = el.cv.height
      /** 显示 canvas 位图尚未赋值时 width/height 为 0，用离屏蒙版逻辑尺寸映射，否则矩形 move/up 会得到 null 无法落笔 */
      if (cw < 1 || ch < 1) {
        const m = this._getInpaintMaskCanvas(n)
        if (m && m.width >= 1 && m.height >= 1) {
          cw = m.width
          ch = m.height
        } else {
          return null
        }
      }
      let x = ((clientX - map.left) / Math.max(map.width, 1e-6)) * cw
      let y = ((clientY - map.top) / Math.max(map.height, 1e-6)) * ch
      x = Math.max(0, Math.min(cw, x))
      y = Math.max(0, Math.min(ch, y))
      return { x, y, cv: el.cv }
    },
    /** 单段笔画蒙版距离上限：合并指针 / coalesced 中偶发异常坐标会拉到画布角，画出横穿整图的斜线 */
    _inpaintMaxStrokeJumpPx(n) {
      const maskCv = this._getInpaintMaskCanvas(n)
      const mw = maskCv ? maskCv.width : 0
      const mh = maskCv ? maskCv.height : 0
      const brushPx = Math.max(4, Number(n && n.data && n.data.inpaintBrushSize) || 28)
      if (mw < 2 || mh < 2) return 320
      const diag = Math.hypot(mw, mh)
      return Math.min(
        diag * 0.42,
        Math.max(brushPx * 14, Math.min(mw, mh) * 0.38)
      )
    },
    /** 插值补笔：快速拖动时指针事件稀疏，单段直线会在蒙版上留下透明空洞 */
    _inpaintPaintStrokeInterpolated(n, x1, y1, x2, y2, erase) {
      const w = Math.max(2, Number(n.data.inpaintBrushSize) || 28)
      const step = Math.max(1.2, w * 0.22)
      const dx = x2 - x1
      const dy = y2 - y1
      const dist = Math.hypot(dx, dy)
      if (dist < 0.25) return
      const maxJump = this._inpaintMaxStrokeJumpPx(n)
      if (dist > maxJump) {
        this._inpaintPaintDot(n, x2, y2, erase, true)
        return
      }
      const steps = Math.min(640, Math.max(1, Math.ceil(dist / step)))
      let px = x1
      let py = y1
      for (let i = 1; i <= steps; i++) {
        const t = i / steps
        const nx = x1 + dx * t
        const ny = y1 + dy * t
        this._inpaintPaintLine(n, px, py, nx, ny, erase, false)
        px = nx
        py = ny
      }
      this._inpaintAfterMaskMutation(n)
    },
    /** 提示词/文本框聚焦时不抢快捷键 */
    _inpaintKeyboardBlocksBrush(target) {
      const t = target
      if (!t) return false
      if (t.isContentEditable) return true
      const tag = t.tagName
      if (tag === 'TEXTAREA' || tag === 'SELECT') return true
      if (tag === 'INPUT') {
        const ty = String(t.type || 'text').toLowerCase()
        if (['text', 'search', 'url', 'password', 'email', 'number', 'tel'].includes(ty)) return true
      }
      if (t.closest && t.closest('[data-prompt-editor]')) return true
      return false
    },
    /** 当前正在编辑蒙版的图片节点（大屏优先） */
    _activeInpaintImageNode() {
      if (this.inpaintOnlineEditorNode) return this.inpaintOnlineEditorNode
      for (const n of this.nodes) {
        if (n && n.type === 'image' && n.data && n.data.imageInpaintMode) return n
      }
      return null
    },
    /** Alt + 滚轮 调整笔刷；在蒙版画布上滚动但仍需改笔刷时用 */
    inpaintWrapWheel(e, n) {
      if (!n || !n.data || !n.data.imageInpaintMode) return
      if (!e.altKey) return
      if (e.cancelable) e.preventDefault()
      const cur = Math.round(Number(n.data.inpaintBrushSize) || 28)
      const delta = e.deltaY > 0 ? -2 : 2
      const next = Math.min(128, Math.max(2, cur + delta))
      this.$set(n.data, 'inpaintBrushSize', next)
    },
    /** 文档级拖拽：mousemove / touchmove */
    _inpaintDocClientXYMove(e) {
      if (e.touches && e.touches[0]) {
        return { x: e.touches[0].clientX, y: e.touches[0].clientY }
      }
      return { x: e.clientX, y: e.clientY }
    },
    /** mouseup / touchend */
    _inpaintDocClientXYUp(e) {
      if (e.changedTouches && e.changedTouches[0]) {
        return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY }
      }
      return { x: e.clientX, y: e.clientY }
    },
    /**
     * 在包裹层上接指针事件：按底图 img 的屏幕矩形判断是否点在图上，再强制以 canvas 为 capture 目标。
     * 解决 canvas 与 img 不同步时「整块区域点不到」；canvas 本身 pointer-events-none，事件由 wrap 统一处理。
     */
    /**
     * 预览区：仅「局部重绘」开启时拦截指针并交给 inpaint；否则不 stop，以便冒泡到外层 onNodeDown 拖节点。
     */
    onImageNodeInpaintSurfacePointerDown(e, n, surface) {
      if (!n || !n.data || !n.data.imageInpaintMode) return
      e.stopPropagation()
      if (e.cancelable) e.preventDefault()
      this.inpaintWrapPointerDown(e, n, surface)
    },
    inpaintWrapPointerDown(e, n, surface) {
      if (typeof window !== 'undefined' && window.PointerEvent) {
        if (e.type === 'mousedown') return
      }
      if (!n || !n.data || !n.data.imageInpaintMode) return
      if (e.button != null && e.button !== 0) return
      const wrapEl = e.currentTarget
      if (!wrapEl || !wrapEl.querySelector) return
      const img = wrapEl.querySelector('img[data-ngc-inpaint-base-img]')
      const cv = wrapEl.querySelector('canvas[data-ngc-inpaint-canvas]')
      if (!img || !cv) return
      const ir = img.getBoundingClientRect()
      const x = e.clientX
      const y = e.clientY
      const pad = 3
      if (x < ir.left - pad || x > ir.right + pad || y < ir.top - pad || y > ir.bottom + pad) return
      this.syncInpaintCanvasSize(n, surface)
      /** 在 wrap 上 capture：显示 canvas 为 pointer-events-none，对其 setPointerCapture 部分环境会收不到 move/up，矩形拖不动 */
      const synthetic = {
        type: e.type,
        clientX: x,
        clientY: y,
        button: e.button,
        pointerId: e.pointerId,
        currentTarget: wrapEl,
        target: wrapEl,
        preventDefault: () => {
          if (e.cancelable) e.preventDefault()
        },
        stopPropagation: () => e.stopPropagation()
      }
      this.inpaintPointerDown(n, synthetic)
    },
    inpaintPointerDown(n, e) {
      /** 现代浏览器：pointerdown 后会再发 mousedown，二次 sync 曾导致画布被清空 */
      if (typeof window !== 'undefined' && window.PointerEvent) {
        if (e.type === 'mousedown' || e.type === 'touchstart') return
      }
      if (!n || !n.data || !n.data.imageInpaintMode) return
      if (e.button != null && e.button !== 0) return

      const tool = n.data.inpaintDrawTool || 'brush'
      const surf = this.inpaintOnlineEditorNodeId === n.id ? 'modal' : 'inline'
      this.syncInpaintCanvasSize(n, surf)

      const maskCv = this._getInpaintMaskCanvas(n)
      const brushPx = Math.max(4, Number(n.data.inpaintBrushSize) || 28)
      /** 矩形选区与笔刷粗细无关，勿用大笔刷阈值卡 layout，否则易 defer → 矩形拖不动 / 松手才出现 */
      const minBitmap =
        tool === 'rect'
          ? 8
          : Math.max(8, Math.ceil(brushPx))
      const layoutBad =
        !maskCv || maskCv.width < minBitmap || maskCv.height < minBitmap
      const pos = this._inpaintCanvasCoords(n, e.clientX, e.clientY)

      if ((layoutBad || !pos) && !e._ngcInpaintLayoutRetry) {
        const e2 = { ...e, _ngcInpaintLayoutRetry: true }
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.syncInpaintCanvasSize(n, surf)
            this.inpaintPointerDown(n, e2)
          })
        })
        return
      }
      if (!pos) return

      const target = e.currentTarget || e.target
      const ptrId = typeof e.pointerId === 'number' ? e.pointerId : null
      /** 矩形拖拽依赖 window 级监听；勿对 wrap capture，否则部分浏览器下 move 到子元素/外沿时收不到事件 */
      if (
        tool !== 'rect' &&
        target &&
        target.setPointerCapture &&
        ptrId != null &&
        !Number.isNaN(ptrId)
      ) {
        try {
          target.setPointerCapture(ptrId)
        } catch (_) {}
      }
      if (tool === 'rect') {
        this.inpaintRectSession = {
          n,
          x0: pos.x,
          y0: pos.y,
          /** 不按 pointerId 过滤文档级 move/up（多源事件 id 不一致时矩形会拖不动） */
          pointerId: null,
          /** 仅用于 releasePointerCapture；与 pointerId 分离 */
          capturePointerId: ptrId,
          captureEl: target
        }
        this._bindInpaintDocListeners()
        /** 与画笔一致：立即合成一帧，避免依赖 $forceUpdate 整树重绘（会换掉 canvas DOM、擦掉刚画的棋盘格） */
        this._inpaintCompositeDisplay(n, surf)
        return
      }
      this.inpaintStrokeSession = {
        n,
        tool,
        lastX: pos.x,
        lastY: pos.y,
        pointerId: ptrId,
        captureEl: target
      }
      this._bindInpaintDocListeners()
      this._inpaintPaintDot(n, pos.x, pos.y, tool === 'erase')
    },
    _inpaintPaintDot(n, x, y, erase, flushComposite = true) {
      const maskCv = this._getInpaintMaskCanvas(n)
      if (!maskCv) return
      const ctx = maskCv.getContext('2d', INPAINT_2D_CTX)
      const r = Math.max(2, Number(n.data.inpaintBrushSize) / 2 || 14)
      ctx.beginPath()
      ctx.arc(x, y, r, 0, Math.PI * 2)
      if (erase) {
        ctx.globalCompositeOperation = 'source-over'
        ctx.globalAlpha = 1
        ctx.fillStyle = INPAINT_MASK_PRESERVE_WHITE
        ctx.fill()
      } else {
        ctx.globalCompositeOperation = 'destination-out'
        ctx.globalAlpha = 1
        ctx.fillStyle = 'rgba(0,0,0,1)'
        ctx.fill()
      }
      if (flushComposite) this._inpaintAfterMaskMutation(n)
    },
    _inpaintPaintLine(n, x1, y1, x2, y2, erase, flushComposite = true) {
      const maskCv = this._getInpaintMaskCanvas(n)
      if (!maskCv) return
      const ctx = maskCv.getContext('2d', INPAINT_2D_CTX)
      const w = Math.max(2, Number(n.data.inpaintBrushSize) || 28)
      ctx.lineCap = 'round'
      ctx.lineJoin = 'round'
      ctx.lineWidth = w
      if (erase) {
        ctx.globalCompositeOperation = 'source-over'
        ctx.strokeStyle = INPAINT_MASK_PRESERVE_WHITE
        ctx.globalAlpha = 1
        ctx.beginPath()
        ctx.moveTo(x1, y1)
        ctx.lineTo(x2, y2)
        ctx.stroke()
      } else {
        ctx.globalCompositeOperation = 'destination-out'
        ctx.strokeStyle = 'rgba(0,0,0,1)'
        ctx.globalAlpha = 1
        ctx.beginPath()
        ctx.moveTo(x1, y1)
        ctx.lineTo(x2, y2)
        ctx.stroke()
      }
      if (flushComposite) this._inpaintAfterMaskMutation(n)
    },
    _bindInpaintDocListeners() {
      if (this.inpaintDocMoveHandler || this.inpaintDocUpHandler) {
        this._unbindInpaintDocListeners()
      }
      this.inpaintDocMoveHandler = e => {
        const d = this.inpaintStrokeSession
        const r = this.inpaintRectSession
        if (!d && !r) return
        const pid = typeof e.pointerId === 'number' ? e.pointerId : null
        if (
          d &&
          d.pointerId != null &&
          pid != null &&
          pid !== d.pointerId
        ) {
          return
        }
        if (
          r &&
          r.pointerId != null &&
          pid != null &&
          pid !== r.pointerId
        ) {
          return
        }
        if (d && d.n) {
          const raw = typeof e.getCoalescedEvents === 'function' ? e.getCoalescedEvents() : null
          let events = raw && raw.length ? raw.slice() : [e]
          if (events.length > 1) {
            events.sort((a, b) => (a.timeStamp || 0) - (b.timeStamp || 0))
          }
          const maxJump = this._inpaintMaxStrokeJumpPx(d.n)
          let lx = d.lastX
          let ly = d.lastY
          for (const ev of events) {
            const { x: cx, y: cy } = this._inpaintDocClientXYMove(ev)
            const pos = this._inpaintCanvasCoords(d.n, cx, cy)
            if (!pos) continue
            if (d.tool === 'brush' || d.tool === 'erase') {
              const dj = Math.hypot(pos.x - lx, pos.y - ly)
              if (dj > maxJump) {
                lx = pos.x
                ly = pos.y
                continue
              }
              this._inpaintPaintStrokeInterpolated(d.n, lx, ly, pos.x, pos.y, d.tool === 'erase')
              lx = pos.x
              ly = pos.y
            }
          }
          d.lastX = lx
          d.lastY = ly
        } else if (r && r.n) {
          const { x: cx, y: cy } = this._inpaintDocClientXYMove(e)
          let pos = this._inpaintCanvasCoords(r.n, cx, cy)
          if (pos) {
            if (e.shiftKey) {
              const dx = pos.x - r.x0
              const dy = pos.y - r.y0
              const s = Math.max(Math.abs(dx), Math.abs(dy))
              const sx = pos.x >= r.x0 ? 1 : -1
              const sy = pos.y >= r.y0 ? 1 : -1
              pos = { ...pos, x: r.x0 + sx * s, y: r.y0 + sy * s }
            }
            this.$set(r, 'x1', pos.x)
            this.$set(r, 'y1', pos.y)
            const surf = this.inpaintOnlineEditorNodeId === r.n.id ? 'modal' : 'inline'
            /** 每步立即合成棋盘格；勿 $forceUpdate：整组件重绘可能替换 canvas，导致洞内预览直到切工具才出现 */
            this._inpaintCompositeDisplay(r.n, surf)
          }
        }
      }
      this.inpaintDocUpHandler = e => {
        const d = this.inpaintStrokeSession
        const r = this.inpaintRectSession
        const pid = typeof e.pointerId === 'number' ? e.pointerId : null
        const active = d || r
        if (
          active &&
          active.pointerId != null &&
          pid != null &&
          pid !== active.pointerId
        ) {
          return
        }
        const cap = d || r
        if (cap && cap.captureEl && cap.captureEl.releasePointerCapture) {
          const rid =
            pid != null && !Number.isNaN(pid)
              ? pid
              : typeof cap.capturePointerId === 'number' && !Number.isNaN(cap.capturePointerId)
                ? cap.capturePointerId
                : cap.pointerId != null && !Number.isNaN(cap.pointerId)
                  ? cap.pointerId
                  : null
          if (rid != null && !Number.isNaN(rid)) {
            try {
              cap.captureEl.releasePointerCapture(rid)
            } catch (_) {}
          }
        }
        const { x: ux, y: uy } = this._inpaintDocClientXYUp(e)
        try {
          if (r && r.n) {
            let pos = this._inpaintCanvasCoords(r.n, ux, uy)
            if (!pos && r.x1 != null && r.y1 != null) {
              pos = { x: r.x1, y: r.y1, cv: null }
            }
            if (!pos) pos = { x: r.x0, y: r.y0, cv: null }
            const maskCv = this._getInpaintMaskCanvas(r.n)
            if (maskCv && pos) {
              if (e.shiftKey) {
                const dx = pos.x - r.x0
                const dy = pos.y - r.y0
                const s = Math.max(Math.abs(dx), Math.abs(dy))
                const sx = pos.x >= r.x0 ? 1 : -1
                const sy = pos.y >= r.y0 ? 1 : -1
                pos = { ...pos, x: r.x0 + sx * s, y: r.y0 + sy * s }
              }
              const x0 = Math.min(r.x0, pos.x)
              const y0 = Math.min(r.y0, pos.y)
              const x1 = Math.max(r.x0, pos.x)
              const y1 = Math.max(r.y0, pos.y)
              const ctx = maskCv.getContext('2d', INPAINT_2D_CTX)
              const rw = Math.max(1, x1 - x0)
              const rh = Math.max(1, y1 - y0)
              ctx.globalCompositeOperation = 'destination-out'
              ctx.globalAlpha = 1
              ctx.fillStyle = 'rgba(0,0,0,1)'
              ctx.fillRect(x0, y0, rw, rh)
              this._inpaintAfterMaskMutation(r.n)
              this._commitInpaintStrokeEnd(r.n)
            }
          } else if (d && d.n) {
            const strokeNode = d.n
            /** 先刷新棋盘预览再写入撤销栈：避免 commit 触发的 Vue 更新替换 canvas 后出现空白帧 */
            this._inpaintAfterMaskMutation(strokeNode)
            this._commitInpaintStrokeEnd(strokeNode)
            this.$nextTick(() => {
              if (
                strokeNode &&
                strokeNode.data &&
                strokeNode.data.imageInpaintMode
              ) {
                this._inpaintAfterMaskMutation(strokeNode)
              }
              requestAnimationFrame(() => {
                if (
                  strokeNode &&
                  strokeNode.data &&
                  strokeNode.data.imageInpaintMode
                ) {
                  this._inpaintAfterMaskMutation(strokeNode)
                }
              })
            })
          }
        } finally {
          this.inpaintRectSession = null
          this.inpaintStrokeSession = null
          this._unbindInpaintDocListeners()
        }
      }
      const usePtr = typeof window !== 'undefined' && window.PointerEvent
      this.inpaintDocListenersPointer = usePtr
      const rectOnly = !!(this.inpaintRectSession && !this.inpaintStrokeSession)
      const win = typeof window !== 'undefined' ? window : null
      if (usePtr) {
        /** 矩形：window 捕获阶段监听，保证拖出 wrap、有 modal 遮罩时仍能收到 move/up */
        if (rectOnly && win) {
          this.inpaintRectListenerRoot = win
          win.addEventListener('pointermove', this.inpaintDocMoveHandler, true)
          win.addEventListener('pointerup', this.inpaintDocUpHandler, true)
          win.addEventListener('pointercancel', this.inpaintDocUpHandler, true)
          /** 与 pointer 并行：部分 Chromium/远程桌面只稳定投递 mousemove，矩形会拖不动 */
          win.addEventListener('mousemove', this.inpaintDocMoveHandler, true)
          win.addEventListener('mouseup', this.inpaintDocUpHandler, true)
        } else {
          this.inpaintRectListenerRoot = null
          document.addEventListener('pointermove', this.inpaintDocMoveHandler, true)
          document.addEventListener('pointerup', this.inpaintDocUpHandler, true)
          document.addEventListener('pointercancel', this.inpaintDocUpHandler, true)
        }
      } else {
        this.inpaintRectListenerRoot = null
        document.addEventListener('mousemove', this.inpaintDocMoveHandler, true)
        document.addEventListener('mouseup', this.inpaintDocUpHandler, true)
        this.inpaintDocTouchMoveHandler = e => {
          if (e.cancelable) e.preventDefault()
          this.inpaintDocMoveHandler(e)
        }
        this.inpaintDocTouchEndHandler = e => {
          if (e.cancelable) e.preventDefault()
          this.inpaintDocUpHandler(e)
        }
        document.addEventListener('touchmove', this.inpaintDocTouchMoveHandler, {
          passive: false,
          capture: true
        })
        document.addEventListener('touchend', this.inpaintDocTouchEndHandler, true)
        document.addEventListener('touchcancel', this.inpaintDocTouchEndHandler, true)
      }
    },
    _unbindInpaintDocListeners() {
      const usePtr = this.inpaintDocListenersPointer
      const wrapRoot = this.inpaintRectListenerRoot
      this.inpaintDocListenersPointer = false
      this.inpaintRectListenerRoot = null
      if (this.inpaintDocMoveHandler) {
        if (wrapRoot && usePtr) {
          wrapRoot.removeEventListener('pointermove', this.inpaintDocMoveHandler, true)
          wrapRoot.removeEventListener('mousemove', this.inpaintDocMoveHandler, true)
        } else if (usePtr) {
          document.removeEventListener('pointermove', this.inpaintDocMoveHandler, true)
        } else {
          document.removeEventListener('mousemove', this.inpaintDocMoveHandler, true)
        }
        this.inpaintDocMoveHandler = null
      }
      if (this.inpaintDocUpHandler) {
        if (wrapRoot && usePtr) {
          wrapRoot.removeEventListener('pointerup', this.inpaintDocUpHandler, true)
          wrapRoot.removeEventListener('pointercancel', this.inpaintDocUpHandler, true)
          wrapRoot.removeEventListener('mouseup', this.inpaintDocUpHandler, true)
        } else if (usePtr) {
          document.removeEventListener('pointerup', this.inpaintDocUpHandler, true)
          document.removeEventListener('pointercancel', this.inpaintDocUpHandler, true)
        } else {
          document.removeEventListener('mouseup', this.inpaintDocUpHandler, true)
        }
        this.inpaintDocUpHandler = null
      }
      if (!usePtr && this.inpaintDocTouchMoveHandler) {
        document.removeEventListener('touchmove', this.inpaintDocTouchMoveHandler, {
          passive: false,
          capture: true
        })
        this.inpaintDocTouchMoveHandler = null
      }
      if (!usePtr && this.inpaintDocTouchEndHandler) {
        document.removeEventListener('touchend', this.inpaintDocTouchEndHandler, true)
        document.removeEventListener('touchcancel', this.inpaintDocTouchEndHandler, true)
        this.inpaintDocTouchEndHandler = null
      }
    },
    inpaintMaskHasTransparentRegion(cv) {
      const ctx = cv.getContext('2d', INPAINT_2D_CTX)
      const { width: w, height: h } = cv
      if (w < 2 || h < 2) return false
      const stepX = Math.max(1, Math.floor(w / 64))
      const stepY = Math.max(1, Math.floor(h / 64))
      const d = ctx.getImageData(0, 0, w, h).data
      for (let y = 0; y < h; y += stepY) {
        for (let x = 0; x < w; x += stepX) {
          const i = (y * w + x) * 4
          const r = d[i]
          const g = d[i + 1]
          const b = d[i + 2]
          const a = d[i + 3]
          if (this._inpaintPixelExportsTransparentInMask(r, g, b, a)) return true
        }
      }
      return false
    },
    async commitInpaintMaskFromCanvas(n) {
      const maskCv = this._getInpaintMaskCanvas(n)
      const el = this._getInpaintElements(n)
      if (!maskCv || !el || !n.data.imageInpaintMode) return false
      const { img } = el
      const nw = img.naturalWidth || img.width
      const nh = img.naturalHeight || img.height
      if (nw < 2 || nh < 2) {
        showErrorToast('无法读取底图尺寸')
        return false
      }
      if (!this.inpaintMaskHasTransparentRegion(maskCv)) {
        showErrorToast('请用画笔或矩形涂抹要重绘的区域')
        return false
      }
      const off = document.createElement('canvas')
      off.width = nw
      off.height = nh
      const octx = off.getContext('2d')
      octx.drawImage(maskCv, 0, 0, maskCv.width, maskCv.height, 0, 0, nw, nh)
      const src = octx.getImageData(0, 0, nw, nh)
      const out = octx.createImageData(nw, nh)
      const sd = src.data
      const od = out.data
      for (let i = 0; i < sd.length; i += 4) {
        const r = sd[i]
        const g = sd[i + 1]
        const b = sd[i + 2]
        const a = sd[i + 3]
        if (this._inpaintPixelExportsTransparentInMask(r, g, b, a)) {
          od[i] = 0
          od[i + 1] = 0
          od[i + 2] = 0
          od[i + 3] = 0
        } else {
          od[i] = 255
          od[i + 1] = 255
          od[i + 2] = 255
          od[i + 3] = 255
        }
      }
      octx.putImageData(out, 0, 0)
      const blob = await new Promise((resolve, reject) => {
        off.toBlob(b => (b ? resolve(b) : reject(new Error('导出蒙版失败'))), 'image/png')
      })
      const file = new File([blob], 'inpaint-mask.png', { type: 'image/png' })
      const url = await uploadVideoMediaFile({ file, relative: true })
      this.$set(n.data, 'inpaintMaskUrl', url)
      return true
    },
    async finishImageInpaintMode(n) {
      if (!n || !n.data.imageInpaintMode) return
      try {
        const ok = await this.commitInpaintMaskFromCanvas(n)
        if (!ok) return
        this._unbindInpaintDocListeners()
        this.$set(n.data, 'imageInpaintMode', false)
        if (this.inpaintOnlineEditorNodeId === n.id) this.inpaintOnlineEditorNodeId = null
        showSuccessToast('蒙版已保存，可在下方输入重绘描述后点击生成')
      } catch (err) {
        showErrorToast(err && err.message ? String(err.message) : '蒙版保存失败')
      }
    },
    cancelImageInpaintMode(n) {
      if (!n || !n.data) return
      this._unbindInpaintDocListeners()
      this.inpaintStrokeSession = null
      this.inpaintRectSession = null
      if (this.inpaintOnlineEditorNodeId === n.id) this.inpaintOnlineEditorNodeId = null
      delete this.inpaintUndoStacks[n.id]
      delete this.inpaintRedoStacks[n.id]
      this.$delete(this.inpaintMaskBuffers, n.id)
      this.$set(n.data, 'imageInpaintMode', false)
    },
    /**
     * @param {number} [attempt] 内联画布尚未布局完成时的重试次数（由 enter 自动打开时使用）
     */
    openInpaintOnlineEditor(n, attempt = 0) {
      if (!n || n.type !== 'image' || !n.data || !n.data.imageInpaintMode) return
      if (!this.imageNodeDisplaySrc(n)) return
      this.syncInpaintCanvasSize(n, 'inline')
      let inline = this._getInpaintSurfaceElements(n, 'inline')
      const maskCv = this._getInpaintMaskCanvas(n)
      if (!inline || !maskCv || maskCv.width < 1 || maskCv.height < 1) {
        if (attempt < 20) {
          requestAnimationFrame(() => this.openInpaintOnlineEditor(n, attempt + 1))
          return
        }
        showErrorToast('请等待预览图加载完成后再打开在线编辑')
        return
      }
      this.inpaintOnlineEditorNodeId = n.id

      const paintFromTmp = () => {
        const modal = this._getInpaintSurfaceElements(n, 'modal')
        if (!modal) return false
        this.syncInpaintCanvasSize(n, 'modal')
        const m = this._getInpaintMaskCanvas(n)
        if (!m || m.width < 2 || m.height < 2) return false
        const mctx = m.getContext('2d', INPAINT_2D_CTX)
        this._inpaintNormalizePreserveTint(mctx, m.width, m.height)
        const snap = mctx.getImageData(0, 0, m.width, m.height)
        this.inpaintUndoStacks[n.id] = { snapshots: [this._cloneImageData(snap)], idx: 0 }
        this.inpaintRedoStacks[n.id] = []
        this._inpaintCompositeDisplay(n, 'modal')
        return true
      }

      const run = async () => {
        await this.$nextTick()
        const sel = `[data-ngc-inpaint-wrap-modal="${n.id}"] img[data-ngc-inpaint-base-img]`
        const imgEl = document.querySelector(sel)
        if (imgEl && typeof imgEl.decode === 'function') {
          try {
            await imgEl.decode()
          } catch (_) {}
        }
        await this.waitInpaintModalLayoutReady(n)
        let ok = paintFromTmp()
        let tries = 0
        while (!ok && tries < 45) {
          await new Promise(r => requestAnimationFrame(r))
          ok = paintFromTmp()
          tries++
        }
        if (!ok) {
          showErrorToast('大屏蒙版未就绪（画布尺寸异常）。请关闭后重试，或刷新页面后再编辑')
        }
      }
      run()
    },
    closeInpaintOnlineEditor() {
      const id = this.inpaintOnlineEditorNodeId
      if (id == null) return
      const node = this.nodes.find(nn => nn.id === id)
      const maskCv = node ? this._getInpaintMaskCanvas(node) : null
      this.inpaintOnlineEditorNodeId = null
      if (!node || !maskCv || maskCv.width < 1) return
      this.$nextTick(() => {
        this.syncInpaintCanvasSize(node, 'inline')
        const m = this._getInpaintMaskCanvas(node)
        if (!m || m.width < 1) return
        const snap = m.getContext('2d', INPAINT_2D_CTX).getImageData(0, 0, m.width, m.height)
        this.inpaintUndoStacks[node.id] = { snapshots: [this._cloneImageData(snap)], idx: 0 }
        this.inpaintRedoStacks[node.id] = []
        this._inpaintCompositeDisplay(node, 'inline')
      })
    },
    openImageNodeLargePreview(n) {
      const url = String(this.imageNodeOwnPreviewSrc(n) || this.imageNodeDisplaySrc(n) || '').trim()
      if (!url) {
        showErrorToast('请先生成或上传图片')
        return
      }
      this.upstreamPreview = {
        kind: 'image',
        url,
        title: '图片节点 · 大图预览'
      }
    },
    imageNodeAssetLibraryTitle(n) {
      if (!n || !n.data) return '未命名角色'
      const name = String(n.data.storyboardAssetName || '').trim()
      if (name) return name
      const prompt = String(n.data.prompt || '')
        .replace(/\s+/g, ' ')
        .trim()
      if (prompt) return prompt.slice(0, 40)
      return `图片节点 ${this.imageNodeIndex(n)}`
    },
    async addImageNodeToAssetLibrary(n) {
      if (!n || n.type !== 'image' || !n.data) return
      const url = String(this.imageNodeOwnPreviewSrc(n) || '').trim()
      if (!url) {
        showErrorToast('请先生成或上传图片')
        return
      }
      if (this.ngcImageAssetSavingId === n.id) return
      this.ngcImageAssetSavingId = n.id
      const now = new Date().toISOString()
      const title = this.imageNodeAssetLibraryTitle(n)
      const prompt = String(n.data.prompt || '').trim()
      const item = {
        kind: 'image',
        url,
        title,
        prompt,
        meta: {
          source: 'node_graph_canvas',
          nodeId: n.id,
          imageInputMode: n.data.imageInputMode || 'generate',
          createdAt: now
        }
      }
      try {
        await addAssetsToLibrary([item])
        showSuccessToast(`已加入角色库：${title}`)
      } catch {
        try {
          const key = 'assetLibrary'
          const raw = localStorage.getItem(key)
          let arr = []
          try {
            const parsed = JSON.parse(raw || '[]')
            arr = Array.isArray(parsed) ? parsed : []
          } catch {
            arr = []
          }
          arr.unshift({
            id: `asset-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
            kind: 'image',
            url,
            title,
            prompt,
            createdAt: now
          })
          localStorage.setItem(key, JSON.stringify(arr))
          showSuccessToast(`已加入角色库（本地）：${title}`)
        } catch (e) {
          showErrorToast((e && e.message) || '加入角色库失败')
        }
      } finally {
        if (this.ngcImageAssetSavingId === n.id) this.ngcImageAssetSavingId = ''
      }
    },
    ngcResolveAssetFetchUrl(url) {
      const u = String(url || '').trim()
      if (!u) return ''
      if (/^(https?:|blob:|data:)/i.test(u)) return u
      if (u.startsWith('//')) return `${window.location.protocol}${u}`
      const uploads = extractUploadsPath(u)
      if (uploads) return fixImageUrl(uploads)
      return fixImageUrl(u)
    },
    ngcGuessImageDownloadExt(url, blobType) {
      const mime = String(blobType || '').toLowerCase()
      if (mime.includes('webp')) return 'webp'
      if (mime.includes('jpeg') || mime.includes('jpg')) return 'jpg'
      if (mime.includes('gif')) return 'gif'
      const base = String(url || '')
        .split('?')[0]
        .toLowerCase()
      if (base.endsWith('.webp')) return 'webp'
      if (base.endsWith('.jpg') || base.endsWith('.jpeg')) return 'jpg'
      if (base.endsWith('.gif')) return 'gif'
      return 'png'
    },
    imageNodeDownloadFilename(n, url, blobType) {
      const idx = this.imageNodeIndex(n)
      const ext = this.ngcGuessImageDownloadExt(url, blobType)
      const stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')
      return `ngc-image-${String(idx).padStart(2, '0')}-${stamp}.${ext}`
    },
    imageNodePreviewImgEl(n) {
      if (!n || !n.id) return null
      return document.querySelector(`[data-ngc-inpaint-base-img="${n.id}"]`)
    },
    async downloadImageNodeOutput(n) {
      if (!n || n.type !== 'image' || !n.data) return
      const url = String(
        this.imageNodeOwnPreviewSrc(n) || this.imageNodeDisplaySrc(n) || ''
      ).trim()
      if (!url) {
        showErrorToast('请先生成或上传图片')
        return
      }
      const filename = this.imageNodeDownloadFilename(n, url)
      const imgEl = this.imageNodePreviewImgEl(n)
      if (imgEl && imgEl.complete && imgEl.naturalWidth > 0) {
        const domBlob = await blobFromLoadedImageElement(imgEl)
        if (domBlob) {
          const objUrl = URL.createObjectURL(domBlob)
          const a = document.createElement('a')
          a.href = objUrl
          a.download = filename
          a.rel = 'noopener'
          document.body.appendChild(a)
          a.click()
          a.remove()
          URL.revokeObjectURL(objUrl)
          showSuccessToast('图片已下载')
          return
        }
      }
      try {
        await downloadImageFile(url, filename)
        showSuccessToast('图片已下载')
      } catch (err) {
        const msg = err && err.message ? String(err.message) : ''
        if (/401|未登录|login/i.test(msg)) {
          showErrorToast('请先登录后再下载')
          return
        }
        const openUrl = this.ngcResolveAssetFetchUrl(url) || url
        try {
          const a = document.createElement('a')
          a.href = openUrl
          a.download = filename
          a.rel = 'noopener'
          a.target = '_blank'
          document.body.appendChild(a)
          a.click()
          a.remove()
          showSuccessToast('已在新标签打开，若未自动保存请右键另存为')
        } catch {
          showErrorToast(msg || '下载失败，请稍后重试')
        }
      }
    },
    ngcGuessVideoDownloadExt(url) {
      const base = String(url || '')
        .split('?')[0]
        .toLowerCase()
      if (base.endsWith('.webm')) return 'webm'
      if (base.endsWith('.mov')) return 'mov'
      if (base.endsWith('.m4v')) return 'm4v'
      return 'mp4'
    },
    videoNodeDownloadFilename(n, opts = {}) {
      const idx = this.videoNodeIndex(n)
      const sortKey = this.videoNodeLayoutSortKey(n)
      const shot =
        n && n.data && n.data.storyboardShotNo != null
          ? String(n.data.storyboardShotNo).trim()
          : ''
      const shotPart = shot ? `-shot${shot.replace(/[^\w\u4e00-\u9fff-]+/g, '')}` : ''
      const stamp =
        opts.stamp != null
          ? String(opts.stamp)
          : new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')
      const seq = opts.bulkIndex != null ? opts.bulkIndex : sortKey
      const ext = this.ngcGuessVideoDownloadExt(
        n && n.data ? String(n.data.videoUrl || '') : ''
      )
      return `ngc-video-${String(seq).padStart(2, '0')}-node${idx}${shotPart}-${stamp}.${ext}`
    },
    collectVideoNodesForBulkDownload() {
      return (this.nodes || [])
        .filter(n => n && n.type === 'video' && n.data && String(n.data.videoUrl || '').trim())
        .sort((a, b) => this.canvasNodeVerticalSortKey(a) - this.canvasNodeVerticalSortKey(b))
    },
    async downloadVideoNodeOutput(n, opts = {}) {
      if (!n || n.type !== 'video' || !n.data) return false
      const url = String(n.data.videoUrl || '').trim()
      if (!url) {
        if (!opts.silentToast) showErrorToast('请先生成视频')
        return false
      }
      const filename = this.videoNodeDownloadFilename(n, opts)
      try {
        const res = await fetch(url, { mode: 'cors' })
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        const blob = await res.blob()
        const objUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = objUrl
        a.download = filename
        a.rel = 'noopener'
        document.body.appendChild(a)
        a.click()
        a.remove()
        URL.revokeObjectURL(objUrl)
      } catch {
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        a.rel = 'noopener'
        a.target = '_blank'
        document.body.appendChild(a)
        a.click()
        a.remove()
      }
      if (!opts.silentToast) showSuccessToast('已触发下载')
      return true
    },
    async downloadAllVideoNodeOutputs() {
      const list = this.collectVideoNodesForBulkDownload()
      if (!list.length) {
        showErrorToast('暂无已生成视频的视频节点')
        return
      }
      if (this.ngcBulkVideoDownloadRunning) return
      this.ngcBulkVideoDownloadRunning = true
      const stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')
      let ok = 0
      try {
        for (let i = 0; i < list.length; i++) {
          const done = await this.downloadVideoNodeOutput(list[i], {
            bulkIndex: i + 1,
            stamp,
            silentToast: true
          })
          if (done) ok += 1
          if (i < list.length - 1) await sleep(450)
        }
        if (ok) {
          showSuccessToast(
            ok === list.length
              ? `已依次下载 ${ok} 个视频`
              : `已下载 ${ok}/${list.length} 个视频（部分可能需浏览器另存）`
          )
        } else {
          showErrorToast('下载失败，请检查视频链接是否有效')
        }
      } catch (e) {
        showErrorToast((e && e.message) || '批量下载中断')
      } finally {
        this.ngcBulkVideoDownloadRunning = false
      }
    },
    /** 在图片节点提示词末尾插入 720° 全景生成指令（与 Seedream 最终 prompt 一并提交） */
    append720PanoramaInstructionToImageNode(n) {
      if (!n || n.type !== 'image' || !n.data) return
      this.imageToolbarMenu = null
      const cur = n.data.prompt != null ? String(n.data.prompt) : ''
      if (cur.includes(NGC_720_PANORAMA_MARKER)) {
        showSuccessToast('提示词已包含 720° 全景指令')
        return
      }
      const next = (cur.trim() ? `${cur.trim()}\n\n` : '') + NGC_720_PANORAMA_INSTRUCTION
      this.$set(n.data, 'prompt', next)
      showSuccessToast('已插入 720° 全景生成指令，可执行本节点出图')
      this.$nextTick(() => {
        const el = document.querySelector(`[data-prompt-editor][data-prompt-node-id="${n.id}"]`)
        if (el && document.activeElement !== el) this.hydratePromptEditor(n, el)
      })
    },
    /** 上游缩略图：普通点击预览图片/音频/文本；Alt 或 Meta+点击定位上游节点 */
    onUpstreamThumbClick(n, ref, e) {
      if (!ref) return
      if (e && (e.altKey || e.metaKey)) {
        this.focusUpstreamNode(ref.nodeId)
        return
      }
      if (ref.kind === 'image' && ref.url) {
        this.upstreamPreview = {
          kind: 'image',
          url: ref.url,
          title: ref.title || '图片预览'
        }
        return
      }
      if (ref.kind === 'audio' && ref.audioUrl) {
        this.upstreamPreview = {
          kind: 'audio',
          url: ref.audioUrl,
          title: ref.title || '音频预览'
        }
        return
      }
      if (ref.kind === 'text' && ref.snippet) {
        this.upstreamPreview = {
          kind: 'text',
          snippet: ref.snippet,
          title: ref.title || '文本预览'
        }
        return
      }
      this.focusUpstreamNode(ref.nodeId)
    },
    onUpstreamThumbContextMenu(n, ref, e) {
      if (!n || !ref || !e) return
      this.closeInlineCanvasPickers()
      const pad = 6
      const menuW = 168
      const menuH = 40
      let left = e.clientX
      let top = e.clientY
      if (typeof window !== 'undefined') {
        left = Math.min(left, window.innerWidth - menuW - pad)
        top = Math.min(top, window.innerHeight - menuH - pad)
      }
      this.ngcUpstreamThumbMenu = {
        nodeId: n.id,
        ref,
        left,
        top
      }
    },
    closeUpstreamThumbMenu() {
      this.ngcUpstreamThumbMenu = null
    },
    confirmRemoveUpstreamThumbRef() {
      const m = this.ngcUpstreamThumbMenu
      this.closeUpstreamThumbMenu()
      if (!m || !m.ref) return
      const n = this.nodes.find(x => x.id === m.nodeId)
      if (!n) return
      this.removeUpstreamRefFromNode(n, m.ref)
    },
    /**
     * 删除当前节点对指定上游的入边引用，并同步提示词中的 [图片N]/[音频N]
     */
    removeUpstreamRefFromNode(n, ref) {
      if (!n || !ref || !ref.nodeId) return
      if (n.type !== 'image' && n.type !== 'video' && n.type !== 'audio') return
      const fromId = String(ref.nodeId).trim()
      const toId = n.id
      const hadEdge = (this.edges || []).some(
        e => e && e.from && e.to && e.from.nodeId === fromId && e.to.nodeId === toId
      )
      if (!hadEdge) {
        showErrorToast('未找到与该上游的连线')
        return
      }
      const beforeRefs = this.upstreamRefsForNode(n)
      const dropRefs = beforeRefs.filter(r => r && r.nodeId === fromId)
      this.pushDeleteUndoSnapshot()
      this.edges = (this.edges || []).filter(
        e => !(e && e.from && e.to && e.from.nodeId === fromId && e.to.nodeId === toId)
      )
      for (const r of dropRefs) {
        const k = this.upstreamThumbBadKey(n, r)
        if (k && this.upstreamThumbBad[k]) this.$delete(this.upstreamThumbBad, k)
      }
      if (n.data && (n.type === 'image' || n.type === 'video')) {
        const nextPrompt = this.resyncPromptAfterRemovingUpstream(n, fromId, beforeRefs)
        this.$set(n.data, 'prompt', nextPrompt)
        this.$nextTick(() => {
          const el = document.querySelector(
            `[data-prompt-editor][data-prompt-node-id="${n.id}"]`
          )
          if (el && document.activeElement !== el) this.hydratePromptEditor(n, el)
          else if (el) this.syncPromptChipThumbnails(n, el)
        })
      }
      if (this.assetMention && this.assetMention.nodeId === n.id) {
        this.assetMention = null
      }
      const title = ref.title || '上游节点'
      showSuccessToast(`已删除引用：${title}`)
      this.scheduleAutosave()
      this.$nextTick(() => this.flushPromptChipThumbnailsForAllImageVideoNodes())
    },
    resyncPromptAfterRemovingUpstream(n, removedFromId, beforeRefs) {
      let text = String((n && n.data && n.data.prompt) || '')
      const afterRefs = this.upstreamRefsForNode(n)
      const findAfter = (kind, nodeId) =>
        afterRefs.find(r => r && r.kind === kind && r.nodeId === nodeId)
      const replaceKind = (prefix, kind) => {
        const re = new RegExp(`\\[${prefix}(\\d+)\\]`, 'g')
        text = text.replace(re, (full, num) => {
          const old = (beforeRefs || []).find(
            r => r && r.kind === kind && String(r.badge) === String(num)
          )
          if (!old) return ''
          if (old.nodeId === removedFromId) return ''
          const neu = findAfter(kind, old.nodeId)
          return neu ? `[${prefix}${neu.badge}]` : ''
        })
      }
      replaceKind('图片', 'image')
      replaceKind('音频', 'audio')
      replaceKind('参考', 'text')
      return text
        .replace(/[ \t]+\n/g, '\n')
        .replace(/\n{3,}/g, '\n\n')
        .trim()
    },
    focusUpstreamNode(fromId) {
      const id = String(fromId || '').trim()
      const target = id ? this.nodes.find(x => x.id === id) : null
      if (!target) {
        showErrorToast('未找到对应上游节点')
        return
      }
      this.selectedId = id
      this.bringNodeToFront(target)
      this.$nextTick(() => this.focusViewportOnNode(id))
    },
    /** 提示词内 [图片N] 芯片：点击定位到对应上游节点 */
    onPromptChipClick(n, snippet, e) {
      if (e) {
        e.preventDefault()
        e.stopPropagation()
      }
      const ref = this.findUpstreamRefBySnippet(n, snippet)
      if (!ref || !ref.nodeId) {
        showErrorToast('未找到该引用对应的上游节点')
        return
      }
      this.focusUpstreamNode(ref.nodeId)
    },
    imageNodeCreditHint(n) {
      if (!n || !n.data) return 0
      const model = String(n.data.seedreamModel || '').trim()
      const cnt = Math.min(8, Math.max(1, Number(n.data.imageCount) || 1))
      const total = calcRequiredCreditsFromCatalog(
        this.ngcModelsCatalog,
        model,
        NGC_MODEL_KIND.IMAGE,
        { times: cnt }
      )
      return total > 0 ? total : 0
    },
    toggleImagePanelExpand(n) {
      if (!n || n.type !== 'image' || !n.data) return
      this.$set(n.data, 'panelExpanded', !n.data.panelExpanded)
      this.syncImageNodeLayoutHeight(n)
      this.$nextTick(() => this.scheduleSyncNodeVisualHeights())
    },
    effectiveImageWorkflowStyle(n) {
      if (!n || n.type !== 'image') return null
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      return effectiveWorkflowStyleForImageNode(n, map, this.edges)
    },
    imageWorkflowStyleIsInherited(n) {
      if (!n || !n.data) return false
      return !isWorkflowStyleSet(n.data.workflowStyle) && !!this.effectiveImageWorkflowStyle(n)
    },
    imageNodeStyleButtonLabel(n) {
      const s = this.effectiveImageWorkflowStyle(n)
      if (s && s.name) {
        const name = String(s.name)
        return this.imageWorkflowStyleIsInherited(n) ? `${name}·分镜` : name
      }
      return '风格'
    },
    imageNodeStyleButtonTitle(n) {
      if (!n || !n.data) return '选择风格（与对话工作流风格库同源）'
      const s = this.effectiveImageWorkflowStyle(n)
      if (s && s.name) {
        const base = `风格：${String(s.name)}`
        return this.imageWorkflowStyleIsInherited(n)
          ? `${base}（继承自上游分镜脚本节点，可在本节点单独覆盖）`
          : base
      }
      return '选择风格（与对话工作流风格库同源）；若上游已接分镜脚本并选风格，将自动继承'
    },
    /** 分镜选风格后，同步到已连接/本分解镜衍生的、且未单独设风格的图片节点 */
    syncStoryboardWorkflowStyleToDownstreamImages(sbNode, stylePlain) {
      if (!sbNode || sbNode.type !== 'storyboard') return
      const sid = sbNode.id
      const next = stylePlain ? cloneWorkflowStylePlain(stylePlain) : null
      for (const n of this.nodes || []) {
        if (!n || n.type !== 'image' || !n.data) continue
        const spawned = String(n.data.spawnedFromStoryboardId || '') === sid
        const linked = (this.edges || []).some(
          e => e && e.from && e.to && e.from.nodeId === sid && e.to.nodeId === n.id
        )
        if (!spawned && !linked) continue
        if (isWorkflowStyleSet(n.data.workflowStyle)) continue
        this.$set(n.data, 'workflowStyle', next)
      }
    },
    onStoryboardAspectRatioChange(n, v) {
      if (!n || n.type !== 'storyboard' || !n.data) return
      const ratio = resolveStoryboardAspectRatio({ storyboardAspectRatio: v })
      this.$set(n.data, 'storyboardAspectRatio', ratio)
      this.syncStoryboardAspectToDownstreamMedia(n)
      this.scheduleAutosave()
    },
    /** 分镜改比例后，同步到已连接/本分解镜衍生的、且未手动改过比例的图片/视频节点 */
    syncStoryboardAspectToDownstreamMedia(sbNode) {
      if (!sbNode || sbNode.type !== 'storyboard' || !sbNode.data) return
      const sid = sbNode.id
      const sbRatio = resolveStoryboardAspectRatio(sbNode.data)
      const map = Object.fromEntries((this.nodes || []).map(x => [x.id, x]))
      for (const n of this.nodes || []) {
        if (!n || !n.data) continue
        const spawned = String(n.data.spawnedFromStoryboardId || '') === sid
        const linked = (this.edges || []).some(
          e => e && e.from && e.to && e.from.nodeId === sid && e.to.nodeId === n.id
        )
        if (!spawned && !linked) continue
        if (n.type === 'image' && !n.data.aspectRatioUserPick) {
          const key = effectiveImageAspectKeyForImageNode(n, map, this.edges)
          this.$set(n.data, 'aspectKey', key)
        } else if (n.type === 'video' && !n.data.ratioUserPick) {
          this.$set(n.data, 'ratio', sbRatio)
        }
      }
    },
    effectiveImageAspectKey(n) {
      if (!n || n.type !== 'image') return '16x9_2k'
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      return effectiveImageAspectKeyForImageNode(n, map, this.edges)
    },
    imageAspectIsInherited(n) {
      if (!n || !n.data || n.data.aspectRatioUserPick) return false
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      return !!gatherUpstreamStoryboardAspectRatio(n.id, map, this.edges)
    },
    effectiveVideoRatio(n) {
      if (!n || n.type !== 'video') return '16:9'
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      return effectiveVideoRatioForVideoNode(n, map, this.edges)
    },
    videoRatioIsInherited(n) {
      if (!n || !n.data || n.data.ratioUserPick) return false
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      return !!gatherUpstreamStoryboardAspectRatio(n.id, map, this.edges)
    },
    setVideoNodeRatio(n, slug) {
      if (!n || !n.data) return
      this.$set(n.data, 'ratio', slug)
      this.$set(n.data, 'ratioUserPick', true)
    },
    closeImageStyleLibrary() {
      this.showImageStyleLibrary = false
      this.imageStyleLibraryNodeId = null
    },
    storyboardNodeStyleButtonTitle(n) {
      if (!n || !n.data) return '从风格库选择视觉风格（与图片节点同源）'
      const s = n.data.workflowStyle
      if (s && typeof s === 'object' && s.name) return `风格库：${String(s.name)}`
      return '从风格库选择视觉风格（与图片节点同源）'
    },
    async openWorkflowStyleLibrary(n) {
      if (!n || !n.data || this.isNodeRunning(n.id)) return
      if (n.type !== 'image' && n.type !== 'storyboard') return
      this.closeInlineCanvasPickers()
      this.imageStyleLibraryNodeId = n.id
      this.showImageStyleLibrary = true
      this.ngcStyleTab = 'all'
      this._ngcStyleMineLoaded = false
      this._ngcStyleRecentLoaded = false
      this.ngcLoadStyleRecentFromStorage()
      this.ngcStylePanelLoading = true
      try {
        this.ngcStyleCategoryList = await fetchWorkflowStyleCategoriesList()
        await this.ngcFetchCategoryStyles({ categoryId: 'all', reset: true })
      } catch {
        this.ngcStyleCategoryList = []
      } finally {
        this.ngcStylePanelLoading = false
      }
      this.$nextTick(() => {
        try {
          const el = this.$refs.ngcStyleLibraryScroll
          if (el) el.scrollTop = 0
        } catch {
          // ignore
        }
      })
    },
    async openImageStyleLibrary(n) {
      return this.openWorkflowStyleLibrary(n)
    },
    clearWorkflowStyleForPickerTarget() {
      const n = this.ngcStyleLibraryTargetNode
      if (!n || !n.data) return
      this.$set(n.data, 'workflowStyle', null)
      if (n.type === 'storyboard') {
        this.syncStoryboardWorkflowStyleToDownstreamImages(n, null)
        this.scheduleAutosave()
      }
    },
    clearImageWorkflowStyleForPickerTarget() {
      this.clearWorkflowStyleForPickerTarget()
    },
    selectWorkflowStyle(s) {
      const n = this.ngcStyleLibraryTargetNode
      if (!n || !n.data || (n.type !== 'image' && n.type !== 'storyboard')) {
        this.closeImageStyleLibrary()
        return
      }
      let plain = null
      try {
        plain = s ? JSON.parse(JSON.stringify(s)) : null
      } catch {
        plain = s && typeof s === 'object' ? { ...s } : null
      }
      this.$set(n.data, 'workflowStyle', plain)
      if (n.type === 'storyboard') {
        this.syncStoryboardWorkflowStyleToDownstreamImages(n, plain)
        this.scheduleAutosave()
      }
      try {
        const key = 'cw_recent_styles'
        const raw = localStorage.getItem(key) || '[]'
        const arr = Array.isArray(JSON.parse(raw)) ? JSON.parse(raw) : []
        const next = [s].concat(arr.filter(x => x && x.id !== s.id)).slice(0, 12)
        localStorage.setItem(key, JSON.stringify(next))
        this.ngcStyleRecent = next
      } catch {
        // ignore
      }
      this.closeImageStyleLibrary()
    },
    selectImageWorkflowStyle(s) {
      this.selectWorkflowStyle(s)
    },
    ngcLoadStyleMineFromStorage() {
      if (this._ngcStyleMineLoaded) return
      this._ngcStyleMineLoaded = true
      try {
        const raw = localStorage.getItem('cw_style_mine') || '[]'
        const arr = JSON.parse(raw)
        this.ngcStyleMine = Array.isArray(arr) ? arr.filter(x => x && x.id && x.name && x.thumb) : []
      } catch {
        this.ngcStyleMine = []
      }
    },
    ngcLoadStyleRecentFromStorage() {
      if (this._ngcStyleRecentLoaded) return
      this._ngcStyleRecentLoaded = true
      try {
        const raw = localStorage.getItem('cw_recent_styles') || '[]'
        const arr = JSON.parse(raw)
        this.ngcStyleRecent = Array.isArray(arr) ? arr.filter(x => x && x.id && x.name) : []
      } catch {
        this.ngcStyleRecent = []
      }
    },
    ngcOnStyleCategoryTabClick(t) {
      const id = t && t.id != null ? String(t.id) : ''
      this.ngcStyleTab = id || 'all'
      if (Array.isArray(this.ngcStyleCategoryList) && this.ngcStyleCategoryList.length > 0) {
        if (id === 'mine') {
          this.ngcLoadStyleMineFromStorage()
          return
        }
        if (id === 'recent') {
          this._ngcStyleRecentLoaded = false
          this.ngcLoadStyleRecentFromStorage()
          return
        }
        if (id === 'all') {
          void this.ngcFetchCategoryStyles({ categoryId: 'all', reset: false })
          return
        }
        if (id && id !== 'mine' && id !== 'recent') {
          void this.ngcFetchCategoryStyles({ categoryId: id, reset: false })
        }
      }
    },
    ngcLoadMoreCategoryStyles() {
      const id = String(this.ngcStyleTab || '')
      if (!id || id === 'mine' || id === 'recent' || id === 'ip') return
      void this.ngcFetchCategoryStyles({ categoryId: id, reset: false })
    },
    ngcOnStyleLibraryScroll() {
      if (this._ngcStyleScrollRaf) return
      this._ngcStyleScrollRaf = requestAnimationFrame(() => {
        this._ngcStyleScrollRaf = 0
        if (!this.ngcShouldShowStyleLoadMore) return
        if (this.ngcStyleCategoryLoading) return
        const el = this.$refs.ngcStyleLibraryScroll
        if (!el) return
        const top = el.scrollTop || 0
        const height = el.clientHeight || 0
        const total = el.scrollHeight || 0
        const remain = total - (top + height)
        if (remain > 160) return
        const now = Date.now()
        if (now - (this._ngcStyleLastAutoLoadAt || 0) < 600) return
        this._ngcStyleLastAutoLoadAt = now
        this.ngcLoadMoreCategoryStyles()
      })
    },
    async ngcFetchCategoryStyles({ categoryId, reset }) {
      const cid = categoryId != null ? String(categoryId) : ''
      if (!cid) return
      if (this.ngcStyleCategoryLoading) return
      const cur = (this.ngcStyleCategoryMap && this.ngcStyleCategoryMap[cid]) || null
      if (cur && cur.finished && !reset) return

      this.ngcStyleCategoryLoading = true
      const nextPage = reset ? 1 : Math.max(1, parseInt(cur && cur.page, 10) || 1)
      try {
        const res = await postWorkflowStyleSearch({ categoryId: cid, page: nextPage })
        const bucket = mergeWorkflowStyleSearchResponse(res, {
          categoryId: cid,
          reset,
          previousBucket: cur
        })
        this.$set(this.ngcStyleCategoryMap, cid, bucket)
      } catch {
        // ignore
      } finally {
        this.ngcStyleCategoryLoading = false
      }
    },
    toggleImageAspectPicker(n) {
      if (!n || n.type !== 'image') return
      if (this.imageAspectPickerNodeId === n.id) {
        this.closeImageAspectPickerModal()
        return
      }
      this.closeInlineCanvasPickers()
      this.imageAspectPickerNodeId = n.id
      this.$nextTick(() => {
        if (!this.imageAspectPickerNode) this.imageAspectPickerNodeId = null
      })
    },
    closeImageAspectPickerModal() {
      this.imageAspectPickerNodeId = null
    },
    toggleImageModelPicker(n) {
      if (!n || n.type !== 'image') return
      if (this.imageModelPickerNodeId === n.id) {
        this.closeImageModelPickerModal()
        return
      }
      this.closeInlineCanvasPickers()
      this.imageModelPickerNodeId = n.id
      this.$nextTick(() => {
        if (!this.imageModelPickerNode) this.imageModelPickerNodeId = null
      })
    },
    closeImageModelPickerModal() {
      this.imageModelPickerNodeId = null
    },
    /** 关闭所有画布内浮层：比例/各类模型/视频规格（打开其一前调用） */
    closeInlineCanvasPickers() {
      if (this.$root) this.$root.$emit('ngc-close-node-selects')
      this.imageAspectPickerNodeId = null
      this.imageModelPickerNodeId = null
      this.storyboardModelPickerNodeId = null
      this.ecomDetailDeepseekPickerNodeId = null
      this.ecomDetailImageModelPickerNodeId = null
      this.uiDesignDeepseekPickerNodeId = null
      this.uiDesignImageModelPickerNodeId = null
      this.llmModelPickerNodeId = null
      this.videoModelPickerNodeId = null
      this.audioModelPickerNodeId = null
      this.videoSpecPanelNodeId = null
      this.ngcUpstreamThumbMenu = null
      this.closeNgcCharacterLibrary()
    },
    /** 仅关闭「模型」类弹出层（文档 mousedown 点外部） */
    closeAllNgInlineModelPickers() {
      this.imageModelPickerNodeId = null
      this.storyboardModelPickerNodeId = null
      this.ecomDetailDeepseekPickerNodeId = null
      this.ecomDetailImageModelPickerNodeId = null
      this.uiDesignDeepseekPickerNodeId = null
      this.uiDesignImageModelPickerNodeId = null
      this.llmModelPickerNodeId = null
      this.videoModelPickerNodeId = null
      this.audioModelPickerNodeId = null
    },
    toggleEcomDetailDeepseekPicker(n) {
      if (!n || n.type !== 'ecomDetail') return
      if (this.ecomDetailDeepseekPickerNodeId === n.id) {
        this.ecomDetailDeepseekPickerNodeId = null
        return
      }
      this.closeInlineCanvasPickers()
      this.ecomDetailDeepseekPickerNodeId = n.id
    },
    closeEcomDetailDeepseekPickerModal() {
      this.ecomDetailDeepseekPickerNodeId = null
    },
    toggleEcomDetailImageModelPicker(n) {
      if (!n || n.type !== 'ecomDetail') return
      if (this.ecomDetailImageModelPickerNodeId === n.id) {
        this.closeEcomDetailImageModelPickerModal()
        return
      }
      this.closeInlineCanvasPickers()
      this.ecomDetailImageModelPickerNodeId = n.id
    },
    closeEcomDetailImageModelPickerModal() {
      this.ecomDetailImageModelPickerNodeId = null
    },
    ecomDetailImageModelLabel(n) {
      const id =
        n && n.data && n.data.seedreamModel != null ? String(n.data.seedreamModel).trim() : ''
      const opts = this.ecomImageModelOptions || []
      for (let i = 0; i < opts.length; i++) {
        const im = opts[i]
        if (im && String(im.id || '').trim() === id) return im.label || id
      }
      return opts.length ? '选择模型' : '暂无可用模型'
    },
    async setEcomDetailSeedreamModel(n, modelId) {
      if (!n || n.type !== 'ecomDetail' || !n.data) return
      const opts = this.ecomImageModelOptions || []
      const fallback =
        opts[0] && opts[0].id != null ? String(opts[0].id).trim() : ''
      if (!fallback) {
        showErrorToast('请先在后台配置并上架图片模型')
        return
      }
      const mid = modelId != null ? String(modelId).trim() : fallback
      await this.ngcChargeAndApplyModel(n, {
        field: 'seedreamModel',
        kind: NGC_MODEL_KIND.IMAGE,
        modelId: mid || fallback,
        normalize: v => (v && String(v).trim() ? String(v).trim() : fallback),
        onClose: () => this.closeEcomDetailImageModelPickerModal()
      })
    },
    ecomDetailDeepseekModelLabel(n) {
      const id =
        n && n.data && n.data.deepseekModel != null ? String(n.data.deepseekModel).trim() : ''
      const opts = this.storyboardModelOptions || []
      for (let i = 0; i < opts.length; i++) {
        const m = opts[i]
        if (m && String(m.id || '').trim() === id) return m.label || id
      }
      return opts.length ? '选择模型' : '暂无可用模型'
    },
    async setEcomDetailDeepseekModel(n, modelId) {
      if (!n || !n.data) return
      const mid = modelId != null ? String(modelId).trim() : 'deepseek-v4-flash'
      await this.ngcChargeAndApplyModel(n, {
        field: 'deepseekModel',
        kind: NGC_MODEL_KIND.LLM,
        modelId: mid,
        normalize: v => (v.startsWith('deepseek-v4') ? v : 'deepseek-v4-flash'),
        onClose: () => this.closeEcomDetailDeepseekPickerModal()
      })
    },
    setEcomDetailUseDeepseek(n, ev) {
      if (!n || !n.data) return
      this.$set(n.data, 'useDeepseekPrompt', !!(ev && ev.target && ev.target.checked))
      this.scheduleAutosave()
    },
    toggleStoryboardModelPicker(n) {
      if (!n || (n.type !== 'storyboard' && n.type !== 'scriptWrite')) return
      if (this.storyboardModelPickerNodeId === n.id) {
        this.storyboardModelPickerNodeId = null
        return
      }
      this.closeInlineCanvasPickers()
      this.storyboardModelPickerNodeId = n.id
    },
    closeStoryboardModelPickerModal() {
      this.storyboardModelPickerNodeId = null
    },
    storyboardNodeModelTriggerLabel(n) {
      const id = n && n.data && n.data.model != null ? String(n.data.model).trim() : ''
      const opts = this.storyboardModelOptions || []
      for (let i = 0; i < opts.length; i++) {
        const m = opts[i]
        if (m && String(m.id || '').trim() === id) return m.label || id
      }
      return opts.length ? '选择模型' : '暂无可用模型'
    },
    async setStoryboardNodeModel(n, modelId) {
      if (!n || !n.data) return
      await this.ngcChargeAndApplyModel(n, {
        field: 'model',
        kind: NGC_MODEL_KIND.LLM,
        modelId,
        onClose: () => this.closeStoryboardModelPickerModal()
      })
    },
    toggleLlmModelPicker(n) {
      if (!n || n.type !== 'llm') return
      if (this.llmModelPickerNodeId === n.id) {
        this.llmModelPickerNodeId = null
        return
      }
      this.closeInlineCanvasPickers()
      if (!this.ngcModelsCatalog.length && !this.ngcModelsCatalogLoading) {
        this.loadNgcModelsCatalog()
      }
      this.syncNodeCreditDisplayFromModel(n)
      this.llmModelPickerNodeId = n.id
    },
    closeLlmModelPickerModal() {
      this.llmModelPickerNodeId = null
    },
    llmNodeModelTriggerLabel(n) {
      const id = n && n.data && n.data.model != null ? String(n.data.model).trim() : ''
      const opts = this.llmModelOptions || []
      for (let i = 0; i < opts.length; i++) {
        const m = opts[i]
        if (m && String(m.id || '').trim() === id) return m.label || id
      }
      return opts.length ? '选择模型' : '暂无可用模型'
    },
    async setLlmNodeModel(n, modelId) {
      if (!n || !n.data) return
      await this.ngcChargeAndApplyModel(n, {
        field: 'model',
        kind: NGC_MODEL_KIND.LLM,
        modelId,
        onClose: () => this.closeLlmModelPickerModal()
      })
    },
    toggleVideoModelPicker(n) {
      if (!n || n.type !== 'video') return
      if (this.videoModelPickerNodeId === n.id) {
        this.videoModelPickerNodeId = null
        return
      }
      this.closeInlineCanvasPickers()
      this.videoModelPickerNodeId = n.id
    },
    closeVideoModelPickerModal() {
      this.videoModelPickerNodeId = null
    },
    videoNodeModelTriggerLabel(n) {
      const id = n && n.data && n.data.seedanceModel != null ? String(n.data.seedanceModel).trim() : ''
      const opts = this.videoModelOptions || []
      for (let i = 0; i < opts.length; i++) {
        const vm = opts[i]
        if (vm && String(vm.id != null ? vm.id : '').trim() === id) return vm.label || id
      }
      return opts.length ? '选择模型' : '暂无可用模型'
    },
    async setVideoNodeSeedanceModel(n, modelId) {
      if (!n || !n.data) return
      await this.ngcChargeAndApplyModel(n, {
        field: 'seedanceModel',
        kind: NGC_MODEL_KIND.VIDEO,
        modelId,
        onClose: () => this.closeVideoModelPickerModal()
      })
    },
    toggleAudioModelPicker(n) {
      if (!n || n.type !== 'audio') return
      if (this.audioModelPickerNodeId === n.id) {
        this.audioModelPickerNodeId = null
        return
      }
      this.closeInlineCanvasPickers()
      this.audioModelPickerNodeId = n.id
    },
    closeAudioModelPickerModal() {
      this.audioModelPickerNodeId = null
    },
    audioNodeModelTriggerLabel(n) {
      const id = n && n.data && n.data.model != null ? String(n.data.model).trim() : ''
      const opts = this.audioModelOptions || []
      for (let i = 0; i < opts.length; i++) {
        const am = opts[i]
        if (am && String(am.id || '').trim() === id) return am.label || id
      }
      return opts.length ? '选择模型' : '暂无可用模型'
    },
    async setAudioNodeModel(n, modelId) {
      if (!n || !n.data) return
      await this.ngcChargeAndApplyModel(n, {
        field: 'model',
        kind: NGC_MODEL_KIND.AUDIO,
        modelId,
        onClose: () => this.closeAudioModelPickerModal()
      })
    },
    imageNodeModelTriggerLabel(n) {
      const id = n && n.data && n.data.seedreamModel != null ? String(n.data.seedreamModel).trim() : ''
      const opts = this.imageModelOptions || []
      for (let i = 0; i < opts.length; i++) {
        const im = opts[i]
        if (im && String(im.id || '').trim() === id) return im.label || id
      }
      return opts.length ? '选择模型' : '暂无可用模型'
    },
    async setImageNodeSeedreamModel(n, modelId) {
      if (!n || !n.data) return
      await this.ngcChargeAndApplyModel(n, {
        field: 'seedreamModel',
        kind: NGC_MODEL_KIND.IMAGE,
        modelId,
        onClose: () => this.closeImageModelPickerModal()
      })
    },
    imageNodeAspectParts(n) {
      const k = this.effectiveImageAspectKey(n)
      const p = IMAGE_ASPECT_PRESETS.find(x => x.key === k)
      if (p) return { ratioSlug: p.ratioSlug, tier: p.tier }
      return { ratioSlug: '16x9', tier: '2k' }
    },
    imageNodeAspectTriggerLabel(n) {
      const k = this.effectiveImageAspectKey(n)
      const p = IMAGE_ASPECT_PRESETS.find(x => x.key === k)
      let label = p && p.label ? p.label : '16:9 · 2K'
      if (this.imageAspectIsInherited(n)) {
        const parts = label.split(' · ')
        label = `${parts[0] || '16:9'}·分镜 · ${parts[1] || '2K'}`
      }
      return label
    },
    setImageNodeAspectTier(n, tierId) {
      if (!n || !n.data) return
      const { ratioSlug } = this.imageNodeAspectParts(n)
      const key = `${ratioSlug}_${tierId}`
      if (IMAGE_ASPECT_PRESETS.some(x => x.key === key)) {
        this.$set(n.data, 'aspectKey', key)
        this.$set(n.data, 'aspectRatioUserPick', true)
        this.$nextTick(() => this.scheduleSyncNodeVisualHeights())
      }
    },
    setImageNodeAspectRatio(n, ratioSlug) {
      if (!n || !n.data) return
      const { tier } = this.imageNodeAspectParts(n)
      const key = `${ratioSlug}_${tier}`
      if (IMAGE_ASPECT_PRESETS.some(x => x.key === key)) {
        this.$set(n.data, 'aspectKey', key)
        this.$set(n.data, 'aspectRatioUserPick', true)
        this.$nextTick(() => this.scheduleSyncNodeVisualHeights())
      }
    },
    ngcImageRatioButtonLabel(slug) {
      const m = {
        adaptive: '自适应',
        '1x1': '1:1',
        '9x16': '9:16',
        '16x9': '16:9',
        '3x4': '3:4',
        '4x3': '4:3',
        '3x2': '3:2',
        '2x3': '2:3',
        '4x5': '4:5',
        '5x4': '5:4',
        '21x9': '21:9'
      }
      return m[slug] || String(slug || '')
    },
    ngcImageRatioFrameStyle(slug) {
      const map = {
        adaptive: { aspectRatio: '16 / 9', width: '22px' },
        '1x1': { aspectRatio: '1 / 1', width: '13px' },
        '9x16': { aspectRatio: '9 / 16', width: '9px' },
        '16x9': { aspectRatio: '16 / 9', width: '22px' },
        '3x4': { aspectRatio: '3 / 4', width: '11px' },
        '4x3': { aspectRatio: '4 / 3', width: '18px' },
        '3x2': { aspectRatio: '3 / 2', width: '20px' },
        '2x3': { aspectRatio: '2 / 3', width: '11px' },
        '4x5': { aspectRatio: '4 / 5', width: '9px' },
        '5x4': { aspectRatio: '5 / 4', width: '20px' },
        '21x9': { aspectRatio: '21 / 9', width: '26px' }
      }
      const s = map[slug] || map['16x9']
      return {
        aspectRatio: s.aspectRatio,
        width: s.width,
        height: 'auto',
        maxHeight: '14px',
        display: 'block'
      }
    },
    imagePresetSize(aspectKey) {
      const p = IMAGE_ASPECT_PRESETS.find(x => x.key === aspectKey) || IMAGE_ASPECT_PRESETS[0]
      return p && p.size ? p.size : ''
    },
    async executeVideoNode(node, id, map) {
      const ctx = gatherUpstreamText(id, map, this.edges)
      const prompt = [node.data.prompt, ctx].filter(Boolean).join('\n\n')
      const fromUpstream = gatherUpstreamImageUrls(id, map, this.edges)
      const pinned = String(node.data.referenceImageUrl || '').trim()
      const imgs = []
      if (pinned) imgs.push(pinned)
      for (const u of fromUpstream) {
        if (u && !imgs.includes(u)) imgs.push(u)
      }
      const mode = (node.data && node.data.videoMode) || 'ref'
      const useImages = mode !== 't2v' && imgs.length > 0
      const model =
        node.data.seedanceModel != null && String(node.data.seedanceModel).trim()
          ? String(node.data.seedanceModel).trim()
          : undefined
      const duration = Math.min(15, Math.max(1, Math.round(Number(node.data.duration) || 5)))
      const ratio = effectiveVideoRatioForVideoNode(node, map, this.edges)
      const resolution = (node.data.resolution && String(node.data.resolution).trim()) || '720p'
      const hhModel = model && isHappyHorseVideoModel(model) ? model : ''
      let created
      if (hhModel) {
        const hhDuration = Math.min(15, Math.max(2, duration))
        const upstreamVideos = gatherUpstreamVideoUrls(id, map, this.edges)
        created = await createHappyHorseVideoTask({
          prompt: prompt || ' ',
          model: hhModel,
          duration: hhDuration,
          resolution,
          ...(useImages ? { images: imgs } : {}),
          ...(hhModel === 'happyhorse-1.0-video-edit' && upstreamVideos.length
            ? { videoUrl: upstreamVideos[0] }
            : {})
        })
      } else {
        created = await createSeedanceVideoTask({
          prompt: prompt || ' ',
          ...(model ? { model } : {}),
          duration,
          ratio,
          resolution,
          ...(useImages ? { images: imgs } : {})
        })
      }
      const taskId = created && (created.id || created.task_id)
      if (!taskId) throw new Error('未创建视频任务')
      this.$set(node.data, 'taskId', String(taskId))
      const videoUrl = await this.pollVideoUntilUrl(String(taskId), model)
      this.$set(node.data, 'videoUrl', videoUrl)
    },
    async runSingleVideoNode(n) {
      if (!n || n.type !== 'video' || this.isNodeRunning(n.id)) return
      this.flushPromptModelFromDom(n)
      try {
        await this.ensureNgcScoreBeforeRun(n, { label: '生成视频' })
      } catch (e) {
        showErrorToast(e && e.message ? String(e.message) : '积分不足~')
        return
      }
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      this.beginNodeRunning(n.id)
      this.$set(n.data, 'status', 'running')
      try {
        await this.executeVideoNode(n, n.id, map)
        this.$set(n.data, 'status', '完成')
        showSuccessToast('视频生成完成')
      } catch (err) {
        this.$set(n.data, 'status', '失败')
        showErrorToast(err && err.message ? String(err.message) : String(err))
      } finally {
        this.endNodeRunning(n.id)
      }
    },
    syncAudioVolcPublicSpeakerFromPick(n) {
      if (!n || n.type !== 'audio' || !n.data) return
      const pick = String(n.data.volcSpeakerPick || '').trim()
      if (pick && pick !== this.volcSpeakerCustomId) {
        this.$set(n.data, 'volcPublicSpeaker', pick)
      }
    },
    volcAudioBiasDisplay(n, key) {
      if (!n || !n.data) return 0
      const x = Math.round(Number(n.data[key]) || 0)
      return Math.max(-10, Math.min(10, x))
    },
    resetVolcAudioProsody(n) {
      if (!n || n.type !== 'audio' || !n.data) return
      this.$set(n.data, 'volcAudioPitch', 0)
      this.$set(n.data, 'volcAudioSpeed', 0)
      this.$set(n.data, 'volcAudioVolume', 0)
    },
    volcAudioProsodyApiPayload(n) {
      if (!n || !n.data) return {}
      const clampBias = v => {
        const x = Math.round(Number(v) || 0)
        return Math.max(-10, Math.min(10, x))
      }
      const pi = clampBias(n.data.volcAudioPitch)
      const si = clampBias(n.data.volcAudioSpeed)
      const vi = clampBias(n.data.volcAudioVolume)
      const out = {}
      if (pi !== 0) out.pitchBias = pi
      if (si !== 0) out.speedBias = si
      if (vi !== 0) out.volumeBias = vi
      return out
    },
    async executeAudioNode(node, id, map) {
      const inputMode = String(node.data.audioInputMode || 'tts')
      if (inputMode === 'upload') {
        let ref = String(node.data.referenceAudioUrl || '').trim()
        if (!ref) {
          const map2 = Object.fromEntries(this.nodes.map(x => [x.id, x]))
          const upstream = gatherUpstreamAudioUrls(id, map2, this.edges)
          if (upstream.length) ref = upstream[0]
        }
        if (!ref) {
          throw new Error('上传音频模式：请先「选择文件」或接入上游已产出音频的节点')
        }
        this.$set(node.data, 'audioUrl', ref)
        this.$nextTick(() => this.syncAudioNodeHeight(node))
        return
      }

      const ctx = gatherUpstreamSpeechText(id, map, this.edges)
      const textJoined = [node.data.synthText, ctx].filter(Boolean).join('\n\n').trim()
      const text = normalizeVolcTtsBracketText(textJoined).trim()
      if (!text) throw new Error('请输入要合成的文本')
      let ref = String(node.data.referenceAudioUrl || '').trim()
      if (!ref) {
        const upstream = gatherUpstreamAudioUrls(id, map, this.edges)
        if (upstream.length) ref = upstream[0]
      }
      const model = String(node.data.model || '').trim()
      const mode = String(node.data.volcTtsExpressMode || 'default')
      const vi =
        mode === 'voice_instruction' ? String(node.data.volcVoiceInstruction || '').trim() : ''
      const pc = mode === 'prior_context' ? String(node.data.volcPriorContext || '').trim() : ''
      const volcAdditionsApi = {}
      if (vi) volcAdditionsApi.voiceInstruction = vi
      if (pc) volcAdditionsApi.priorContext = pc
      const hasBracketExpression =
        mode === 'default' && /\[[^\]\r\n]+\]/.test(text)

      let audioUrl = ''

      if (model === 'minimax-speech-2.8-hd') {
        if (!ref) {
          throw new Error('兼容链路需要参考音频：请上传或接入上游音频节点')
        }
        audioUrl = await synthesizeClonedVoice({ referenceAudioUrl: ref, text })
      } else if (model === 'volc-doubao-tts-2' || model === 'volc-doubao-tts-2-expressive') {
        const sp = String(node.data.volcPublicSpeaker || '').trim()
        const resFromPreset = getVolcTtsResourceIdForSpeaker(sp)
        const extra =
          model === 'volc-doubao-tts-2-expressive'
            ? { ttsSubModel: 'seed-tts-2.0-expressive' }
            : model === 'volc-doubao-tts-2' && hasBracketExpression
              ? { ttsSubModel: 'seed-tts-2.0-expressive' }
              : {}
        audioUrl = await synthesizeVolcDoubaoTts({
          text,
          ...(sp ? { speaker: sp } : {}),
          ...(resFromPreset ? { resourceId: resFromPreset } : {}),
          ...extra,
          ...volcAdditionsApi,
          ...this.volcAudioProsodyApiPayload(node)
        })
      } else if (model === 'volc-doubao-icl-2') {
        let speakerId = String(node.data.volcSpeakerId || '').trim()
        if (!speakerId) {
          if (!ref) {
            throw new Error('声音复刻需要参考音频：请上传或接入上游音频，并填写「复刻对照文本」')
          }
          const cloneTxt =
            String(node.data.cloneScriptText || '').trim() ||
            String(node.data.synthText || '')
              .split(/\n\n/)[0]
              .trim() ||
            text
          if (!cloneTxt) {
            throw new Error('请填写与参考音频一致的复刻对照文本')
          }
          const reg = await registerVolcDoubaoCloneVoice({
            referenceAudioUrl: ref,
            text: cloneTxt,
            modelType: 4,
            resourceId: 'seed-icl-2.0'
          })
          speakerId = reg.speakerId
          this.$set(node.data, 'volcSpeakerId', speakerId)
        }
        audioUrl = await synthesizeVolcDoubaoTts({
          text,
          speaker: speakerId,
          resourceId: 'seed-icl-2.0',
          ...volcAdditionsApi,
          ...this.volcAudioProsodyApiPayload(node)
        })
      } else {
        if (!ref) {
          throw new Error('请先上传参考音频，或接入上游已产出音频的音频节点')
        }
        audioUrl = await synthesizeClonedVoice({ referenceAudioUrl: ref, text })
      }

      this.$set(node.data, 'audioUrl', audioUrl)
      this.$nextTick(() => this.syncAudioNodeHeight(node))
    },
    async registerVolcCloneForAudioNode(n) {
      if (!n || n.type !== 'audio' || this.isNodeRunning(n.id)) return
      let ref = String(n.data.referenceAudioUrl || '').trim()
      if (!ref) {
        const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
        const upstream = gatherUpstreamAudioUrls(n.id, map, this.edges)
        if (upstream.length) ref = upstream[0]
      }
      if (!ref) {
        showErrorToast('请先上传参考音频或连接上游音频节点')
        return
      }
      const cloneTxt = String(n.data.cloneScriptText || '').trim()
      if (!cloneTxt) {
        showErrorToast('请填写复刻对照文本（须与参考音频内容一致）')
        return
      }
      this.beginNodeRunning(n.id)
      try {
        const reg = await registerVolcDoubaoCloneVoice({
          referenceAudioUrl: ref,
          text: cloneTxt,
          modelType: 4,
          resourceId: 'seed-icl-2.0'
        })
        this.$set(n.data, 'volcSpeakerId', reg.speakerId)
        showSuccessToast('复刻音色已注册，可点击合成朗读下方全文')
      } catch (err) {
        showErrorToast(err && err.message ? String(err.message) : String(err))
      } finally {
        this.endNodeRunning(n.id)
      }
    },
    async runSingleAudioNode(n) {
      if (!n || n.type !== 'audio' || this.isNodeRunning(n.id)) return
      try {
        await this.ensureNgcScoreBeforeRun(n, { label: '语音合成' })
      } catch (e) {
        showErrorToast(e && e.message ? String(e.message) : '积分不足~')
        return
      }
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      this.beginNodeRunning(n.id)
      this.$set(n.data, 'status', 'running')
      try {
        await this.executeAudioNode(n, n.id, map)
        this.$set(n.data, 'status', '完成')
        showSuccessToast(
          String(n.data.audioInputMode || 'tts') === 'upload' ? '已应用上传/上游音频' : '语音合成完成'
        )
      } catch (err) {
        this.$set(n.data, 'status', '失败')
        showErrorToast(err && err.message ? String(err.message) : String(err))
      } finally {
        this.endNodeRunning(n.id)
      }
    },
    async executeImageNode(node, id, map) {
      const inputMode = String(node.data.imageInputMode || 'generate')
      if (inputMode === 'upload') {
        let ref = String(node.data.referenceImageUrl || '').trim()
        if (!ref) {
          const imgs = gatherUpstreamImageUrls(id, map, this.edges)
          if (imgs.length) ref = imgs[0]
        }
        if (!ref) {
          throw new Error('上传图片模式：请先「选择文件」或接入上游已产出图片的节点')
        }
        this.$set(node.data, 'imageUrl', ref)
        return
      }

      const modelIdRaw = node.data.seedreamModel != null ? String(node.data.seedreamModel).trim() : ''
      const paintModelId = resolveNodeImagePaintModelId(modelIdRaw)
      const needsCharacterLlm = nodeNeedsCharacterDesignerLlm(node)

      const ctx = gatherUpstreamTextForImagePrompt(id, map, this.edges)
      const sizeOverrideEarly = String(node.data.seedreamSizeOverride || '').trim()
      const nodePrompt = String(node.data.prompt || '').trim()
      /** 电商详情拆出的图片节点已含完整英文/中文提示词，勿再拼接上游文本（易超 8k 触发「参数不完整」） */
      const skipUpstreamPromptMerge = !!(sizeOverrideEarly && nodePrompt.length > 80)
      let basePrompt = skipUpstreamPromptMerge
        ? nodePrompt
        : [node.data.prompt, ctx].filter(Boolean).join('\n\n')
      const imgs = gatherUpstreamImageUrls(id, map, this.edges)
      const ws = effectiveWorkflowStyleForImageNode(node, map, this.edges)
      const sizeOverride = String(node.data.seedreamSizeOverride || '').trim()
      const aspectKeyForSize = effectiveImageAspectKeyForImageNode(node, map, this.edges)
      const size = sizeOverride || this.imagePresetSize(aspectKeyForSize)
      let nCount = Math.min(8, Math.max(1, Number(node.data.imageCount) || 1))
      if (this.apiYiSingleImageSeedreamModels.includes(paintModelId)) {
        nCount = 1
      }
      let finalPrompt = ''
      let mergedRefs = []
      if (needsCharacterLlm) {
        if (modelIdRaw === 'character-designer' && !ws) {
          throw new Error(
            '角色设计模型：请先在「风格」中选择一种风格（与对话工作流一致，需风格参考）'
          )
        }
        let volcBase = skipUpstreamPromptMerge
          ? nodePrompt
          : [node.data.prompt, ctx].filter(Boolean).join('\n\n').trim()
        volcBase = appendWorkflowStyleMetaForCharacterDesigner(volcBase, ws)
        const paintPrompt = await streamCharacterDesignerPaintPrompt(volcBase)
        finalPrompt = buildFinalCharacterSheetPaintPrompt(paintPrompt, ws)
        const styleImgs = characterSheetStyleRefImages(ws)
        mergedRefs = styleImgs.concat(imgs).filter(Boolean).slice(0, 16)
        nCount = 1
      } else {
        const styleName = ws && ws.name ? String(ws.name) : ''
        const stylePrompt = ws && ws.prompt ? String(ws.prompt).trim() : ''
        if (styleName || stylePrompt) {
          const meta = []
          if (styleName) meta.push('StyleName=' + styleName)
          if (stylePrompt) meta.push('StylePrompt=' + stylePrompt)
          basePrompt = (basePrompt ? basePrompt + '\n\n' : '') + '【已选风格】' + meta.join('；')
        }
        const styleSuffix = buildWorkflowStylePromptSuffix(ws)
        finalPrompt = `${basePrompt || ' '}${styleSuffix}`.trim() || ' '
        const styleRef = pickWorkflowStyleRef(ws)
        mergedRefs = (styleRef ? [styleRef] : []).concat(imgs).filter(Boolean).slice(0, 16)
      }
      const maskUrl = String(node.data.inpaintMaskUrl || '').trim()
      if (this.gptInpaintCapableSeedreamModels.includes(paintModelId) && maskUrl) {
        if (!mergedRefs.length) {
          throw new Error(
            '局部重绘：请先提供首张原图（连接上游图片节点、或选择带参考图的风格，或本地上传参考）'
          )
        }
        const outU = String(node.data.imageUrl || '').trim()
        if (outU) {
          mergedRefs = [outU, ...mergedRefs.filter(u => String(u).trim() !== outU)].slice(0, 16)
        }
      }
      const res = await generateSeedreamImages({
        prompt: finalPrompt,
        n: nCount,
        ...(paintModelId ? { model: paintModelId } : {}),
        ...(size ? { size } : {}),
        ...(mergedRefs.length
          ? { image: mergedRefs[0], images: mergedRefs }
          : {}),
        ...(maskUrl && this.gptInpaintCapableSeedreamModels.includes(paintModelId)
          ? { mask: maskUrl }
          : {})
      })
      const url = pickFirstSeedreamImageUrl(res)
      if (!url) throw new Error('未返回图片数据')
      this.$set(node.data, 'imageUrl', url)
    },
    imageNodeHasGeneratedOutput(n) {
      if (!n || n.type !== 'image' || !n.data) return false
      if (String(n.data.imageInputMode || 'generate') === 'upload') return false
      return !!String(n.data.imageUrl || '').trim()
    },
    openNgcConfirm(opts = {}) {
      return new Promise(resolve => {
        this.ngcConfirmDialog = {
          title: opts.title || '请确认',
          message: opts.message || '',
          confirmText: opts.confirmText || '确定',
          cancelText: opts.cancelText || '取消',
          tone: opts.tone === 'danger' ? 'danger' : 'amber',
          resolve
        }
      })
    },
    resolveNgcConfirm(ok) {
      const dlg = this.ngcConfirmDialog
      if (!dlg) return
      this.ngcConfirmDialog = null
      if (typeof dlg.resolve === 'function') dlg.resolve(!!ok)
    },
    onImageNodeGenerateClick(n) {
      if (!n || n.type !== 'image' || this.isNodeRunning(n.id)) return
      if (this.imageNodeHasGeneratedOutput(n)) {
        this.openNgcConfirm({
          title: '重新生成图片',
          message: '当前节点已有生成结果。继续将用新图覆盖现有图片，并会再次消耗积分。',
          confirmText: '重新生成',
          cancelText: '取消',
          tone: 'amber'
        }).then(ok => {
          if (ok) this.runSingleImageNode(n)
        })
        return
      }
      this.runSingleImageNode(n)
    },
    async runSingleImageNode(n) {
      if (!n || n.type !== 'image' || this.isNodeRunning(n.id)) return
      const isRegenerate = this.imageNodeHasGeneratedOutput(n)
      this.flushPromptModelFromDom(n)
      try {
        await this.ensureNgcScoreBeforeRun(n, { label: '生成图片' })
      } catch (e) {
        showErrorToast(e && e.message ? String(e.message) : '积分不足~')
        return
      }
      if (n.data && n.data.imageInpaintMode) {
        try {
          const ok = await this.commitInpaintMaskFromCanvas(n)
          if (!ok) return
          this.$set(n.data, 'imageInpaintMode', false)
          this._unbindInpaintDocListeners()
          if (this.inpaintOnlineEditorNodeId === n.id) this.inpaintOnlineEditorNodeId = null
        } catch (err) {
          showErrorToast(err && err.message ? String(err.message) : '蒙版保存失败')
          return
        }
      }
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      this.beginNodeRunning(n.id)
      this.$set(n.data, 'status', 'running')
      try {
        await this.executeImageNode(n, n.id, map)
        this.$set(n.data, 'status', '完成')
        showSuccessToast(
          String(n.data.imageInputMode || 'generate') === 'upload'
            ? '已应用上传/上游图片'
            : String(n.data.seedreamModel || '').trim() === 'character-designer'
              ? isRegenerate
                ? '角色设计图已重新生成'
                : '角色设计图生成完成'
              : isRegenerate
                ? '图片已重新生成'
                : '图片生成完成'
        )
      } catch (err) {
        this.$set(n.data, 'status', '失败')
        showErrorToast(err && err.message ? String(err.message) : String(err))
      } finally {
        this.endNodeRunning(n.id)
        this.syncImageNodeLayoutHeight(n)
        this.$nextTick(() => {
          this.scheduleSyncNodeVisualHeights()
          requestAnimationFrame(() => this.scheduleSyncNodeVisualHeights())
        })
      }
    },
    setLlmTextMode(n, key) {
      if (!n || n.type !== 'llm' || !n.data) return
      this.$set(n.data, 'textMode', key)
    },
    /** 模型 id 以 deepseek 开头时显式传 DeepSeek base_url，避免后台仍指向火山 */
    resolveLlmChatBaseUrl(modelId) {
      const m = String(modelId || '').trim().toLowerCase()
      if (m.startsWith('deepseek')) return DEEPSEEK_CHAT_BASE
      return ''
    },
    buildStateSerialized() {
      if (!this._autosavePaused) {
        this.flushAllPromptEditorsFromDom()
      }
      return JSON.stringify({
        version: 1,
        nodes: this.nodes,
        edges: this.edges,
        viewport: { ...this.viewport }
      })
    },
    buildState() {
      return JSON.parse(this.buildStateSerialized())
    },
    applyState(raw) {
      this._autosavePaused = true
      const s = raw && typeof raw === 'object' ? raw : {}
      this.deleteUndoStack = []
      this.selectedEdgeId = null
      this.assetMention = null
      this.clearAssetMentionBlurTimer()
      this.upstreamPreview = null
      this.closeImageStyleLibrary()
      this.closeInlineCanvasPickers()
      this.nodes = Array.isArray(s.nodes) ? s.nodes : []
      this.edges = Array.isArray(s.edges) ? s.edges : []
      let maxZStack = 100
      this.nodes.forEach(n => {
        if (n && n.zStack != null && Number(n.zStack) > maxZStack) {
          maxZStack = Number(n.zStack)
        }
      })
      this.nodeZStack = maxZStack
      this.nodes.forEach(n => {
        if (n.type === 'llm' && n.data && typeof n.data === 'object') {
          if (!n.data.textMode) this.$set(n.data, 'textMode', 'write')
          if (!n.data.model) this.$set(n.data, 'model', LLM_DEFAULT_MODEL)
          if (n.data.inlineVideoUrl == null) this.$set(n.data, 'inlineVideoUrl', '')
        }
        if (n.type === 'image' && n.data && typeof n.data === 'object') {
          if (n.data.seedreamModel == null) this.$set(n.data, 'seedreamModel', '')
          if (!n.data.aspectKey || !IMAGE_ASPECT_PRESETS.some(p => p.key === n.data.aspectKey)) {
            this.$set(n.data, 'aspectKey', '16x9_2k')
          }
          if (n.data.aspectRatioUserPick == null) this.$set(n.data, 'aspectRatioUserPick', false)
          if (n.data.imageCount == null) this.$set(n.data, 'imageCount', 1)
          if (n.data.seedreamSizeOverride == null) this.$set(n.data, 'seedreamSizeOverride', '')
          if (n.data.panelExpanded == null) this.$set(n.data, 'panelExpanded', false)
          if (Object.prototype.hasOwnProperty.call(n.data, 'uiStyle')) {
            try {
              delete n.data.uiStyle
            } catch {
              this.$delete(n.data, 'uiStyle')
            }
          }
          if (n.data.workflowStyle === undefined) this.$set(n.data, 'workflowStyle', null)
          else if (n.data.workflowStyle != null && typeof n.data.workflowStyle !== 'object') {
            this.$set(n.data, 'workflowStyle', null)
          }
          if (n.data.uiMark == null) this.$set(n.data, 'uiMark', false)
          if (n.data.uiFocus == null) this.$set(n.data, 'uiFocus', false)
          if (n.data.uiCharacterDesign == null) this.$set(n.data, 'uiCharacterDesign', false)
          if (n.data.imageInputMode == null) {
            this.$set(n.data, 'imageInputMode', 'generate')
          } else if (n.data.imageInputMode !== 'upload' && n.data.imageInputMode !== 'generate') {
            this.$set(n.data, 'imageInputMode', 'generate')
          }
          if (n.data.referenceImageUrl == null) this.$set(n.data, 'referenceImageUrl', '')
          if (n.data.inpaintMaskUrl == null) this.$set(n.data, 'inpaintMaskUrl', '')
          if (n.data.imageInpaintMode == null) this.$set(n.data, 'imageInpaintMode', false)
          if (n.data.inpaintDrawTool == null) this.$set(n.data, 'inpaintDrawTool', 'brush')
          if (n.data.inpaintBrushSize == null) this.$set(n.data, 'inpaintBrushSize', 28)
          if (n.data.inpaintBrushColor == null) this.$set(n.data, 'inpaintBrushColor', '#ff3355')
        }
        if (n.type === 'video' && n.data && typeof n.data === 'object') {
          if (!n.data.videoMode) this.$set(n.data, 'videoMode', 'ref')
          if (n.data.seedanceModel == null) this.$set(n.data, 'seedanceModel', '')
          if (!n.data.ratio) this.$set(n.data, 'ratio', '16:9')
          if (n.data.ratioUserPick == null) this.$set(n.data, 'ratioUserPick', false)
          if (!n.data.resolution) this.$set(n.data, 'resolution', '720p')
          if (n.data.duration == null) this.$set(n.data, 'duration', 15)
          if (n.data.panelExpanded == null) this.$set(n.data, 'panelExpanded', false)
          if (n.data.uiHd == null) this.$set(n.data, 'uiHd', false)
          if (n.data.uiMark == null) this.$set(n.data, 'uiMark', false)
          if (n.data.uiCam == null) this.$set(n.data, 'uiCam', false)
          if (n.data.uiCharLib == null) this.$set(n.data, 'uiCharLib', false)
          if (n.data.referenceImageUrl == null) this.$set(n.data, 'referenceImageUrl', '')
          if (n.data.seedanceGenerateAudio == null) this.$set(n.data, 'seedanceGenerateAudio', true)
          if (n.data.storyboardShotNo == null) this.$set(n.data, 'storyboardShotNo', '')
          if (n.data.storyboardShotSort == null) this.$set(n.data, 'storyboardShotSort', null)
        }
        if (n.type === 'directorDeck') {
          if (!n.data || typeof n.data !== 'object') {
            this.$set(n, 'data', { directorShotPreviewUrl: '' })
          } else if (n.data.directorShotPreviewUrl == null) {
            this.$set(n.data, 'directorShotPreviewUrl', '')
          }
        }
        if (n.type === 'ecomDetail' && n.data && typeof n.data === 'object') {
          if (n.data.productName == null) this.$set(n.data, 'productName', '')
          if (n.data.sellingPoints == null) this.$set(n.data, 'sellingPoints', '')
          if (n.data.extraPrompt == null) this.$set(n.data, 'extraPrompt', '')
          if (!n.data.platform) this.$set(n.data, 'platform', 'taobao')
          if (!n.data.outputLanguage) {
            this.$set(n.data, 'outputLanguage', ECOM_DETAIL_DEFAULT_OUTPUT_LANGUAGE)
          }
          const ecomSkillId = String(n.data.selectedSkillId || '').trim()
          if (!ecomSkillId) {
            this.$set(n.data, 'selectedSkillId', ECOM_SKILL_PROMPT_EXPERT_ID)
          }
          if (n.data.selectedSkill !== null && typeof n.data.selectedSkill !== 'object') {
            this.$set(n.data, 'selectedSkill', null)
          }
          if (!n.data.seedreamModel) this.$set(n.data, 'seedreamModel', 'doubao-seedream-5-0-260128')
          const dsm = String(n.data.deepseekModel || '').trim()
          if (!dsm.startsWith('deepseek-v4')) {
            this.$set(n.data, 'deepseekModel', 'deepseek-v4-flash')
          }
          if (n.data.useDeepseekPrompt == null) this.$set(n.data, 'useDeepseekPrompt', true)
          if (n.data.slots == null || typeof n.data.slots !== 'object') {
            this.$set(n.data, 'slots', normalizeEcomDetailSlots(null))
          } else {
            this.$set(n.data, 'slots', normalizeEcomDetailSlots(n.data.slots))
          }
          if (!Array.isArray(n.data.promptPlans)) this.$set(n.data, 'promptPlans', [])
          if (n.data.promptRaw == null) this.$set(n.data, 'promptRaw', '')
          if (n.data.upstreamImageAnalysis == null) this.$set(n.data, 'upstreamImageAnalysis', '')
          if (n.data.upstreamImageAnalysisMethod == null) {
            this.$set(n.data, 'upstreamImageAnalysisMethod', '')
          }
          if (n.data.visionModel == null) this.$set(n.data, 'visionModel', '')
          if (!Array.isArray(n.data.referenceImageUrls)) {
            this.$set(n.data, 'referenceImageUrls', [])
          }
          if (!Array.isArray(n.data.spawnedImageNodeIds)) {
            this.$set(n.data, 'spawnedImageNodeIds', [])
          }
          if (!Array.isArray(n.data.outputImages)) this.$set(n.data, 'outputImages', [])
          if (n.data.progress == null) this.$set(n.data, 'progress', '')
          if (n.data.status == null) this.$set(n.data, 'status', '')
        }
        if (n.type === 'uiDesign' && n.data && typeof n.data === 'object') {
          if (n.data.projectName == null) this.$set(n.data, 'projectName', '')
          if (n.data.brief == null) this.$set(n.data, 'brief', '')
          if (n.data.extraPrompt == null) this.$set(n.data, 'extraPrompt', '')
          if (!n.data.platform) this.$set(n.data, 'platform', 'app')
          const legacyStyle = String(n.data.designStyle || '').trim()
          if (n.data.designStyleId) {
            this.$set(n.data, 'designStyleId', normalizeUiDesignStyleId(n.data.designStyleId))
          } else if (legacyStyle) {
            this.$set(n.data, 'designStyleId', UI_DESIGN_STYLE_CUSTOM_ID)
            this.$set(n.data, 'designStyleCustom', legacyStyle)
          } else {
            this.$set(n.data, 'designStyleId', UI_DESIGN_DEFAULT_STYLE_ID)
          }
          if (n.data.designStyleCustom == null) {
            this.$set(n.data, 'designStyleCustom', legacyStyle && n.data.designStyleId === UI_DESIGN_STYLE_CUSTOM_ID ? legacyStyle : '')
          }
          if (!n.data.themeColorPrimary) {
            this.$set(n.data, 'themeColorPrimary', UI_DESIGN_DEFAULT_PRIMARY)
          }
          if (!n.data.themeColorSecondary) {
            this.$set(n.data, 'themeColorSecondary', UI_DESIGN_DEFAULT_SECONDARY)
          }
          if (!n.data.displayMode) this.$set(n.data, 'displayMode', 'frameless')
          if (n.data.screenCount == null) {
            this.$set(n.data, 'screenCount', UI_DESIGN_DEFAULT_SCREEN_COUNT)
          } else {
            this.$set(n.data, 'screenCount', normalizeUiDesignScreenCount(n.data.screenCount))
          }
          this.reconcileUiDesignSkillOnNode(n)
          if (!n.data.seedreamModel) this.$set(n.data, 'seedreamModel', 'doubao-seedream-5-0-260128')
          const udsm = String(n.data.deepseekModel || '').trim()
          if (!udsm.startsWith('deepseek-v4')) {
            this.$set(n.data, 'deepseekModel', 'deepseek-v4-flash')
          }
          if (!Array.isArray(n.data.screenPlans)) this.$set(n.data, 'screenPlans', [])
          if (n.data.promptRaw == null) this.$set(n.data, 'promptRaw', '')
          if (n.data.upstreamImageAnalysis == null) this.$set(n.data, 'upstreamImageAnalysis', '')
          if (n.data.referenceStyleGuide == null) {
            this.$set(
              n.data,
              'referenceStyleGuide',
              String(n.data.upstreamImageAnalysis || '').trim()
            )
          }
          if (n.data.upstreamImageAnalysisMethod == null) {
            this.$set(n.data, 'upstreamImageAnalysisMethod', '')
          }
          if (n.data.visionModel == null) this.$set(n.data, 'visionModel', '')
          if (n.data.applyUpstreamStyleToFields == null) {
            this.$set(n.data, 'applyUpstreamStyleToFields', true)
          }
          if (!Array.isArray(n.data.referenceImageUrls)) {
            this.$set(n.data, 'referenceImageUrls', [])
          }
          if (!Array.isArray(n.data.spawnedImageNodeIds)) {
            this.$set(n.data, 'spawnedImageNodeIds', [])
          }
          if (!Array.isArray(n.data.outputImages)) this.$set(n.data, 'outputImages', [])
          if (n.data.progress == null) this.$set(n.data, 'progress', '')
          if (n.data.status == null) this.$set(n.data, 'status', '')
        }
        if (n.type === 'storyboard' && n.data && typeof n.data === 'object') {
          if (n.data.body == null) this.$set(n.data, 'body', '')
          if (n.data.output == null) this.$set(n.data, 'output', '')
          if (n.data.status == null) this.$set(n.data, 'status', '')
          if (n.data.continuityFromStoryboardId == null) this.$set(n.data, 'continuityFromStoryboardId', '')
          if (n.data.storyboardAspectRatio == null) this.$set(n.data, 'storyboardAspectRatio', '16:9')
          this.reconcileStoryboardNodePickFields(n)
          const mid = String(n.data.model || '').trim()
          if (!mid.startsWith('deepseek-v4')) {
            this.$set(n.data, 'model', 'deepseek-v4-flash')
          }
        }
        if (n.type === 'scriptWrite' && n.data && typeof n.data === 'object') {
          if (n.data.body == null) this.$set(n.data, 'body', '')
          if (n.data.output == null) this.$set(n.data, 'output', '')
          if (n.data.status == null) this.$set(n.data, 'status', '')
          this.reconcileScriptWritePickFields(n)
          const midSw = String(n.data.model || '').trim()
          if (!midSw.startsWith('deepseek-v4')) {
            this.$set(n.data, 'model', 'deepseek-v4-flash')
          }
        }
        if (n.type === 'audio' && n.data && typeof n.data === 'object') {
          if (n.data.synthText == null && n.data.prompt != null) {
            this.$set(n.data, 'synthText', String(n.data.prompt))
          }
          if (n.data.synthText == null) this.$set(n.data, 'synthText', '')
          if (!n.data.tryMode) this.$set(n.data, 'tryMode', 'a2v')
          if (n.data.audioInputMode == null) {
            this.$set(n.data, 'audioInputMode', 'tts')
          } else if (n.data.audioInputMode !== 'upload' && n.data.audioInputMode !== 'tts') {
            this.$set(n.data, 'audioInputMode', 'tts')
          }
          if (!n.data.model) this.$set(n.data, 'model', 'volc-doubao-tts-2')
          if (n.data.referenceAudioUrl == null) this.$set(n.data, 'referenceAudioUrl', '')
          if (n.data.voiceId == null) this.$set(n.data, 'voiceId', '')
          if (n.data.volcSpeakerId == null) this.$set(n.data, 'volcSpeakerId', '')
          if (n.data.volcPublicSpeaker == null) this.$set(n.data, 'volcPublicSpeaker', '')
          if (n.data.volcSpeakerPick == null) {
            this.$set(n.data, 'volcSpeakerPick', inferVolcSpeakerPick(n.data.volcPublicSpeaker))
          }
          if (n.data.cloneScriptText == null) this.$set(n.data, 'cloneScriptText', '')
          if (n.data.audioUrl == null) this.$set(n.data, 'audioUrl', '')
          if (n.data.maxChars == null) this.$set(n.data, 'maxChars', 50000)
          if (n.data.volcVoiceInstruction == null) this.$set(n.data, 'volcVoiceInstruction', '')
          if (n.data.volcPriorContext == null) this.$set(n.data, 'volcPriorContext', '')
          if (n.data.volcTtsExpressMode == null) this.$set(n.data, 'volcTtsExpressMode', 'default')
          if (n.data.volcAudioPitch == null) this.$set(n.data, 'volcAudioPitch', 0)
          if (n.data.volcAudioSpeed == null) this.$set(n.data, 'volcAudioSpeed', 0)
          if (n.data.volcAudioVolume == null) this.$set(n.data, 'volcAudioVolume', 0)
        }
      })
      if (s.viewport && typeof s.viewport === 'object') {
        this.viewport = {
          panX: Number(s.viewport.panX) || 0,
          panY: Number(s.viewport.panY) || 0,
          scale: Math.min(2, Math.max(0.25, Number(s.viewport.scale) || 1))
        }
      }
      this.$nextTick(() => {
        this.reconcileEcomDetailSkillsOnNodes()
        this.reconcileUiDesignSkillsOnNodes()
        this.reconcileAllNodesModelsWithCatalog()
        this.nodes.forEach(n => this.syncNodeCreditDisplayFromModel(n))
        this.nodes.filter(x => x.type === 'audio').forEach(node => this.syncAudioNodeHeight(node))
        this.resyncInpaintNodesAfterProjectLoad()
        this.hydrateAllPromptEditorsFromModel()
        this.scheduleSyncNodeVisualHeights()
        try {
          this._lastCloudSaveFingerprint = this.buildStateSerialized()
        } catch {
          this._lastCloudSaveFingerprint = ''
        }
        this._autosavePaused = false
        this.$nextTick(() => this.hydrateAllPromptEditorsFromModel())
      })
    },
    hasAuthTokenForCloudSave() {
      try {
        return !!(
          (localStorage.getItem('token') || '').trim() ||
          (sessionStorage.getItem('token') || '').trim()
        )
      } catch {
        return false
      }
    },
    setAutoSaveHint(text, autoClearMs) {
      this.autoSaveHint = text ? String(text) : ''
      if (this._autoSaveHintTimer) {
        clearTimeout(this._autoSaveHintTimer)
        this._autoSaveHintTimer = null
      }
      if (text && autoClearMs > 0) {
        this._autoSaveHintTimer = setTimeout(() => {
          this._autoSaveHintTimer = null
          this.autoSaveHint = ''
        }, autoClearMs)
      }
    },
    /** 编辑防抖：本机 + 云端 */
    scheduleAutosave() {
      if (this._autosavePaused || !this.projectUuid) return
      if (this.saveTimer) clearTimeout(this.saveTimer)
      this.saveTimer = setTimeout(() => {
        this.saveTimer = null
        this.persistProjectAfterMutation({ cloudDelayMs: NGC_CLOUD_SAVE_DEBOUNCE_MS })
      }, NGC_EDIT_AUTOSAVE_MS)
    },
    /** 接口提交/返回导致画布变更：立即写本机并尽快同步云端 */
    persistProjectAfterMutation(opts = {}) {
      if (this._autosavePaused || !this.projectUuid) return
      this.flushAllPromptEditorsFromDom()
      try {
        this.persistRecentProjectSnapshot()
      } catch (e) {
        console.warn('[NodeGraphCanvas] local persist failed', e)
      }
      if (!this.hasAuthTokenForCloudSave()) {
        this.setAutoSaveHint('已保存到本机', 3000)
        return
      }
      const delay =
        opts.cloudDelayMs != null ? Number(opts.cloudDelayMs) : NGC_CLOUD_SAVE_AFTER_API_MS
      if (this._hasRunsBlockingCurrentProjectSave()) {
        this._pendingCloudSaveAfterRun = true
        return
      }
      this.queueCloudProjectSave(delay)
    },
    queueCloudProjectSave(delayMs) {
      if (this._autosavePaused || !this.projectUuid || !this.hasAuthTokenForCloudSave()) return
      if (this.cloudSaveTimer) clearTimeout(this.cloudSaveTimer)
      const ms = Math.max(200, Number(delayMs) || NGC_CLOUD_SAVE_AFTER_API_MS)
      this.cloudSaveTimer = setTimeout(() => {
        this.cloudSaveTimer = null
        this.flushCloudProjectSave()
      }, ms)
    },
    flushPendingCloudSaveAfterRun(delayMs) {
      if (!this._pendingCloudSaveAfterRun || this._hasRunsBlockingCurrentProjectSave()) {
        return
      }
      this._pendingCloudSaveAfterRun = false
      this.queueCloudProjectSave(delayMs != null ? delayMs : 300)
    },
    async flushCloudProjectSave() {
      if (this._autosavePaused || !this.projectUuid || !this.hasAuthTokenForCloudSave()) return
      if (this.saving || this.autoSaving) return
      if (this._hasRunsBlockingCurrentProjectSave()) {
        this._pendingCloudSaveAfterRun = true
        return
      }
      let fp = ''
      let state = null
      try {
        fp = this.buildStateSerialized()
        state = JSON.parse(fp)
      } catch {
        return
      }
      if (fp && fp === this._lastCloudSaveFingerprint) return
      this.autoSaving = true
      this.setAutoSaveHint('正在同步到云端…', 0)
      try {
        const thumb = pickFirstImageThumb(this.nodes)
        await saveNodeCanvas({
          uuid: this.projectUuid,
          title: this.projectTitle,
          thumb_url: thumb,
          state
        })
        this._lastCloudSaveFingerprint = fp
        this.setAutoSaveHint('已自动保存到云端', 4000)
      } catch (e) {
        console.warn('[NodeGraphCanvas] cloud autosave failed', e)
        this.setAutoSaveHint('云端保存失败，本机副本已保留', 5000)
      } finally {
        this.autoSaving = false
      }
    },
    formatProjectListTime(raw) {
      if (raw == null || raw === '') return '—'
      const s = String(raw).trim()
      if (!s) return '—'
      const d = new Date(s.includes('T') ? s : s.replace(' ', 'T'))
      if (Number.isNaN(d.getTime())) return s.length > 18 ? s.slice(0, 16) : s
      const now = new Date()
      const pad = n => (n < 10 ? '0' + n : '' + n)
      const hm = `${pad(d.getHours())}:${pad(d.getMinutes())}`
      if (d.toDateString() === now.toDateString()) return `今天 ${hm}`
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${hm}`
    },
    onProjectThumbError(p) {
      if (p && p.thumb_url) this.$set(p, 'thumb_url', '')
    },
    readRecentProjectsFromStorage() {
      try {
        const raw = localStorage.getItem(NODE_CANVAS_RECENT_LS)
        const arr = raw ? JSON.parse(raw) : []
        return Array.isArray(arr) ? arr : []
      } catch {
        return []
      }
    },
    persistRecentProjectSnapshot() {
      const uuid = this.projectUuid
      if (!uuid) return
      const thumb = pickFirstImageThumb(this.nodes)
      let json = ''
      try {
        json = this.buildStateSerialized()
      } catch {
        return
      }
      try {
        localStorage.setItem(NODE_CANVAS_STATE_PREFIX + uuid, json)
      } catch {
        /* quota 等 */
      }
      const rec = {
        uuid,
        title: (this.projectTitle && String(this.projectTitle).trim()) || '未命名画布',
        thumb_url: thumb ? String(thumb).trim() : '',
        updated_at: new Date().toISOString()
      }
      try {
        let arr = this.readRecentProjectsFromStorage()
        arr = [rec, ...arr.filter(x => x && x.uuid !== uuid)].slice(0, 40)
        localStorage.setItem(NODE_CANVAS_RECENT_LS, JSON.stringify(arr))
      } catch {
        /* ignore */
      }
    },
    loadLocalCachedState(uuid) {
      const id = String(uuid || '').trim()
      if (!id) return null
      try {
        const raw = localStorage.getItem(NODE_CANVAS_STATE_PREFIX + id)
        if (!raw) return null
        const s = JSON.parse(raw)
        return s && typeof s === 'object' ? s : null
      } catch {
        return null
      }
    },
    mergeServerAndLocalProjectRows(mappedServer) {
      const byUuid = new Map()
      for (const p of mappedServer) {
        if (p && p.uuid) {
          byUuid.set(p.uuid, { ...p, _localOnly: false })
        }
      }
      for (const loc of this.readRecentProjectsFromStorage()) {
        if (!loc || !loc.uuid) continue
        const id = String(loc.uuid)
        const ex = byUuid.get(id)
        if (!ex) {
          byUuid.set(id, {
            uuid: id,
            title: (loc.title && String(loc.title).trim()) || '未命名画布',
            thumb_url: (loc.thumb_url && String(loc.thumb_url).trim()) || '',
            updated_at: loc.updated_at || '',
            created_at: loc.created_at || '',
            _localOnly: true
          })
        } else if (!ex.thumb_url && loc.thumb_url) {
          ex.thumb_url = String(loc.thumb_url).trim()
        }
      }
      const out = Array.from(byUuid.values())
      out.sort((a, b) => {
        const ta = +new Date(a.updated_at || 0)
        const tb = +new Date(b.updated_at || 0)
        return tb - ta
      })
      return out
    },
    apiErrorMessage(e) {
      const d = e && e.response && e.response.data
      const m =
        (d && (d.message || d.msg || d.error)) ||
        (e && e.message) ||
        (e && String(e))
      return m ? String(m).slice(0, 220) : '请求失败'
    },
    async refreshList() {
      this.listError = ''
      let serverHint = ''
      let mapped = []
      try {
        const pack = await fetchNodeCanvasList({ limit: 50 })
        serverHint = pack.listError ? String(pack.listError) : ''
        mapped = (pack.rows || []).map(r => ({
          uuid: String(r.uuid || ''),
          title: (r.title && String(r.title).trim()) || '未命名画布',
          thumb_url: (r.thumb_url && String(r.thumb_url).trim()) || '',
          updated_at: r.updated_at != null ? r.updated_at : r.updatedAt,
          created_at: r.created_at != null ? r.created_at : r.createdAt,
          _localOnly: false
        }))
      } catch (e) {
        serverHint = this.apiErrorMessage(e)
      }
      this.projectList = this.mergeServerAndLocalProjectRows(mapped)
      if (this.projectList.length === 0) {
        this.listError =
          serverHint ||
          '暂无项目。请先登录并点击「保存到云端」，或确认代理 /node_canvas_projects 指向已部署的后端。'
      } else if (serverHint && mapped.length === 0) {
        this.listError = `${serverHint}（下列含本机最近保存，可点击打开）`
      } else if (serverHint) {
        this.listError = serverHint
      }
    },
    newProject() {
      this.prepareProjectSwitch(this.projectUuid)
      this.projectUuid = genId()
      this.projectTitle = '未命名画布'
      this.deleteUndoStack = []
      this.nodes = []
      this.edges = []
      this.nodeZStack = 100
      this.canvasTool = 'select'
      this.viewport = { panX: 80, panY: 60, scale: 1 }
      this.selectedId = null
      this.selectedEdgeId = null
      this.assetMention = null
      this.clearAssetMentionBlurTimer()
      this.upstreamPreview = null
      this.closeInlineCanvasPickers()
      showSuccessToast('已新建本地项目，记得保存')
    },
    onSidebarProjectClick(p) {
      const id = p && p.uuid != null ? String(p.uuid).trim() : ''
      if (!id) {
        showErrorToast('项目 ID 无效')
        return
      }
      void this.loadRemoteProject(id)
    },
    async loadRemoteProject(uuid) {
      const id = String(uuid || '').trim()
      if (!id) {
        showErrorToast('项目 ID 无效')
        return
      }

      const prevUuid = String(this.projectUuid || '').trim()
      let leavingLocalPersist = null
      if (prevUuid && prevUuid !== id) {
        if (!this._hasActiveRunsForProject(prevUuid)) {
          this.flushAllPromptEditorsFromDom()
          leavingLocalPersist = {
            uuid: prevUuid,
            title: this.projectTitle,
            nodes: this.nodes,
            edges: this.edges,
            viewport: { ...this.viewport }
          }
        }
        this.prepareProjectSwitch(prevUuid)
      }

      const loadToken = ++this.ngcLoadProjectToken
      this._autosavePaused = true
      const row = (this.projectList || []).find(p => p && p.uuid === id)
      const titleFromList = this._resolveProjectTitle(id, row)

      try {
        this.projectUuid = id
        this.projectTitle = titleFromList
        this.selectedId = null
        this.selectedEdgeId = null

        const liveWc = this.ngcProjectWorkingCopies[id]
        if (liveWc && this._hasActiveRunsForProject(id)) {
          this._applyWorkingCopyState(id, liveWc)
          if (prevUuid && prevUuid !== id) {
            void this.persistRecentProjectSnapshotFor(prevUuid, leavingLocalPersist)
          }
          showSuccessToast('已恢复进行中的项目')
          return
        }

        const localSt = this.loadLocalCachedState(id)
        if (localSt) {
          try {
            this.applyState(localSt)
          } catch (err) {
            console.warn('[NodeGraphCanvas] apply local state failed', err)
            showErrorToast('本机缓存损坏，正在尝试云端加载…')
          }
        }

        try {
          const d = await fetchNodeCanvasDetail(id)
          if (loadToken !== this.ngcLoadProjectToken) return
          const wcAfterFetch = this.ngcProjectWorkingCopies[id]
          if (wcAfterFetch && this._hasActiveRunsForProject(id)) {
            this._applyWorkingCopyState(id, wcAfterFetch)
            showSuccessToast('已恢复进行中的项目')
          } else {
            this.projectUuid = String(d.uuid || id)
            this.projectTitle = d.title || titleFromList
            try {
              this.applyState(d.state)
            } catch (err) {
              console.warn('[NodeGraphCanvas] apply remote state failed', err)
              if (!localSt) {
                this.applyState({
                  nodes: [],
                  edges: [],
                  viewport: { panX: 80, panY: 60, scale: 1 }
                })
                showErrorToast('项目数据异常，已打开空白画布')
              }
            }
            if (!localSt) showSuccessToast('已加载项目')
          }
        } catch (e) {
          if (loadToken !== this.ngcLoadProjectToken) return
          if (localSt) {
            showSuccessToast('已用本机缓存打开（尚未保存到云端）')
          } else {
            this.projectUuid = id
            this.projectTitle = titleFromList
            this.applyState({
              nodes: [],
              edges: [],
              viewport: { panX: 80, panY: 60, scale: 1 }
            })
            const msg = e && e.message ? String(e.message) : '加载失败'
            showErrorToast(`${msg}（已打开空白画布，编辑后请保存）`)
          }
        }

        if (loadToken !== this.ngcLoadProjectToken) return

        try {
          sessionStorage.setItem(NGC_LAST_OPENED_CANVAS_KEY, id)
        } catch {
          /* ignore */
        }

        if (prevUuid && prevUuid !== id) {
          void this.persistRecentProjectSnapshotFor(prevUuid, leavingLocalPersist)
        }

        if (this.ngcProjectWorkingCopies[id] && !this._hasActiveRunsForProject(id)) {
          void this.persistDetachedProject(id)
        }
      } catch (err) {
        console.warn('[NodeGraphCanvas] loadRemoteProject failed', err)
        showErrorToast(err && err.message ? String(err.message) : '切换项目失败')
      } finally {
        this._autosavePaused = false
        this.$nextTick(() => {
          try {
            this.applyRouteNgcDirectorReturn()
          } catch {
            /* ignore */
          }
        })
      }
    },
    /** 切换走后异步写入离开项目的本机快照（不阻塞 UI） */
    persistRecentProjectSnapshotFor(projectUuid, captured) {
      const uuid = String(projectUuid || '').trim()
      if (!uuid) return
      setTimeout(() => {
        try {
          const wc = this.ngcProjectWorkingCopies[uuid]
          let state = null
          if (wc && this._hasActiveRunsForProject(uuid)) {
            state = {
              version: 1,
              nodes: wc.nodes,
              edges: wc.edges,
              viewport: { ...(wc.viewport || {}) }
            }
          } else if (captured && captured.uuid === uuid) {
            state = {
              version: 1,
              nodes: captured.nodes,
              edges: captured.edges,
              viewport: { ...(captured.viewport || {}) }
            }
          }
          if (!state) return
          localStorage.setItem(NODE_CANVAS_STATE_PREFIX + uuid, JSON.stringify(state))
          const thumb = pickFirstImageThumb(state.nodes)
          const title =
            (captured && captured.title && String(captured.title).trim()) ||
            (wc && wc.projectTitle && String(wc.projectTitle).trim()) ||
            '未命名画布'
          let arr = this.readRecentProjectsFromStorage()
          const rec = {
            uuid,
            title,
            thumb_url: thumb ? String(thumb).trim() : '',
            updated_at: new Date().toISOString()
          }
          arr = [rec, ...arr.filter(x => x && x.uuid !== uuid)].slice(0, 40)
          localStorage.setItem(NODE_CANVAS_RECENT_LS, JSON.stringify(arr))
        } catch {
          /* ignore */
        }
      }, 0)
    },
    async saveProject(silent) {
      if (!this.projectUuid) return
      if (this.cloudSaveTimer) {
        clearTimeout(this.cloudSaveTimer)
        this.cloudSaveTimer = null
      }
      this.saving = true
      try {
        const thumb = pickFirstImageThumb(this.nodes)
        const state = this.buildState()
        await saveNodeCanvas({
          uuid: this.projectUuid,
          title: this.projectTitle,
          thumb_url: thumb,
          state
        })
        try {
          this._lastCloudSaveFingerprint = this.buildStateSerialized()
        } catch {
          this._lastCloudSaveFingerprint = ''
        }
        this.persistRecentProjectSnapshot()
        this.setAutoSaveHint('已保存到云端', 4000)
        if (!silent) showSuccessToast('已保存')
        this.refreshList()
      } catch (e) {
        showErrorToast(e && e.message ? String(e.message) : '保存失败')
      } finally {
        this.saving = false
        /** 保存会 refreshList / 主线程序列化 state，易触发侧栏与节点区重绘，显示层 canvas 可能被换新 DOM；此处按蒙版重画棋盘预览 */
        this._resyncAllInpaintSurfaces()
      }
    },
    goSimpleWorkspace() {
      this.$router.push({ path: '/workspace', query: { simple: '1' } }).catch(() => {})
    },
    goHome() {
      this.$router.push('/').catch(() => {})
    },
    screenToWorld(clientX, clientY) {
      const el = this.$refs.viewEl
      if (!el) return { x: 0, y: 0 }
      const r = el.getBoundingClientRect()
      const lx = clientX - r.left
      const ly = clientY - r.top
      const v = this.viewport
      return {
        x: (lx - v.panX) / v.scale,
        y: (ly - v.panY) / v.scale
      }
    },
    /** 平移拖拽中：直接改 DOM，避免每帧触发含全部节点的 Vue 渲染 */
    _applyViewportPanDom(panX, panY) {
      const sc = Math.max(0.25, Math.min(2, Number(this.viewport.scale) || 1))
      const layer = this.$refs.viewWorldLayerEl
      if (layer && layer.style) {
        layer.style.transform = `translate3d(${panX}px, ${panY}px, 0) scale(${sc})`
        layer.style.transformOrigin = '0 0'
        if (!layer._ngcPanWillSet) {
          layer.style.willChange = 'transform'
          layer._ngcPanWillSet = 1
        }
      }
      const grid = this.$refs.viewGridEl
      if (grid && grid.style) {
        grid.style.backgroundPosition = `${panX}px ${panY}px`
      }
    },
    _clearPanDomHints() {
      const layer = this.$refs.viewWorldLayerEl
      if (layer && layer.style) {
        layer.style.willChange = ''
        delete layer._ngcPanWillSet
      }
    },
    onWheel(e) {
      const el = this.$refs.viewEl
      if (!el) return
      const r = el.getBoundingClientRect()
      const lx = e.clientX - r.left
      const ly = e.clientY - r.top
      const delta = e.deltaY > 0 ? -0.08 : 0.08
      const nextScale = Math.min(2, Math.max(0.25, this.viewport.scale + delta))
      const wx = (lx - this.viewport.panX) / this.viewport.scale
      const wy = (ly - this.viewport.panY) / this.viewport.scale
      this.viewport.panX = lx - wx * nextScale
      this.viewport.panY = ly - wy * nextScale
      this.viewport.scale = nextScale
    },
    zoom(d) {
      const nextScale = Math.min(2, Math.max(0.25, this.viewport.scale + d))
      this.viewport.scale = nextScale
    },
    /**
     * 一键整理：有边子图按层从左到右；列内自上而下等距，各列按「最高列」垂直居中对齐（多对一汇点与左侧整列视觉居中）。
     * 孤立节点不参与分层，在右侧用与 VideoCopy 项目列表一致的 2/3/4 列网格；坐标对齐 24px。
     * 列间距 / 行间距偏大，整理后节点之间更疏朗，便于扫线与拖拽（列间 gutter 约 320px）。
     * 同列内图片/视频节点按镜号或画布位置自上而下排列；整理完成后全局序号与 y 坐标一致。
     */
    tidyCanvasLayout() {
      const nodes = this.nodes || []
      if (!nodes.length) return

      const gridSnap = v => Math.round(Number(v) / 24) * 24
      const libTvGridCols = vw => {
        const w = Number(vw) || 1280
        if (w >= 1280) return 4
        if (w >= 768) return 3
        return 2
      }

      const incident = new Set()
      for (const e of this.edges || []) {
        if (!e || !e.from || !e.to) continue
        incident.add(e.from.nodeId)
        incident.add(e.to.nodeId)
      }
      const connectedList = nodes.filter(n => n.id && incident.has(n.id))
      const isolatedList = nodes.filter(n => n.id && !incident.has(n.id))
      const connSet = new Set(connectedList.map(n => n.id))
      const connEdges = (this.edges || []).filter(
        e => e && e.from && e.to && connSet.has(e.from.nodeId) && connSet.has(e.to.nodeId)
      )

      const idSet = connSet
      const layer = Object.fromEntries(connectedList.map(n => [n.id, 0]))

      let ordered = null
      if (connectedList.length) {
        try {
          ordered = topoSort(connectedList, connEdges)
        } catch {
          ordered = null
        }
        if (ordered) {
          for (const id of ordered) {
            const preds = predecessorIds(id, connEdges).filter(pid => idSet.has(pid))
            let L = 0
            for (const p of preds) L = Math.max(L, layer[p] + 1)
            layer[id] = L
          }
        } else {
          const cap = Math.min(120, Math.max(30, connectedList.length * 3))
          for (let i = 0; i < cap; i++) {
            for (const e of connEdges) {
              layer[e.to.nodeId] = Math.max(layer[e.to.nodeId], layer[e.from.nodeId] + 1)
            }
          }
        }
      }

      const byLayer = new Map()
      for (const n of connectedList) {
        const L = layer[n.id] || 0
        if (!byLayer.has(L)) byLayer.set(L, [])
        byLayer.get(L).push(n)
      }
      for (const [, arr] of byLayer) {
        arr.sort((a, b) => this.compareNodesForTidyLayout(a, b))
      }

      const gapCol = 320
      const gapRow = 88
      const originX = 72
      const originY = 72
      const layerKeys = Array.from(byLayer.keys()).sort((a, b) => a - b)

      const colLayouts = []
      let colX = originX
      for (const L of layerKeys) {
        const arr = byLayer.get(L) || []
        if (!arr.length) continue
        const colW = Math.max(...arr.map(n => Math.max(120, Number(n.w) || 0)))
        const slots = []
        let acc = 0
        for (const n of arr) {
          const h = Math.max(72, Number(n.h) || 160)
          slots.push({ n, localTop: acc, h })
          acc += h + gapRow
        }
        const colH = slots.length ? slots[slots.length - 1].localTop + slots[slots.length - 1].h : 0
        colLayouts.push({ colX, colW, slots, colH })
        colX += colW + gapCol
      }

      const maxColH = colLayouts.length ? Math.max(...colLayouts.map(c => c.colH)) : 0
      for (const col of colLayouts) {
        const vShift = (maxColH - col.colH) / 2
        for (const { n, localTop } of col.slots) {
          this.$set(n, 'x', gridSnap(col.colX))
          this.$set(n, 'y', gridSnap(originY + vShift + localTop))
        }
      }

      let gridStartX = gridSnap(originX)
      let gridStartY = gridSnap(originY)
      if (connectedList.length) {
        let maxRight = -Infinity
        let minYConn = Infinity
        for (const n of connectedList) {
          const w = Math.max(120, Number(n.w) || 0)
          maxRight = Math.max(maxRight, n.x + w)
          minYConn = Math.min(minYConn, n.y)
        }
        gridStartX = gridSnap(maxRight + gapCol)
        gridStartY = gridSnap(minYConn)
      }

      const viewEl = this.$refs.viewEl
      const vw = viewEl ? viewEl.clientWidth : 1280
      const libCols = libTvGridCols(vw)
      const gapLib = 28

      if (isolatedList.length) {
        const sortedIso = [...isolatedList].sort((a, b) => this.compareNodesForTidyLayout(a, b))
        const colsEff = Math.min(libCols, sortedIso.length)
        const cellW = Math.max(
          ...sortedIso.map(n => Math.max(120, Number(n.w) || 0) + gapLib),
          120 + gapLib
        )
        const cellH = Math.max(
          ...sortedIso.map(n => Math.max(72, Number(n.h) || 160) + gapLib),
          72 + gapLib
        )
        for (let i = 0; i < sortedIso.length; i++) {
          const n = sortedIso[i]
          const col = i % colsEff
          const row = Math.floor(i / colsEff)
          this.$set(n, 'x', gridSnap(gridStartX + col * cellW))
          this.$set(n, 'y', gridSnap(gridStartY + row * cellH))
        }
      }

      this.syncNodeSequenceNumbersAfterTidyLayout()

      this.$nextTick(() => {
        this.nodes.forEach(n => {
          if (n.type === 'audio') this.syncAudioNodeHeight(n)
        })
        this.fitView()
      })

      let msg = ''
      if (!connectedList.length && isolatedList.length) {
        msg = `已按项目列表网格整理（${Math.min(libCols, isolatedList.length)} 列）`
      } else if (connectedList.length) {
        msg = ordered ? '已分层整理，各列相对最高列垂直居中' : '已整理（含环路近似分层），各列垂直居中'
        if (isolatedList.length) {
          msg += `；孤立 ${isolatedList.length} 个已在右侧网格`
        }
      }
      showSuccessToast(msg || '已整理')
    },
    fitView() {
      if (!this.nodes.length) return
      let minX = Infinity
      let minY = Infinity
      let maxX = -Infinity
      let maxY = -Infinity
      for (const n of this.nodes) {
        minX = Math.min(minX, n.x)
        minY = Math.min(minY, n.y)
        maxX = Math.max(maxX, n.x + n.w)
        maxY = Math.max(maxY, n.y + n.h)
      }
      const pad = 80
      const bw = maxX - minX + pad * 2
      const bh = maxY - minY + pad * 2
      const el = this.$refs.viewEl
      if (!el) return
      const rw = el.clientWidth
      const rh = el.clientHeight
      const s = Math.min(rw / bw, rh / bh, 1.2)
      this.viewport.scale = Math.min(2, Math.max(0.35, s))
      this.viewport.panX = (rw - (minX + maxX) * this.viewport.scale) / 2
      this.viewport.panY = (rh - (minY + maxY) * this.viewport.scale) / 2
    },
    _unbindMinimapWindow() {
      if (this._minimapBoundMove) {
        window.removeEventListener('mousemove', this._minimapBoundMove)
        this._minimapBoundMove = null
      }
      if (this._minimapBoundUp) {
        window.removeEventListener('mouseup', this._minimapBoundUp)
        this._minimapBoundUp = null
      }
      this._minimapDrag = null
    },
    ngcMinimapClientToWorld(ev) {
      const svg = this.$refs.ngcMinimapSvg
      if (!svg || !ev || typeof ev.clientX !== 'number') return null
      try {
        if (!svg.createSVGPoint || !svg.getScreenCTM) return null
        const ctm = svg.getScreenCTM()
        if (!ctm) return null
        const inv = ctm.inverse()
        if (!inv) return null
        const pt = svg.createSVGPoint()
        pt.x = ev.clientX
        pt.y = ev.clientY
        const p = pt.matrixTransform(inv)
        return { x: p.x, y: p.y }
      } catch (_) {
        return null
      }
    },
    onMinimapMouseDown(ev) {
      if (ev.button !== 0) return
      ev.stopPropagation()
      const w = this.ngcMinimapClientToWorld(ev)
      if (!w) return
      const sc = Math.max(0.25, Math.min(2, Number(this.viewport.scale) || 1))
      this._unbindMinimapWindow()
      this._minimapDrag = {
        w0x: w.x,
        w0y: w.y,
        pan0x: this.viewport.panX,
        pan0y: this.viewport.panY,
        sc,
        sx0: ev.clientX,
        sy0: ev.clientY
      }
      this._minimapBoundMove = e => this._onMinimapWindowMove(e)
      this._minimapBoundUp = e => this._onMinimapWindowUp(e)
      window.addEventListener('mousemove', this._minimapBoundMove)
      window.addEventListener('mouseup', this._minimapBoundUp)
    },
    _onMinimapWindowMove(ev) {
      const d = this._minimapDrag
      if (!d) return
      const w = this.ngcMinimapClientToWorld(ev)
      if (!w) return
      const sc = d.sc
      this.viewport.panX = d.pan0x - (w.x - d.w0x) * sc
      this.viewport.panY = d.pan0y - (w.y - d.w0y) * sc
      this._applyViewportPanDom(this.viewport.panX, this.viewport.panY)
    },
    _onMinimapWindowUp(ev) {
      const d = this._minimapDrag
      this._unbindMinimapWindow()
      if (!d) return
      const cx = ev && typeof ev.clientX === 'number' ? ev.clientX : d.sx0
      const cy = ev && typeof ev.clientY === 'number' ? ev.clientY : d.sy0
      const dist = Math.hypot(cx - d.sx0, cy - d.sy0)
      if (dist > 6) return
      const el = this.$refs.viewEl
      if (!el) return
      const rw = el.clientWidth
      const rh = el.clientHeight
      const sc = d.sc
      const w = this.ngcMinimapClientToWorld(ev)
      if (!w) return
      this.viewport.panX = rw / 2 - w.x * sc
      this.viewport.panY = rh / 2 - w.y * sc
      this._applyViewportPanDom(this.viewport.panX, this.viewport.panY)
    },
    bindGlobalPointer() {
      this._boundMove = e => this.onGlobalMove(e)
      this._boundUp = e => this.onGlobalUp(e)
      window.addEventListener('mousemove', this._boundMove)
      window.addEventListener('mouseup', this._boundUp)
    },
    unbindGlobalPointer() {
      if (this._boundMove) window.removeEventListener('mousemove', this._boundMove)
      if (this._boundUp) window.removeEventListener('mouseup', this._boundUp)
    },
    ngcIsBlankCanvasTarget(target) {
      if (!target || !target.closest) return false
      if (
        target.closest(
          '.ngc-node, [data-nc-in], [data-nc-out], .ngc-edge-hit, .ngc-connect-menu, .ngc-add-menu, .ngc-minimap, button, a, input, textarea, select, label, .ngc-inline-model-picker, .ngc-video-spec-popover, .ngc-image-aspect-picker, .ngc-image-node-toolbar'
        )
      ) {
        return false
      }
      const view = this.$refs.viewEl
      return !!(view && view.contains(target))
    },
    ngcActivateHandToolForCanvasPan() {
      this.selectedId = null
      this.selectedEdgeId = null
      this.upstreamPreview = null
      this.assetMention = null
      this.clearAssetMentionBlurTimer()
      if (this.canvasTool !== 'hand') {
        this.canvasTool = 'hand'
      }
    },
    beginViewportPan(e) {
      if (!e) return
      e.preventDefault()
      this.isPanning = true
      this.panStart = {
        x: e.clientX,
        y: e.clientY,
        px: this.viewport.panX,
        py: this.viewport.panY
      }
    },
    shouldStartViewportPan(e) {
      if (!e) return false
      return (
        e.button === 1 ||
        (e.button === 0 && e.altKey) ||
        (e.button === 0 && this.canvasTool === 'hand') ||
        (e.button === 0 && this.ngcIsBlankCanvasTarget(e.target))
      )
    },
    onWorldMouseDown(e) {
      const onBg =
        e.target && e.target.closest && e.target.closest('[data-nc-canvas-bg]')
      if (e.button === 0 && !e.altKey && onBg) {
        this.ngcActivateHandToolForCanvasPan()
      }
      if (this.shouldStartViewportPan(e)) {
        this.beginViewportPan(e)
      }
    },
    onWorldDblClick(e) {
      const w = this.screenToWorld(e.clientX, e.clientY)
      this.addMenu = { wx: w.x, wy: w.y, sx: e.clientX, sy: e.clientY }
    },
    onDocClick(e) {
      const t = e && e.target
      if (this.addMenu && (!t || !t.closest || !t.closest('.ngc-add-menu'))) {
        this.addMenu = null
      }
      if (this.showAddBar) {
        if (t && t.closest && !t.closest('.relative.inline-block')) {
          this.showAddBar = false
        }
      }
    },
    /** 连线菜单用 mousedown 关闭：避免拖线松手后的合成 click 立刻把菜单关掉 */
    onDocMouseDown(e) {
      if (e.button !== 0) return
      const t = e.target
      if (this.connectMenu && (!t || !t.closest || !t.closest('.ngc-connect-menu'))) {
        this.connectMenu = null
      }
      if (
        this.imageToolbarMenu &&
        (!t || !t.closest || !t.closest('.ngc-image-node-toolbar'))
      ) {
        this.imageToolbarMenu = null
      }
      if (
        this.imageAspectPickerNodeId != null &&
        (!t || !t.closest || !t.closest('.ngc-image-aspect-picker'))
      ) {
        this.imageAspectPickerNodeId = null
      }
      if (
        (this.imageModelPickerNodeId != null ||
          this.storyboardModelPickerNodeId != null ||
          this.llmModelPickerNodeId != null ||
          this.videoModelPickerNodeId != null ||
          this.audioModelPickerNodeId != null) &&
        (!t || !t.closest || !t.closest('.ngc-inline-model-picker'))
      ) {
        this.closeAllNgInlineModelPickers()
      }
      if (
        this.videoSpecPanelNodeId != null &&
        (!t || !t.closest || !t.closest('.ngc-video-spec-popover'))
      ) {
        this.videoSpecPanelNodeId = null
      }
    },
    toggleAddBar() {
      this.showAddBar = !this.showAddBar
    },
    onViewMouseDown(e) {
      if (this.ngcUpstreamThumbMenu) {
        const t = e.target
        if (!t || !t.closest || !t.closest('.ngc-upstream-thumb-menu')) {
          this.ngcUpstreamThumbMenu = null
        }
      }
      if (this.showAddBar) {
        const t = e.target
        if (!t || !t.closest || !t.closest('.relative.inline-block')) {
          this.showAddBar = false
        }
      }
      const onBg =
        e.target && e.target.closest && e.target.closest('[data-nc-canvas-bg]')
      if (e.button === 0 && !e.altKey && !onBg && this.ngcIsBlankCanvasTarget(e.target)) {
        this.ngcActivateHandToolForCanvasPan()
        this.beginViewportPan(e)
      }
    },
    addNodeAtViewportCenter(type) {
      const el = this.$refs.viewEl
      if (!el) return
      const r = el.getBoundingClientRect()
      const w = this.screenToWorld(r.left + r.width / 2, r.top + r.height / 2)
      this.addNodeAt(type, w.x, w.y)
      showSuccessToast('已添加节点')
    },
    /** 首页输入框交接：在视口中心创建节点、写入提示词并可选自动执行 */
    applyHomeCanvasNodeHandoff() {
      const q = this.$route && this.$route.query ? this.$route.query : {}
      const canvasQ = q.canvas != null ? (Array.isArray(q.canvas) ? q.canvas[0] : q.canvas) : ''
      if (String(canvasQ || '').trim()) return

      const data = consumeCanvasNodeHandoff()
      if (!data) return

      const type = String(data.nodeType || '').trim()
      const prompt = String(data.prompt || data.contentPlain || '').trim()
      const def = DEFAULT_NODE[type]
      if (!def) {
        showErrorToast('无效的节点类型')
        return
      }
      if (!prompt && data.autoRun !== false) {
        showErrorToast('缺少创作要求')
        return
      }

      const el = this.$refs.viewEl
      if (!el) return
      const r = el.getBoundingClientRect()
      const w = this.screenToWorld(r.left + r.width / 2, r.top + r.height / 2)
      const n = {
        id: genId(),
        type,
        x: Math.round(w.x - def.w / 2),
        y: Math.round(w.y - def.h / 2),
        w: def.w,
        h: def.h,
        data: def.data()
      }
      if (prompt) {
        this.applyCanvasHandoffPromptToNode(n, prompt, data.style)
      }
      this.nodes.push(n)
      this.bringNodeToFront(n)
      this.selectedId = n.id
      this.focusViewportOnNode(n.id)
      this.scheduleAutosave()

      const label = canvasLaunchNodeLabel(type)
      const autoRun = data.autoRun !== false
      this.$nextTick(() => {
        this.applyDefaultModelForNewNode(n)
        this.syncNodeCreditDisplayFromModel(n)
        this.scheduleSyncNodeVisualHeights()
        const ed = document.querySelector(
          `[data-prompt-editor][data-prompt-node-id="${n.id}"]`
        )
        if (ed && n.type === 'image') {
          this.hydratePromptEditor(n, ed)
        }
        if (autoRun) {
          this.runNodeFromHomeHandoff(n)
        } else {
          showSuccessToast(`已创建「${label}」节点`)
        }
      })
    },
    applyCanvasHandoffPromptToNode(n, prompt, style) {
      if (!n || !n.data) return
      const text = String(prompt || '').trim()
      if (!text) return
      const t = n.type
      if (t === 'scriptWrite' || t === 'storyboard' || t === 'note') {
        this.$set(n.data, 'body', text)
      } else if (t === 'ecomDetail') {
        this.$set(n.data, 'extraPrompt', text)
        if (!String(n.data.productName || '').trim()) {
          this.$set(n.data, 'productName', '首页任务')
        }
      } else if (t === 'uiDesign') {
        this.$set(n.data, 'brief', text)
        if (!String(n.data.projectName || '').trim()) {
          this.$set(n.data, 'projectName', '首页任务')
        }
      } else if (t === 'audio') {
        this.$set(n.data, 'synthText', text)
      } else {
        this.$set(n.data, 'prompt', text)
      }
      if (style && typeof style === 'object' && (t === 'image' || t === 'storyboard')) {
        this.$set(n.data, 'workflowStyle', { ...style })
      }
    },
    runNodeFromHomeHandoff(n) {
      if (!n || !n.id) return
      const label = canvasLaunchNodeLabel(n.type)
      switch (n.type) {
        case 'scriptWrite':
          this.runSingleScriptWriteNode(n)
          return
        case 'storyboard':
          this.runSingleStoryboardNode(n)
          return
        case 'llm':
          this.runSingleTextNode(n)
          return
        case 'image':
          this.runSingleImageNode(n)
          return
        case 'video':
          this.runSingleVideoNode(n)
          return
        case 'ecomDetail':
          this.runSingleEcomDetailNode(n)
          return
        case 'uiDesign':
          this.runSingleUiDesignNode(n)
          return
        case 'audio':
          this.runSingleAudioNode(n)
          return
        default:
          showSuccessToast(`已创建「${label}」节点，请在画布内手动执行`)
      }
    },
    bringNodeToFront(n) {
      if (!n) return
      this.nodeZStack += 1
      this.$set(n, 'zStack', this.nodeZStack)
    },
    /** 捕获阶段：内部子元素多带有 @mousedown.stop，需在此置顶否则点内容区无法浮起 */
    onNodeStackCapture(n, e) {
      if (!n || !e || e.button !== 0) return
      this.bringNodeToFront(n)
    },
    startLinkDrag(n, e) {
      if (!n || e.button !== 0) return
      this.selectedEdgeId = null
      this.assetMention = null
      this.clearAssetMentionBlurTimer()
      this.upstreamPreview = null
      this.connectMenu = null
      const p = this.portOut(n)
      this.linkDragState = {
        kind: 'out',
        nodeId: n.id,
        x1: p.x,
        y1: p.y,
        x2: p.x,
        y2: p.y,
        sx0: e.clientX,
        sy0: e.clientY,
        sessionId: genId()
      }
      this.selectedId = n.id
    },
    startLinkDragFromIn(n, e) {
      if (!n || e.button !== 0) return
      this.selectedEdgeId = null
      this.assetMention = null
      this.clearAssetMentionBlurTimer()
      this.upstreamPreview = null
      this.connectMenu = null
      const p = this.portIn(n)
      this.linkDragState = {
        kind: 'in',
        nodeId: n.id,
        x1: p.x,
        y1: p.y,
        x2: p.x,
        y2: p.y,
        sx0: e.clientX,
        sy0: e.clientY,
        sessionId: genId()
      }
      this.selectedId = n.id
    },
    linkDragPointerOverValidPort(clientX, clientY, ld) {
      const t = document.elementFromPoint(clientX, clientY)
      if (!t || !t.closest) return false
      const kind = ld.kind || 'out'
      if (kind === 'out') {
        const inEl = t.closest('[data-nc-in]')
        if (!inEl) return false
        const toId = inEl.getAttribute('data-node-id')
        return !!(toId && toId !== ld.nodeId)
      }
      const outEl = t.closest('[data-nc-out]')
      if (!outEl) return false
      const fromId = outEl.getAttribute('data-node-id')
      return !!(fromId && fromId !== ld.nodeId)
    },
    clampConnectMenuInView() {
      const m = this.connectMenu
      const el = this.$refs.viewEl
      if (!m || !el) return
      const r = el.getBoundingClientRect()
      const mw = 228
      const mh = 340
      let sx = m.sx
      let sy = m.sy
      sx = Math.min(Math.max(sx, r.left + 8), r.right - mw - 8)
      sy = Math.min(Math.max(sy, r.top + 8), r.bottom - mh - 8)
      if (sx !== m.sx || sy !== m.sy) {
        this.connectMenu = { ...m, sx, sy }
      }
    },
    syncConnectMenuWhileDragging(ld, clientX, clientY, worldX, worldY) {
      const anchorMode = ld.kind === 'in' ? 'in' : 'out'
      const base = {
        anchorMode,
        refId: ld.nodeId,
        sessionId: ld.sessionId,
        wx: worldX,
        wy: worldY,
        sx: clientX,
        sy: clientY
      }
      const isNew = !this.connectMenu || this.connectMenu.sessionId !== ld.sessionId
      if (isNew) {
        this.connectMenu = { ...base }
        this.$nextTick(() => this.clampConnectMenuInView())
      } else {
        this.connectMenu = { ...this.connectMenu, ...base }
        this.clampConnectMenuInView()
      }
    },
    onConnectMenuPick(item) {
      if (item.disabled) {
        showErrorToast(item.hint || '即将开放')
        return
      }
      const m = this.connectMenu
      if (!m || !item.nodeType) return
      this.connectMenu = null
      if (m.anchorMode === 'in') {
        this.createUpstreamNodeAndConnect(m.refId, item.nodeType, m.wx, m.wy)
      } else {
        this.createNodeAndConnect(m.refId, item.nodeType, m.wx, m.wy)
      }
    },
    createNodeAndConnect(fromId, type, wx, wy) {
      const def = DEFAULT_NODE[type]
      if (!def || !fromId) return
      const n = {
        id: genId(),
        type,
        x: Math.round(wx - def.w / 2),
        y: Math.round(wy - def.h / 2),
        w: def.w,
        h: def.h,
        data: def.data()
      }
      this.nodes.push(n)
      this.bringNodeToFront(n)
      this.tryConnect(fromId, n.id)
      this.selectedId = n.id
      this.$nextTick(() => {
        this.applyDefaultModelForNewNode(n)
        this.syncNodeCreditDisplayFromModel(n)
      })
      showSuccessToast('已创建并联线')
    },
    createUpstreamNodeAndConnect(targetId, type, wx, wy) {
      const def = DEFAULT_NODE[type]
      if (!def || !targetId) return
      const n = {
        id: genId(),
        type,
        x: Math.round(wx - def.w / 2),
        y: Math.round(wy - def.h / 2),
        w: def.w,
        h: def.h,
        data: def.data()
      }
      this.nodes.push(n)
      this.bringNodeToFront(n)
      this.tryConnect(n.id, targetId)
      this.selectedId = n.id
      this.$nextTick(() => {
        this.applyDefaultModelForNewNode(n)
        this.syncNodeCreditDisplayFromModel(n)
      })
      showSuccessToast('已创建并联线')
    },
    onNodeDown(n, e) {
      if (e.button !== 0) return
      if (this.canvasTool === 'hand') {
        this.canvasTool = 'select'
      }
      this.selectedEdgeId = null
      this.upstreamPreview = null
      if (this.assetMention && this.assetMention.nodeId !== n.id) {
        this.assetMention = null
        this.clearAssetMentionBlurTimer()
      }
      const t = e.target
      if (t && t.closest) {
        let skip = t.closest(
          'button, a, input, textarea, select, label, option, video, [data-prompt-editor], [data-nc-in], [data-nc-out], .ngc-asset-mention, .ngc-image-node-toolbar, [data-ngc-inpaint-wrap-modal]'
        )
        const inpaintWrapHit =
          n &&
          n.data &&
          n.data.imageInpaintMode &&
          t.closest('[data-ngc-inpaint-wrap]')
        if (!skip && inpaintWrapHit) skip = inpaintWrapHit
        if (skip) {
          this.selectedId = n.id
          return
        }
      }
      this.selectedId = n.id
      if (this._dragNodeRaf) {
        cancelAnimationFrame(this._dragNodeRaf)
        this._dragNodeRaf = 0
      }
      this.dragNode = {
        id: n.id,
        sx: e.clientX,
        sy: e.clientY,
        ox: n.x,
        oy: n.y,
        pendingClientX: e.clientX,
        pendingClientY: e.clientY
      }
    },
    /** 根据 dragNode 里最新的屏幕坐标写回节点世界坐标；仅 round=true 时写入模型（拖动中仅预览，避免 deep watch 每帧扫全图） */
    applyDragNodePositionFromPending(d, roundCoords) {
      if (!d) return
      const cx = d.pendingClientX != null ? d.pendingClientX : d.sx
      const cy = d.pendingClientY != null ? d.pendingClientY : d.sy
      const sc = Number(this.viewport.scale) || 1
      const dx = (cx - d.sx) / sc
      const dy = (cy - d.sy) / sc
      const n = this.nodes.find(x => x.id === d.id)
      if (!n) return
      const nx = d.ox + dx
      const ny = d.oy + dy
      if (!roundCoords) {
        return
      }
      n.x = Math.round(nx)
      n.y = Math.round(ny)
    },
    tryConnect(fromId, toId) {
      if (!fromId || !toId || fromId === toId) return
      const dup = this.edges.some(
        x => x.from.nodeId === fromId && x.to.nodeId === toId
      )
      if (dup) return
      this.edges.push({
        id: genEdgeId(),
        from: { nodeId: fromId },
        to: { nodeId: toId }
      })
    },
    onGlobalMove(e) {
      if (this.linkDragState) {
        const w = this.screenToWorld(e.clientX, e.clientY)
        const ld = this.linkDragState
        this.linkDragState = {
          ...ld,
          x2: w.x,
          y2: w.y
        }
        const overPort = this.linkDragPointerOverValidPort(e.clientX, e.clientY, ld)
        if (overPort) {
          if (this.connectMenu && this.connectMenu.sessionId === ld.sessionId) {
            this.connectMenu = null
          }
        } else {
          const scrMoved = Math.hypot(e.clientX - ld.sx0, e.clientY - ld.sy0) >= 20
          if (scrMoved) {
            this.syncConnectMenuWhileDragging(ld, e.clientX, e.clientY, w.x, w.y)
          }
        }
      } else if (this.dragNode) {
        if (!this.inpaintStrokeSession && !this.inpaintRectSession) {
          this._dragLastClient = { x: e.clientX, y: e.clientY }
          if (!this._dragNodeRaf) {
            this._dragNodeRaf = requestAnimationFrame(() => {
              this._dragNodeRaf = 0
              const d = this.dragNode
              const c = this._dragLastClient
              if (!d || !c) return
              d.pendingClientX = c.x
              d.pendingClientY = c.y
            })
          }
        }
      } else if (this.isPanning && this.panStart) {
        const ps = this.panStart
        ps.lx = e.clientX
        ps.ly = e.clientY
        if (!this._panDomRaf) {
          this._panDomRaf = requestAnimationFrame(() => {
            this._panDomRaf = 0
            if (!this.isPanning || !this.panStart) return
            const p = this.panStart
            const cx = p.lx != null ? p.lx : p.x
            const cy = p.ly != null ? p.ly : p.y
            this._applyViewportPanDom(p.px + (cx - p.x), p.py + (cy - p.y))
          })
        }
      }
    },
    onGlobalUp(e) {
      if (this._panDomRaf) {
        cancelAnimationFrame(this._panDomRaf)
        this._panDomRaf = 0
      }
      const ld = this.linkDragState
      if (ld && e && e.target) {
        const t = e.target
        const inEl = t.closest && t.closest('[data-nc-in]')
        const outEl = t.closest && t.closest('[data-nc-out]')
        const kind = ld.kind || 'out'
        let handled = false
        if (kind === 'out') {
          if (inEl) {
            const toId = inEl.getAttribute('data-node-id')
            if (toId && toId !== ld.nodeId) {
              this.tryConnect(ld.nodeId, toId)
            }
            handled = true
          }
        } else if (kind === 'in') {
          if (outEl) {
            const fromId = outEl.getAttribute('data-node-id')
            if (fromId && fromId !== ld.nodeId) {
              this.tryConnect(fromId, ld.nodeId)
            }
            handled = true
          }
        }
        if (handled) {
          this.connectMenu = null
        } else if (!this.connectMenu) {
          const scrDist = Math.hypot(e.clientX - ld.sx0, e.clientY - ld.sy0)
          if (scrDist >= 12) {
            const w = this.screenToWorld(e.clientX, e.clientY)
            this.syncConnectMenuWhileDragging(ld, e.clientX, e.clientY, w.x, w.y)
          }
        }
        this.linkDragState = null
      }
      if (this._dragNodeRaf) {
        cancelAnimationFrame(this._dragNodeRaf)
        this._dragNodeRaf = 0
      }
      if (this.dragNode) {
        if (e && typeof e.clientX === 'number' && typeof e.clientY === 'number') {
          this.dragNode.pendingClientX = e.clientX
          this.dragNode.pendingClientY = e.clientY
        }
        this.applyDragNodePositionFromPending(this.dragNode, true)
      }
      this.dragNode = null
      if (this.isPanning && this.panStart) {
        const p = this.panStart
        let cx = p.x
        let cy = p.y
        if (e && typeof e.clientX === 'number' && typeof e.clientY === 'number') {
          cx = e.clientX
          cy = e.clientY
        } else if (p.lx != null && p.ly != null) {
          cx = p.lx
          cy = p.ly
        }
        this.viewport.panX = p.px + (cx - p.x)
        this.viewport.panY = p.py + (cy - p.y)
      }
      this._clearPanDomHints()
      this.isPanning = false
      this.panStart = null
    },
    portOut(n) {
      const p = this.nodeWorldXYForLayout(n)
      return { x: p.x + n.w, y: p.y + n.h / 2 }
    },
    portIn(n) {
      const p = this.nodeWorldXYForLayout(n)
      return { x: p.x, y: p.y + n.h / 2 }
    },
    /** 两端端口外包矩形与视口是否相交（略宽松，少漏检） */
    ngcEdgeRoughlyInViewport(e, b) {
      if (!e || !b) return true
      const m = this.ngcNodeIdMap
      const a = m[e.from && e.from.nodeId]
      const bn = m[e.to && e.to.nodeId]
      if (!a || !bn) return true
      const p0 = this.portOut(a)
      const p1 = this.portIn(bn)
      const pad = 160
      const ex1 = Math.min(p0.x, p1.x) - pad
      const ex2 = Math.max(p0.x, p1.x) + pad
      const ey1 = Math.min(p0.y, p1.y) - pad
      const ey2 = Math.max(p0.y, p1.y) + pad
      return !(ex2 < b.minX || ex1 > b.maxX || ey2 < b.minY || ey1 > b.maxY)
    },
    /** 每条边错开流光相位，避免同步闪烁 */
    edgeStreamDelaySec(e) {
      const s = e && e.id != null ? String(e.id) : '0'
      let h = 2166136261
      for (let i = 0; i < s.length; i++) h = Math.imul(h ^ s.charCodeAt(i), 16777619)
      const sec = ((h >>> 0) % 240) / 100
      return `${sec.toFixed(2)}s`
    },
    /** 仅当前选中节点相连的边（或当前选中的边）启用流光 dash 动画 */
    ngcEdgeStreamActiveForEdge(e) {
      if (!e || !e.from || !e.to) return false
      const eid = this.selectedEdgeId
      if (eid != null && e.id === eid) return true
      const sid = this.selectedId
      if (sid == null || sid === '') return false
      return e.from.nodeId === sid || e.to.nodeId === sid
    },
    edgePath(e) {
      if (!e || !e.from || !e.to) return ''
      const m = this.ngcNodeIdMap
      const a = m[e.from.nodeId]
      const b = m[e.to.nodeId]
      if (!a || !b) return ''
      const p0 = this.portOut(a)
      const p1 = this.portIn(b)
      const mx = (p0.x + p1.x) / 2
      return `M ${p0.x} ${p0.y} C ${mx} ${p0.y}, ${mx} ${p1.y}, ${p1.x} ${p1.y}`
    },
    /** 与 edgePath 相同的三次贝塞尔控制点 */
    edgeBezierControls(e) {
      if (!e || !e.from || !e.to) return null
      const m = this.ngcNodeIdMap
      const a = m[e.from.nodeId]
      const b = m[e.to.nodeId]
      if (!a || !b) return null
      const p0 = this.portOut(a)
      const p3 = this.portIn(b)
      const mx = (p0.x + p3.x) / 2
      return {
        p0,
        p1: { x: mx, y: p0.y },
        p2: { x: mx, y: p3.y },
        p3
      }
    },
    cubicBezierPoint(p0, p1, p2, p3, t) {
      const u = 1 - t
      const uu = u * u
      const tt = t * t
      return {
        x: uu * u * p0.x + 3 * uu * t * p1.x + 3 * u * tt * p2.x + tt * t * p3.x,
        y: uu * u * p0.y + 3 * uu * t * p1.y + 3 * u * tt * p2.y + tt * t * p3.y
      }
    },
    /** 点击位置投影到连线上，返回最近点对应的 t */
    edgeBezierClosestT(e, wx, wy) {
      const c = this.edgeBezierControls(e)
      if (!c) return null
      const px = Number(wx)
      const py = Number(wy)
      if (!Number.isFinite(px) || !Number.isFinite(py)) return null
      let bestT = 0.5
      let bestD = Infinity
      const coarse = 64
      for (let i = 0; i <= coarse; i++) {
        const t = i / coarse
        const p = this.cubicBezierPoint(c.p0, c.p1, c.p2, c.p3, t)
        const d = (p.x - px) * (p.x - px) + (p.y - py) * (p.y - py)
        if (d < bestD) {
          bestD = d
          bestT = t
        }
      }
      const span = 1 / coarse
      let lo = Math.max(0, bestT - span)
      let hi = Math.min(1, bestT + span)
      const fine = 24
      for (let i = 0; i <= fine; i++) {
        const t = lo + ((hi - lo) * i) / fine
        const p = this.cubicBezierPoint(c.p0, c.p1, c.p2, c.p3, t)
        const d = (p.x - px) * (p.x - px) + (p.y - py) * (p.y - py)
        if (d < bestD) {
          bestD = d
          bestT = t
        }
      }
      return bestT
    },
    /** 点击位置投影到连线上（最近点） */
    edgeBezierClosestToPoint(e, wx, wy) {
      const t = this.edgeBezierClosestT(e, wx, wy)
      if (t == null) return null
      const c = this.edgeBezierControls(e)
      if (!c) return null
      return this.cubicBezierPoint(c.p0, c.p1, c.p2, c.p3, t)
    },
    /** 与 edgePath 相同的三次贝塞尔在 t=0.5 处的点（无点击坐标时的兜底） */
    edgeBezierMidpoint(e) {
      const c = this.edgeBezierControls(e)
      if (!c) return null
      return this.cubicBezierPoint(c.p0, c.p1, c.p2, c.p3, 0.5)
    },
    selectEdge(edge, ev) {
      if (!edge || this.linkDragState) return
      if (!ev || ev.button !== 0) return
      ev.stopPropagation()
      if (this.canvasTool === 'hand') {
        this.canvasTool = 'select'
      }
      this.selectedEdgeId = edge.id
      const w = this.screenToWorld(ev.clientX, ev.clientY)
      const t = this.edgeBezierClosestT(edge, w.x, w.y)
      this.selectedEdgeCutT = t != null ? t : 0.5
      this.selectedId = null
      this.assetMention = null
      this.clearAssetMentionBlurTimer()
      this.upstreamPreview = null
    },
    /** 在删除节点/连线前调用，保存当前 nodes+edges 快照供撤销 */
    pushDeleteUndoSnapshot() {
      try {
        this.deleteUndoStack.push({
          nodes: JSON.parse(JSON.stringify(this.nodes)),
          edges: JSON.parse(JSON.stringify(this.edges))
        })
        const max = 20
        while (this.deleteUndoStack.length > max) {
          this.deleteUndoStack.shift()
        }
      } catch (err) {
        console.warn('NodeGraphCanvas: delete undo snapshot failed', err)
      }
    },
    undoLastDelete() {
      if (!this.deleteUndoStack.length) return
      const snap = this.deleteUndoStack.pop()
      if (!snap) return
      this.closeImageStyleLibrary()
      this.imageToolbarMenu = null
      this.assetMention = null
      this.clearAssetMentionBlurTimer()
      this.upstreamPreview = null
      this.selectedId = null
      this.selectedEdgeId = null
      this.upstreamThumbBad = {}
      this.nodes = Array.isArray(snap.nodes) ? snap.nodes : []
      this.edges = Array.isArray(snap.edges) ? snap.edges : []
      this.$nextTick(() => {
        this.nodes.filter(x => x && x.type === 'audio').forEach(n => this.syncAudioNodeHeight(n))
      })
      showSuccessToast('已撤销删除')
    },
    deleteSelectedEdge() {
      const id = this.selectedEdgeId
      if (!id) return
      this.pushDeleteUndoSnapshot()
      this.edges = this.edges.filter(e => e.id !== id)
      this.selectedEdgeId = null
      this.selectedEdgeCutT = null
    },
    removeCurrentSelection() {
      if (this.selectedEdgeId) {
        this.deleteSelectedEdge()
        return
      }
      this.deleteSelected()
    },
    addNodeAt(type, wx, wy) {
      const def = DEFAULT_NODE[type]
      if (!def) return
      const n = {
        id: genId(),
        type,
        x: Math.round(wx - def.w / 2),
        y: Math.round(wy - 30),
        w: def.w,
        h: def.h,
        data: def.data()
      }
      this.nodes.push(n)
      this.bringNodeToFront(n)
      this.selectedId = n.id
      if (type === 'ecomDetail') {
        this.reconcileEcomDetailSkillsOnNodes()
      }
      this.$nextTick(() => {
        this.applyDefaultModelForNewNode(n)
        this.syncNodeCreditDisplayFromModel(n)
        if (type === 'audio') this.syncAudioNodeHeight(n)
      })
    },
    deleteSelected() {
      const id = this.selectedId
      if (!id) return
      this.pushDeleteUndoSnapshot()
      this.closeImageStyleLibrary()
      this.edges = this.edges.filter(e => e.from.nodeId !== id && e.to.nodeId !== id)
      this.nodes = this.nodes.filter(n => n.id !== id)
      this.selectedId = null
      this.selectedEdgeId = null
      this.assetMention = null
      this.clearAssetMentionBlurTimer()
      this.upstreamPreview = null
      if (this.inpaintOnlineEditorNodeId === id) this.inpaintOnlineEditorNodeId = null
      if (this.imageAspectPickerNodeId === id) this.imageAspectPickerNodeId = null
      if (this.imageModelPickerNodeId === id) this.imageModelPickerNodeId = null
      if (this.storyboardModelPickerNodeId === id) this.storyboardModelPickerNodeId = null
      if (this.ecomDetailDeepseekPickerNodeId === id) this.ecomDetailDeepseekPickerNodeId = null
      if (this.ecomDetailImageModelPickerNodeId === id) this.ecomDetailImageModelPickerNodeId = null
      if (this.uiDesignDeepseekPickerNodeId === id) this.uiDesignDeepseekPickerNodeId = null
      if (this.uiDesignImageModelPickerNodeId === id) this.uiDesignImageModelPickerNodeId = null
      if (this.llmModelPickerNodeId === id) this.llmModelPickerNodeId = null
      if (this.videoModelPickerNodeId === id) this.videoModelPickerNodeId = null
      if (this.audioModelPickerNodeId === id) this.audioModelPickerNodeId = null
      if (this.videoSpecPanelNodeId === id) this.videoSpecPanelNodeId = null
    },
    onKey(e) {
      if (e.key === 'Escape') {
        if (this.inpaintOnlineEditorNodeId != null) {
          this.closeInpaintOnlineEditor()
          e.preventDefault()
          return
        }
        if (this.ngcConfirmDialog) {
          this.resolveNgcConfirm(false)
          e.preventDefault()
          return
        }
        if (this.showImageStyleLibrary) {
          this.closeImageStyleLibrary()
          e.preventDefault()
          return
        }
        if (this.imageAspectPickerNodeId != null) {
          this.closeImageAspectPickerModal()
          e.preventDefault()
          return
        }
        if (this.imageModelPickerNodeId != null) {
          this.closeImageModelPickerModal()
          e.preventDefault()
          return
        }
        if (this.storyboardModelPickerNodeId != null) {
          this.closeStoryboardModelPickerModal()
          e.preventDefault()
          return
        }
        if (this.llmModelPickerNodeId != null) {
          this.closeLlmModelPickerModal()
          e.preventDefault()
          return
        }
        if (this.videoModelPickerNodeId != null) {
          this.closeVideoModelPickerModal()
          e.preventDefault()
          return
        }
        if (this.audioModelPickerNodeId != null) {
          this.closeAudioModelPickerModal()
          e.preventDefault()
          return
        }
        if (this.imageToolbarMenu) {
          this.imageToolbarMenu = null
          e.preventDefault()
          return
        }
        if (this.upstreamPreview) {
          this.closeUpstreamPreview()
          e.preventDefault()
          return
        }
      }
      const brushKey =
        e.key === '[' ||
        e.key === ']' ||
        e.key === 'BracketLeft' ||
        e.key === 'BracketRight'
      if (brushKey) {
        if (e.ctrlKey || e.metaKey || e.altKey) return
        if (this._inpaintKeyboardBlocksBrush(e.target)) return
        const n = this._activeInpaintImageNode()
        if (!n) return
        e.preventDefault()
        const cur = Math.round(Number(n.data.inpaintBrushSize) || 28)
        const dec = e.key === '[' || e.key === 'BracketLeft'
        const next = Math.min(128, Math.max(2, cur + (dec ? -2 : 2)))
        this.$set(n.data, 'inpaintBrushSize', next)
        return
      }
      if ((e.ctrlKey || e.metaKey) && String(e.key).toLowerCase() === 'z' && !e.shiftKey) {
        const t = e.target
        if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA')) return
        if (t && t.closest && t.closest('[data-prompt-editor]')) return
        if (!this.deleteUndoStack.length) return
        e.preventDefault()
        this.undoLastDelete()
        return
      }
      if (e.key === 'Delete' || e.key === 'Backspace') {
        const t = e.target
        if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA')) return
        if (t && t.closest && t.closest('[data-prompt-editor]')) return
        if (this.selectedEdgeId) {
          this.deleteSelectedEdge()
          return
        }
        this.deleteSelected()
      }
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 's') {
        e.preventDefault()
        this.saveProject()
      }
    },
    /**
     * 轮询 Seedance 任务直到返回视频 URL。
     * 高分辨率 / 长时长生成常超过数分钟，与 ConversationWorkflow 对齐为约 10 分钟上限。
     */
    async pollSeedanceUntilVideo(taskId) {
      const maxAttempts = 200
      const intervalMs = 3000
      let videoUrl = ''
      for (let i = 0; i < maxAttempts; i++) {
        const info = await getSeedanceVideoTask(String(taskId))
        const st = String(info.status || '').toLowerCase()
        videoUrl = pickSeedanceTaskVideoUrl(info)
        if (videoUrl) return videoUrl
        if (
          st === 'failed' ||
          st === 'failure' ||
          st === 'error' ||
          st === 'cancelled' ||
          st === 'canceled'
        ) {
          throw new Error(
            (info && (info.message || info.error)) ? String(info.message || info.error) : '视频任务失败'
          )
        }
        if (i < maxAttempts - 1) await sleep(intervalMs)
      }
      const approxMin = Math.round(((maxAttempts - 1) * intervalMs) / 60000) || 1
      throw new Error(
        `等待视频超时（已轮询约 ${approxMin} 分钟仍无地址）。可缩短时长/分辨率后重试，或稍后在任务列表中查看是否已完成。`
      )
    },
    /**
     * HappyHorse 典型 720P/5s 约 105–115s；轮询间隔 5s，上限约 20 分钟。
     */
    async pollHappyHorseUntilVideo(taskId) {
      const maxAttempts = 240
      const intervalMs = 5000
      let videoUrl = ''
      for (let i = 0; i < maxAttempts; i++) {
        const info = await getHappyHorseVideoTask(String(taskId))
        const st = String(info.status || '').toLowerCase()
        videoUrl = pickHappyHorseTaskVideoUrl(info)
        if (videoUrl) return videoUrl
        if (st === 'failed' || st === 'failure' || st === 'error') {
          throw new Error(
            (info && (info.message || info.error || info.fail_reason))
              ? String(info.message || info.error || info.fail_reason)
              : 'HappyHorse 视频任务失败'
          )
        }
        if (i < maxAttempts - 1) await sleep(intervalMs)
      }
      const approxMin = Math.round(((maxAttempts - 1) * intervalMs) / 60000) || 1
      throw new Error(`等待 HappyHorse 视频超时（已轮询约 ${approxMin} 分钟）`)
    },
    async pollVideoUntilUrl(taskId, modelId) {
      if (isHappyHorseVideoModel(modelId)) {
        return this.pollHappyHorseUntilVideo(taskId)
      }
      return this.pollSeedanceUntilVideo(taskId)
    },
    async executeLlmNode(node, nodeId, map) {
      const mode = (node.data && node.data.textMode) || 'write'
      const ctx = gatherUpstreamText(nodeId, map, this.edges)
      const basePrompt = [node.data.prompt, ctx].filter(Boolean).join('\n\n---\n\n')

      if (mode === 'write') {
        const bu = this.resolveLlmChatBaseUrl(node.data.model)
        const text = await volcChatComplete({
          model: node.data.model,
          baseUrl: bu || undefined,
          messages: [{ role: 'user', content: basePrompt || ' ' }]
        })
        this.$set(node.data, 'output', text)
        return
      }
      if (mode === 't2v') {
        this.$set(node.data, 'inlineVideoUrl', '')
        const created = await createSeedanceVideoTask({ prompt: basePrompt || ' ' })
        const tid = created && (created.id || created.task_id)
        if (!tid) throw new Error('未创建视频任务')
        const videoUrl = await this.pollSeedanceUntilVideo(String(tid))
        this.$set(node.data, 'inlineVideoUrl', videoUrl)
        this.$set(node.data, 'output', `视频：${videoUrl}`)
        return
      }
      if (mode === 'img2prompt') {
        const imgs = gatherUpstreamImageUrls(nodeId, map, this.edges)
        if (!imgs.length) {
          throw new Error('请先连接上游「图像」节点，或先出图再反推')
        }
        const hint =
          (node.data.prompt && String(node.data.prompt).trim()) ||
          '请根据图片反推详细的中文绘图提示词，一条即可。'
        const messages = [
          {
            role: 'user',
            content: [
              { type: 'text', text: hint },
              { type: 'image_url', image_url: { url: imgs[0] } }
            ]
          }
        ]
        const bu = this.resolveLlmChatBaseUrl(node.data.model)
        const text = await volcChatComplete({
          model: node.data.model,
          baseUrl: bu || undefined,
          messages
        })
        this.$set(node.data, 'output', text)
        return
      }
      if (mode === 't2music') {
        throw new Error('文字生音乐暂未接入，后续版本开放')
      }
      throw new Error('未知文本模式')
    },
    async executeStoryboardNode(node, nodeId, map) {
      if (!node || node.type !== 'storyboard' || !node.data) return
      const ctx = gatherUpstreamText(nodeId, map, this.edges)
      const draft = String(node.data.body || '').trim()
      if (!draft && !String(ctx || '').trim()) {
        throw new Error('请先编写分镜草稿，或接入上游节点提供参考文本')
      }
      let model = String(node.data.model || '').trim()
      if (!model.startsWith('deepseek-v4')) {
        model = 'deepseek-v4-flash'
        this.$set(node.data, 'model', model)
      }
      const userParts = []
      if (String(ctx || '').trim()) userParts.push('【上游参考】\n' + ctx)
      const prefsBlock = buildStoryboardPreferencesUserBlock(node.data)
      if (prefsBlock) userParts.push('【分镜偏好】\n' + prefsBlock)
      if (draft) userParts.push('【当前分镜草稿】\n' + draft)
      const userContent = userParts.join('\n\n')
      const bu = this.resolveLlmChatBaseUrl(model)
      const text = await volcChatComplete({
        model,
        baseUrl: bu || undefined,
        messages: [
          { role: 'system', content: STORYBOARD_DEEPSEEK_SYSTEM_PROMPT },
          { role: 'user', content: userContent || ' ' }
        ]
      })
      this.$set(node.data, 'output', text)
    },
    async executeScriptWriteNode(node, nodeId, map) {
      if (!node || node.type !== 'scriptWrite' || !node.data) return
      const ctx = gatherUpstreamText(nodeId, map, this.edges)
      const brief = String(node.data.body || '').trim()
      const genre = resolveScriptWriteGenre(node.data)
      const lengthHint = resolveScriptWriteLengthHint(node.data)
      if (!brief && !String(ctx || '').trim() && !genre && !lengthHint) {
        throw new Error('请选择题材或篇幅，或接入上游节点提供参考')
      }
      let model = String(node.data.model || '').trim()
      if (!model.startsWith('deepseek-v4')) {
        model = 'deepseek-v4-flash'
        this.$set(node.data, 'model', model)
      }
      const userParts = []
      if (String(ctx || '').trim()) userParts.push('【上游参考】\n' + ctx)
      const meta = [genre && `题材：${genre}`, lengthHint && `篇幅：${lengthHint}`]
        .filter(Boolean)
        .join('\n')
      if (meta) userParts.push('【创作约束】\n' + meta)
      if (brief) userParts.push('【创作要求 / 梗概】\n' + brief)
      const userContent = userParts.join('\n\n')
      const bu = this.resolveLlmChatBaseUrl(model)
      const text = await volcChatComplete({
        model,
        baseUrl: bu || undefined,
        messages: [
          { role: 'system', content: SCRIPT_WRITE_DEEPSEEK_SYSTEM_PROMPT },
          { role: 'user', content: userContent || ' ' }
        ]
      })
      this.$set(node.data, 'output', text)
    },
    onScriptWriteGenerateClick(n) {
      if (!n || n.type !== 'scriptWrite' || this.isNodeRunning(n.id)) return
      if (this.scriptWriteHasGeneratedContent(n)) {
        this.openNgcConfirm({
          title: '重新生成剧本',
          message: '当前节点已有生成剧本。继续将覆盖现有结果，并会再次消耗积分。',
          confirmText: '重新生成',
          cancelText: '取消',
          tone: 'amber'
        }).then(ok => {
          if (ok) this.runSingleScriptWriteNode(n)
        })
        return
      }
      this.runSingleScriptWriteNode(n)
    },
    async runSingleScriptWriteNode(n) {
      if (!n || n.type !== 'scriptWrite' || this.isNodeRunning(n.id)) return
      const isRegenerate = this.scriptWriteHasGeneratedContent(n)
      try {
        await this.ensureNgcScoreBeforeRun(n, {
          label: isRegenerate ? '重新生成剧本' : '剧本创作'
        })
      } catch (e) {
        showErrorToast(e && e.message ? String(e.message) : '积分不足~')
        return
      }
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      this.beginNodeRunning(n.id)
      this.$set(n.data, 'status', 'running')
      try {
        await this.executeScriptWriteNode(n, n.id, map)
        this.$set(n.data, 'status', '完成')
        showSuccessToast(isRegenerate ? '剧本已重新生成' : '剧本生成完成')
      } catch (err) {
        this.$set(n.data, 'status', '失败')
        showErrorToast(err && err.message ? String(err.message) : String(err))
      } finally {
        this.endNodeRunning(n.id)
      }
    },
    async runSingleStoryboardNode(n) {
      if (!n || n.type !== 'storyboard' || this.isNodeRunning(n.id)) return
      try {
        await this.ensureNgcScoreBeforeRun(n, { label: '分镜生成' })
      } catch (e) {
        showErrorToast(e && e.message ? String(e.message) : '积分不足~')
        return
      }
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      this.beginNodeRunning(n.id)
      this.$set(n.data, 'status', 'running')
      try {
        await this.executeStoryboardNode(n, n.id, map)
        this.$set(n.data, 'status', '完成')
        showSuccessToast('时间轴分镜稿已整理完成')
      } catch (err) {
        this.$set(n.data, 'status', '失败')
        showErrorToast(err && err.message ? String(err.message) : String(err))
      } finally {
        this.endNodeRunning(n.id)
      }
    },
    normalizeStoryboardShotsFromParsed(arr) {
      if (!Array.isArray(arr)) return []
      const out = []
      for (let i = 0; i < arr.length; i++) {
        const row = arr[i]
        if (!row || typeof row !== 'object') continue
        const timeRangeRaw = String(
          row['时间段'] != null ? row['时间段'] : row.timeSegment || row.timeRange || ''
        ).trim()
        let timeStartSec
        let timeEndSec
        const tr = /^(\d+(?:\.\d+)?)\s*[-~–—至到]\s*(\d+(?:\.\d+)?)\s*秒?/i.exec(timeRangeRaw)
        if (tr) {
          timeStartSec = parseFloat(tr[1])
          timeEndSec = parseFloat(tr[2])
        }
        const durRaw = row.durationSec != null ? row.durationSec : row['时长']
        let durationSec = Math.round(Number(durRaw))
        if (
          Number.isFinite(timeStartSec) &&
          Number.isFinite(timeEndSec) &&
          timeEndSec > timeStartSec
        ) {
          const fromRange = Math.round(timeEndSec - timeStartSec)
          if (!Number.isNaN(fromRange) && fromRange >= 1) durationSec = fromRange
        }
        if (Number.isNaN(durationSec)) durationSec = 5
        durationSec = Math.min(15, Math.max(1, durationSec))
        const shotNo = String(row['镜号'] != null ? row['镜号'] : row.shotNo || i + 1)
          .trim()
          .replace(/\s+/g, '') || String(i + 1).padStart(2, '0')
        const jingbie = String(row['景别'] != null ? row['景别'] : row.jingbie || '').trim() || '—'
        const yunjing = String(row['运镜'] != null ? row['运镜'] : row.yunjing || '').trim() || '—'
        const composition = String(
          row['画面描述'] != null ? row['画面描述'] : row.composition || ''
        ).trim() || '—'
        const dialogue = String(row['台词'] != null ? row['台词'] : row.dialogue || '').trim() || '无'
        const sfx = String(row['音效'] != null ? row['音效'] : row.sfx || '').trim() || '无'
        let videoPrompt = String(
          row.videoPrompt != null ? row.videoPrompt : row['videoPrompt'] || ''
        ).trim()
        const shotDraft = {
          shotNo,
          durationSec,
          jingbie,
          yunjing,
          composition,
          dialogue,
          sfx
        }
        if (!videoPrompt) {
          const start =
            Number.isFinite(timeStartSec) ? timeStartSec : out.reduce((s, x) => s + (x.durationSec || 0), 0)
          const end = Number.isFinite(timeEndSec) ? timeEndSec : start + durationSec
          const body = buildTimelineStyleShotBody(shotDraft)
          videoPrompt = `${start}-${end}秒：${body}`
        } else if (timeRangeRaw && videoPrompt.indexOf('秒') === -1) {
          videoPrompt = `${timeRangeRaw}：${videoPrompt.replace(/^[：:\s]+/, '')}`
        }
        const charIndices = normStoryboardIndexList(row['人物索引'] ?? row.charIndices ?? row['人物'])
        const propIndices = normStoryboardIndexList(row['道具索引'] ?? row.propIndices ?? row['道具'])
        const sceneIndices = normStoryboardIndexList(row['场景索引'] ?? row.sceneIndices ?? row['场景'])
        out.push({
          shotNo,
          durationSec,
          timeStartSec: Number.isFinite(timeStartSec) ? timeStartSec : undefined,
          timeEndSec: Number.isFinite(timeEndSec) ? timeEndSec : undefined,
          jingbie,
          yunjing,
          composition,
          dialogue,
          sfx,
          videoPrompt,
          charIndices,
          propIndices,
          sceneIndices
        })
      }
      return out
    },
    normalizeStoryboardAssetEntries(arr, roleKey, opts) {
      const allowEmpty = opts && opts.allowEmptyAssetPrompt
      if (!Array.isArray(arr)) return []
      const out = []
      for (let i = 0; i < arr.length; i++) {
        const row = arr[i]
        if (!row || typeof row !== 'object') continue
        const name = String(row['名称'] != null ? row['名称'] : row.name || `${roleKey}${i + 1}`)
          .trim()
          .replace(/\r?\n/g, ' ')
        let prompt = String(row['提示词'] != null ? row['提示词'] : row.prompt || '').trim()
        if (!name) continue
        if (!prompt && !allowEmpty) continue
        out.push({ name: name || `${roleKey}${i + 1}`, prompt })
      }
      return out
    },
    parseStoryboardSpawnBundleFromModelText(raw, opts) {
      const text = String(raw || '').trim()
      if (!text) throw new Error('模型返回为空')
      const allowEmpty = !!(opts && opts.allowEmptyAssetPrompt)
      const pass = { allowEmptyAssetPrompt: allowEmpty }
      try {
        const obj = stripJsonObjectFromModelText(text)
        const characters = this.normalizeStoryboardAssetEntries(obj['角色'] || obj.characters, '角色', pass)
        const props = this.normalizeStoryboardAssetEntries(obj['道具'] || obj.props, '道具', pass)
        const scenes = this.normalizeStoryboardAssetEntries(obj['场景'] || obj.scenes, '场景', pass)
        const shotsRaw = obj['镜头'] || obj.shots
        const shots = this.normalizeStoryboardShotsFromParsed(Array.isArray(shotsRaw) ? shotsRaw : [])
        return { characters, props, scenes, shots }
      } catch (eObj) {
        try {
          const arr = stripJsonArrayFromModelText(text)
          return {
            characters: [],
            props: [],
            scenes: [],
            shots: this.normalizeStoryboardShotsFromParsed(arr)
          }
        } catch (eArr) {
          const timeline = parseTimelineStoryboardSegments(text)
          if (timeline.length) {
            return {
              characters: [],
              props: [],
              scenes: [],
              shots: timeline
            }
          }
          throw eObj || eArr
        }
      }
    },
    storyboardContinuitySelectOptions(currentSb) {
      if (!currentSb || currentSb.type !== 'storyboard') return []
      const out = []
      for (const x of this.nodes) {
        if (!x || x.type !== 'storyboard' || x.id === currentSb.id) continue
        out.push({ id: x.id, label: `分镜脚本 ${this.storyboardNodeIndex(x)}` })
      }
      return out
    },
    resolveStoryboardContinuityAnchorId(sbNode, map, edges) {
      if (!sbNode || !map || !edges) return ''
      const raw =
        sbNode.data && sbNode.data.continuityFromStoryboardId != null
          ? String(sbNode.data.continuityFromStoryboardId).trim()
          : ''
      if (raw === '_none_') return ''
      if (raw && raw !== '') {
        const n = map[raw]
        if (n && n.type === 'storyboard' && n.id !== sbNode.id) return n.id
      }
      for (const pid of predecessorIds(sbNode.id, edges)) {
        const p = map[pid]
        if (p && p.type === 'storyboard' && p.id !== sbNode.id) return p.id
      }
      return ''
    },
    buildStoryboardContinuityCanonicalMaps(anchorStoryboardId) {
      const empty = () => ({
        character: new Map(),
        prop: new Map(),
        scene: new Map()
      })
      const sid = String(anchorStoryboardId || '').trim()
      const out = empty()
      if (!sid) return out
      for (const n of this.nodes) {
        if (!n || n.type !== 'image' || !n.data) continue
        if (String(n.data.spawnedFromStoryboardId || '') !== sid) continue
        const kind = String(n.data.storyboardAssetKind || '').trim()
        if (kind !== 'character' && kind !== 'prop' && kind !== 'scene') continue
        const name = String(n.data.storyboardAssetName || '').trim()
        if (!name) continue
        const key = continuityAssetLookupKey(name)
        if (!key) continue
        const prompt = String(n.data.prompt || '').trim()
        const bucket = kind === 'character' ? 'character' : kind === 'prop' ? 'prop' : 'scene'
        out[bucket].set(key, { id: n.id, name, prompt })
      }
      return out
    },
    /** 前一集映射优先；本集已有同名素材（仅当锚点未占该键）作为补充，避免重复建图 */
    mergeStoryboardContinuityMapsPreferAnchor(anchorMaps, localMaps) {
      const empty = () => ({
        character: new Map(),
        prop: new Map(),
        scene: new Map()
      })
      const out = empty()
      const buckets = ['character', 'prop', 'scene']
      if (!anchorMaps) {
        if (!localMaps) return out
        for (const bucket of buckets) {
          const lm = localMaps[bucket]
          if (lm) {
            for (const [k, v] of lm) {
              out[bucket].set(k, { id: v.id, name: v.name, prompt: v.prompt })
            }
          }
        }
        return out
      }
      for (const bucket of buckets) {
        const am = anchorMaps[bucket]
        if (am) {
          for (const [k, v] of am) {
            out[bucket].set(k, { id: v.id, name: v.name, prompt: v.prompt })
          }
        }
        const lm = localMaps && localMaps[bucket]
        if (lm) {
          for (const [k, v] of lm) {
            if (!out[bucket].has(k)) out[bucket].set(k, { id: v.id, name: v.name, prompt: v.prompt })
          }
        }
      }
      return out
    },
    /** 合并前一集与本集画布上的已定素材图（用于续接解析 / 复用节点） */
    mergedStoryboardContinuityMaps(anchorStoryboardId, currentStoryboardId) {
      if (!anchorStoryboardId) return null
      const a = this.buildStoryboardContinuityCanonicalMaps(anchorStoryboardId)
      const l = this.buildStoryboardContinuityCanonicalMaps(currentStoryboardId)
      return this.mergeStoryboardContinuityMapsPreferAnchor(a, l)
    },
    buildContinuityUserBlockForLlm(anchorId, maps) {
      if (!anchorId || !maps) return ''
      let nch = 0
      for (const k of ['character', 'prop', 'scene']) {
        nch += maps[k] && maps[k].size ? maps[k].size : 0
      }
      if (!nch) return ''
      const mapById = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      const an = mapById[anchorId]
      const lab =
        an && an.type === 'storyboard' ? `分镜脚本 ${this.storyboardNodeIndex(an)}` : '上游分镜'
      const lines = [
        `【续集已定素材】本集为续集：下列为**已定案**的角色/道具/场景（含前一集 ${lab} 与本集已解析出的同名节点）。凡剧本中再次出现者，JSON 中「名称」须与下列**完全一致**；「提示词」可略写——解析完成后将以**画布上对应图片节点内当前提示词**为准（与下列摘要可能略有出入以画布为准）。`
      ]
      const dump = (title, bucket) => {
        const m = maps[bucket]
        if (!m || !m.size) return
        lines.push('', `${title}：`)
        for (const [, v] of m) {
          const nd = mapById[v.id]
          const live = nd && nd.data ? String(nd.data.prompt || '').trim() : ''
          const p = live || v.prompt || ''
          const excerpt = p ? (p.length > 400 ? p.slice(0, 400) + '…' : p) : ''
          lines.push(`- 「${v.name}」｜文生图提示：${String(excerpt).replace(/\r?\n/g, ' ')}`)
        }
      }
      dump('角色', 'character')
      dump('道具', 'prop')
      dump('场景', 'scene')
      return lines.join('\n')
    },
    applyContinuityCanonicalPromptsToBundle(bundle, maps) {
      if (!bundle || !maps) return
      const mapById = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      const livePrompt = nodeId => {
        const n = mapById[nodeId]
        if (!n || n.type !== 'image' || !n.data) return ''
        return String(n.data.prompt || '').trim()
      }
      const applyList = (list, bucket) => {
        if (!Array.isArray(list)) return
        for (const entry of list) {
          if (!entry || typeof entry !== 'object') continue
          const key = continuityAssetLookupKey(entry.name)
          const prev = maps[bucket] && maps[bucket].get(key)
          if (prev && prev.id) {
            const live = livePrompt(prev.id)
            const snap = String(prev.prompt || '').trim()
            const locked = live || snap
            if (locked) entry.prompt = locked
            if (String(prev.name || '').trim()) entry.name = String(prev.name).trim()
          }
        }
      }
      applyList(bundle.characters, 'character')
      applyList(bundle.props, 'prop')
      applyList(bundle.scenes, 'scene')
    },
    formatStoryboardBundleMarkdown(bundle) {
      if (!bundle || !bundle.shots || !bundle.shots.length) return ''
      const esc = v =>
        String(v != null ? v : '')
          .replace(/\|/g, '/')
          .replace(/\r?\n/g, ' ')
          .trim()
      const lines = [
        `【解析摘要 · 素材与分镜时间轴（视频节点 ${STORYBOARD_VIDEO_NODE_MIN_SEC}～${STORYBOARD_VIDEO_NODE_MAX_SEC} 秒/条）】`,
        ''
      ]
      const pushAsset = (title, list) => {
        lines.push(`### ${title}`)
        if (!list || !list.length) {
          lines.push('_（无）_', '')
          return
        }
        lines.push('| 名称 | 文生图提示词 |', '| --- | --- |')
        for (const a of list) {
          lines.push(`| ${esc(a.name)} | ${esc(a.prompt)} |`)
        }
        lines.push('')
      }
      pushAsset('角色提示词', bundle.characters)
      pushAsset('道具提示词', bundle.props)
      pushAsset('场景提示词', bundle.scenes)
      lines.push('### 分镜时间轴', '')
      lines.push(formatShotsAsTimelineStoryboard(bundle.shots))
      return lines.join('\n')
    },
    buildStoryboardShotImagePreds(shot, assetLists) {
      const characters = (assetLists && assetLists.characters) || []
      const props = (assetLists && assetLists.props) || []
      const scenes = (assetLists && assetLists.scenes) || []
      const ids = []
      const metas = []
      const seen = new Set()
      const push = (indices, list, kindZh) => {
        for (const ii of indices || []) {
          if (ii == null || ii < 0 || ii >= list.length) continue
          const item = list[ii]
          if (!item || !item.id || seen.has(item.id)) continue
          seen.add(item.id)
          ids.push(item.id)
          metas.push({ id: item.id, name: String(item.name || '').trim() || '未命名', kindZh })
        }
      }
      push(shot.charIndices, characters, '人物')
      push(shot.propIndices, props, '道具')
      push(shot.sceneIndices, scenes, '场景')
      return { ids, metas }
    },
    removeSpawnedImagesForStoryboard(storyboardId) {
      const sid = String(storyboardId || '')
      if (!sid) return
      const toRemove = new Set()
      for (const n of this.nodes) {
        if (n && n.type === 'image' && n.data && String(n.data.spawnedFromStoryboardId || '') === sid) {
          toRemove.add(n.id)
        }
      }
      if (!toRemove.size) return
      if (this.selectedId && toRemove.has(this.selectedId)) this.selectedId = null
      this.edges = (this.edges || []).filter(
        e => e && e.from && e.to && !toRemove.has(e.from.nodeId) && !toRemove.has(e.to.nodeId)
      )
      this.nodes = (this.nodes || []).filter(n => !toRemove.has(n.id))
    },
    removeSpawnedVideosForStoryboard(storyboardId) {
      const sid = String(storyboardId || '')
      if (!sid) return
      const toRemove = new Set()
      for (const n of this.nodes) {
        if (n && n.type === 'video' && n.data && String(n.data.spawnedFromStoryboardId || '') === sid) {
          toRemove.add(n.id)
        }
      }
      if (!toRemove.size) return
      if (this.selectedId && toRemove.has(this.selectedId)) this.selectedId = null
      this.edges = (this.edges || []).filter(
        e => e && e.from && e.to && !toRemove.has(e.from.nodeId) && !toRemove.has(e.to.nodeId)
      )
      this.nodes = (this.nodes || []).filter(n => !toRemove.has(n.id))
    },
    /** 续集：删除本分镜下、已不在本次解析资产表中的「本集专属」素材图（不碰前一集节点） */
    pruneSpawnedStoryboardImagesNotInBundle(sbNode, bundle) {
      if (!sbNode || !bundle) return
      const sid = String(sbNode.id || '')
      if (!sid) return
      const keep = new Set()
      const add = (list, bucket) => {
        for (const e of list || []) {
          if (!e || typeof e !== 'object') continue
          const k = continuityAssetLookupKey(e.name)
          if (k) keep.add(`${bucket}:${k}`)
        }
      }
      add(bundle.characters, 'character')
      add(bundle.props, 'prop')
      add(bundle.scenes, 'scene')
      const toRemove = new Set()
      for (const n of this.nodes) {
        if (!n || n.type !== 'image' || !n.data) continue
        if (String(n.data.spawnedFromStoryboardId || '') !== sid) continue
        const kind = String(n.data.storyboardAssetKind || '').trim()
        if (kind !== 'character' && kind !== 'prop' && kind !== 'scene') continue
        const k = continuityAssetLookupKey(n.data.storyboardAssetName)
        if (!k) continue
        if (!keep.has(`${kind}:${k}`)) toRemove.add(n.id)
      }
      if (!toRemove.size) return
      if (this.selectedId && toRemove.has(this.selectedId)) this.selectedId = null
      this.edges = (this.edges || []).filter(
        e => e && e.from && e.to && !toRemove.has(e.from.nodeId) && !toRemove.has(e.to.nodeId)
      )
      this.nodes = (this.nodes || []).filter(n => !toRemove.has(n.id))
    },
    spawnStoryboardAssetImageNodes(sbNode, bundle, continuityMaps, anchorStoryboardId) {
      const def = DEFAULT_NODE.image
      if (!sbNode || !def || !bundle) {
        return { characters: [], props: [], scenes: [], assetColW: 0 }
      }
      const maps = continuityMaps || { character: new Map(), prop: new Map(), scene: new Map() }
      const mapById = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      const anchorSid = String(anchorStoryboardId || '').trim()
      const gapX = 40
      const gapY = 16
      const colW = Math.max(120, Number(def.w) || 336)
      const rowH = Math.max(120, Number(def.h) || 520)
      const baseX = Math.round(Number(sbNode.x) + Number(sbNode.w || colW) + gapX)
      let y = Math.round(Number(sbNode.y))
      const characters = []
      const props = []
      const scenes = []
      const tryReuse = (entry, bucket) => {
        const kind = bucket === 'character' ? 'character' : bucket === 'prop' ? 'prop' : 'scene'
        const b = maps[bucket]
        const key = continuityAssetLookupKey(entry.name)
        if (b && key) {
          const prev = b.get(key)
          if (prev && prev.id) {
            this.tryConnect(sbNode.id, prev.id)
            const nd = mapById[prev.id]
            const sbWsCont = workflowStyleFromStoryboardNode(sbNode)
            if (nd && nd.data && sbWsCont && !isWorkflowStyleSet(nd.data.workflowStyle)) {
              this.$set(nd.data, 'workflowStyle', sbWsCont)
            }
            if (nd && nd.data && !nd.data.aspectRatioUserPick) {
              const sbArC = storyboardAspectRatioFromNode(sbNode)
              const { tier } = this.imageNodeAspectParts(nd)
              this.$set(
                nd.data,
                'aspectKey',
                buildImageAspectKeyFromStoryboardRatio(sbArC, tier)
              )
            }
            const nm = nd && nd.data ? String(nd.data.storyboardAssetName || '').trim() : ''
            return { id: prev.id, name: nm || String(prev.name || '').trim() || entry.name }
          }
        }
        const gid = this.findStoryboardAssetImageNodeIdByBoundName(sbNode, kind, entry.name, anchorSid)
        if (gid) {
          this.tryConnect(sbNode.id, gid)
          const nd = mapById[gid]
          const sbWsReuse = workflowStyleFromStoryboardNode(sbNode)
          if (nd && nd.data && sbWsReuse && !isWorkflowStyleSet(nd.data.workflowStyle)) {
            this.$set(nd.data, 'workflowStyle', sbWsReuse)
          }
          if (nd && nd.data && !nd.data.aspectRatioUserPick) {
            const sbArR = storyboardAspectRatioFromNode(sbNode)
            const { tier } = this.imageNodeAspectParts(nd)
            this.$set(
              nd.data,
              'aspectKey',
              buildImageAspectKeyFromStoryboardRatio(sbArR, tier)
            )
          }
          const nm = nd && nd.data ? String(nd.data.storyboardAssetName || '').trim() : ''
          return { id: gid, name: nm || String(entry.name || '').trim() }
        }
        return null
      }
      const mk = (entry, kind) => {
        const bucket = kind === 'character' ? 'character' : kind === 'prop' ? 'prop' : 'scene'
        const b = maps[bucket]
        const k = continuityAssetLookupKey(entry.name)
        let ptext = String(entry.prompt || '').trim()
        if (b && k) {
          const pv = b.get(k)
          if (pv && pv.id) {
            const nd = mapById[pv.id]
            const live = nd && nd.data ? String(nd.data.prompt || '').trim() : ''
            const snap = String(pv.prompt || '').trim()
            if (live || snap) ptext = live || snap
          }
        }
        if (!ptext) ptext = '请补充该资产的文生图描述'
        let dispName = String(entry.name || '').trim()
        if (b && k) {
          const pv2 = b.get(k)
          if (pv2 && String(pv2.name || '').trim()) dispName = String(pv2.name).trim()
        }
        const n = {
          id: genId(),
          type: 'image',
          x: baseX,
          y,
          w: def.w,
          h: def.h,
          data: def.data()
        }
        const sbWs = workflowStyleFromStoryboardNode(sbNode)
        if (sbWs) this.$set(n.data, 'workflowStyle', sbWs)
        const sbAr = storyboardAspectRatioFromNode(sbNode)
        this.$set(
          n.data,
          'aspectKey',
          buildImageAspectKeyFromStoryboardRatio(sbAr, '2k')
        )
        this.$set(n.data, 'spawnedFromStoryboardId', sbNode.id)
        this.$set(n.data, 'storyboardAssetKind', kind)
        this.$set(n.data, 'storyboardAssetName', dispName)
        this.$set(n.data, 'prompt', ptext)
        if (kind === 'character') {
          this.$set(n.data, 'uiCharacterDesign', true)
        }
        this.nodes.push(n)
        this.bringNodeToFront(n)
        this.applyDefaultModelForNewNode(n)
        this.syncNodeCreditDisplayFromModel(n)
        this.tryConnect(sbNode.id, n.id)
        y += rowH + gapY
        return { id: n.id, name: dispName }
      }
      for (const c of bundle.characters || []) {
        const r = tryReuse(c, 'character')
        characters.push(r || mk(c, 'character'))
      }
      for (const p of bundle.props || []) {
        const r = tryReuse(p, 'prop')
        props.push(r || mk(p, 'prop'))
      }
      for (const s of bundle.scenes || []) {
        const r = tryReuse(s, 'scene')
        scenes.push(r || mk(s, 'scene'))
      }
      const nSlots =
        (bundle.characters && bundle.characters.length) +
        (bundle.props && bundle.props.length) +
        (bundle.scenes && bundle.scenes.length)
      const assetColW = nSlots > 0 ? colW + gapX : 0
      return { characters, props, scenes, assetColW }
    },
    spawnVideoNodesFromStoryboardShots(sbNode, shots, assetLists, layout) {
      const def = DEFAULT_NODE.video
      if (!sbNode || !def || !Array.isArray(shots) || !shots.length) return 0
      const gapX = 40
      const gapY = 16
      const rowsPerCol = 7
      const rowH = Math.max(120, Number(def.h) || 640)
      const colW = Math.max(120, Number(def.w) || 368)
      const assetColW = layout && layout.assetColW != null ? Number(layout.assetColW) || 0 : 0
      const startX = Math.round(Number(sbNode.x) + Number(sbNode.w || colW) + gapX + assetColW + gapX)
      const baseY = Math.round(Number(sbNode.y))
      let created = 0
      for (let i = 0; i < shots.length; i++) {
        const sh = shots[i]
        const col = Math.floor(i / rowsPerCol)
        const row = i % rowsPerCol
        const n = {
          id: genId(),
          type: 'video',
          x: startX + col * (colW + gapX),
          y: baseY + row * (rowH + gapY),
          w: def.w,
          h: def.h,
          data: def.data()
        }
        this.$set(n.data, 'spawnedFromStoryboardId', sbNode.id)
        const shotNo = String(sh.shotNo != null ? sh.shotNo : i + 1)
        const shotSort = parseStoryboardShotNumberSortKey(shotNo)
        this.$set(n.data, 'storyboardShotNo', shotNo)
        this.$set(
          n.data,
          'storyboardShotSort',
          Number.isFinite(shotSort) ? shotSort : i + 1
        )
        this.$set(n.data, 'ratio', storyboardAspectRatioFromNode(sbNode))
        this.$set(n.data, 'duration', sh.durationSec)
        const { ids, metas } = this.buildStoryboardShotImagePreds(sh, assetLists)
        for (const pid of ids) {
          this.tryConnect(pid, n.id)
        }
        this.tryConnect(sbNode.id, n.id)
        let promptBody = mergeStoryboardLinesIntoVideoPromptBody(sh, String(sh.videoPrompt || '').trim())
        if (metas.length) {
          const head = metas
            .map((m, idx) => `@${m.kindZh}「${m.name}」→[图片${idx + 1}]`)
            .join('；')
          promptBody = `【分镜素材对应】${head}。\n${promptBody}`
        }
        this.$set(n.data, 'prompt', promptBody)
        this.nodes.push(n)
        this.bringNodeToFront(n)
        this.applyDefaultModelForNewNode(n)
        this.syncNodeCreditDisplayFromModel(n)
        created += 1
      }
      return created
    },
    async fetchStoryboardShotsJson(scriptBlock, model, continuityAppend, preferencesBlock) {
      const m = String(model || '').trim().startsWith('deepseek-v4')
        ? String(model || '').trim()
        : 'deepseek-v4-flash'
      const bu = this.resolveLlmChatBaseUrl(m)
      const cont = continuityAppend && String(continuityAppend).trim() ? String(continuityAppend).trim() : ''
      const prefs =
        preferencesBlock && String(preferencesBlock).trim() ? String(preferencesBlock).trim() : ''
      const userBody = [
        cont,
        prefs,
        '以下内容可能是文学剧本或「起始秒-结束秒：」时间轴分镜稿（可含「参考资料」块）。请严格按要求只输出 JSON 对象（含「角色」「道具」「场景」「镜头」；时间轴稿须按段落拆条；兼容旧版时也可仅为镜头数组，但优先完整对象）：\n\n' +
          String(scriptBlock || '').trim()
      ]
        .filter(Boolean)
        .join('\n\n')
      const raw = await volcChatComplete({
        model: m,
        baseUrl: bu || undefined,
        messages: [
          { role: 'system', content: SCRIPT_TO_STORYBOARD_BUNDLE_JSON_PROMPT },
          {
            role: 'user',
            content: userBody || ' '
          }
        ]
      })
      return raw
    },
    async runStoryboardParseAndSpawnVideos(sbNode) {
      if (!sbNode || sbNode.type !== 'storyboard' || !sbNode.data || this.isNodeRunning(sbNode.id)) return
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      const draft = String(sbNode.data.body || '').trim()
      const refined = String(sbNode.data.output || '').trim()
      const ctx = gatherUpstreamText(sbNode.id, map, this.edges)
      const mainParts = []
      if (refined && draft && refined !== draft) {
        mainParts.push('【分镜时间轴整理稿】\n' + refined, '【原始剧本】\n' + draft)
      } else if (refined) {
        mainParts.push('【分镜时间轴整理稿】\n' + refined)
      } else if (draft) {
        mainParts.push('【剧本】\n' + draft)
      }
      const scriptBlock = [ctx ? '【参考资料】\n' + ctx : '', ...mainParts].filter(Boolean).join('\n\n')
      if (!String(scriptBlock || '').trim()) {
        showErrorToast('请先粘贴剧本或整理出时间轴分镜稿，或接入上游节点提供参考')
        return
      }
      this.beginNodeRunning(sbNode.id)
      this.$set(sbNode.data, 'status', 'running')
      try {
        let model = String(sbNode.data.model || '').trim()
        if (!model.startsWith('deepseek-v4')) {
          model = 'deepseek-v4-flash'
          this.$set(sbNode.data, 'model', model)
        }
        const anchorId = this.resolveStoryboardContinuityAnchorId(sbNode, map, this.edges)
        const mergedMaps = anchorId ? this.mergedStoryboardContinuityMaps(anchorId, sbNode.id) : null
        const anchorMapsOnly = anchorId ? this.buildStoryboardContinuityCanonicalMaps(anchorId) : null
        const contMapsForLlm =
          mergedMaps &&
          mergedMaps.character.size + mergedMaps.prop.size + mergedMaps.scene.size > 0
            ? mergedMaps
            : anchorMapsOnly
        const contBlock =
          anchorId && contMapsForLlm ? this.buildContinuityUserBlockForLlm(anchorId, contMapsForLlm) : ''
        const prefsBlock = buildStoryboardPreferencesUserBlock(sbNode.data)
        const raw = await this.fetchStoryboardShotsJson(scriptBlock, model, contBlock, prefsBlock)
        const bundle = this.parseStoryboardSpawnBundleFromModelText(raw, {
          allowEmptyAssetPrompt: !!anchorId
        })
        if (!bundle.shots.length) throw new Error('模型未返回有效分镜条目')
        const mm = anchorId ? this.mergedStoryboardContinuityMaps(anchorId, sbNode.id) : null
        if (mm && (mm.character.size || mm.prop.size || mm.scene.size)) {
          this.applyContinuityCanonicalPromptsToBundle(bundle, mm)
        }
        this.pushDeleteUndoSnapshot()
        this.removeSpawnedVideosForStoryboard(sbNode.id)
        if (!anchorId) {
          this.removeSpawnedImagesForStoryboard(sbNode.id)
        }
        const mapsForSpawn = anchorId ? this.mergedStoryboardContinuityMaps(anchorId, sbNode.id) : null
        const assetSpawn = this.spawnStoryboardAssetImageNodes(sbNode, bundle, mapsForSpawn, anchorId || '')
        const assetLists = {
          characters: assetSpawn.characters,
          props: assetSpawn.props,
          scenes: assetSpawn.scenes
        }
        const layout = { assetColW: assetSpawn.assetColW }
        const groupedShots = groupStoryboardShotsForVideoNodes(bundle.shots)
        if (!groupedShots.length) throw new Error('分镜时长合并后无有效视频条目')
        const nVid = this.spawnVideoNodesFromStoryboardShots(sbNode, groupedShots, assetLists, layout)
        if (anchorId) {
          const mm2 = this.mergedStoryboardContinuityMaps(anchorId, sbNode.id)
          if (mm2 && (mm2.character.size || mm2.prop.size || mm2.scene.size)) {
            this.applyContinuityCanonicalPromptsToBundle(bundle, mm2)
          }
          this.pruneSpawnedStoryboardImagesNotInBundle(sbNode, bundle)
        }
        const md = this.formatStoryboardBundleMarkdown({ ...bundle, shots: groupedShots })
        this.$set(sbNode.data, 'output', md)
        this.$set(sbNode.data, 'status', '完成')
        const na = assetSpawn.characters.length + assetSpawn.props.length + assetSpawn.scenes.length
        let tail = ''
        if (anchorId) {
          const an = map[anchorId]
          tail =
            an && an.type === 'storyboard'
              ? `（续接：分镜脚本 ${this.storyboardNodeIndex(an)}）`
              : '（续接已定素材）'
        }
        showSuccessToast(
          `已解析：${na} 个素材引用/图节点 + ${nVid} 个视频节点（每条 ${STORYBOARD_VIDEO_NODE_MIN_SEC}～${STORYBOARD_VIDEO_NODE_MAX_SEC} 秒）${tail}；视频提示词含 @人物/道具/场景 与 [图片N]`
        )
        this.$nextTick(() => this.scheduleSyncNodeVisualHeights())
      } catch (err) {
        this.$set(sbNode.data, 'status', '失败')
        showErrorToast(err && err.message ? String(err.message) : String(err))
      } finally {
        this.endNodeRunning(sbNode.id)
      }
    },
    async runSingleTextNode(n) {
      if (!n || n.type !== 'llm' || this.isNodeRunning(n.id)) return
      try {
        await this.ensureNgcScoreBeforeRun(n, { label: '文本生成' })
      } catch (e) {
        showErrorToast(e && e.message ? String(e.message) : '积分不足~')
        return
      }
      const map = Object.fromEntries(this.nodes.map(x => [x.id, x]))
      this.beginNodeRunning(n.id)
      this.$set(n.data, 'status', 'running')
      try {
        await this.executeLlmNode(n, n.id, map)
        this.$set(n.data, 'status', '完成')
        showSuccessToast('本节点已完成')
      } catch (err) {
        this.$set(n.data, 'status', '失败')
        showErrorToast(err && err.message ? String(err.message) : String(err))
      } finally {
        this.endNodeRunning(n.id)
      }
    },
    async runGraph() {
      if (!this.nodes.length || this.graphRunning) return
      let order
      try {
        order = topoSort(this.nodes, this.edges)
      } catch (err) {
        showErrorToast(err.message || '拓扑失败')
        return
      }
      const map = Object.fromEntries(this.nodes.map(n => [n.id, n]))
      this.flushAllPromptEditorsFromDom()
      const runPu = String(this.projectUuid || '')
      this.$set(this.ngcGraphRuns, runPu, true)
      try {
        for (const id of order) {
          const node = map[id]
          if (!node || node.type === 'note' || node.type === 'directorDeck') continue
          if (this.isNodeRunning(id)) continue
          this.beginNodeRunning(id, runPu)
          this.$set(node.data, 'status', 'running')
          try {
            await this.ensureNgcScoreBeforeRun(node, {
              label: this.nodeTitle(node)
            })
            if (node.type === 'llm') {
              await this.executeLlmNode(node, id, map)
              this.$set(node.data, 'status', '完成')
            } else if (node.type === 'storyboard') {
              await this.executeStoryboardNode(node, id, map)
              this.$set(node.data, 'status', '完成')
            } else if (node.type === 'scriptWrite') {
              await this.executeScriptWriteNode(node, id, map)
              this.$set(node.data, 'status', '完成')
            } else if (node.type === 'image') {
              await this.executeImageNode(node, id, map)
              this.$set(node.data, 'status', '完成')
            } else if (node.type === 'ecomDetail') {
              await this.executeEcomDetailNode(node, id, map)
              const planCnt = this.ecomDetailPromptPlanCount(node)
              if (planCnt > 0) {
                this.spawnEcomDetailImageNodes(node)
              }
              this.$set(node.data, 'status', planCnt ? '提示词就绪' : '完成')
              this.$set(node.data, 'progress', '')
            } else if (node.type === 'uiDesign') {
              const uiRes = await this.executeUiDesignNode(node, id, map)
              this.$set(
                node.data,
                'status',
                uiRes.planCount ? '提示词就绪' : '完成'
              )
              this.$set(node.data, 'progress', '')
            } else if (node.type === 'video') {
              await this.executeVideoNode(node, id, map)
              this.$set(node.data, 'status', '完成')
            } else if (node.type === 'audio') {
              await this.executeAudioNode(node, id, map)
              this.$set(node.data, 'status', '完成')
            }
          } catch (err) {
            this.$set(node.data, 'status', '失败')
            const msg = err && err.message ? String(err.message) : String(err)
            showErrorToast(
              msg.includes('积分不足') ? msg : `${this.nodeTitle(node)}: ${msg}`
            )
            break
          } finally {
            this.endNodeRunning(id)
          }
        }
        showSuccessToast('执行结束')
      } finally {
        this.$delete(this.ngcGraphRuns, runPu)
        this.refreshNgcToolbarCredits()
        if (runPu === String(this.projectUuid || '')) {
          this.persistProjectAfterMutation({ cloudDelayMs: 400 })
        } else {
          this.persistDetachedProject(runPu).catch(e => {
            console.warn('[NodeGraphCanvas] detached persist after graph failed', e)
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.ngc-inline-model-picker {
  max-height: min(72vh, 480px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 14px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0) 24%),
    linear-gradient(165deg, rgba(24, 24, 32, 0.98) 0%, rgba(14, 14, 18, 0.99) 100%);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 18px 48px -12px rgba(0, 0, 0, 0.72),
    0 0 0 1px rgba(129, 140, 248, 0.06);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.18) transparent;
  box-sizing: border-box;
}
.ngc-inline-model-picker--node-anchor {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 4px);
  z-index: 90;
  width: min(304px, calc(100% - 16px));
  max-width: calc(100% - 16px);
  transform: translateX(-50%);
}
.ngc-image-aspect-picker {
  max-height: min(72vh, 480px);
  overflow-y: auto;
  padding: 14px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0) 24%),
    linear-gradient(165deg, rgba(24, 24, 32, 0.98) 0%, rgba(14, 14, 18, 0.99) 100%);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 18px 48px -12px rgba(0, 0, 0, 0.72);
  box-sizing: border-box;
}
.ngc-inline-model-picker::-webkit-scrollbar {
  width: 5px;
}
.ngc-inline-model-picker::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.18);
}
.ngc-inline-model-picker__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
.ngc-inline-model-picker__title {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: rgba(255, 255, 255, 0.94);
}
.ngc-inline-model-picker__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: rgba(255, 255, 255, 0.45);
  font-size: 12px;
  cursor: pointer;
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    color 0.18s ease,
    transform 0.15s ease;
}
.ngc-inline-model-picker__close:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.16);
  color: rgba(255, 255, 255, 0.92);
}
.ngc-inline-model-picker__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ngc-inline-model-picker__item {
  position: relative;
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 34px 10px 10px;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.025);
  text-align: left;
  font-size: 11px;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.58);
  cursor: pointer;
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    color 0.18s ease,
    box-shadow 0.18s ease,
    transform 0.15s ease;
}
.ngc-inline-model-picker__item:hover {
  border-color: rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.82);
  transform: translateY(-1px);
}
.ngc-inline-model-picker__item--active {
  border-color: rgba(129, 140, 248, 0.38);
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.18) 0%, rgba(56, 189, 248, 0.08) 100%);
  color: rgba(255, 255, 255, 0.96);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    0 0 0 1px rgba(129, 140, 248, 0.12),
    0 10px 24px -14px rgba(79, 70, 229, 0.45);
}
.ngc-inline-model-picker__item--active::after {
  content: '✓';
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  font-size: 12px;
  font-weight: 700;
  color: rgba(165, 180, 252, 0.95);
}
.ngc-inline-model-picker__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.07) 0%, rgba(255, 255, 255, 0.02) 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
}
.ngc-inline-model-picker__item--active .ngc-inline-model-picker__icon {
  border-color: rgba(165, 180, 252, 0.28);
  background: linear-gradient(145deg, rgba(129, 140, 248, 0.22) 0%, rgba(56, 189, 248, 0.1) 100%);
}
.ngc-inline-model-picker__label {
  min-width: 0;
  flex: 1;
  font-weight: 600;
}
.ngc-inline-model-picker__item > .min-w-0.flex-1 {
  min-width: 0;
  flex: 1;
  font-weight: 600;
}
.ngc-inline-model-picker__item [class*='text-amber'] {
  display: block;
  margin-top: 3px;
  font-size: 9px;
  font-weight: 500;
  color: rgba(251, 191, 36, 0.72) !important;
}

.ngc-sidebar-head {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px 12px 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  background: linear-gradient(
    180deg,
    rgba(22, 22, 28, 0.98) 0%,
    rgba(14, 14, 18, 0.96) 100%
  );
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.04) inset;
}
.ngc-sidebar-back-btn {
  align-self: flex-start;
  height: 28px;
  padding: 0 10px;
  color: rgba(156, 163, 175, 0.95);
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.08);
}
.ngc-sidebar-back-btn:hover:not(:disabled) {
  color: rgba(221, 214, 254, 0.96);
  border-color: rgba(139, 92, 246, 0.32);
  background: rgba(124, 58, 237, 0.12);
}
.ngc-sidebar-action-segment {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  padding: 3px;
  gap: 3px;
}
.ngc-sidebar-action-btn {
  width: 100%;
  min-width: 0;
  height: 32px;
  font-size: 11px;
}
.ngc-sidebar-hint {
  margin: 2px 0 0;
  padding: 0 2px;
  font-size: 9px;
  line-height: 1.45;
}
.ngc-sidebar-hint--ok {
  color: rgba(156, 163, 175, 0.82);
}
.ngc-sidebar-hint--pending {
  color: rgba(167, 139, 250, 0.88);
}
.ngc-sidebar-hint--warn {
  color: rgba(253, 230, 138, 0.9);
}

.ngc .absolute.inset-0 > .absolute {
  pointer-events: auto;
}
.ngc-edges-svg .ngc-edge-hit {
  cursor: pointer;
}
@keyframes ngc-edge-stream-dash {
  to {
    stroke-dashoffset: -100;
  }
}
.ngc-edges-svg .ngc-edge-aura {
  opacity: 0.85;
}
.ngc-edges-svg .ngc-edge-stream {
  stroke-dashoffset: 0;
  animation: ngc-edge-stream-dash 2.35s linear infinite;
  filter: drop-shadow(0 0 3px rgba(232, 121, 251, 0.75)) drop-shadow(0 0 6px rgba(34, 211, 238, 0.35));
}
.ngc-edges-svg .ngc-edge-stream--selected {
  animation-duration: 1.55s;
  stroke-dasharray: 22 78;
  filter: drop-shadow(0 0 4px rgba(147, 197, 253, 0.95)) drop-shadow(0 0 8px rgba(56, 189, 248, 0.45));
}
.ngc-edges-svg .ngc-edge-stream--fx-off {
  animation: none !important;
  filter: none !important;
}
.ngc-node-box {
  contain: layout;
}
/* 图片/视频/音频节点 · 上游素材缩略图横条 */
.ngc-upstream-thumb-scroll {
  overscroll-behavior-x: contain;
  -webkit-overflow-scrolling: touch;
}
.scrollbar-thin {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.28) transparent;
}
.scrollbar-thin::-webkit-scrollbar {
  height: 5px;
  width: 5px;
}
.scrollbar-thin::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.22);
}
.scrollbar-thin::-webkit-scrollbar-track {
  background: transparent;
}
/* contenteditable 内联素材芯片（动态插入 DOM，用 >>> 穿透 scoped） */
.ngc-prompt-ed[data-empty='1']:not(:focus)::before {
  content: attr(data-placeholder);
  position: absolute;
  left: 0.625rem;
  right: 0.625rem;
  top: 0.5rem;
  color: rgba(148, 163, 184, 0.78);
  font-size: 11px;
  line-height: 1.45;
  white-space: pre-wrap;
  pointer-events: none;
}
.ngc-prompt-ed >>> .ngc-prompt-chip {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  gap: 4px;
  margin: 0 2px;
  padding: 2px 8px 2px 4px;
  border-radius: 6px;
  background: #2c2c34;
  border: 1px solid rgba(255, 255, 255, 0.12);
  font-size: 11px;
  line-height: 1.25;
  color: #f3f4f6;
  max-width: 100%;
  user-select: none;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background 0.15s ease,
    box-shadow 0.15s ease;
}
.ngc-prompt-ed >>> .ngc-prompt-chip:hover {
  border-color: rgba(251, 191, 36, 0.45);
  background: #34343f;
  box-shadow: 0 0 0 1px rgba(251, 191, 36, 0.12);
}
.ngc-prompt-ed >>> .ngc-prompt-chip__thumb {
  display: flex;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.35);
}
.ngc-prompt-ed >>> .ngc-prompt-chip__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.ngc-prompt-ed >>> .ngc-prompt-chip__ico {
  font-size: 10px;
  color: rgba(207, 250, 254, 0.92);
}
.ngc-prompt-ed >>> .ngc-prompt-chip__label {
  flex: 1;
  min-width: 0;
  font-weight: 500;
  white-space: nowrap;
}
/* 节点内自定义输入（与 NgcNodeSelect 触发器风格一致） */
.ngc-node-field-input {
  display: block;
  width: 100%;
  min-width: 0;
  height: 1.75rem;
  padding: 0 0.625rem;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.11);
  background: linear-gradient(180deg, rgba(28, 28, 34, 0.98) 0%, rgba(14, 14, 18, 0.98) 100%);
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.05) inset;
  font-size: 10px;
  line-height: 1.3;
  color: rgba(243, 244, 246, 0.95);
  outline: none;
  transition:
    border-color 0.15s ease,
    background 0.15s ease,
    box-shadow 0.15s ease;
}
.ngc-node-field-input::placeholder {
  color: rgba(156, 163, 175, 0.72);
}
.ngc-node-field-input:hover {
  border-color: rgba(255, 255, 255, 0.18);
}
.ngc-node-field-input:focus {
  border-color: rgba(139, 92, 246, 0.48);
  box-shadow:
    0 0 0 2px rgba(139, 92, 246, 0.16),
    0 1px 0 rgba(255, 255, 255, 0.05) inset;
}

/* @ 素材菜单：阻断滚动链，避免滚轮穿透到提示词外层 */
.ngc-asset-mention {
  overscroll-behavior: contain;
  overscroll-behavior-y: contain;
  -webkit-overflow-scrolling: touch;
}
/* 画布顶栏工具条（需高于下方画布层，否则「添加节点」下拉会被盖住） */
.ngc-canvas-toolbar {
  position: relative;
  z-index: 50;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  font-size: 11px;
  color: rgba(229, 231, 235, 0.92);
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  background: linear-gradient(
    180deg,
    rgba(22, 22, 28, 0.98) 0%,
    rgba(14, 14, 18, 0.96) 100%
  );
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.04) inset;
  backdrop-filter: blur(12px);
  min-width: 0;
  overflow: visible;
}
.ngc-toolbar-leading,
.ngc-toolbar-trailing {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
  overflow: visible;
}
.ngc-toolbar-leading {
  flex: 1 1 auto;
  min-width: 0;
}
.ngc-toolbar-trailing {
  flex: 0 0 auto;
  justify-content: flex-end;
}
.ngc-toolbar-group {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.ngc-toolbar-title {
  flex: 1 1 140px;
  max-width: 280px;
  padding: 2px 10px 2px 8px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.28);
}
.ngc-toolbar-input {
  flex: 1;
  min-width: 0;
  height: 28px;
  padding: 0 4px;
  border: none;
  outline: none;
  background: transparent;
  font-size: 12px;
  font-weight: 500;
  color: rgba(243, 244, 246, 0.96);
}
.ngc-toolbar-input::placeholder {
  color: rgba(156, 163, 175, 0.75);
  font-weight: 400;
}
.ngc-toolbar-input:focus {
  color: #fff;
}
.ngc-toolbar-divider {
  width: 1px;
  height: 22px;
  flex-shrink: 0;
  background: linear-gradient(
    180deg,
    transparent,
    rgba(255, 255, 255, 0.12) 50%,
    transparent
  );
}
.ngc-toolbar-divider--spacer {
  flex: 1 1 8px;
  width: auto;
  min-width: 4px;
  height: 22px;
  background: transparent;
}
.ngc-toolbar-credits {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 10px 0 8px;
  border-radius: 8px;
  border: 1px solid rgba(251, 191, 36, 0.22);
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  color: rgba(254, 243, 199, 0.92);
  background: linear-gradient(
    180deg,
    rgba(251, 191, 36, 0.14) 0%,
    rgba(180, 83, 9, 0.1) 100%
  );
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    box-shadow 0.15s ease;
}
.ngc-toolbar-credits:hover {
  border-color: rgba(251, 191, 36, 0.38);
  color: #fffbeb;
  background: linear-gradient(
    180deg,
    rgba(251, 191, 36, 0.22) 0%,
    rgba(180, 83, 9, 0.16) 100%
  );
  box-shadow: 0 0 0 1px rgba(251, 191, 36, 0.12) inset;
}
.ngc-toolbar-credits-label {
  color: rgba(209, 213, 219, 0.82);
  font-weight: 400;
}
.ngc-toolbar-credits-value {
  font-weight: 600;
  color: rgba(255, 251, 235, 0.98);
  letter-spacing: 0.02em;
}
.ngc-toolbar-segment {
  padding: 2px;
  gap: 2px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(255, 255, 255, 0.03);
}
.ngc-tb-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: 30px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid transparent;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  color: rgba(209, 213, 219, 0.95);
  background: rgba(255, 255, 255, 0.05);
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    box-shadow 0.15s ease,
    transform 0.1s ease;
}
.ngc-tb-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.09);
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}
.ngc-tb-btn:active:not(:disabled) {
  transform: scale(0.98);
}
.ngc-tb-btn:disabled {
  opacity: 0.38;
  cursor: not-allowed;
}
.ngc-tb-btn--run {
  padding: 0 12px;
  color: #ecfdf5;
  border-color: rgba(52, 211, 153, 0.35);
  background: linear-gradient(180deg, rgba(16, 185, 129, 0.42) 0%, rgba(5, 150, 105, 0.32) 100%);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.12) inset,
    0 4px 14px -4px rgba(16, 185, 129, 0.45);
}
.ngc-tb-btn--run:hover:not(:disabled) {
  border-color: rgba(110, 231, 183, 0.5);
  background: linear-gradient(180deg, rgba(34, 197, 94, 0.5) 0%, rgba(5, 150, 105, 0.38) 100%);
  color: #fff;
}
.ngc-tb-btn--icon {
  padding: 0 9px;
}
.ngc-tb-btn--amber {
  color: rgba(253, 230, 138, 0.95);
}
.ngc-tb-btn--amber:hover:not(:disabled) {
  border-color: rgba(245, 158, 11, 0.35);
  background: rgba(245, 158, 11, 0.12);
  color: #fde68a;
}
.ngc-tb-btn--icon-only {
  width: 28px;
  padding: 0;
}
.ngc-tb-btn--add {
  padding: 0 12px;
  color: #ede9fe;
  border-color: rgba(139, 92, 246, 0.4);
  background: linear-gradient(180deg, rgba(124, 58, 237, 0.45) 0%, rgba(91, 33, 182, 0.38) 100%);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.1) inset,
    0 4px 16px -6px rgba(124, 58, 237, 0.55);
}
.ngc-tb-btn--add:hover:not(:disabled) {
  border-color: rgba(167, 139, 250, 0.55);
  background: linear-gradient(180deg, rgba(139, 92, 246, 0.55) 0%, rgba(109, 40, 217, 0.45) 100%);
  color: #fff;
}
.ngc-toolbar-zoom {
  padding: 2px 4px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(0, 0, 0, 0.22);
}
.ngc-toolbar-zoom-label {
  min-width: 38px;
  text-align: center;
  font-size: 10px;
  font-weight: 600;
  color: rgba(156, 163, 175, 0.95);
  letter-spacing: 0.02em;
}
.ngc-toolbar-check {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 8px;
  border-radius: 8px;
  cursor: pointer;
  color: rgba(156, 163, 175, 0.95);
  transition: color 0.15s ease, background 0.15s ease;
}
.ngc-toolbar-check:hover {
  color: rgba(209, 213, 219, 0.95);
  background: rgba(255, 255, 255, 0.04);
}
.ngc-toolbar-checkbox {
  width: 14px;
  height: 14px;
  margin: 0;
  accent-color: #8b5cf6;
  cursor: pointer;
}
/* 画布双击 · 添加节点菜单（与顶栏下拉共用尺寸） */
.ngc-add-menu,
.ngc-toolbar-dropdown {
  box-sizing: border-box;
  width: 7.75rem;
  min-width: 7.75rem;
  max-width: min(11.5rem, calc(100vw - 1.5rem));
  padding: 3px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(20, 20, 26, 0.98);
  box-shadow:
    0 16px 40px -12px rgba(0, 0, 0, 0.75),
    0 0 0 1px rgba(255, 255, 255, 0.04) inset;
  backdrop-filter: blur(16px);
}
.ngc-add-menu-item,
.ngc-toolbar-dropdown-item {
  display: block;
  width: 100%;
  padding: 6px 12px;
  border: none;
  border-radius: 8px;
  text-align: center;
  font-size: 11px;
  white-space: nowrap;
  color: rgba(229, 231, 235, 0.92);
  background: transparent;
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease;
}
.ngc-add-menu-item:hover,
.ngc-toolbar-dropdown-item:hover {
  background: rgba(139, 92, 246, 0.18);
  color: #fff;
}
.ngc-toolbar-tools {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.25);
}
.ngc-tb-tool {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 28px;
  border: none;
  border-radius: 7px;
  font-size: 11px;
  color: rgba(156, 163, 175, 0.9);
  background: transparent;
  cursor: pointer;
  transition:
    background 0.15s ease,
    color 0.15s ease,
    box-shadow 0.15s ease;
}
.ngc-tb-tool:hover {
  color: rgba(229, 231, 235, 0.95);
  background: rgba(255, 255, 255, 0.06);
}
.ngc-tb-tool--active {
  color: #e0e7ff;
  background: linear-gradient(180deg, rgba(99, 102, 241, 0.45) 0%, rgba(79, 70, 229, 0.35) 100%);
  box-shadow: 0 0 0 1px rgba(129, 140, 248, 0.35) inset;
}
.ngc-tb-tool--active:hover {
  color: #fff;
}
.ngc-tb-tool--active-hand {
  color: #e0f2fe;
  background: linear-gradient(180deg, rgba(14, 165, 233, 0.42) 0%, rgba(2, 132, 199, 0.32) 100%);
  box-shadow: 0 0 0 1px rgba(56, 189, 248, 0.35) inset;
}
.ngc-tb-tool--active-hand:hover {
  color: #fff;
}

/* UI 设计节点 · 主题色可视化选择 */
.ui-design-color-swatch {
  -webkit-appearance: none;
  appearance: none;
  border-radius: 6px;
  cursor: pointer;
}
.ui-design-color-swatch::-webkit-color-swatch-wrapper {
  padding: 0;
}
.ui-design-color-swatch::-webkit-color-swatch {
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 5px;
}
.ui-design-color-swatch::-moz-color-swatch {
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 5px;
}

/* 画布内确认弹窗 */
.ngc-confirm-fade-enter-active,
.ngc-confirm-fade-leave-active {
  transition: opacity 0.2s ease;
}
.ngc-confirm-fade-enter-active .ngc-confirm-panel,
.ngc-confirm-fade-leave-active .ngc-confirm-panel {
  transition:
    transform 0.22s cubic-bezier(0.22, 1, 0.36, 1),
    opacity 0.2s ease;
}
.ngc-confirm-fade-enter,
.ngc-confirm-fade-leave-to {
  opacity: 0;
}
.ngc-confirm-fade-enter .ngc-confirm-panel,
.ngc-confirm-fade-leave-to .ngc-confirm-panel {
  opacity: 0;
  transform: scale(0.96) translateY(8px);
}
.ngc-confirm-panel-accent {
  background: linear-gradient(90deg, rgba(251, 191, 36, 0.85), rgba(245, 158, 11, 0.5));
}
.ngc-confirm-panel-accent--amber {
  background: linear-gradient(90deg, rgba(251, 191, 36, 0.9), rgba(245, 158, 11, 0.45));
}
.ngc-confirm-panel-accent--danger {
  background: linear-gradient(90deg, rgba(244, 63, 94, 0.9), rgba(225, 29, 72, 0.45));
}
.ngc-confirm-btn {
  border: 1px solid transparent;
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    transform 0.12s ease,
    box-shadow 0.15s ease;
}
.ngc-confirm-btn:active {
  transform: scale(0.98);
}
.ngc-confirm-btn--ghost {
  border-color: rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
}
.ngc-confirm-btn--ghost:hover {
  border-color: rgba(255, 255, 255, 0.16);
  background: rgba(255, 255, 255, 0.08);
  color: #f3f4f6;
}
.ngc-confirm-btn--amber {
  border-color: rgba(251, 191, 36, 0.35);
  background: linear-gradient(180deg, rgba(245, 158, 11, 0.95) 0%, rgba(217, 119, 6, 0.92) 100%);
  box-shadow: 0 4px 14px -4px rgba(245, 158, 11, 0.55);
}
.ngc-confirm-btn--amber:hover {
  filter: brightness(1.06);
  box-shadow: 0 6px 18px -4px rgba(245, 158, 11, 0.65);
}
.ngc-confirm-btn--danger {
  border-color: rgba(244, 63, 94, 0.4);
  background: linear-gradient(180deg, rgba(244, 63, 94, 0.95) 0%, rgba(225, 29, 72, 0.92) 100%);
  box-shadow: 0 4px 14px -4px rgba(244, 63, 94, 0.5);
}
.ngc-confirm-btn--danger:hover {
  filter: brightness(1.06);
}

/* 各节点底栏统一的「执行 / 生成」圆形按钮 */
.ngc-node-run-btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 9999px;
  background: linear-gradient(
    165deg,
    rgba(255, 255, 255, 0.99) 0%,
    rgba(244, 244, 248, 0.96) 48%,
    rgba(228, 228, 234, 0.94) 100%
  );
  color: #101014;
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.95) inset,
    0 2px 10px rgba(0, 0, 0, 0.38),
    0 0 0 1px rgba(0, 0, 0, 0.14);
  cursor: pointer;
  transition:
    transform 0.14s ease,
    box-shadow 0.14s ease,
    border-color 0.14s ease,
    background 0.14s ease,
    opacity 0.14s ease;
}
.ngc-node-run-btn:hover:not(:disabled) {
  border-color: rgba(255, 255, 255, 0.42);
  background: linear-gradient(165deg, #fff 0%, #f8f8fc 52%, #ececf2 100%);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 1) inset,
    0 4px 16px rgba(0, 0, 0, 0.42),
    0 0 0 1px rgba(255, 255, 255, 0.06),
    0 0 18px rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
}
.ngc-node-run-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.85) inset,
    0 1px 6px rgba(0, 0, 0, 0.32);
}
.ngc-node-run-btn:disabled {
  opacity: 0.38;
  cursor: not-allowed;
  transform: none;
}
.ngc-node-run-btn--wide {
  width: auto;
  min-width: 4.75rem;
  padding: 0 0.625rem;
}
.ngc-node-run-btn__icon {
  font-size: 11px;
  line-height: 1;
  font-weight: 700;
}
.ngc-node-run-btn__icon--sm {
  font-size: 9px;
  font-weight: 600;
}
.ngc-node-run-btn__text {
  font-size: 9px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  letter-spacing: 0.01em;
}
</style>
